const legalNature = [
  { value: '399-9', name: 'Associação Privada' },
  { value: '111-2', name: 'Autarquia Estadual ou do Distrito Federal' },
  { value: '110-4', name: 'Autarquia Federal' },
  { value: '112-0', name: 'Autarquia Municipal' },
  { value: '409-0', name: 'Candidato a Cargo Político Eletivo' },
  { value: '222-4', name: 'Clube/Fundo de Investimento' },
  { value: '310-7', name: 'Comissão de Conciliação Prévia' },
  { value: '119-8', name: 'Comissão Polinacional' },
  { value: '328-0', name: 'Comitê Financeiro de Partido Político' },
  { value: '323-9', name: 'Comunidade Indígena' },
  { value: '308-5', name: 'Condomínio Edilício' },
  { value: '228-3', name: 'Consórcio de Empregadores' },
  { value: '215-1', name: 'Consórcio de Sociedades' },
  { value: '122-8', name: 'Consórcio Público de Direito Privado' },
  {
    value: '121-0',
    name: 'Consórcio Público de Direito Público (Associação Pública)',
  },
  { value: '229-1', name: 'Consórcio Simples' },
  { value: '408-1', name: 'Contribuinte Individual' },
  { value: '214-3', name: 'Cooperativa' },
  { value: '233-0', name: 'Cooperativas de Consumo' },
  { value: '331-0', name: 'Demais Condomínios' },
  { value: '227-5', name: 'Empresa Binacional' },
  { value: '221-6', name: 'Empresa Domiciliada no Exterior' },
  {
    value: '230-5',
    name: 'Empresa Individual de Responsabilidade Limitada (de Natureza Empresária)',
  },
  {
    value: '231-3',
    name: 'Empresa Individual de Responsabilidade Limitada (de Natureza Simples)',
  },
  { value: '401-4', name: 'Empresa Individual Imobiliária' },
  { value: '201-1', name: 'Empresa Pública' },
  {
    value: '234-8',
    name: 'Empresa Simples de Inovação - Inova Simples',
  },
  { value: '213-5', name: 'Empresário (Individual)' },
  { value: '311-5', name: 'Entidade de Mediação e Arbitragem' },
  { value: '313-1', name: 'Entidade Sindical' },
  {
    value: '219-4',
    name: 'Estabelecimento, no Brasil, de Empresa Binacional Argentino-Brasileira',
  },
  {
    value: '320-4',
    name: 'Estabelecimento, no Brasil, de Fundação ou Associação Estrangeiras',
  },
  {
    value: '217-8',
    name: 'Estabelecimento, no Brasil, de Sociedade Estrangeira',
  },
  { value: '123-6', name: 'Estado ou Distrito Federal' },
  { value: '329-8', name: 'Frente Plebiscitária ou Referendária' },
  {
    value: '321-2',
    name: 'Fundação ou Associação domiciliada no exterior',
  },
  { value: '306-9', name: 'Fundação Privada' },
  {
    value: '126-0',
    name: 'Fundação Pública de Direito Privado Estadual ou do Distrito Federal',
  },
  {
    value: '125-2',
    name: 'Fundação Pública de Direito Privado Federal',
  },
  {
    value: '127-9',
    name: 'Fundação Pública de Direito Privado Municipal',
  },
  {
    value: '114-7',
    name: 'Fundação Pública de Direito Público Estadual ou do Distrito Federal',
  },
  {
    value: '113-9',
    name: 'Fundação Pública de Direito Público Federal',
  },
  {
    value: '115-5',
    name: 'Fundação Pública de Direito Público Municipal',
  },
  { value: '324-7', name: 'Fundo Privado' },
  { value: '120-1', name: 'Fundo Público' },
  {
    value: '132-5',
    name: 'Fundo Público da Administração Direta Estadual ou do Distrito Federal',
  },
  {
    value: '131-7',
    name: 'Fundo Público da Administração Direta Federal',
  },
  {
    value: '133-3',
    name: 'Fundo Público da Administração Direta Municipal',
  },
  {
    value: '129-5',
    name: 'Fundo Público da Administração Indireta Estadual ou do Distrito Federal',
  },
  {
    value: '128-7',
    name: 'Fundo Público da Administração Indireta Federal',
  },
  {
    value: '130-9',
    name: 'Fundo Público da Administração Indireta Municipal',
  },
  { value: '216-0', name: 'Grupo de Sociedades' },
  { value: '235-6', name: 'Investidor Não Residente' },
  { value: '411-1', name: 'Leiloeiro' },
  { value: '124-4', name: 'Município' },
  { value: '501-0', name: 'Organização Internacional' },
  { value: '322-0', name: 'Organização Religiosa' },
  { value: '330-1', name: 'Organização Social (OS)' },
  {
    value: '327-1',
    name: 'Órgão de Direção Local de Partido Político',
  },
  {
    value: '325-5',
    name: 'Órgão de Direção Nacional de Partido Político',
  },
  {
    value: '326-3',
    name: 'Órgão de Direção Regional de Partido Político',
  },
  {
    value: '117-1',
    name: 'Órgão Público Autônomo Estadual ou do Distrito Federal',
  },
  { value: '116-3', name: 'Órgão Público Autônomo Federal' },
  { value: '118-0', name: 'Órgão Público Autônomo Municipal' },
  {
    value: '102-3',
    name: 'Órgão Público do Poder Executivo Estadual ou do Distrito Federal',
  },
  { value: '101-5', name: 'Órgão Público do Poder Executivo Federal' },
  {
    value: '103-1',
    name: 'Órgão Público do Poder Executivo Municipal',
  },
  {
    value: '108-2',
    name: 'Órgão Público do Poder Judiciário Estadual',
  },
  { value: '107-4', name: 'Órgão Público do Poder Judiciário Federal' },
  {
    value: '105-8',
    name: 'Órgão Público do Poder Legislativo Estadual ou do Distrito Federal',
  },
  {
    value: '104-0',
    name: 'Órgão Público do Poder Legislativo Federal',
  },
  {
    value: '106-6',
    name: 'Órgão Público do Poder Legislativo Municipal',
  },
  { value: '503-7', name: 'Outras Instituições Extraterritoriais' },
  { value: '312-3', name: 'Partido Político' },
  {
    value: '332-8',
    name: 'Plano de Benefícios de Previdência Complementar Fechada',
  },
  { value: '412-0', name: 'Produtor Rural (Pessoa Física)' },
  { value: '502-9', name: 'Representação Diplomática Estrangeira' },
  { value: '402-2', name: 'Segurado Especial' },
  { value: '303-4', name: 'Serviço Notarial e Registral (Cartório)' },
  { value: '307-7', name: 'Serviço Social Autônomo' },
  { value: '204-6', name: 'Sociedade Anônima Aberta' },
  { value: '205-4', name: 'Sociedade Anônima Fechada' },
  { value: '203-8', name: 'Sociedade de Economia Mista' },
  { value: '212-7', name: 'Sociedade em Conta de Participação' },
  {
    value: '209-7',
    name: 'Sociedade Empresária em Comandita por Ações',
  },
  { value: '208-9', name: 'Sociedade Empresária em Comandita Simples' },
  { value: '207-0', name: 'Sociedade Empresária em Nome Coletivo' },
  { value: '206-2', name: 'Sociedade Empresária Limitada' },
  { value: '226-7', name: 'Sociedade Simples em Comandita Simples' },
  { value: '225-9', name: 'Sociedade Simples em Nome Coletivo' },
  { value: '224-0', name: 'Sociedade Simples Limitada' },
  { value: '223-2', name: 'Sociedade Simples Pura' },
  { value: '232-1', name: 'Sociedade Unipessoal de Advogados' },
  { value: '134-1', name: 'União' },
];

// Igual ao core/src/components/modals/EditUserModal/Tabs/inputOptions.js

const educationOptions = [
  {
    name: 'Analfabeto',
    value: 'ANALFABETO',
  },
  {
    name: 'Até 4ª série (5º. ano) incompleta do Ensino Fundamental',
    value: 'PRIMEIRO_GRAU_INCOMPLETO',
  },
  {
    name: '4ª série (5º. ano) completa do Ensino Fundamental (antigo 1º grau ou primário)',
    value: 'PRIMEIRO_GRAU_COMPLETO_1',
  },
  {
    name: 'Da 5ª à 8ª série (6º. a 9º. ano) do Ensino Fundamental (antigo 1º grau ou ginásio)',
    value: 'PRIMEIRO_GRAU_COMPLETO_2',
  },
  {
    name: 'Ensino Fundamental completo (antigo 1º grau ou primário e ginasial)',
    value: 'PRIMEIRO_GRAU_COMPLETO_3',
  },
  {
    name: 'Ensino Médio incompleto (antigo 2º grau, secundário ou colegial)',
    value: 'SEGUNDO_GRAU_INCOMPLETO',
  },
  {
    name: 'Ensino Médio completo (antigo 2º grau, secundário ou colegial)',
    value: 'SEGUNDO_GRAU_COMPLETO',
  },
  {
    name: 'Educação Superior incompleta',
    value: 'SUPERIOR_INCOMPLETO',
  },
  {
    name: 'Educação Superior completa',
    value: 'SUPERIOR_COMPLETO',
  },
];

const badesulRole = [
  { name: 'Tomador', value: 'TOMADOR' },
  { name: 'Fiador/Avalista', value: 'FIADOR_AVALISTA' },
  { name: 'Interveniente Hipotecante', value: 'INTERVENIENTE_HIPOTECANTE' },
  { name: 'Sócio', value: 'SOCIO' },
  { name: 'Representante Legal', value: 'REPRESENTANTE_LEGAL' },
];

const race = [
  { name: 'NÃO SE APLICA', value: 'NAO_SE_APLICA' },
  { name: 'INDÍGENA', value: 'INDIGENA' },
  { name: 'BRANCA', value: 'BRANCA' },
  { name: 'NEGRA', value: 'PRETA' },
  { name: 'AMARELA', value: 'AMARELA' },
  { name: 'PARDA', value: 'PARDA' },
  { name: 'NÃO DECLARADO', value: 'NAO_INFORMADO' },
];

const occupation = [
  { value: 1, name: 'ABALIZADOR' },
  { value: 2, name: 'ABASTECEDOR DE ESPULAS' },
  { value: 3, name: 'ABASTECEDOR DE FORNO (CERAMICA)' },
  { value: 4, name: 'ABASTECEDOR DE LINHA DE PRODUCAO' },
  { value: 5, name: 'ABASTECEDOR DE MAQUINAS (MAD. E PASTA PAPEL)' },
  { value: 6, name: 'ABASTECEDOR DE OVOS (INCUBADEIRA)' },
  { value: 7, name: 'ABASTECEDOR DE PECAS PARA FORNO' },
  { value: 8, name: 'ABASTECEDOR DE PRENSA HIDRAULICA' },
  { value: 9, name: 'ABASTECEDOR SEM ESPECIFICACAO' },
  { value: 10, name: 'ABATEDOR (DE ANIMAIS)' },
  { value: 11, name: 'ABELHEIRO' },
  { value: 12, name: 'ABETUMADOR' },
  { value: 13, name: 'ABRIDOR (FOLHAS DE FUMO)' },
  { value: 14, name: 'ACABADOR DE CALCADOS' },
  { value: 15, name: 'ACABADOR DE CHAPEUS' },
  { value: 16, name: 'ACABADOR DE COFRES' },
  { value: 17, name: 'ACABADOR DE MACHOS' },
  { value: 18, name: 'ACABADOR DE MOVEIS (MADEIRA)' },
  { value: 19, name: 'ACABADOR DE PECAS' },
  { value: 20, name: 'ACABADOR DE PECAS (CERAMICA)' },
  { value: 21, name: 'ACABADOR DE PECAS (PLASTICO)' },
  { value: 22, name: 'ACABADOR DE PEDRAS' },
  { value: 23, name: 'ACABADOR DE SUPERFICIES DE CONCRETO ARMADO' },
  { value: 24, name: 'ACABADOR DE TECIDOS' },
  { value: 25, name: 'ACABADOR SEM ESPECIFICACAO' },
  { value: 26, name: 'ACETINADOR' },
  { value: 27, name: 'ACOMPANHADOR DE COMPRAS' },
  { value: 28, name: 'ACOMPANHANTE' },
  { value: 29, name: 'ACONDICIONADOR' },
  { value: 30, name: 'ACOUGUEIRO' },
  { value: 31, name: 'ACROBATA' },
  { value: 32, name: 'ACUPUNTURISTA' },
  { value: 33, name: 'ADAPTADOR DE PECAS TEATRAIS' },
  { value: 34, name: 'ADERECISTA' },
  { value: 35, name: 'ADMINISTRADOR AGRICOLA' },
  { value: 36, name: 'ADMINISTRADOR COMERCIAL' },
  { value: 37, name: 'ADMINISTRADOR DE CAMPING' },
  { value: 38, name: 'ADMINISTRADOR DE CARGOS E SALARIOS' },
  { value: 39, name: 'ADMINISTRADOR DE EDIFICIOS' },
  { value: 40, name: 'ADMINISTRADOR DE EMPRESAS' },
  { value: 41, name: 'ADMINISTRADOR DE ENGORDA' },
  { value: 42, name: 'ADMINISTRADOR DE EXPLORACAO PESQUEIRA' },
  { value: 43, name: 'ADMINISTRADOR DE FAZENDA' },
  { value: 44, name: 'ADMINISTRADOR DE IMOVEIS' },
  { value: 45, name: 'ADMINISTRADOR DE ORQUESTRAS' },
  { value: 46, name: 'ADMINISTRADOR DE PATRIMONIO' },
  { value: 47, name: 'ADMINISTRADOR DE PECUARIA' },
  { value: 48, name: 'ADMINISTRADOR DE PESSOAL' },
  { value: 49, name: 'ADMINISTRADOR DE RESTAURANTE' },
  { value: 50, name: 'ADMINISTRADOR DE VENDAS' },
  { value: 51, name: 'ADMINISTRADOR FLORESTAL' },
  { value: 52, name: 'ADMINISTRADOR HOSPITALAR' },
  { value: 53, name: 'ADMINISTRADOR SEM ESPECIFICACAO' },
  { value: 54, name: 'ADORNISTA (PEDRA)' },
  { value: 55, name: 'ADUBADOR' },
  { value: 56, name: 'ADUELEIRO' },
  { value: 57, name: 'ADVOGADO' },
  { value: 58, name: 'AEROMOCO' },
  { value: 59, name: 'AERONAUTA' },
  { value: 60, name: 'AEROVIARIO SEM ESPECIFICAO' },
  { value: 61, name: 'AFERIDOR DE PRODUTIVIDADE (PETROLEO)' },
  { value: 62, name: 'AFIADOR EM GERAL' },
  { value: 63, name: 'AFINADOR DE INSTRUMENTOS MUSICAIS' },
  { value: 64, name: 'AFINADOR DE MOTORES (VEICULOS)' },
  { value: 65, name: 'AFINADOR SEM ESPECIFICACAO' },
  { value: 66, name: 'AGENCIADOR DE PROPAGANDA' },
  { value: 67, name: 'AGENCIADOR' },
  { value: 68, name: 'AGENTE ADMINISTRATIVO' },
  { value: 69, name: 'AGENTE COMERCIAL' },
  { value: 70, name: 'AGENTE DE AUTOMOVEIS' },
  { value: 71, name: 'AGENTE DE CAMBIO' },
  { value: 72, name: 'AGENTE DE CAMBIO E BOLSA' },
  { value: 73, name: 'AGENTE DE COBRANCA' },
  { value: 74, name: 'AGENTE DE COLETA' },
  { value: 75, name: 'AGENTE DE COLOCACAO' },
  { value: 76, name: 'AGENTE DE COMPRAS' },
  { value: 77, name: 'AGENTE DE CORREIO' },
  { value: 78, name: 'AGENTE DE DEFESA FLORESTAL' },
  { value: 79, name: 'AGENTE DE ESTACAO (FERROVIAS)' },
  { value: 80, name: 'AGENTE DE HIGIENE E SEGURANCA DO TRABALHO' },
  { value: 81, name: 'AGENTE DE INSPECAO DE PESCA' },
  { value: 82, name: 'AGENTE DE INVESTIMENTOS' },
  { value: 83, name: 'AGENTE DE MANOBRAS (FERROVIAS)' },
  { value: 84, name: 'AGENTE DE MARCAS E PATENTES' },
  { value: 85, name: 'AGENTE DE MOVIMENTO (FERROVIAS)' },
  { value: 86, name: 'AGENTE DE PESOS E MEDIDAS' },
  { value: 87, name: 'AGENTE DE POLICIA' },
  { value: 88, name: 'AGENTE DE PUBLICIDADE' },
  { value: 89, name: 'AGENTE DE RELACOES PUBLICAS' },
  { value: 90, name: 'AGENTE DE RESERVAS' },
  { value: 91, name: 'AGENTE DE SAUDE PUBLICA' },
  { value: 92, name: 'AGENTE DE SEGURANCA' },
  { value: 93, name: 'AGENTE DE SEGUROS' },
  { value: 94, name: 'AGENTE DE TREINAMENTO' },
  { value: 95, name: 'AGENTE DE TREM' },
  { value: 96, name: 'AGENTE DE TURISMO' },
  { value: 97, name: 'AGENTE DE TURISMO' },
  { value: 98, name: 'AGENTE DE VENDA DE PUBLICIDADE' },
  { value: 99, name: 'AGENTE DE VENDA DE PUBLICIDADE' },
  { value: 100, name: 'AGENTE DE VIAGEM' },
  { value: 101, name: 'AGENTE ESPECIAL' },
  { value: 102, name: 'AGENTE FISCAL DE AVIACAO CIVIL' },
  { value: 103, name: 'AGENTE FISCAL DE RENDAS' },
  { value: 104, name: 'AGENTE FUNERARIO' },
  { value: 105, name: 'AGENTE IMOBILIARIO' },
  { value: 106, name: 'AGENTE LOTERICO' },
  { value: 107, name: 'AGENTE PASTORAL' },
  { value: 108, name: 'AGENTE POSTAL' },
  { value: 109, name: 'AGENTE PREVIDENCIARIO' },
  { value: 110, name: 'AGENTE PUBLICITARIO' },
  { value: 111, name: 'AGENTE SINDICAL' },
  { value: 112, name: 'AGENTE TECNICO DE VENDAS' },
  { value: 113, name: 'AGENTE TELEGRAFICO' },
  { value: 114, name: 'AGRICULTOR' },
  { value: 115, name: 'AGRIMENSOR' },
  { value: 116, name: 'AGRIMENSOR (SEM CURSO SUPERIOR)' },
  { value: 117, name: 'AGRONOMO (SEM CURSO SUPERIOR)' },
  { value: 118, name: 'AGRONOMO' },
  { value: 119, name: 'AGROPECUARISTA' },
  { value: 120, name: 'AGROTECNICO' },
  { value: 121, name: 'AGUA-FORTISTA' },
  { value: 122, name: 'AGUARDENTEIRO (FABRICACAO)' },
  { value: 123, name: 'AJUDANTE DE ACABAMENTO' },
  { value: 124, name: 'AJUDANTE DE ACIARIA' },
  { value: 125, name: 'AJUDANTE DE ALMOXARIFADO' },
  { value: 126, name: 'AJUDANTE DE ARTIFICE DE OBRAS' },
  { value: 127, name: 'AJUDANTE DE CABELEIREIRO' },
  { value: 128, name: 'AJUDANTE DE CAMINHAO' },
  { value: 129, name: 'AJUDANTE DE CAMPO' },
  { value: 130, name: 'AJUDANTE DE CARREGAMENTO DE FORNOS' },
  { value: 131, name: 'AJUDANTE DE COSTUREIRA' },
  { value: 132, name: 'AJUDANTE DE COZINHA' },
  { value: 133, name: 'AJUDANTE DE DESTILARIA' },
  { value: 134, name: 'AJUDANTE DE ENGARRAFAMENTO' },
  { value: 135, name: 'AJUDANTE DE FIANDEIRA' },
  { value: 136, name: 'AJUDANTE DE FRIGORIFICO' },
  { value: 137, name: 'AJUDANTE DE FUNDICAO' },
  { value: 138, name: 'AJUDANTE DE LAMINACAO SEM ESPECIFICACAO' },
  { value: 139, name: 'AJUDANTE DE MANUSEIO' },
  { value: 140, name: 'AJUDANTE DE MANUTENCAO SEM ESPECIFICACAO' },
  { value: 141, name: 'AJUDANTE DE MAQUINA SEM ESPECIFICACAO' },
  { value: 142, name: 'AJUDANTE DE MAQUINISTA DE TREM' },
  { value: 143, name: 'AJUDANTE DE MECANICO' },
  { value: 144, name: 'AJUDANTE DE MESA' },
  { value: 145, name: 'AJUDANTE DE MINERACAO' },
  { value: 146, name: 'AJUDANTE DE MOTORISTA' },
  { value: 147, name: 'AJUDANTE DE OBRAS' },
  { value: 148, name: 'AJUDANTE DE OLARIA' },
  { value: 149, name: 'AJUDANTE DE PADEIRO' },
  { value: 150, name: 'AJUDANTE DE PEDREIRA' },
  { value: 151, name: 'AJUDANTE DE PRODUCAO' },
  { value: 152, name: 'AJUDANTE DE REFEITORIO' },
  { value: 153, name: 'AJUDANTE DE REFRIGERACAO' },
  { value: 154, name: 'AJUDANTE DE SULFATAGEM' },
  { value: 155, name: 'AJUDANTE DE TECELAGEM' },
  { value: 156, name: 'AJUDANTE DE TORNEIRO' },
  { value: 157, name: 'AJUDANTE DE TREM' },
  { value: 158, name: 'AJUDANTE DE VAQUEIRO' },
  { value: 159, name: 'AJUDANTE GERAL' },
  { value: 160, name: 'AJUDANTE SEM ESPECIFICACAO' },
  { value: 161, name: 'AJULEJISTA' },
  { value: 162, name: 'AJUSTADOR (FORA EXCECOES)' },
  { value: 163, name: 'AJUSTADOR DE APARELHOS ORTOPEDICOS' },
  { value: 164, name: 'AJUSTADOR DE BANCADA' },
  { value: 165, name: 'AJUSTADOR DE EQUIPAMENTO TELEFONICO' },
  { value: 166, name: 'AJUSTADOR DE FERRAMENTARIA' },
  { value: 167, name: 'AJUSTADOR DE INSTRUMENTOS DE PRECISAO' },
  { value: 168, name: 'AJUSTADOR DE MANUTENCAO' },
  { value: 169, name: 'AJUSTADOR DE MODULO DE CANAL' },
  { value: 170, name: 'AJUSTADOR DE RELES' },
  { value: 171, name: 'AJUSTADOR MECANICO' },
  { value: 172, name: 'AJUSTADOR SEM ESPECIFICACAO' },
  { value: 173, name: 'ALAMBIQUEIRO' },
  { value: 174, name: 'ALCEADOR' },
  { value: 175, name: 'ALFAIATE' },
  { value: 176, name: 'ALFANDEGARIO' },
  { value: 177, name: 'ALIMENTADOR DE LINHA' },
  { value: 178, name: 'ALIMENTADOR DE LINHA DE PRODUCAO' },
  { value: 179, name: 'ALIMENTADOR DE PRODUCAO' },
  { value: 180, name: 'ALIMENTADOR DE ROTATIVA' },
  { value: 181, name: 'ALMOXARIFE' },
  { value: 182, name: 'ALVEJADOR DE COUROS' },
  { value: 183, name: 'ALVEJADOR DE TECIDOS' },
  { value: 184, name: 'ALVEJADOR SEM ESPECIFICACAO' },
  { value: 185, name: 'AMA-SECA' },
  { value: 186, name: 'AMACIADOR DE COUROS' },
  { value: 187, name: 'AMACIADOR DE TECIDOS' },
  { value: 188, name: 'AMACIADOR SEM ESPECIFICACAO' },
  { value: 189, name: 'AMANSADOR' },
  { value: 190, name: 'AMARRADOR DE TEIAS' },
  { value: 191, name: 'AMARRADOR SEM ESPECIFICACAO' },
  { value: 192, name: 'AMASSADOR DE BORRACHA' },
  { value: 193, name: 'AMBULANTE' },
  { value: 194, name: 'AMOLADOR EM GERAL' },
  { value: 195, name: 'AMOSTRADOR DE MINERAIS' },
  { value: 196, name: 'AMOSTRADOR DE PRODUTOS' },
  { value: 197, name: 'AMPLIADOR DE FOTOGRAFIAS' },
  { value: 198, name: 'ANALISTA CONTABIL' },
  { value: 199, name: 'ANALISTA DE AGUA' },
  { value: 200, name: 'ANALISTA DE AREIAS' },
  { value: 201, name: 'ANALISTA DE BALANCO' },
  { value: 202, name: 'ANALISTA DE CARGOS E SALARIOS' },
  { value: 203, name: 'ANALISTA DE CARVAO' },
  { value: 204, name: 'ANALISTA DE COMPUTADOR' },
  { value: 205, name: 'ANALISTA DE CONTABILIDADE' },
  { value: 206, name: 'ANALISTA DE CONTROLE DE QUALIDADE' },
  { value: 207, name: 'ANALISTA DE CREDITO E COBRANCA' },
  { value: 208, name: 'ANALISTA DE CUSTOS' },
  { value: 209, name: 'ANALISTA DE DADOS' },
  { value: 210, name: 'ANALISTA DE ESTOQUES' },
  { value: 211, name: 'ANALISTA DE ESTUDOS DE MERCADO' },
  { value: 212, name: 'ANALISTA DE FIOS (TEXTIL)' },
  { value: 213, name: 'ANALISTA DE FORMULARIOS' },
  { value: 214, name: 'ANALISTA DE IMPORTACAO E EXPORTACAO' },
  { value: 215, name: 'ANALISTA DE MARCAS E PATENTE' },
  { value: 216, name: 'ANALISTA DE MERCADO DE PRODUTOS' },
  { value: 217, name: 'ANALISTA DE METODOS' },
  { value: 218, name: 'ANALISTA DE OCUPACOES' },
  { value: 219, name: 'ANALISTA DE OLEOS E GRAXAS' },
  { value: 220, name: 'ANALISTA DE OPERACOES' },
  { value: 221, name: 'ANALISTA DE ORCAMENTO' },
  { value: 222, name: 'ANALISTA DE ORGANIZACAO E METODOS' },
  { value: 223, name: 'ANALISTA DE OXIGENIO' },
  { value: 224, name: 'ANALISTA DE PESQUISAS DE MERCADO' },
  { value: 225, name: 'ANALISTA DE PESSOAL' },
  { value: 226, name: 'ANALISTA DE PROCESSOS' },
  { value: 227, name: 'ANALISTA DE QUALIDADE' },
  { value: 228, name: 'ANALISTA DE SISTEMAS' },
  { value: 229, name: 'ANALISTA DE SISTEMAS E METODOS' },
  { value: 230, name: 'ANALISTA DE SOM' },
  { value: 231, name: 'ANALISTA DE SUPRIMENTOS' },
  { value: 232, name: 'ANALISTA DE TARIFAS' },
  { value: 233, name: 'ANALISTA DE TEMPOS' },
  { value: 234, name: 'ANALISTA ECONOMICO-FINANCEIRO' },
  { value: 235, name: 'ANALISTA FINANCEIRO E CONTABIL' },
  { value: 236, name: 'ANALISTA METALOGRAFICO' },
  { value: 237, name: 'ANALISTA QUIMICO (SEM CURSO SUPERIOR)' },
  { value: 238, name: 'ANALISTA SEM ESPECIFICACAO' },
  { value: 239, name: 'ANATOMISTA' },
  { value: 240, name: 'ANIMADOR DE VENDAS' },
  { value: 241, name: 'ANODIZADOR' },
  { value: 242, name: 'ANOTADOR DE PRODUCAO' },
  { value: 243, name: 'ANOTADOR SEM ESPECIFICACAO' },
  { value: 244, name: 'ANTIQUARIO' },
  { value: 245, name: 'ANTROPOLOGO' },
  { value: 246, name: 'APANHADOR DE ALGODAO' },
  { value: 247, name: 'APANHADOR DE CAFE' },
  { value: 248, name: 'APARELHADOR EM GERAL' },
  { value: 249, name: 'APLICADOR DE INJECOES' },
  { value: 250, name: 'APLICADOR SEM ESPECIFICACAO' },
  { value: 251, name: 'APLICADOR SINTETICO' },
  { value: 252, name: 'APONTADOR DE CAMPO' },
  { value: 253, name: 'APONTADOR DE CARTOES DE PONTO' },
  { value: 254, name: 'APONTADOR DE MAO-DE-OBRA' },
  { value: 255, name: 'APONTADOR DE MAO-DE-OBRA' },
  { value: 256, name: 'APONTADOR DE PESSOAL' },
  { value: 257, name: 'APONTADOR DE PRODUCAO' },
  { value: 258, name: 'APONTADOR SEM ESPECIFICACAO' },
  { value: 259, name: 'APOSENTADO' },
  { value: 260, name: 'APRENDIZ SEM ESPECIFICACAO' },
  { value: 261, name: 'APRESENTADOR DE ESPETACULOS' },
  { value: 262, name: 'APROPRIADOR DE CUSTOS' },
  { value: 263, name: 'APROPRIADOR DE MAO-DE-OBRA' },
  { value: 264, name: 'APROVADOR DE CREDITO' },
  { value: 265, name: 'APURADOR DE CUSTOS' },
  { value: 266, name: 'AQUECEDOR DE REBITES' },
  { value: 267, name: 'ARBITRO DESPORTIVO' },
  { value: 268, name: 'ARGAMASSADOR' },
  { value: 269, name: 'ARMADOR DE CALCADOS' },
  { value: 270, name: 'ARMADOR DE CONCRETO' },
  { value: 271, name: 'ARMADOR DE ESTRUTURAS' },
  { value: 272, name: 'ARMADOR DE FERROS' },
  { value: 273, name: 'ARMADOR DE MALAS' },
  { value: 274, name: 'ARMADOR DE MANILHAS' },
  { value: 275, name: 'ARMADOR DE MOVEIS' },
  { value: 276, name: 'ARMADOR DE ROLO' },
  { value: 277, name: 'ARMADOR' },
  { value: 278, name: 'ARMADOR-SERRALHEIRO' },
  { value: 279, name: 'ARMAZENISTA' },
  { value: 280, name: 'ARMEIRO' },
  { value: 281, name: 'ARPOADOR' },
  { value: 282, name: 'ARQUEOLOGO' },
  { value: 283, name: 'ARQUITETO' },
  { value: 284, name: 'ARQUIVISTA' },
  { value: 285, name: 'ARQUIVOLOGISTA' },
  { value: 286, name: 'ARRAIS DE PESCA' },
  { value: 287, name: 'ARRASTADOR DE ARVORES' },
  { value: 288, name: 'ARRECADADOR' },
  { value: 289, name: 'ARREMATADOR (CONFECCOES)' },
  { value: 290, name: 'ARRENDATARIO' },
  { value: 291, name: 'ARRIADOR DE FIANDEIRA' },
  { value: 292, name: 'ARROLHADOR' },
  { value: 293, name: 'ARRUMADEIRA' },
  { value: 294, name: 'ARRUMADOR (COMERCIO)' },
  { value: 295, name: 'ARTE CULINARIA (2o.GRAU)' },
  { value: 296, name: 'ARTE CULINARIA (FUNDAMENTAL)' },
  { value: 297, name: 'ARTE-FINALISTA' },
  { value: 298, name: 'ARTESAO' },
  { value: 299, name: 'ARTIFICE DE COURO' },
  { value: 300, name: 'ARTIFICE SEM ESPECIFICACAO' },
  { value: 301, name: 'ARTILHEIRO DE CETACEOS' },
  { value: 302, name: 'ARTISTA PLASTICO' },
  { value: 303, name: 'ARTISTA SEM ESPECIFICACAO' },
  { value: 304, name: 'ASCENSORISTA' },
  { value: 305, name: 'ASSENTADOR DE CANALIZACAO' },
  { value: 306, name: 'ASSESSOR' },
  { value: 307, name: 'ASSINALADOR (PECUARIA)' },
  { value: 308, name: 'ASSISTENTE ADMINISTRATIVO (SERVICO PUBLICO)' },
  { value: 309, name: 'ASSISTENTE COMERCIAL' },
  { value: 310, name: 'ASSISTENTE CONTABIL' },
  { value: 311, name: 'ASSISTENTE CONTABIL (SEM CURSO SUPERIOR)' },
  { value: 312, name: 'ASSISTENTE CONTROLE ECON.(S/CURSO SUPERIOR)' },
  { value: 313, name: 'ASSISTENTE DE ARTE SEM ESPECIFICACAO' },
  { value: 314, name: 'ASSISTENTE DE BANHOS' },
  { value: 315, name: 'ASSISTENTE DE COBRANCA' },
  { value: 316, name: 'ASSISTENTE DE COMPRAS' },
  { value: 317, name: 'ASSISTENTE DE CONTAB. (SEM CURSO SUPERIOR)' },
  { value: 318, name: 'ASSISTENTE DE DIRECAO' },
  { value: 319, name: 'ASSISTENTE DE ENSINO' },
  { value: 320, name: 'ASSISTENTE DE FINANCEIRA' },
  { value: 321, name: 'ASSISTENTE DE IMPORTACAO' },
  { value: 322, name: 'ASSISTENTE DE MATERIAL' },
  { value: 323, name: 'ASSISTENTE DE PLANEJAMENTO' },
  { value: 324, name: 'ASSISTENTE DE PRODUCAO (1o.GRAU)' },
  { value: 325, name: 'ASSISTENTE DE PROPAGANDA' },
  { value: 326, name: 'ASSISTENTE DE TERMAS' },
  { value: 327, name: 'ASSISTENTE DE VENDAS' },
  { value: 328, name: 'ASSISTENTE JURIDICO' },
  { value: 329, name: 'ASSISTENTE ESCOLAR' },
  { value: 330, name: 'ASSISTENTE FINANCEIRO' },
  { value: 331, name: 'ASSISTENTE FINANCEIRO (SEM 2o. GRAU)' },
  { value: 332, name: 'ASSISTENTE JURIDICO (CURSO SUPERIOR)' },
  { value: 333, name: 'ASSISTENTE JURIDICO (SEM CURSO SUPERIOR)' },
  { value: 334, name: 'ASSISTENTE SEM ESPECIFICACAO' },
  { value: 335, name: 'ASSISTENTE SOCIAL' },
  { value: 336, name: 'ASSISTENTE TECNICO' },
  { value: 337, name: 'ASSOALHADOR' },
  { value: 338, name: 'ASTROFISICO' },
  { value: 339, name: 'ASTROLOGO' },
  { value: 340, name: 'ASTRONOMO' },
  { value: 341, name: 'ATENDENTE COMERCIAL' },
  { value: 342, name: 'ATENDENTE DE AMBULATORIO' },
  { value: 343, name: 'ATENDENTE DE BANCO DE SANGUE' },
  { value: 344, name: 'ATENDENTE DE CONSULTORIO' },
  { value: 345, name: 'ATENDENTE DE DENTISTA' },
  { value: 346, name: 'ATENDENTE DE DENTISTA' },
  { value: 347, name: 'ATENDENTE DE GUICHE POSTAL' },
  { value: 348, name: 'ATENDENTE DE LANCHONETE' },
  { value: 349, name: 'ATENDENTE DE MEDICO' },
  { value: 350, name: 'ATENDENTE DE PORTARIA' },
  { value: 351, name: 'ATENDENTE DE POSTO DE GASOLINA' },
  { value: 352, name: 'ATENDENTE HOSPITALAR' },
  { value: 353, name: 'ATENDENTE ODONTOLOGICO' },
  { value: 354, name: 'ATENDENTE SEM ESPECIFICACAO' },
  { value: 355, name: 'ATENDENTE SOCIAL' },
  { value: 356, name: 'ATENDENTE VETERINARIO' },
  { value: 357, name: 'ATLETA PROFISSIONAL' },
  { value: 358, name: 'ATOR' },
  { value: 359, name: 'ATUARIO' },
  { value: 360, name: 'AUDIO (FUNDAMENTAL)' },
  { value: 361, name: 'AUDITOR' },
  { value: 362, name: 'AUTONOMO' },
  { value: 363, name: 'AUX. DE TEC. DE PECUARIA (SEM CURSO SUPERIOR)' },
  { value: 364, name: 'AUX. TECNICO DE AGRICULTURA(S/CURSO SUPERIOR)' },
  { value: 365, name: 'AUX. TECNICO DE AGRIMENSURA(S/CURSO SUPERIOR)' },
  { value: 366, name: 'AUXILIAR ADMINISTRATIVO' },
  { value: 367, name: 'AUXILIAR DE ABATE' },
  { value: 368, name: 'AUXILIAR DE ACABAMENTO' },
  { value: 369, name: 'AUXILIAR DE ADVOGADO' },
  { value: 370, name: 'AUXILIAR DE AGENCIA SEM ESPECIFICACAO' },
  { value: 371, name: 'AUXILIAR DE ALMOXARIFADO' },
  { value: 372, name: 'AUXILIAR DE AMBULATORIO' },
  { value: 373, name: 'AUXILIAR DE AMNUTENCAO SEM ESPECIFICACAO' },
  { value: 374, name: 'AUXILIAR DE ARMAZEM' },
  { value: 375, name: 'AUXILIAR DE ARQUITETO (SEM CURSO SUPERIOR)' },
  { value: 376, name: 'AUXILIAR DE ARQUIVO' },
  { value: 377, name: 'AUXILIAR DE ASSESSORIA' },
  { value: 378, name: 'AUXILIAR DE BANCO DE SANGUE' },
  { value: 379, name: 'AUXILIAR DE BIBLIOTECA' },
  { value: 380, name: 'AUXILIAR DE CAMPO' },
  { value: 381, name: 'AUXILIAR DE CARTORIO' },
  { value: 382, name: 'AUXILIAR DE COBRANCA' },
  { value: 383, name: 'AUXILIAR DE COMPRAS' },
  { value: 384, name: 'AUXILIAR DE CONTABILIDADE' },
  { value: 385, name: 'AUXILIAR DE CONTAS A PAGAR' },
  { value: 386, name: 'AUXILIAR DE CONTAS CORRENTES' },
  { value: 387, name: 'AUXILIAR DE CONTROLE DE QUALIDADE' },
  { value: 388, name: 'AUXILIAR DE CONTROLE SEM ESPECIFICACAO' },
  { value: 389, name: 'AUXILIAR DE COPA' },
  { value: 390, name: 'AUXILIAR DE CORTE SEM ESPECIFICACAO' },
  { value: 391, name: 'AUXILIAR DE COZINHA' },
  { value: 392, name: 'AUXILIAR DE CRECHE' },
  { value: 393, name: 'AUXILIAR DE CREDITO E COBRANCA' },
  { value: 394, name: 'AUXILIAR DE CUSTOS' },
  { value: 395, name: 'AUXILIAR DE CUSTOS E ORCAMENTOS' },
  { value: 396, name: 'AUXILIAR DE DENTISTA' },
  { value: 397, name: 'AUXILIAR DE DEPARTAMENTO DE ESPORTES' },
  { value: 398, name: 'AUXILIAR DE DEPARTAMENTO DE PESSOAL' },
  { value: 399, name: 'AUXILIAR DE DEPOSITO' },
  { value: 400, name: 'AUXILIAR DE DESPENSA' },
  { value: 401, name: 'AUXILIAR DE DOCUMENTACAO' },
  { value: 402, name: 'AUXILIAR DE ELETRONICA' },
  { value: 403, name: 'AUXILIAR DE EMBALAGEM' },
  { value: 404, name: 'AUXILIAR DE EMBARQUE' },
  { value: 405, name: 'AUXILIAR DE ENCADERNAGEM' },
  { value: 406, name: 'AUXILIAR DE ENCAIXOTADOR' },
  { value: 407, name: 'AUXILIAR DE ENFERMAGEM' },
  { value: 408, name: 'AUXILIAR DE ENGENHARIA(SEM CURSO SUPERIOR)' },
  { value: 409, name: 'AUXILIAR DE ENSINO' },
  { value: 410, name: 'AUXILIAR DE ESCRITA' },
  { value: 411, name: 'AUXILIAR DE ESCRITA FISCAL' },
  { value: 412, name: 'AUXILIAR DE ESCRITORIO (SERVICO PUBLICO)' },
  { value: 413, name: 'AUXILIAR DE ESTATISTICA' },
  { value: 414, name: 'AUXILIAR DE ESTOQUE' },
  { value: 415, name: 'AUXILIAR DE EXECUTIVO' },
  { value: 416, name: 'AUXILIAR DE EXPEDICAO E RECEPCAO' },
  { value: 417, name: 'AUXILIAR DE FABRICACAO' },
  { value: 418, name: 'AUXILIAR DE FARMACIA' },
  { value: 419, name: 'AUXILIAR DE FATURAMENTO' },
  { value: 420, name: 'AUXILIAR DE FIACAO' },
  { value: 421, name: 'AUXILIAR DE FILMAGEM' },
  { value: 422, name: 'AUXILIAR DE FISIOTERAPIA' },
  { value: 423, name: 'AUXILIAR DE FORNO (SEGUNDA FUSAO)' },
  { value: 424, name: 'AUXILIAR DE GARCON' },
  { value: 425, name: 'AUXILIAR DE GERENTE' },
  { value: 426, name: 'AUXILIAR DE HIPODERMIA' },
  { value: 427, name: 'AUXILIAR DE ILUMINACAO' },
  { value: 428, name: 'AUXILIAR DE IMPORTACAO/EXPORTACAO' },
  { value: 429, name: 'AUXILIAR DE IMPRENSA(SEM CURSO SUPERIOR)' },
  { value: 430, name: 'AUXILIAR DE INFORMACAO' },
  { value: 431, name: 'AUXILIAR DE INSPECAO' },
  { value: 432, name: 'AUXILIAR DE JUSTICA' },
  { value: 433, name: 'AUXILIAR DE LABORATORIO' },
  { value: 434, name: 'AUXILIAR DE LIMPEZA' },
  { value: 435, name: 'AUXILIAR DE MANOBRAS (FERROVIAS)' },
  { value: 436, name: 'AUXILIAR DE MANUTENCAO (EDIFICIO)' },
  { value: 437, name: 'AUXILIAR DE MANUTENCAO (INDUSTRIA)' },
  { value: 438, name: 'AUXILIAR DE MAQUINISTA (FERROVIAS)' },
  { value: 439, name: 'AUXILIAR DE MECANICO SEM ESPECIFICACAO' },
  { value: 440, name: 'AUXILIAR DE MECANIZACAO' },
  { value: 441, name: 'AUXILIAR DE MEDICAO (SEM CURSO SUPERIOR)' },
  { value: 442, name: 'AUXILIAR DE MEDICINA' },
  { value: 443, name: 'AUXILIAR DE MICROFILMAGEM' },
  { value: 444, name: 'AUXILIAR DE MONTAGEM' },
  { value: 445, name: 'AUXILIAR DE MOTORISTA DE PESCA' },
  { value: 446, name: 'AUXILIAR DE NUTRICAO' },
  { value: 447, name: 'AUXILIAR DE ODONTOLOGIA' },
  { value: 448, name: 'AUXILIAR DE ONCOLOGIA' },
  { value: 449, name: 'AUXILIAR DE ORCAMENTO' },
  { value: 450, name: 'AUXILIAR DE PESQUISA (SEM CURSO SUPERIOR)' },
  { value: 451, name: 'AUXILIAR DE PESQUISA(CURSO SUP.OU SEG.GRAU)' },
  { value: 452, name: 'AUXILIAR DE PESSOAL' },
  { value: 453, name: 'AUXILIAR DE PLANEJAMENTO' },
  { value: 454, name: 'AUXILIAR DE PLASTIFICADOR' },
  { value: 455, name: 'AUXILIAR DE PORTARIA' },
  { value: 456, name: 'AUXILIAR DE PRODUCAO' },
  { value: 457, name: 'AUXILIAR DE PROTESE' },
  { value: 458, name: 'AUXILIAR DE RECEBIMENTO' },
  { value: 459, name: 'AUXILIAR DE REFRIGERACAO' },
  { value: 460, name: 'AUXILIAR DE REGISTRO (INDUSTRIA)' },
  { value: 461, name: 'AUXILIAR DE RELACOES HUMANAS' },
  { value: 462, name: 'AUXILIAR DE SEGURANCA' },
  { value: 463, name: 'AUXILIAR DE SEGUROS' },
  { value: 464, name: 'AUXILIAR DE SELECAO' },
  { value: 465, name: 'AUXILIAR DE SERVICO JURIDICO' },
  { value: 466, name: 'AUXILIAR DE SERVICO MEDICO' },
  { value: 467, name: 'AUXILIAR DE SERVICO POSTAL' },
  { value: 468, name: 'AUXILIAR DE SERVICO SOCIAL' },
  { value: 469, name: 'AUXILIAR DE SONDAGEM (EXCETO DE PETROLEO)' },
  { value: 470, name: 'AUXILIAR DE SUPERVISAO SEM ESPECIFICACAO' },
  { value: 471, name: 'AUXILIAR DE SUPRIMENTOS' },
  { value: 472, name: 'AUXILIAR DE TERAPIA OCUPACIONAL' },
  { value: 473, name: 'AUXILIAR DE TESOURARIA' },
  { value: 474, name: 'AUXILIAR DE TIROTEX' },
  { value: 475, name: 'AUXILIAR DE TOPOGRAFO (SEM CURSO SUPERIOR)' },
  { value: 476, name: 'AUXILIAR DE TRAFEGO' },
  { value: 477, name: 'AUXILIAR DE USINAGEM' },
  { value: 478, name: 'AUXILIAR DE VENDAS' },
  { value: 479, name: 'AUXILIAR DE VETERINARIA' },
  { value: 480, name: 'AUXILIAR FINANCEIRO' },
  { value: 481, name: 'AUXILIAR FISCAL' },
  { value: 482, name: 'AUXILIAR GERAL' },
  { value: 483, name: 'AUXILIAR GRAFICO' },
  { value: 484, name: 'AUXILIAR HOSPITALAR' },
  { value: 485, name: 'AUXILIAR INDUSTRIAL' },
  { value: 486, name: 'AUXILIAR QUIMICO' },
  { value: 487, name: 'AUXILIAR SEM ESPECIFICACAO' },
  { value: 488, name: 'AUXILIAR SEM ESPECIFICACAO (SEM 2o.GRAU)' },
  { value: 489, name: 'AUXILIAR SOCIAL' },
  { value: 490, name: 'AUXILIAR TECNICO DE SINISTROS' },
  { value: 491, name: 'AUXILIAR TECNICO' },
  { value: 492, name: 'AVALIADOR EM GERAL' },
  { value: 493, name: 'AVICULTOR' },
  { value: 494, name: 'AZULEJADOR' },
  { value: 495, name: 'BABA' },
  { value: 496, name: 'BACHAREL EM LETRAS' },
  { value: 497, name: 'TURISMOLOGO' },
  { value: 498, name: 'BACTERIOLOGISTA' },
  { value: 499, name: 'BAGACEIRO DE SISAL' },
  { value: 500, name: 'BAGAGEIRO' },
  { value: 501, name: 'BAILARINO' },
  { value: 502, name: 'BALANCEADOR (AFERICAO DE BALANCAS)' },
  { value: 503, name: 'BALANCEIRO' },
  { value: 504, name: 'BALANCISTA (AFERICAO DE BALANCAS)' },
  { value: 505, name: 'BALATEIRO' },
  { value: 506, name: 'BALCONISTA (FORA EXCECOES)' },
  { value: 507, name: 'BALCONISTA DE AGENCIA POSTAL' },
  { value: 508, name: 'BALCONISTA DE LANCHONETE' },
  { value: 509, name: 'BALCONISTA' },
  { value: 510, name: 'BAMBURISTA' },
  { value: 511, name: 'BANCARIO' },
  { value: 512, name: 'BANDEIRINHA' },
  { value: 513, name: 'BANHISTA' },
  { value: 514, name: 'BARBAQUASEIRO (ERVA-MATE)' },
  { value: 515, name: 'BARBEIRO' },
  { value: 516, name: 'BARCACEIRO DE CACAU' },
  { value: 517, name: 'BARMAN' },
  { value: 518, name: 'BARQUEIRO' },
  { value: 519, name: 'BARRAQUEIRO (COMERCIO)' },
  { value: 520, name: 'BATE-FOLHA' },
  { value: 521, name: 'BATEDOR DE COLA' },
  { value: 522, name: 'BATEDOR DE PANO' },
  { value: 523, name: 'BATERISTA (MUSICO)' },
  { value: 524, name: 'BATERISTA DE ACETILENO' },
  { value: 525, name: 'BATIDORISTA (FIBRAS)' },
  { value: 526, name: 'BEDEL' },
  { value: 527, name: 'BENEFICIADOR' },
  { value: 528, name: 'BENEFICIARIO' },
  { value: 529, name: 'BERCARISTA' },
  { value: 530, name: 'BETONEIRISTA' },
  { value: 531, name: 'BETONEIRO' },
  { value: 532, name: 'BETUMADOR' },
  { value: 533, name: 'BIBLIOGRAFO' },
  { value: 534, name: 'BIBLIOTECARIO' },
  { value: 535, name: 'BILHETEIRO DE LOTERIA (AMBULANTE)' },
  { value: 536, name: 'BILHETEIRO EM GERAL' },
  { value: 537, name: 'BINADOR' },
  { value: 538, name: 'BIOFISICO' },
  { value: 539, name: 'BIOLOGISTA' },
  { value: 540, name: 'BIOLOGO' },
  { value: 541, name: 'BIOMEDICO' },
  { value: 542, name: 'BIOQUIMICO' },
  { value: 543, name: 'BISCATEIRO (COMERCIO)' },
  { value: 544, name: 'BISCATEIRO (SERVICOS)' },
  { value: 545, name: 'BISCATEIRO SEM ESPECIFICACAO' },
  { value: 546, name: 'BISCOITEIRO' },
  { value: 547, name: 'BISELADOR DE CRISTAIS' },
  { value: 548, name: 'BLASTER' },
  { value: 549, name: 'BLOCADOR' },
  { value: 550, name: 'BLOQUISTA' },
  { value: 551, name: 'BOBINADOR (INDUSTRIA TEXTIL)' },
  { value: 552, name: 'BOBINADOR DE FIOS' },
  { value: 553, name: 'BOBINADOR ELETRICISTA' },
  { value: 554, name: 'BOBINADOR SEM ESPECIFICACAO' },
  { value: 555, name: 'BOBINEIRO (PAPEL)' },
  { value: 556, name: 'BOBVINADOR DE PAPEL' },
  { value: 557, name: 'BOIADEIRO' },
  { value: 558, name: 'BOLACHEIRO' },
  { value: 559, name: 'BOLADOR' },
  { value: 560, name: 'BOLEIRO (COURO)' },
  { value: 561, name: 'BOLSEIRO' },
  { value: 562, name: 'BOMBEADOR (REFINO DE PETROLEO)' },
  { value: 563, name: 'BOMBEIRO (FORA EXCECAO)' },
  { value: 564, name: 'BOMBEIRO HIDRAULICO' },
  { value: 565, name: 'BOMBEIRO' },
  { value: 566, name: 'BOMBISTA' },
  { value: 567, name: 'BOMBONEIRO' },
  { value: 568, name: 'BORDADEIRA' },
  { value: 569, name: 'BORDADOR' },
  { value: 570, name: 'BORRACHEIRO' },
  { value: 571, name: 'BOTANICO' },
  { value: 572, name: 'BOXEADOR' },
  { value: 573, name: 'BOY' },
  { value: 574, name: 'BRANQUEADOR DE PASTA PARA PAPEL' },
  { value: 575, name: 'BRANQUEADOR DE PRODUTOS QUIMICOS' },
  { value: 576, name: 'BRANQUEADOR DE TECIDOS' },
  { value: 577, name: 'BREQUISTA' },
  { value: 578, name: 'BRITADOR (MINAS E PEDREIRAS)' },
  { value: 579, name: 'BRITADOR MANUAL' },
  { value: 580, name: 'BRITADOR SEM ESPECIFICACAO' },
  { value: 581, name: 'BROCHADOR' },
  { value: 582, name: 'BROCHURISTA' },
  { value: 583, name: 'BRONZEADOR DE METAIS' },
  { value: 584, name: 'BRONZEADOR SEM ESPECIFICACAO' },
  { value: 585, name: 'BROQUEADOR DE CILINDROS' },
  { value: 586, name: 'BRUNIDOR DE CILINDROS' },
  { value: 587, name: 'BRUNIDOR DE METAIS' },
  { value: 588, name: 'BSLSNCEADOR DE VEICULOS' },
  { value: 589, name: 'BUCHEIRO' },
  { value: 590, name: 'BUTEIRO' },
  { value: 591, name: 'CABECEIRO' },
  { value: 592, name: 'CABELEIREIRO' },
  { value: 593, name: 'CABINEIRO (FERROVIAS)' },
  { value: 594, name: 'CABINEIRO (SERVICOS)' },
  { value: 595, name: 'CABISTA' },
  { value: 596, name: 'CABO DE CAMPO (AGRICULTURA)' },
  { value: 597, name: 'CABO DE FOGO' },
  { value: 598, name: 'CABO DE TURMA (AGRICULTURA)' },
  { value: 599, name: 'CACADOR' },
  { value: 600, name: 'CACAMBEIRO (METAIS)' },
  { value: 601, name: 'CACHIMBEIRO' },
  { value: 602, name: 'CADASTRADOR DE PESSOAL' },
  { value: 603, name: 'CADASTRADOR SEM ESPECIFICACAO' },
  { value: 604, name: 'CADASTRISTA DE PESSOAL' },
  { value: 605, name: 'CAFETEIRO' },
  { value: 606, name: 'CAIADOR' },
  { value: 607, name: 'CAIXA' },
  { value: 608, name: 'CAIXEIRO' },
  { value: 609, name: 'CAIXEIRO-VIAJANTE' },
  { value: 610, name: 'CAIXOTEIRO' },
  { value: 611, name: 'CALAFETADOR' },
  { value: 612, name: 'CALANDRADOR DE PAPEL' },
  { value: 613, name: 'CALANDRADOR DE TECIDO' },
  { value: 614, name: 'CALANDREIRO DE BORRACHA' },
  { value: 615, name: 'CALANDRISTA DE BORRACHA' },
  { value: 616, name: 'CALANDRISTA DE LAVANDERIA' },
  { value: 617, name: 'CALANDRISTA DE PAPEL' },
  { value: 618, name: 'CALANDRISTA DE TECIDO' },
  { value: 619, name: 'CALANDRISTA SEM ESPECIFICACAO' },
  { value: 620, name: 'CALCADOR SEM ESPECIFICACAO' },
  { value: 621, name: 'CALCEIRO' },
  { value: 622, name: 'CALCETEIRO' },
  { value: 623, name: 'CALCULISTA DE CUSTOS' },
  { value: 624, name: 'CALCULISTA EM GERAL' },
  { value: 625, name: 'CALDEIREIRO' },
  { value: 626, name: 'CALDEIREIRO-MONTADOR' },
  { value: 627, name: 'CALDEIRISTA' },
  { value: 628, name: 'CALIBRADOR (DE MEDIDORES)' },
  { value: 629, name: 'CALISTA' },
  { value: 630, name: 'CAMARADA (PECUARIA)' },
  { value: 631, name: 'CAMAREIRO' },
  { value: 632, name: 'CAMARISTA' },
  { value: 633, name: 'CAMBISTA (FUNDAMENTAL)' },
  { value: 634, name: 'CAMBISTA (SEGUNDO GRAU)' },
  { value: 635, name: 'CAMBITEIRO DE CANA-DE-ACUCAR' },
  { value: 636, name: 'CAMBUZEIRO' },
  { value: 637, name: 'CAMELO' },
  { value: 638, name: 'CAMERAMAN' },
  { value: 639, name: 'CAMISEIRO' },
  { value: 640, name: 'CAMPEIRO' },
  { value: 641, name: 'CANALEIRO' },
  { value: 642, name: 'CANAVIEIRO' },
  { value: 643, name: 'CANCHEADOR (ERVA-MATE)' },
  { value: 644, name: 'CANELEIRO' },
  { value: 645, name: 'CANTEIRO EM GERAL' },
  { value: 646, name: 'CANTINEIRO' },
  { value: 647, name: 'CANTONEIRO' },
  { value: 648, name: 'CANTOR' },
  { value: 649, name: 'CAPATAZ EM GERAL' },
  { value: 650, name: 'CAPELAO' },
  { value: 651, name: 'CAPITAO DE MINAS' },
  { value: 652, name: 'CAPITAO DE PESCA' },
  { value: 653, name: 'CAPOTEIRO' },
  { value: 654, name: 'CARAMELISTA' },
  { value: 655, name: 'CARAPINA' },
  { value: 656, name: 'CARBONIZADOR DE LA' },
  { value: 657, name: 'CARCEREIRO' },
  { value: 658, name: 'CARDADOR' },
  { value: 659, name: 'CARDEXISTA' },
  { value: 660, name: 'CARDISTA' },
  { value: 661, name: 'CARGUEIRO' },
  { value: 662, name: 'CARICATURISTA' },
  { value: 663, name: 'CARIMBADOR' },
  { value: 664, name: 'CARPIDOR SEM ESPECIFICACAO' },
  { value: 665, name: 'CARPINTEIRO (FORA EXCECAO)' },
  { value: 666, name: 'CARPINTEIRO DE ASSOALHOS' },
  { value: 667, name: 'CARPINTEIRO SEM ESPECIFICACAO' },
  { value: 668, name: 'CARRANQUEIRO' },
  { value: 669, name: 'CARREGADOR (FORA EXCECOES)' },
  { value: 670, name: 'CARREGADOR DE ALTO FORNO' },
  { value: 671, name: 'CARREGADOR DE FORNO ( PRIMEIRA FUSAO )' },
  { value: 672, name: 'CARREGADOR DE FORNO ( SEGUNDA  FUSAO )' },
  { value: 673, name: 'CARREGADOR DE FORNO (CERAMICA)' },
  { value: 674, name: 'CARREGADOR DE GARRAFA' },
  { value: 675, name: 'CARREGADOR DE PAPEL' },
  { value: 676, name: 'CARREGADOR SEM ESPECIFICACAO' },
  { value: 677, name: 'CARRETEIRO' },
  { value: 678, name: 'CARRETEIRO (FIOS)' },
  { value: 679, name: 'CARROCEIRO' },
  { value: 680, name: 'CARTAZISTA' },
  { value: 681, name: 'CARTEIRO' },
  { value: 682, name: 'CARTONADOR' },
  { value: 683, name: 'CARTONAGEIRO' },
  { value: 684, name: 'CARTONISTA' },
  { value: 685, name: 'CARTORARIO' },
  { value: 686, name: 'CARVOEIRO' },
  { value: 687, name: 'CARVOEJADOR' },
  { value: 688, name: 'CASEADOR' },
  { value: 689, name: 'CASEIRO' },
  { value: 690, name: 'CASQUEIRO (MADEIRA)' },
  { value: 691, name: 'CASTRADOR' },
  { value: 692, name: 'CATADOR DE BOLA (ESPORTE)' },
  { value: 693, name: 'CATAZEIRO' },
  { value: 694, name: 'CAVALARICO' },
  { value: 695, name: 'CAVALEIRO (PECUARIA)' },
  { value: 696, name: 'CAVOCADOR' },
  { value: 697, name: 'CAVOUQUEIRO' },
  { value: 698, name: 'CEIFADOR DE ARROZ' },
  { value: 699, name: 'CEMENTADOR DE METAIS' },
  { value: 700, name: 'CENOGRAFO' },
  { value: 701, name: 'CENOTECNICO' },
  { value: 702, name: 'CERAMISTA (CONSTRUCAO)' },
  { value: 703, name: 'CERAMISTA (FORA EXCECOES)' },
  { value: 704, name: 'CERAMISTA (TAMIZADOR DE TERRAS)' },
  { value: 705, name: 'CERAMISTA FILETEIRO' },
  { value: 706, name: 'CERAMISTA SEM ESPECIFICACAO' },
  { value: 707, name: 'CERVEJEIRO' },
  { value: 708, name: 'CERZIDOR' },
  { value: 709, name: 'CESTEIRO' },
  { value: 710, name: 'CEVADOR (PECUARIA)' },
  { value: 711, name: 'CHACAREIRO' },
  { value: 712, name: 'CHAMUSCADOR DE LA' },
  { value: 713, name: 'CHANFRADOR (MADEIRA)' },
  { value: 714, name: 'CHAPA DE CAMINHAO' },
  { value: 715, name: 'CHAPEADOR (FORA EXCECAO)' },
  { value: 716, name: 'CHAPEADOR DE MOVEIS' },
  { value: 717, name: 'CHAPEADOR SEM ESPECIFICACAO' },
  { value: 718, name: 'CHAPEIRO' },
  { value: 719, name: 'CHAPELEIRO (CHAPEUS DE PALHA)' },
  { value: 720, name: 'CHAPELEIRO DE SENHORAS' },
  { value: 721, name: 'CHAPELEIRO SEM ESPECIFICACAO' },
  { value: 722, name: 'CHAPISTA (TIPOGRAFICO)' },
  { value: 723, name: 'CHAPISTA DE VEICULOS' },
  { value: 724, name: 'CHARGISTA' },
  { value: 725, name: 'CHARQUEADOR' },
  { value: 726, name: 'CHARRETEIRO' },
  { value: 727, name: 'CHARUTEIRO' },
  { value: 728, name: 'CHAVEIRO' },
  { value: 729, name: 'CHEFE DE AGENCIA DE CORREIO' },
  { value: 730, name: 'CHEFE DE ALMOXARIFADO' },
  { value: 731, name: 'CHEFE DE COBRANCA' },
  { value: 732, name: 'CHEFE DE COMPRAS' },
  { value: 733, name: 'CHEFE DE CONTROLE DE PATRIMONIO' },
  { value: 734, name: 'CHEFE DE DESPENSA' },
  { value: 735, name: 'CHEFE DE DIQUE OU VARADOURO' },
  { value: 736, name: 'CHEFE DE ESCRITORIO (CAMBIO)' },
  { value: 737, name: 'CHEFE DE ESCRITORIO (CONTABILIDADE)' },
  { value: 738, name: 'CHEFE DE ESCRITORIO (CREDITO E COBRANCA)' },
  { value: 739, name: 'CHEFE DE ESCRITORIO (CUSTOS)' },
  { value: 740, name: 'CHEFE DE ESCRITORIO (DE PESSOAL)' },
  { value: 741, name: 'CHEFE DE ESCRITORIO (EMBALAGEM E EXPEDICAO)' },
  { value: 742, name: 'CHEFE DE ESCRITORIO (HIG.E SEG.DO TRABALHO)' },
  { value: 743, name: 'CHEFE DE ESCRITORIO (MATERIAL)' },
  { value: 744, name: 'CHEFE DE ESCRITORIO (ORCAMENTO)' },
  { value: 745, name: 'CHEFE DE ESCRITORIO (SERVICOS GERAIS)' },
  { value: 746, name: 'CHEFE DE ESCRITORIO (TESOURARIA)' },
  { value: 747, name: 'CHEFE DE ESCRITORIO' },
  { value: 748, name: 'CHEFE DE ESCRITORIO NAO ESPECIFICADO' },
  { value: 749, name: 'CHEFE DE ESTABULO' },
  { value: 750, name: 'CHEFE DE ESTACAO (FERROVIAS)' },
  { value: 751, name: 'CHEFE DE EXPEDICAO' },
  { value: 752, name: 'CHEFE DE GARAGEM' },
  { value: 753, name: 'CHEFE DE MANUTENCAO' },
  { value: 754, name: 'CHEFE DE MONTAGEM' },
  { value: 755, name: 'CHEFE DE MOVIMENTO (FERROVIAS)' },
  { value: 756, name: 'CHEFE DE OPERACOES DE VOO' },
  { value: 757, name: 'CHEFE DE PLANEJAMENTO (SEGUNDO GRAU)' },
  { value: 758, name: 'CHEFE DE SECAO (ESCRITORIO)' },
  { value: 759, name: 'CHEFE DE SECAO (FABRICA)' },
  { value: 760, name: 'CHEFE DE SECAO NAO ESPECIFICADO' },
  { value: 761, name: 'CHEFE DE SERVICOS DE TELECOMUNICACOES' },
  { value: 762, name: 'CHEFE DE SERVICOS DE TRANSP.P/VIAS NAVEGAVEIS' },
  { value: 763, name: 'CHEFE DE SERVICOS DE TRANSPORTE AEREO' },
  { value: 764, name: 'CHEFE DE SERVICOS DE TRANSPORTES RODOVIARIOS' },
  { value: 765, name: 'CHEFE DE TRAFEGO (TRANSPORTES COLETIVOS)' },
  { value: 766, name: 'CHEFE DE TREM' },
  { value: 767, name: 'CHEFE DE TURMA (AGRICULTURA)' },
  { value: 768, name: 'CHEFE DE VENDAS' },
  { value: 769, name: 'CHEFE SEM ESPECIFICACAO' },
  { value: 770, name: 'CHULEADOR' },
  { value: 771, name: 'CHUMBADOR' },
  { value: 772, name: 'CHURRAQUEIRO' },
  { value: 773, name: 'CICERONE' },
  { value: 774, name: 'CICLISTA' },
  { value: 775, name: 'CIENTISTA POLITICO' },
  { value: 776, name: 'CIGARREIRO' },
  { value: 777, name: 'CILINDRADOR DE COURO' },
  { value: 778, name: 'CILINDREIRO (PASTA PARA PAPEL)' },
  { value: 779, name: 'CILINDREIRO DIGESTORISTA' },
  { value: 780, name: 'CILINDRISTA (BORRACHA)' },
  { value: 781, name: 'CILINDRISTA (IMPRENSA)' },
  { value: 782, name: 'CILINDRISTA SEM ESPECIFICACAO' },
  { value: 783, name: 'CIMENTADOR (POCOS DE PETROLEO E GAS)' },
  { value: 784, name: 'CINEGRAFISTA' },
  { value: 785, name: 'CINTEIRO' },
  { value: 786, name: 'CINZELADOR DE MADEIRA' },
  { value: 787, name: 'CINZELADOR SEM ESPECIFICACAO' },
  { value: 788, name: 'CIRCENSE' },
  { value: 789, name: 'CIRURGIAO DENTISTA' },
  { value: 790, name: 'CIRURGIAO' },
  { value: 791, name: 'CITRICULTOR' },
  { value: 792, name: 'CLARIFICADOR DE TECIDOS' },
  { value: 793, name: 'CLARIFICADOR DE VINHOS' },
  { value: 794, name: 'CLASSIFICADOR CONTABIL' },
  { value: 795, name: 'CLASSIFICADOR DE ALGODAO' },
  { value: 796, name: 'CLASSIFICADOR DE CAFE' },
  { value: 797, name: 'CLASSIFICADOR DE CARNES' },
  { value: 798, name: 'CLASSIFICADOR DE CORRESPONDENCIA' },
  { value: 799, name: 'CLASSIFICADOR DE COUROS E PELES' },
  { value: 800, name: 'CLASSIFICADOR DE DOCUMENTOS' },
  { value: 801, name: 'CLASSIFICADOR DE FIBRAS' },
  { value: 802, name: 'CLASSIFICADOR DE FUMO' },
  { value: 803, name: 'CLASSIFICADOR DE MADEIRA' },
  { value: 804, name: 'CLASSIFICADOR DE MINERIOS' },
  { value: 805, name: 'CLASSIFICADOR DE OVOS' },
  { value: 806, name: 'CLASSIFICADOR DE ROUPAS' },
  { value: 807, name: 'CLASSIFICADOR DE SACARIA' },
  { value: 808, name: 'CLASSIFICADOR DE SUCATA' },
  { value: 809, name: 'CLASSIFICADOR DE TORAS' },
  { value: 810, name: 'CLASSIFICADOR SEM ESPECIFICACAO' },
  { value: 811, name: 'CLICHERISTA' },
  { value: 812, name: 'CLINICO GERAL' },
  { value: 813, name: 'COBRADOR (ALUGUEIS)' },
  { value: 814, name: 'COBRADOR DE CREDIARIO' },
  { value: 815, name: 'COBRADOR DE PEDAGIO' },
  { value: 816, name: 'COBRADOR DE TRANSPORTES COLETIVOS' },
  { value: 817, name: 'COBRADOR SEM ESPECIFICACAO' },
  { value: 818, name: 'COCHEIRO' },
  { value: 819, name: 'CODIFICADOR' },
  { value: 820, name: 'COLADOR DE CHAPAS DE MADEIRA' },
  { value: 821, name: 'COLADOR DE COURO' },
  { value: 822, name: 'COLADOR DE MOSAICO' },
  { value: 823, name: 'COLADOR SEM ESPECIFICACAO' },
  { value: 824, name: 'COLCHOEIRO' },
  { value: 825, name: 'COLETOR DE AMOSTRAS DE MINERIOS' },
  { value: 826, name: 'COLETOR DE BABACU' },
  { value: 827, name: 'COLETOR DE LATEX' },
  { value: 828, name: 'COLETOR DE RESINAS' },
  { value: 829, name: 'COLETOR DE SEMENTES' },
  { value: 830, name: 'COLETOR SEM ESPECIFICACAO (CURSO SUPERIOR)' },
  { value: 831, name: 'COLETOR SEM ESPECIFICACAO(SEM CURSO SUPERIOR)' },
  { value: 832, name: 'COLHEDOR (VIDRARIA)' },
  { value: 833, name: 'COLHEDOR DE ALGODAO' },
  { value: 834, name: 'COLHEDOR DE AMOSTRAS (MINAS)' },
  { value: 835, name: 'COLHEDOR DE ARROZ' },
  { value: 836, name: 'COLHEDOR DE BANANAS' },
  { value: 837, name: 'COLHEDOR DE CACAU' },
  { value: 838, name: 'COLHEDOR DE CAFE' },
  { value: 839, name: 'COLHEDOR DE CANA-DE-ACUCAR' },
  { value: 840, name: 'COLHEDOR DE COCO' },
  { value: 841, name: 'COLHEDOR DE FUMO' },
  { value: 842, name: 'COLHEDOR DE UVA' },
  { value: 843, name: 'COLOCADOR DE CAPAS(IMPRESSOS)' },
  { value: 844, name: 'COLOCADOR DE CARPETE' },
  { value: 845, name: 'COLOCADOR DE FERRAMENTAS' },
  { value: 846, name: 'COLOCADOR DE LIÇOS' },
  { value: 847, name: 'COLOCADOR DE MARMORE' },
  { value: 848, name: 'COLOCADOR DE PALMILHAS(CALCADOS)' },
  { value: 849, name: 'COLOCADOR DE TELHAS' },
  { value: 850, name: 'COLORISTA' },
  { value: 851, name: 'COLORISTA DE TECIDOS(2 GRAU)' },
  { value: 852, name: 'COMANDANTE(AVIACAO)' },
  { value: 853, name: 'COMANDANTE(NAVEGACAO INTERIOR)' },
  { value: 854, name: 'COMANDANTE(NAVEGACAO MARITIMA)' },
  { value: 855, name: 'COMANDANTE(PESCA E ALTO-MAR)' },
  { value: 856, name: 'COMBINADOR DE PELES' },
  { value: 857, name: 'COMEDIANTE' },
  { value: 858, name: 'COMENTARISTA(RADIO E TV)' },
  { value: 859, name: 'COMERCIANTE' },
  { value: 860, name: 'COMERCIARIO' },
  { value: 861, name: 'COMISSARIO DE AGENCIA' },
  { value: 862, name: 'COMISSARIO DE BORDO(AERONAVES)' },
  { value: 863, name: 'COMISSARIO DE BORDO(EMBARCACOES)' },
  { value: 864, name: 'COMISSARIO DE CARROS-LEITO(FERROVIAS)' },
  { value: 865, name: 'COMISSARIO DE ONIBUS' },
  { value: 866, name: 'COMISSARIO SEM ESPECIFICACAO' },
  { value: 867, name: 'COMMIS' },
  { value: 868, name: 'COMPAGINADOR DE FOTOCOMPOSICAO' },
  { value: 869, name: 'COMPENSADOR DE BANCO' },
  { value: 870, name: 'COMPLETADOR(INDUSTRIA)' },
  { value: 871, name: 'COMPOSITOR DE TRENS' },
  { value: 872, name: 'COMPOSITOR MUSICAL' },
  { value: 873, name: 'COMPOSITOR(FORA EXCECOES)' },
  { value: 874, name: 'COMPOTEIRO(REFINO DE ACUCAR)' },
  { value: 875, name: 'COMPRADOR' },
  { value: 876, name: 'COMPRESSORISTA' },
  { value: 877, name: 'COMPUTOMETRISTA' },
  { value: 878, name: 'COMUNICADOR VISUAL(2 GRAU OU SUPERIOR)' },
  { value: 879, name: 'COMUNICOLOGO' },
  { value: 880, name: 'CONCILIADOR' },
  { value: 881, name: 'CONCRETISTA EM GERAL' },
  { value: 882, name: 'CONDUTOR DE BONDE' },
  { value: 883, name: 'CONDUTOR DE PAPEL' },
  { value: 884, name: 'CONFECCIONADOR DE BONECAS' },
  { value: 885, name: 'CONFECCIONADOR' },
  { value: 886, name: 'CONFEITEIRO' },
  { value: 887, name: 'CONFERENTE DE BANCO' },
  { value: 888, name: 'CONFERENTE SEM ESPECIFICACAO' },
  { value: 889, name: 'CONFERENTE(ESTACAO FERROVIARIA)' },
  { value: 890, name: 'CONFERENTE(FORA EXCECOES)' },
  { value: 891, name: 'CONFERIDOR(CARTOES E FITAS)' },
  { value: 892, name: 'CONICALEIRO' },
  { value: 893, name: 'CONSELHEIRO(DIPLOMACIA)' },
  { value: 894, name: 'CONSELHEIRO PROFISSIONAL' },
  { value: 895, name: 'CONSERVADOR DE ESTRADAS' },
  { value: 896, name: 'CONSERVADOR DE LINHA' },
  { value: 897, name: 'CONSERVADOR DE MUSEU' },
  { value: 898, name: 'CONSERVADOR DE PESCADO' },
  { value: 899, name: 'CONSERVEIRO' },
  { value: 900, name: 'CONSTRUTOR CIVIL' },
  { value: 901, name: 'CONSTRUTOR DE AROS' },
  { value: 902, name: 'CONSTRUTOR' },
  { value: 903, name: 'CONSULTOR JURIDICO' },
  { value: 904, name: 'CONSULTOR PROFISSIONAL' },
  { value: 905, name: 'CONSULTOR' },
  { value: 906, name: 'CONSULTOR TECNICO' },
  { value: 907, name: 'CONTABILISTA(2 GRAU)' },
  { value: 908, name: 'CONTABILISTA' },
  { value: 909, name: 'CONTABILISTA(SEM 2 GRAU)' },
  { value: 910, name: 'CONTACTOLOGO' },
  { value: 911, name: 'CONTADOR DE PRODUCAO' },
  { value: 912, name: 'TECNICO EM CONTABILIDADE' },
  { value: 913, name: 'CONTADOR' },
  { value: 914, name: 'CONTATO(PUBLICIDADE)' },
  { value: 915, name: 'CONTINUISTA' },
  { value: 916, name: 'CONTINUO' },
  { value: 917, name: 'CONTRA REGRA' },
  { value: 918, name: 'CONTRA-MESTRE DE EMBARCACAO' },
  { value: 919, name: 'CONTRA-MESTRE SEM ESPECIFICACAO' },
  { value: 920, name: 'CONTRA-MESTRE(ENERGIA ELETRICA,GAS E AGUA)' },
  { value: 921, name: 'CONTRA-MESTRE(ESGOTO SANITARIOS)' },
  { value: 922, name: 'CONTRA-MESTRE(FORA EXCECOES)' },
  { value: 923, name: 'CONTRA-MESTRE(INDUSTRIA TEXTIL)' },
  { value: 924, name: 'CONTRA-MESTRE(MINAS E PEDREIRAS)' },
  { value: 925, name: 'CONTRA-MESTRE(POCOS DE PETROLEO E GAS)' },
  { value: 926, name: 'CONTROLADOR DE ARRECADACAO' },
  { value: 927, name: 'CONTROLADOR DE CADEIRAS DE LAMINACAO' },
  { value: 928, name: 'CONTROLADOR DE DADOS' },
  { value: 929, name: 'CONTROLADOR DE DISTRIBUICAO DE AGUA' },
  { value: 930, name: 'CONTROLADOR DE DOSADORES(RACOES BALANCEADAS)' },
  { value: 931, name: 'CONTROLADOR DE ESTOQUE' },
  { value: 932, name: 'CONTROLADOR DE GASOMETRO' },
  { value: 933, name: 'CONTROLADOR DE IMPORTACAO E EXPORTACAO' },
  { value: 934, name: 'CONTROLADOR DE LEITO DE RESFRIAMENTO' },
  { value: 935, name: 'CONTROLADOR DE PATIO DE SUCATA' },
  { value: 936, name: 'CONTROLADOR DE PECAS' },
  { value: 937, name: 'CONTROLADOR DE PRODUCAO' },
  { value: 938, name: 'CONTROLADOR DE QUALIDADE' },
  { value: 939, name: 'CONTROLADOR DE SILOS DE MATERIAS-PRIMAS(SINTE' },
  { value: 940, name: 'CONTROLADOR DE TEMPERATURA' },
  { value: 941, name: 'CONTROLADOR DE TEMPERATURA BATERIA DE COQUE' },
  { value: 942, name: 'CONTROLADOR DE TRAFEGO AEREO' },
  { value: 943, name: 'CONTROLADOR DE TRAFEGO FERROVIARIO' },
  { value: 944, name: 'CONTROLADOR FIXO' },
  { value: 945, name: 'CONTROLADOR SEM ESPECIFICACAO' },
  { value: 946, name: 'CONTROLISTA SEM ESPECIFICACAO' },
  { value: 947, name: 'CONZELADOR DE METAIS PRECIOSOS' },
  { value: 948, name: 'COORDENADOR DE COPA E COZINHA' },
  { value: 949, name: 'COORDENADOR DE CPD' },
  { value: 950, name: 'COORDENADOR DE ENSINO' },
  { value: 951, name: 'COORDENADOR DE PRODUCAO' },
  { value: 952, name: 'COORDENADOR DE SISTEMAS' },
  { value: 953, name: 'COORDENADOR PEDAGOGICO' },
  { value: 954, name: 'COORDENADOR SEM ESPECIFICACAO' },
  { value: 955, name: 'COPEIRO' },
  { value: 956, name: 'COPIDESQUE' },
  { value: 957, name: 'COPISTA' },
  { value: 958, name: 'COPISTA (CARTOES JACQUARD)' },
  { value: 959, name: 'COQUELEIRO' },
  { value: 960, name: 'COREOGRAFO' },
  { value: 961, name: 'CORREEIRO' },
  { value: 962, name: 'CORRESPONDENTE (JORNALISTA)' },
  { value: 963, name: 'CORRESPONDENTE COMERCIAL' },
  { value: 964, name: 'CORRETOR (FORA EXCECAO)' },
  { value: 965, name: 'CORRETOR DE ANUNCIOS' },
  { value: 966, name: 'CORRETOR DE VALORES' },
  { value: 967, name: 'CORRETOR' },
  { value: 968, name: 'CORTADOR ARTEFADOS COURO(EXC.ROUPAS E CALC.)' },
  { value: 969, name: 'CORTADOR DE ARVORES' },
  { value: 970, name: 'CORTADOR DE CALCADOS' },
  { value: 971, name: 'CORTADOR DE CAVACO' },
  { value: 972, name: 'CORTADOR DE CRISTAIS DE OPTICA' },
  { value: 973, name: 'CORTADOR DE LAMINADOS DE MADEIRA' },
  { value: 974, name: 'CORTADOR DE LENHA' },
  { value: 975, name: 'CORTADOR DE PEDRAS' },
  { value: 976, name: 'CORTADOR DE ROUPAS' },
  { value: 977, name: 'CORTADOR DE TUBOS' },
  { value: 978, name: 'CORTADOR DE VIDRO' },
  { value: 979, name: 'CORTADOR SEM ESPECIFICACAO' },
  { value: 980, name: 'COSMETOLOGO (CURSO SUPERIOR)' },
  { value: 981, name: 'COSMETOLOGO (SEM CURSO SUPERIOR)' },
  { value: 982, name: 'COSTURADOR DE CALCADOS' },
  { value: 983, name: 'COSTURADOR DE COURO(EXCETO ROUPAS E CALCADOS)' },
  { value: 984, name: 'COSTURADOR DE LONAS E ENCERADOS' },
  { value: 985, name: 'COSTURADOR DE SACOS' },
  { value: 986, name: 'COSTUREIRO (CONFECCAO EM SERIE)' },
  { value: 987, name: 'COSTUREIRO (CONFECCAO SOB MEDIDA)' },
  { value: 988, name: 'COSTUREIRO' },
  { value: 989, name: 'COVEIRO' },
  { value: 990, name: 'COZINHADOR (REFINO DE ACUCAR)' },
  { value: 991, name: 'COZINHADOR (TECIDOS)' },
  { value: 992, name: 'COZINHADOR (TRATAMENTOS QUIMICOS)' },
  { value: 993, name: 'COZINHADOR DE ALIMENTOS' },
  { value: 994, name: 'COZINHADOR DE EXTRATO DE CERVEJA' },
  { value: 995, name: 'COZINHADOR DE MALTE' },
  { value: 996, name: 'COZINHEIRO' },
  { value: 997, name: 'CRAVADOR SEM ESPECIFICACAO' },
  { value: 998, name: 'CRIADO DE HOTEL' },
  { value: 999, name: 'CRIADOR DE ABELHAS' },
  { value: 1000, name: 'CRIADOR DE AVES' },
  { value: 1001, name: 'CRIADOR DE AVES PARA POSTURA' },
  { value: 1002, name: 'CRIADOR DE BICHOS-DA-SEDA' },
  { value: 1003, name: 'CRIADOR DE BUFALOS' },
  { value: 1004, name: 'CRIADOR DE CAPRINOS' },
  { value: 1005, name: 'CRIADOR DE CAVALOS' },
  { value: 1006, name: 'CRIADOR DE COELHOS' },
  { value: 1007, name: 'CRIADOR DE GADO' },
  { value: 1008, name: 'CRIADOR DE GATOS' },
  { value: 1009, name: 'CRIADOR DE JABUTIS' },
  { value: 1010, name: 'CRIADOR DE MODELOS DE VESTUARIO' },
  { value: 1011, name: 'CRIADOR DE OVELHAS' },
  { value: 1012, name: 'CRIADOR DE PEIXES' },
  { value: 1013, name: 'CRIADOR DE PORCOS' },
  { value: 1014, name: 'CRIADOR DE RAS' },
  { value: 1015, name: 'CRIADOR DE TARTARUGAS' },
  { value: 1016, name: 'CRIADOR DE ZEBU' },
  { value: 1017, name: 'CRIADOR SEM ESPECIFICACAO' },
  { value: 1018, name: 'CRITICO EM GERAL' },
  { value: 1019, name: 'CRITICO EM GERAL' },
  { value: 1020, name: 'CROMADOR' },
  { value: 1021, name: 'CRONISTA DESPORTIVO' },
  { value: 1022, name: 'CRONISTA LITERARIO' },
  { value: 1023, name: 'CRONOANALISTA' },
  { value: 1024, name: 'CRONOMETRISTA (FORA EXCECAO)' },
  { value: 1025, name: 'CRONOMETRISTA DESPORTIVO' },
  { value: 1026, name: 'CRONOMETRISTA SEM ESPECIFICACAO' },
  { value: 1027, name: 'CUBADOR DE MADEIRA' },
  { value: 1028, name: 'CULIDOR' },
  { value: 1029, name: 'CUNHADOR' },
  { value: 1030, name: 'CUNICULTOR' },
  { value: 1031, name: 'CURRALEIRO DE PESCA' },
  { value: 1032, name: 'CURTIDOR' },
  { value: 1033, name: 'CURTUMEIRO' },
  { value: 1034, name: 'CURVADOR DE CHAPAS' },
  { value: 1035, name: 'CURVADOR DE MADEIRA' },
  { value: 1036, name: 'CURVADOR DE TUBOS DE VIDRO' },
  { value: 1037, name: 'DANCARINO' },
  { value: 1038, name: 'DATILOGRAFO' },
  { value: 1039, name: 'DATILOSCOPISTA' },
  { value: 1040, name: 'DEBITADOR' },
  { value: 1041, name: 'DEBULHADOR DE FUMO' },
  { value: 1042, name: 'DECAPADOR' },
  { value: 1043, name: 'DECORADOR DE CERAMICA' },
  { value: 1044, name: 'DECORADOR DE CHAPEUS' },
  { value: 1045, name: 'DECORADOR DE INTERIORES' },
  { value: 1046, name: 'DECORADOR DE NAVAL' },
  { value: 1047, name: 'DECORADOR DE PINTURA (VIDRO E CERAMICA)' },
  { value: 1048, name: 'DECORADOR DE VIDRO' },
  { value: 1049, name: 'DECORADOR DE VITRINA' },
  { value: 1050, name: 'DECORADOR SEM ESPECIFICACAO' },
  { value: 1051, name: 'DEDETIZADOR' },
  { value: 1052, name: 'DEFUMADOR DE CARNE E PESCADO' },
  { value: 1053, name: 'DEFUMADOR DE LATEX' },
  { value: 1054, name: 'DEGUSTADOR DE CACAU' },
  { value: 1055, name: 'DEGUSTADOR DE CAFE' },
  { value: 1056, name: 'DEGUSTADOR DE CHA' },
  { value: 1057, name: 'DEGUSTADOR DE VINHOS E LICORES' },
  { value: 1058, name: 'DELEGADO DE POLICIA' },
  { value: 1059, name: 'DELINEADOR' },
  { value: 1060, name: 'DEMOLIDOR DE EDIFICIOS' },
  { value: 1061, name: 'DEMONSTRADOR' },
  { value: 1062, name: 'DENTISTA' },
  { value: 1063, name: 'DEPILADOR DE PELES' },
  { value: 1064, name: 'DEPUTADO' },
  { value: 1065, name: 'DESBASTADOR DE PLASTICOS' },
  { value: 1066, name: 'DESBASTADOR SEM ESPECIFICACAO' },
  { value: 1067, name: 'DESCARNADOR (FORA EXCECAO)' },
  { value: 1068, name: 'DESCARNADOR DE COUROS E PELES' },
  { value: 1069, name: 'DESCARNADOR SEM ESPECIFICACAO' },
  { value: 1070, name: 'DESCAROCADOR DE AZEITONAS' },
  { value: 1071, name: 'DESCARREGADOR DE FIANDEIRA' },
  { value: 1072, name: 'DESCARREGADOR DE FORNO (CERAMICA)' },
  { value: 1073, name: 'DESCASCADOR DE LENHA' },
  { value: 1074, name: 'DESEMPENADOR (CALDEIRARIA)' },
  { value: 1075, name: 'DESEMPREGADO' },
  { value: 1076, name: 'DESENFORNADOR (COQUERIA)' },
  { value: 1077, name: 'DESENGOMADOR DE FIOS' },
  { value: 1078, name: 'DESENGOMADOR DE TECIDOS' },
  { value: 1079, name: 'DESENHISTA ARQUITETONICO' },
  { value: 1080, name: 'DESENHISTA ARTISTICO' },
  { value: 1081, name: 'DESENHISTA COPISTA' },
  { value: 1082, name: 'DESENHISTA DE ARQUITETURA' },
  { value: 1083, name: 'DESENHISTA DE ARTE-FINAL' },
  { value: 1084, name: 'DESENHISTA DE DECORACAO' },
  { value: 1085, name: 'DESENHISTA DE EMBALAGENS' },
  { value: 1086, name: 'DESENHISTA DE ESTRUTURAS METALICAS' },
  { value: 1087, name: 'DESENHISTA DE FILATELIA' },
  { value: 1088, name: 'DESENHISTA DE HERALDICA' },
  { value: 1089, name: 'DESENHISTA DE ILUSTRACOES' },
  { value: 1090, name: 'DESENHISTA DE VESTUARIO' },
  { value: 1091, name: 'DESENHISTA DETALHISTA' },
  { value: 1092, name: 'DESENHISTA HUMORISTICO' },
  { value: 1093, name: 'DESENHISTA INDUSTRIAL (CURSO SUPERIOR)' },
  { value: 1094, name: 'DESENHISTA MECANICO' },
  { value: 1095, name: 'DESENHISTA PROJETISTA' },
  { value: 1096, name: 'DESENHISTA PUBLICITARIO' },
  { value: 1097, name: 'DESENHISTA SEM ESPECIFICACAO' },
  { value: 1098, name: 'DESENHISTA TECNICO' },
  { value: 1099, name: 'DESFIBRADOR (LINHO OU JUTA)' },
  { value: 1100, name: 'DESIDRATADOR DE ALIMENTOS' },
  { value: 1101, name: 'DESIGNER' },
  { value: 1102, name: 'DESINCRUSTADOR (POCOS DE PETROLEO E GAS)' },
  { value: 1103, name: 'DESMONTADOR SEM ESPECIFICACAO' },
  { value: 1104, name: 'DESOCUPADO' },
  { value: 1105, name: 'DESOSSADOR' },
  { value: 1106, name: 'DESPACHADOR DE CARGA (ELETRICA)' },
  { value: 1107, name: 'DESPACHADOR DE MOVIMENTO (FERROVIAS)' },
  { value: 1108, name: 'DESPACHANTE ADUANEIRO' },
  { value: 1109, name: 'DESPACHANTE COMERCIAL' },
  { value: 1110, name: 'DESPACHANTE DE AVIOES' },
  { value: 1111, name: 'DESPACHANTE DE BAGAGEM (AEROPORTO)' },
  { value: 1112, name: 'DESPACHANTE DE DOCUMENTOS' },
  { value: 1113, name: 'DESPACHANTE DE ENCOMENDAS' },
  { value: 1114, name: 'DESPACHANTE DE MATERIAIS' },
  { value: 1115, name: 'DESPACHANTE DE MOVIMENTO (FERROVIAS)' },
  { value: 1116, name: 'DESPACHANTE DE TRANSPORTE COLETIVO (EXC.TREM)' },
  { value: 1117, name: 'DESPACHANTE DE TREM' },
  { value: 1118, name: 'DESPACHANTE POLICIAL' },
  { value: 1119, name: 'DESPACHANTE SEM ESPECIFICACAO' },
  { value: 1120, name: 'DESPENSEIRO' },
  { value: 1121, name: 'DESPONTADOR SEM ESPECIFICACAO' },
  { value: 1122, name: 'DESSECADOR DE MALTE' },
  { value: 1123, name: 'DESSULFURADOR (REFINO DE PETROLEO)' },
  { value: 1124, name: 'DESTALADOR DE FUMO' },
  { value: 1125, name: 'DESTILADOR DE GLICERINA' },
  { value: 1126, name: 'DESTILADOR DE LICORES' },
  { value: 1127, name: 'DESTILADOR DE MADEIRA' },
  { value: 1128, name: 'DESTILADOR DE PETROLEO' },
  { value: 1129, name: 'DESTILADOR DE PRODUTOS QUIMICOS(EXC.PETROLEO)' },
  { value: 1130, name: 'DESTOCADOR' },
  { value: 1131, name: 'DESTROCADOR DE PEDRAS' },
  { value: 1132, name: 'DETETIVE' },
  { value: 1133, name: 'DETONADOR' },
  { value: 1134, name: 'DIAGRAMADOR' },
  { value: 1135, name: 'DIARISTA' },
  { value: 1136, name: 'DIETISTA' },
  { value: 1137, name: 'DIGITADOR' },
  { value: 1138, name: 'DIR.DE EMP.DE PROD.E DISTRIBUICAO DE ENERGIA' },
  { value: 1139, name: 'DIR.DE EMP.DE PRODUCAO E DISTRIBUICAO DE GAS' },
  { value: 1140, name: 'DIRETOR ADMINISTRATIVO' },
  { value: 1141, name: 'DIRETOR AGRICOLA' },
  { value: 1142, name: 'DIRETOR DE ARTE' },
  { value: 1143, name: 'DIRETOR DE BANCO' },
  { value: 1144, name: 'DIRETOR DE CINEMA' },
  { value: 1145, name: 'DIRETOR DE COMPANHIA DE SEGUROS' },
  { value: 1146, name: 'DIRETOR DE EMPRESA AGROPECUARIA' },
  { value: 1147, name: 'DIRETOR DE EMPRESA COMERCIAL' },
  { value: 1148, name: 'DIRETOR DE EMPRESA DE AGUA E ESGOTO' },
  { value: 1149, name: 'DIRETOR DE EMPRESA DE COMUNICACOES' },
  { value: 1150, name: 'DIRETOR DE EMPRESA DE CONSTRUCAO CIVIL' },
  { value: 1151, name: 'DIRETOR DE EMPRESA DE CONSTRUCAO NAVAL' },
  { value: 1152, name: 'DIRETOR DE EMPRESA DE EXTRACAO DE PETROLEO' },
  { value: 1153, name: 'DIRETOR DE EMPRESA DE MINERACAO' },
  { value: 1154, name: 'DIRETOR DE EMPRESA DE PRESTACAO DE SERVICO' },
  { value: 1155, name: 'DIRETOR DE EMPRESA DE SERVICOS CULTURAIS' },
  { value: 1156, name: 'DIRETOR DE EMPRESA DE SERVICOS MEDICOS' },
  { value: 1157, name: 'DIRETOR DE EMPRESA DE SERVICOS SOCIAIS' },
  { value: 1158, name: 'DIRETOR DE EMPRESA DE TRANSPORTE' },
  { value: 1159, name: 'DIRETOR DE EMPRESA FINANCEIRA' },
  { value: 1160, name: 'DIRETOR DE EMPRESA FLORESTAL' },
  { value: 1161, name: 'DIRETOR DE EMPRESA HOTELEIRA' },
  { value: 1162, name: 'DIRETOR DE EMPRESA IMOBILIARIA' },
  { value: 1163, name: 'DIRETOR DE EMPRESA MANUFATUREIRA' },
  { value: 1164, name: 'DIRETOR DE EMPRESA PESQUEIRA' },
  { value: 1165, name: 'DIRETOR DE EMPRESA SEM ESPECIFICACAO' },
  { value: 1166, name: 'DIRETOR DE EMPRESAS' },
  { value: 1167, name: 'DIRETOR DE ESCOLA (EXCETO SUPERIOR)' },
  { value: 1168, name: 'DIRETOR DE ESCOLA' },
  { value: 1169, name: 'DIRETOR DE ESPETACULOS' },
  { value: 1170, name: 'DIRETOR DE FINANCAS' },
  { value: 1171, name: 'DIRETOR DE FOTOGRAFIA (CINEMA)' },
  { value: 1172, name: 'DIRETOR DE MARKETING' },
  { value: 1173, name: 'DIRETOR DE PATRIMONIO' },
  { value: 1174, name: 'DIRETOR DE PESSOAL' },
  { value: 1175, name: 'DIRETOR DE PRODUCAO (RADIO E TV)' },
  { value: 1176, name: 'DIRETOR DE PUBLICIDADE' },
  { value: 1177, name: 'DIRETOR DE RECURSOS HUMANOS' },
  { value: 1178, name: 'DIRETOR DE REDACAO' },
  { value: 1179, name: 'DIRETOR DE RELACOES DE TRABALHO' },
  { value: 1180, name: 'DIRETOR DE RELACOES INDUSTRIAIS' },
  { value: 1181, name: 'DIRETOR DE RELACOES PUBLICAS' },
  { value: 1182, name: 'DIRETOR DE TELEVISAO' },
  { value: 1183, name: 'DIRETOR DE TREINAMENTO' },
  { value: 1184, name: 'DIRETOR DE VENDAS' },
  { value: 1185, name: 'DIRETOR FINANCEIRO' },
  { value: 1186, name: 'DIRETOR PEDAGOGICO' },
  { value: 1187, name: 'DIRETOR SEM ESPECIFICACAO' },
  { value: 1188, name: 'DIRETOR TEATRAL' },
  { value: 1189, name: 'DIRETOR TECNICO' },
  { value: 1190, name: 'DISC-JOCKEY' },
  { value: 1191, name: 'DISCOTECARIO (EXCETO PROGRAMADOR)' },
  { value: 1192, name: 'DISCOTECARIO PROGRAMADOR' },
  { value: 1193, name: 'DISTRIBUIDOR DE CARGAS (ENERGIA ELETRICA)' },
  { value: 1194, name: 'DISTRIBUIDOR DE ESPULAS' },
  { value: 1195, name: 'DISTRIBUIDOR DE FERRAMENTAS' },
  { value: 1196, name: 'DISTRIBUIDOR DE FUMO' },
  { value: 1197, name: 'DISTRIBUIDOR DE MACAROCAS' },
  { value: 1198, name: 'DISTRIBUIDOR DE MATERIAL' },
  { value: 1199, name: 'DISTRIBUIDOR DE VEICULOS (FERROVIAS)' },
  { value: 1200, name: 'DISTRIBUIDOR SEM ESPECIFICACAO' },
  { value: 1201, name: 'DIVISOR DE COUROS' },
  { value: 1202, name: 'DIVULGADOR' },
  { value: 1203, name: 'DOBRADOR DE CALCADOS' },
  { value: 1204, name: 'DOBRADOR DE ROUPAS' },
  { value: 1205, name: 'DOBRADOR SEM ESPECIFICACAO' },
  { value: 1206, name: 'DOCEIRO' },
  { value: 1207, name: 'DOCUMENTALISTA' },
  { value: 1208, name: 'DOMADOR (CIRCO)' },
  { value: 1209, name: 'DOMADOR (PECUARIA)' },
  { value: 1210, name: 'DOMESTICO' },
  { value: 1211, name: 'DOMESTICA (EMPREGADA)' },
  { value: 1212, name: 'DO LAR' },
  { value: 1213, name: 'DOSIFICADOR DE ACUCAR' },
  { value: 1214, name: 'DRAGEADOR (MEDICAMENTOS)' },
  { value: 1215, name: 'DRAGISTA' },
  { value: 1216, name: 'DRAGISTA (DOCES E CARAMELOS)' },
  { value: 1217, name: 'DUCHISTA (SAUNAS E AFINS)' },
  { value: 1218, name: 'ECOLOGISTA' },
  { value: 1219, name: 'ECONOMIARIO' },
  { value: 1220, name: 'ECONOMISTA' },
  { value: 1221, name: 'ECONOMISTA (SEM CURSO SUPERIOR)' },
  { value: 1222, name: 'ECONOMISTA DOMESTICO' },
  { value: 1223, name: 'ECONOMO (HOTELARIA)' },
  { value: 1224, name: 'ECOSSONDADOR' },
  { value: 1225, name: 'EDIFICADOR DE CASCO' },
  { value: 1226, name: 'EDITOR DE LIVROS' },
  { value: 1227, name: 'EDUCADOR DE SAUDE PUBLICA' },
  { value: 1228, name: 'EDUCADOR' },
  { value: 1229, name: 'ELETRICISTA BOBINADOR' },
  { value: 1230, name: 'ELETRICISTA DE AERONAVES' },
  { value: 1231, name: 'ELETRICISTA DE ALTA TENSAO' },
  { value: 1232, name: 'ELETRICISTA DE BAIXA TENSAO' },
  { value: 1233, name: 'ELETRICISTA DE BRINQUEDOS ELETRICOS' },
  { value: 1234, name: 'ELETRICISTA DE EDIFICIOS' },
  { value: 1235, name: 'ELETRICISTA DE EMBARCACOES' },
  { value: 1236, name: 'ELETRICISTA DE EQUIP.DE TELEFONIA,TELEIMPRESS' },
  { value: 1237, name: 'ELETRICISTA DE EQUIPAMENTOS HOSPITALAR' },
  { value: 1238, name: 'ELETRICISTA DE ILUMINACAO PUBLICA' },
  { value: 1239, name: 'ELETRICISTA DE INSTALACAO EM GERAL' },
  { value: 1240, name: 'ELETRICISTA DE MANUTENCAO (EXCETO REDE0' },
  { value: 1241, name: 'ELETRICISTA DE MANUTENCAO (REDE)' },
  { value: 1242, name: 'ELETRICISTA DE MANUTENCAO SEM ESPECIFICACAO' },
  { value: 1243, name: 'ELETRICISTA DE REDE' },
  { value: 1244, name: 'ELETRICISTA DE SISTEMA TELEFONICO' },
  { value: 1245, name: 'ELETRICISTA DE TESTES' },
  { value: 1246, name: 'ELETRICISTA DE VEICULOS' },
  { value: 1247, name: 'ELETRICISTA ENROLADOR' },
  { value: 1248, name: 'ELETRICISTA INDUSTRIAL' },
  { value: 1249, name: 'ELETRICISTA INSTALADOR SEM ESPECIFICACAO' },
  { value: 1250, name: 'ELETRICISTA INSTALADOR(ELETRICAS E TELECOMUN)' },
  { value: 1251, name: 'ELETRICISTA MECANICO' },
  { value: 1252, name: 'ELETRICISTA MONTADOR (EQUIP.ELETRICO)' },
  { value: 1253, name: 'ELETRICISTA MONTADOR (EQUIP.ELETRONICO)' },
  { value: 1254, name: 'ELETRICISTA MONTADOR SEM ESPECIFICACAO' },
  { value: 1255, name: 'ELETRICISTA' },
  { value: 1256, name: 'ELETRICITARIO' },
  { value: 1257, name: 'ELETROMECANICO' },
  { value: 1258, name: 'ELETRONICO ANALISTA' },
  { value: 1259, name: 'ELETROPISTA' },
  { value: 1260, name: 'ELETROTECNICO' },
  { value: 1261, name: 'EMBALADOR (FORA EXCECAO)' },
  { value: 1262, name: 'EMBALADOR DE MUDAS (AGRICULTURA)' },
  { value: 1263, name: 'EMBALADOR SEM ESPECIFICACAO' },
  { value: 1264, name: 'EMBALSAMADOR' },
  { value: 1265, name: 'EMBARCADOR' },
  { value: 1266, name: 'EMBLOCADOR' },
  { value: 1267, name: 'EMBORRACHADOR' },
  { value: 1268, name: 'EMBUTIDOR (MADEIRA)' },
  { value: 1269, name: 'EMENDADOR DE CABOS ELETRICOS E TELEFONICOS' },
  { value: 1270, name: 'EMENDADOR DE CORDAS E CABOS' },
  { value: 1271, name: 'EMENDADOR SEM ESPECIFICACAO' },
  { value: 1272, name: 'EMISSOR DE PASSAGEM' },
  { value: 1273, name: 'EMPACOTADOR DE CAFE' },
  { value: 1274, name: 'EMPACOTADOR DE PAREDES' },
  { value: 1275, name: 'EMPACOTADOR SEM ESPECIFICACAO' },
  { value: 1276, name: 'EMPILHADEIRISTA' },
  { value: 1277, name: 'EMPILHADOR' },
  { value: 1278, name: 'EMPREGADA DOMESTICA' },
  { value: 1279, name: 'EMPREGADO DE LIMPEZA' },
  { value: 1280, name: 'EMPREIREIRO DE OBRAS' },
  { value: 1281, name: 'EMPRESARIO ARTISTICO' },
  { value: 1282, name: 'EMPRESARIO DE ESPETACULOS' },
  { value: 1283, name: 'EMPRESARIO DE SERVICOS FUNERARIOS' },
  { value: 1284, name: 'EMPRESARIO' },
  { value: 1285, name: 'ENCADERNADOR' },
  { value: 1286, name: 'ENCAIXOTADOR' },
  { value: 1287, name: 'ENCALHADOR SEM ESPECIFICACAO' },
  { value: 1288, name: 'ENCANADOR' },
  { value: 1289, name: 'ENCARREGADO ADMINISTRATIVO' },
  { value: 1290, name: 'ENCARREGADO DE ALOJAMENTO' },
  { value: 1291, name: 'ENCARREGADO DE ARMAZEM' },
  { value: 1292, name: 'ENCARREGADO DE CABINE (FERROVIAS)' },
  { value: 1293, name: 'ENCARREGADO DE CARNES' },
  { value: 1294, name: 'ENCARREGADO DE CASA DE MAQUINA' },
  { value: 1295, name: 'ENCARREGADO DE COMESTIVEIS (COMERCIO)' },
  { value: 1296, name: 'ENCARREGADO DE COMPRAS' },
  { value: 1297, name: 'ENCARREGADO DE CREDITO' },
  { value: 1298, name: 'ENCARREGADO DE CUSTOS' },
  { value: 1299, name: 'ENCARREGADO DE DEPARTAMENTO (ESCRITORIO)' },
  { value: 1300, name: 'ENCARREGADO DE DEPARTAMENTO (FABRICA)' },
  { value: 1301, name: 'ENCARREGADO DE DEPARTAMENTO NAO ESPECIFICADO' },
  { value: 1302, name: 'ENCARREGADO DE EMBALAGEM' },
  { value: 1303, name: 'ENCARREGADO DE EMPACOTAMENTO' },
  { value: 1304, name: 'ENCARREGADO DE EXPEDICAO' },
  { value: 1305, name: 'ENCARREGADO DE EXPORTACAO' },
  { value: 1306, name: 'ENCARREGADO DE FISCALIZACAO' },
  { value: 1307, name: 'ENCARREGADO DE FROTA' },
  { value: 1308, name: 'ENCARREGADO DE IMPORTACAO' },
  { value: 1309, name: 'ENCARREGADO DE LABORATORIO (CURSO SUPERIOR)' },
  { value: 1310, name: 'ENCARREGADO DE LABORATORIO (S/CURSO SUPERIOR)' },
  { value: 1311, name: 'ENCARREGADO DE MANUTENCAO (EDIFICIO)' },
  { value: 1312, name: 'ENCARREGADO DE MANUTENCAO (INDUSTRIA)' },
  { value: 1313, name: 'ENCARREGADO DE MANUTENCAO INDUSTRIAL' },
  { value: 1314, name: 'ENCARREGADO DE MANUTENCAO SEM ESPECIFICAÇAO' },
  { value: 1315, name: 'ENCARREGADO DE MECANICA (SEÇAO)' },
  { value: 1316, name: 'ENCARREGADO DE MONTAGEM' },
  { value: 1317, name: 'ENCARREGADO DE OBRAS' },
  { value: 1318, name: 'ENCARREGADO DE PRODUCAO' },
  { value: 1319, name: 'ENCARREGADO DE RESTAURANTE' },
  { value: 1320, name: 'ENCARREGADO DE SEÇAO (ESCRITORIO)' },
  { value: 1321, name: 'ENCARREGADO DE SEÇAO (FABRICA)' },
  { value: 1322, name: 'ENCARREGADO DE SEÇAO NAO ESPECIFICADA' },
  { value: 1323, name: 'ENCARREGADO DE TEXTURIZAÇAO' },
  { value: 1324, name: 'ENCARREGADO DE TRAFEGO' },
  { value: 1325, name: 'ENCARREGADO DE TRANSPORTES' },
  { value: 1326, name: 'ENCARREGADO DE TURMA (EXCETO AGRICOLA)' },
  { value: 1327, name: 'ENCARREGADO DE VENDAS' },
  { value: 1328, name: 'ENCARREGADO DE VIDRARIA' },
  { value: 1329, name: 'ENCARREGADO GERAL SEM ESPECIFICACAO' },
  { value: 1330, name: 'ENCARREGADO SEM ESPECIFICAÇAO' },
  { value: 1331, name: 'ENCERADOR (pisos)' },
  { value: 1332, name: 'ENCHEDOR DE COLÇOES' },
  { value: 1333, name: 'ENCORDOADOR' },
  { value: 1334, name: 'ENCUBADORA' },
  { value: 1335, name: 'ENCUNHADOR DE PEDREIRA' },
  { value: 1336, name: 'ENFARDADOR' },
  { value: 1337, name: 'ENFERMEIRO' },
  { value: 1338, name: 'ENFERMEIRO PRATICO' },
  { value: 1339, name: 'ENFESTADOR' },
  { value: 1340, name: 'ENGARRAFADOR' },
  { value: 1341, name: 'ENGASTADOR' },
  { value: 1342, name: 'ENGATADOR' },
  { value: 1343, name: 'ENGENHEIRO AERONAUTICO' },
  { value: 1344, name: 'ENGENHEIRO AGRIMENSOR' },
  { value: 1345, name: 'ENGENHEIRO AGRONOMO' },
  { value: 1346, name: 'ENGENHEIRO ARQUITETO' },
  { value: 1347, name: 'ENGENHEIRO CARTOGRAFO' },
  { value: 1348, name: 'ENGENHEIRO CIVIL' },
  { value: 1349, name: 'ENGENHEIRO DE ALIMENTOS' },
  { value: 1350, name: 'ENGENHEIRO DE APROVISIONAMENTO' },
  { value: 1351, name: 'ENGENHEIRO DE CERAMICA E VIDROS' },
  { value: 1352, name: 'ENGENHEIRO DE CONTROLE DE QUALIDADE' },
  { value: 1353, name: 'ENGENHEIRO DE CUSTOS' },
  { value: 1354, name: 'ENGENHEIRO DE EMBALAGEM' },
  { value: 1355, name: 'ENGENHEIRO DE MANUTENCAO (ELETRICISTA)' },
  { value: 1356, name: 'ENGENHEIRO DE MANUTENCAO (MECANICA)' },
  { value: 1357, name: 'ENGENHEIRO DE MATERIAL' },
  { value: 1358, name: 'ENGENHEIRO DE MINAS' },
  { value: 1359, name: 'ENGENHEIRO DE NORMAS E ESPECIFICAÇOES' },
  { value: 1360, name: 'ENGENHEIRO DE OBRAS' },
  { value: 1361, name: 'ENGENHEIRO DE OPERACAO' },
  { value: 1362, name: 'ENGENHEIRO DE ORGANIZAÇAO COMERCIAL' },
  { value: 1363, name: 'ENGENHEIRO DE ORGANIZAÇAO E METODOS' },
  { value: 1364, name: 'ENGENHEIRO DE ORGANIZAÇAO EM GERAL' },
  { value: 1365, name: 'ENGENHEIRO DE PATENTES' },
  { value: 1366, name: 'ENGENHEIRO DE PERFURAÇAO (PETROLEO)' },
  { value: 1367, name: 'ENGENHEIRO DE PLANEJAMENTO E CONTROLE' },
  { value: 1368, name: 'ENGENHEIRO DE PROCESSOS' },
  { value: 1369, name: 'ENGENHEIRO DE PRODUÇAO' },
  { value: 1370, name: 'ENGENHEIRO DE PROJETOS ELETRICOS' },
  { value: 1371, name: 'ENGENHEIRO DE QUALIDADE' },
  { value: 1372, name: 'ENGENHEIRO DE SEGURANÇA DO TRABALHO' },
  { value: 1373, name: 'ENGENHEIRO DE SEGURANÇA INDUSTRIAL' },
  { value: 1374, name: 'ENGENHEIRO DE SISTEMAS' },
  { value: 1375, name: 'ENGENHEIRO DE SOLOS' },
  { value: 1376, name: 'ENGENHEIRO DE TELECOMUNICAÇOES' },
  { value: 1377, name: 'ENGENHEIRO DE TEMPOS E MOVIMENTOS' },
  { value: 1378, name: 'ENGENHEIRO DE TRAFEGO' },
  { value: 1379, name: 'ENGENHEIRO DE VENDAS' },
  { value: 1380, name: 'ENGENHEIRO ELETRICISTA' },
  { value: 1381, name: 'ENGENHEIRO ELETROMECANICO' },
  { value: 1382, name: 'ENGENHEIRO ELETRONICO' },
  { value: 1383, name: 'ENGENHEIRO ELETROTECNICO' },
  { value: 1384, name: 'ENGENHEIRO FLORESTAL' },
  { value: 1385, name: 'ENGENHEIRO HIDRAULICO' },
  { value: 1386, name: 'ENGENHEIRO HORTICULTOR' },
  { value: 1387, name: 'ENGENHEIRO INDUSTRIAL MECANICO' },
  { value: 1388, name: 'ENGENHEIRO MECANICO' },
  { value: 1389, name: 'ENGENHEIRO METALURGICO' },
  { value: 1390, name: 'ENGENHEIRO MINERALOGISTA' },
  { value: 1391, name: 'ENGENHEIRO NAVAL' },
  { value: 1392, name: 'ENGENHEIRO NUCLEAR' },
  { value: 1393, name: 'ENGENHEIRO ORÇCAMENTISTA' },
  { value: 1394, name: 'ENGENHEIRO QUIMICO' },
  { value: 1395, name: 'ENGENHEIRO QUIMICO(EXC.PRODUTOS ALIMENTARES)' },
  { value: 1396, name: 'ENGENHEIRO SANITARISTA' },
  { value: 1397, name: 'ENGENHEIRO OUTROS' },
  { value: 1398, name: 'ENGENHEIRO SIDERURGICO' },
  { value: 1399, name: 'ENGENHEIRO SILVICULTOR' },
  { value: 1400, name: 'ENGENHEIRO TECNOLOGO DE ALIMENTOS E BEBIDAS' },
  { value: 1401, name: 'ENGENHEIRO TERMOMECANICO' },
  { value: 1402, name: 'ENGENHEIRO TEXTIL' },
  { value: 1403, name: 'ENGOMADOR DE FIOS DE TECIDOS' },
  { value: 1404, name: 'ENGOMADOR DE ROUPAS' },
  { value: 1405, name: 'ENGOMADOR DE TECIDOS COM BORRACHA' },
  { value: 1406, name: 'ENGORDADOR DE GADO' },
  { value: 1407, name: 'ENGRAXATE' },
  { value: 1408, name: 'ENGRUPADOR' },
  { value: 1409, name: 'ENLATADOR' },
  { value: 1410, name: 'ENOLOGO' },
  { value: 1411, name: 'ENQUADRADOR (PEDRA)' },
  { value: 1412, name: 'ENRAIZADOR DE BONECAS' },
  { value: 1413, name: 'ENRAMADOR (AGRICOLA)' },
  { value: 1414, name: 'ENRAMADOR (GRAFICO)' },
  { value: 1415, name: 'ENROLADOR DE BOBINAS' },
  { value: 1416, name: 'ENROLADOR DE FIOS' },
  { value: 1417, name: 'ENROLADOR DE FUMO' },
  { value: 1418, name: 'ENROLADOR DE GAZE' },
  { value: 1419, name: 'ENROLADOR DE PANO' },
  { value: 1420, name: 'ENROLADOR ELETRICO' },
  { value: 1421, name: 'ENROLADOR SEM ESPECIFICAÇAO' },
  { value: 1422, name: 'ENSACADOR (FORA EXCEÇOES)' },
  { value: 1423, name: 'ENSACADOR DE SUPERMERCADO' },
  { value: 1424, name: 'ENSACADOR SEM ESPECIFICAÇAO' },
  { value: 1425, name: 'ENTAIPADOR' },
  { value: 1426, name: 'ENTALHADOR' },
  { value: 1427, name: 'ENTELADOR' },
  { value: 1428, name: 'ENTREGADOR DE FERRAMENTAS' },
  { value: 1429, name: 'ENTREGADOR DE JORNAIS' },
  { value: 1430, name: 'ENTREGADOR SEM ESPECIFICAÇAO' },
  { value: 1431, name: 'ENTREVISTADOR DE PESSOAL' },
  { value: 1432, name: 'ENTREVISTADOR SEM ESPECIFICAÇAO' },
  { value: 1433, name: 'ENVERNIZADOR' },
  { value: 1434, name: 'ENXADEIRO SEM ESPECIFICAÇAO' },
  { value: 1435, name: 'ENXAMEADOR' },
  { value: 1436, name: 'ENXERTADOR' },
  { value: 1437, name: 'ENXUGADOR DE COUROS E PELES' },
  { value: 1438, name: 'ENXUGADOR SEM ESPECIFICACAO' },
  { value: 1439, name: 'EQUILIBRISTA' },
  { value: 1440, name: 'ERGOTERAPEUTA' },
  { value: 1441, name: 'ERVATEIRO' },
  { value: 1442, name: 'ESBRAVADOR' },
  { value: 1443, name: 'ESCAFANDRISTA' },
  { value: 1444, name: 'ESCALADOR DE VOO' },
  { value: 1445, name: 'ESCARFADOR' },
  { value: 1446, name: 'ESCARNADOR' },
  { value: 1447, name: 'ESCAVADEIRISTA' },
  { value: 1448, name: 'ESCOLHEDOR DE PEDRAS' },
  { value: 1449, name: 'ESCOLHEDOR DE PEÇAS' },
  { value: 1450, name: 'ESCOLHEDOR SEM ESPECIFICAÇAO' },
  { value: 1451, name: 'ESCORADOR DE MINAS' },
  { value: 1452, name: 'ESCORADOR SEM ESPECIFICAÇAO' },
  { value: 1453, name: 'ESCOVADOR DE COUROS' },
  { value: 1454, name: 'ESCREVENTE' },
  { value: 1455, name: 'ESCRITOR' },
  { value: 1456, name: 'ESCRITURARIO (FORA EXCEÇOES)' },
  { value: 1457, name: 'ESCRITURARIO CONTABIL' },
  { value: 1458, name: 'ESCRITURARIO DE LIVROS FISCAIS' },
  { value: 1459, name: 'ESCRITURARIO FISCAL' },
  { value: 1460, name: 'ESCRITURARIO SEM ESPECIFICAÇAO' },
  { value: 1461, name: 'ESCRIVAO' },
  { value: 1462, name: 'ESCULPIDOR DE MADEIRA' },
  { value: 1463, name: 'ESCULTOR' },
  { value: 1464, name: 'ESGOTEIRO' },
  { value: 1465, name: 'ESMALTADOR DE CERAMICA' },
  { value: 1466, name: 'ESMALTADOR DE METAIS NAO PRECIOSOS' },
  { value: 1467, name: 'ESMALTADOR DE METAIS PRECIOSOS' },
  { value: 1468, name: 'ESMALTADOR SEM ESPECIFICAÇAO' },
  { value: 1469, name: 'ESMERILADOR DE METAIS' },
  { value: 1470, name: 'ESMERILADOR SEM ESPECIFICAÇAO' },
  { value: 1471, name: 'ESMERILHADOR DE METAIS' },
  { value: 1472, name: 'ESMERILHADOR SEM ESPECIFICACAO' },
  { value: 1473, name: 'ESPECIFICADOR DE MATERIAIS' },
  { value: 1474, name: 'ESPECIFICADOR DE NORMAS TECNICAS' },
  { value: 1475, name: 'ESPECTOGRAFISTA' },
  { value: 1476, name: 'ESPECTROMETRISTA' },
  { value: 1477, name: 'ESPELHADOR' },
  { value: 1478, name: 'ESPULADEIRA' },
  { value: 1479, name: 'ESPULADOR' },
  { value: 1480, name: 'ESQUADRIADOR(MADEIRA)' },
  { value: 1481, name: 'ESQUILADOR' },
  { value: 1482, name: 'ESTAFETA SEM ESPECIFICACAO' },
  { value: 1483, name: 'ESTAFETA(CORREIOS E TELEGRAFOS)' },
  { value: 1484, name: 'ESTAFETA(EXCETO NOS CORREIOS E TELEGRAFOS)' },
  { value: 1485, name: 'ESTALEIRADOR' },
  { value: 1486, name: 'ESTAMPADOR DE COUROS E PELES' },
  { value: 1487, name: 'ESTAMPADOR DE TECIDOS' },
  { value: 1488, name: 'ESTAMPADOR SEM ESPECIFICACAO' },
  { value: 1489, name: 'ESTANHADOR' },
  { value: 1490, name: 'ESTATISTICO (SEM CURSO SUPERIOR)' },
  { value: 1491, name: 'ESTATISTICO AUXILIAR' },
  { value: 1492, name: 'ESTATISTICO(CURSO SUPERIOR)' },
  { value: 1493, name: 'ESTEIREIRO' },
  { value: 1494, name: 'ESTENOGRAFO' },
  { value: 1495, name: 'ESTENOTIPISTA' },
  { value: 1496, name: 'ESTEREOTIPISTA' },
  { value: 1497, name: 'ESTERILIZADOR DE ALIMENTOS' },
  { value: 1498, name: 'ESTERILIZADOR DE PRODUTOS LACTEOS' },
  { value: 1499, name: 'ESTERQUEIRO' },
  { value: 1500, name: 'ESTETICISTA' },
  { value: 1501, name: 'ESTIRADOR DE COUROS E PELES' },
  { value: 1502, name: 'ESTIRADOR DE FIBRAS' },
  { value: 1503, name: 'ESTIRADOR DE METAIS' },
  { value: 1504, name: 'ESTIRADOR DE TUBOS DE METAL SEM COSTURA' },
  { value: 1505, name: 'ESTIRADOR SEM ESPECIFICACAO' },
  { value: 1506, name: 'ESTIVADOR' },
  { value: 1507, name: 'ESTOFADOR EM GERAL' },
  { value: 1508, name: 'ESTOQUISTA' },
  { value: 1509, name: 'ESTRIPADOR' },
  { value: 1510, name: 'ESTROPEIRO' },
  { value: 1511, name: 'ESTUCADOR (DECORAÇAO E GESSO)' },
  { value: 1512, name: 'ESTUCADOR (FORA EXCEÇAO)' },
  { value: 1513, name: 'ESTUCADOR SEM ESPECIFICAÇAO' },
  { value: 1514, name: 'ESTUDANTE' },
  { value: 1515, name: 'ESTUFEIRO (TECIDOS)' },
  { value: 1516, name: 'ESTUFEIRO DE MACHARIA' },
  { value: 1517, name: 'ESTUFISTA DE MACHARIA' },
  { value: 1518, name: 'ETIQUETADOR' },
  { value: 1519, name: 'EVAPOR5ADOR DE OLEO' },
  { value: 1520, name: 'EVISCERADOR' },
  { value: 1521, name: 'EXAMINADOR DE CABOS' },
  { value: 1522, name: 'EXATOR' },
  { value: 1523, name: 'EXECUTIVO' },
  { value: 1524, name: 'EXPEDICISTA' },
  { value: 1525, name: 'EXPEDIDOR DE MATERIAIS' },
  { value: 1526, name: 'EXPEDIDOR SEM ESPECIFICAÇAO' },
  { value: 1527, name: 'EXTRUSOR DE BORRACHA' },
  { value: 1528, name: 'EXTRUSOR DE METAIS' },
  { value: 1529, name: 'EXTRUSOR DE PLASTICO' },
  { value: 1530, name: 'EXTRUSOR DE VIDRO' },
  { value: 1531, name: 'EXTRUSOR SEM ESPECIFICAÇAO' },
  { value: 1532, name: 'FABRICADOR DE CARIMBOS' },
  { value: 1533, name: 'FABRICADOR DE VELAS' },
  { value: 1534, name: 'FAQUEIRO' },
  { value: 1535, name: 'FARINHEIRO' },
  { value: 1536, name: 'FARMACEUTICO' },
  { value: 1537, name: 'FARMACOLOGISTA' },
  { value: 1538, name: 'FAROLEIRO' },
  { value: 1539, name: 'FATURISTA' },
  { value: 1540, name: 'FAXINEIRO' },
  { value: 1541, name: 'FAXINEIRO' },
  { value: 1542, name: 'FAZENDEIRO' },
  { value: 1543, name: 'FECULADOR (CURSO SUPERIOR)' },
  { value: 1544, name: 'FEIRANTE' },
  { value: 1545, name: 'FEITOR AGRICOLA' },
  { value: 1546, name: 'FEITOR DE FERRAMENTARIA' },
  { value: 1547, name: 'FEITOR DE INSPEÇAO' },
  { value: 1548, name: 'FEITOR DE MANOBRAS' },
  { value: 1549, name: 'FEITOR DE OBRAS' },
  { value: 1550, name: 'FEITOR DE PRODUÇAO' },
  { value: 1551, name: 'FEITOR DE TURMA (EXCETO AGRICOLA)' },
  { value: 1552, name: 'FEITOR FLORESTAL' },
  { value: 1553, name: 'FEITOR SEM ESPECIFICAÇAO' },
  { value: 1554, name: 'FERMENTADOR' },
  { value: 1555, name: 'FERRADOR' },
  { value: 1556, name: 'FERRAMENTEIRO' },
  { value: 1557, name: 'FERREIRO (FORA EXCEÇAO)' },
  { value: 1558, name: 'FERREIRO ARMADOR' },
  { value: 1559, name: 'FERREIRO' },
  { value: 1560, name: 'FERROVIARIO SEM ESPECIFICAÇAO' },
  { value: 1561, name: 'FIAMBEIRO' },
  { value: 1562, name: 'FIANDEIRO (FORA EXCEÇAO)' },
  { value: 1563, name: 'FIANDEIRO DE FIBRAS ARTIFICIAIS' },
  { value: 1564, name: 'FIANDEIRO SEM ESPECIFICAÇAO' },
  { value: 1565, name: 'FICHARISTA' },
  { value: 1566, name: 'FIEL DE ALMOXARIFADO' },
  { value: 1567, name: 'FIEL DE VALORES' },
  { value: 1568, name: 'FIGURINISTA' },
  { value: 1569, name: 'FILADOR' },
  { value: 1570, name: 'FILETADOR' },
  { value: 1571, name: 'FILOLOGO' },
  { value: 1572, name: 'FILOSOFO' },
  { value: 1573, name: 'FILTRADOR DE CERVEJA' },
  { value: 1574, name: 'FINANCISTA' },
  { value: 1575, name: 'FISCAL DA PREVIDENCIA SOCIAL' },
  { value: 1576, name: 'FISCAL DE ARMAZEM' },
  { value: 1577, name: 'FISCAL DE BANCO' },
  { value: 1578, name: 'FISCAL' },
  { value: 1579, name: 'FISCAL DE CONTRIBUIÇOES PREVIDENCIARIAS' },
  { value: 1580, name: 'FISCAL DE ESTAÇAO (FERROVIAS)' },
  { value: 1581, name: 'FISCAL DE IBC' },
  { value: 1582, name: 'FISCAL DE LIMPEZA URBANA' },
  { value: 1583, name: 'FISCAL DE LINHA' },
  { value: 1584, name: 'FISCAL DE LOJA' },
  { value: 1585, name: 'FISCAL DE MAQUINA DE PRODUÇAO' },
  { value: 1586, name: 'FISCAL DE MOVIMENTO (FERROVIAS)' },
  { value: 1587, name: 'FISCAL DE OBRAS (EMPRESAS)' },
  { value: 1588, name: 'FISCAL DE OBRAS SEM ESPECIFICACAO' },
  { value: 1589, name: 'FISCAL DE OBRAS(SERVICO PUBLICO,AUTARQUIAS)' },
  { value: 1590, name: 'FISCAL DE ONIBUS' },
  { value: 1591, name: 'FISCAL DE PORTARIA' },
  { value: 1592, name: 'FISCAL DE TRAFEGO AEREO' },
  { value: 1593, name: 'FISCAL DE TRANSPORTE COLETIVO(EXCETO TREM)' },
  { value: 1594, name: 'FISCAL DE TREM' },
  { value: 1595, name: 'FISCAL DE TRIBUTOS' },
  { value: 1596, name: 'FISCAL DE VIACAO' },
  { value: 1597, name: 'FISCAL DE VIGILANCIA' },
  { value: 1598, name: 'FISCAL SEM ESPECIFICACAO' },
  { value: 1599, name: 'FISICO' },
  { value: 1600, name: 'FISIOLOGISTA' },
  { value: 1601, name: 'FISIOTERAPEUTA' },
  { value: 1602, name: 'FITOTECARIO' },
  { value: 1603, name: 'FLORICULTOR' },
  { value: 1604, name: 'FLORISTA (FLORES ARTIFICIAIS)' },
  { value: 1605, name: 'FLORISTA SEM ESPECIFICACAO' },
  { value: 1606, name: 'FLORISTA(COMERCIO)' },
  { value: 1607, name: 'FOGUETEIRO' },
  { value: 1608, name: 'FOGUISTA (CALDEIRA A VAPOR)' },
  { value: 1609, name: 'FOGUISTA DE EMBARCACOES' },
  { value: 1610, name: 'FOGUISTA DE TREM' },
  { value: 1611, name: 'FOGUISTA SEM ESPECIFICACAO' },
  { value: 1612, name: 'FOLHEADOR DE MOVEIS' },
  { value: 1613, name: 'FOLHEADOR SEM ESPECIFICACAO' },
  { value: 1614, name: 'FOLLOW-UP DE PRODUCAO' },
  { value: 1615, name: 'FONEGRAMISTA' },
  { value: 1616, name: 'FONOAUDIOLOGO' },
  { value: 1617, name: 'FORJADOR' },
  { value: 1618, name: 'FORNEIRO DE ALTO FORNO' },
  { value: 1619, name: 'FORNEIRO DE CADINHO' },
  { value: 1620, name: 'FORNEIRO DE CONVERSOR' },
  { value: 1621, name: 'FORNEIRO DE CUBILO' },
  { value: 1622, name: 'FORNEIRO DE FAIANCA E PORCELANA' },
  { value: 1623, name: 'FORNEIRO DE FORJARIA' },
  { value: 1624, name: 'FORNEIRO DE FORNO-POCO' },
  { value: 1625, name: 'FORNEIRO DE MANDIOCA' },
  { value: 1626, name: 'FORNEIRO DE MATERIAL DE CONSTRUCAO' },
  { value: 1627, name: 'FORNEIRO DE REVERBERO' },
  { value: 1628, name: 'FORNEIRO DE TRATAMENTO TERMICO' },
  { value: 1629, name: 'FORNEIRO DE VIDRARIA E CERAMICA' },
  { value: 1630, name: 'FORNEIRO METALURGICO (1 FUSAO)' },
  { value: 1631, name: 'FORNEIRO METALURGICO (2 FUSAO)' },
  { value: 1632, name: 'FORNEIRO PIROMETRISTA' },
  { value: 1633, name: 'FORNEIRO SEM ESPECIFICACAO' },
  { value: 1634, name: 'FOSCADOR (DE ESPELHO)' },
  { value: 1635, name: 'FOSFATIZADOR' },
  { value: 1636, name: 'FOTOCOPISTA' },
  { value: 1637, name: 'FOTOGRAFO (FORA EXCECOES)' },
  { value: 1638, name: 'FOTOGRAFO (FOTOGRAVURA)' },
  { value: 1639, name: 'FOTOGRAFO DE SERIGRAFIA' },
  { value: 1640, name: 'FOTOGRAFO DE TRACO' },
  { value: 1641, name: 'FOTOGRAFO' },
  { value: 1642, name: 'FOTOGRAMETRISTA' },
  { value: 1643, name: 'FOTOGRAVADOR' },
  { value: 1644, name: 'FOTOIMPRESSOR DE CHAPAS' },
  { value: 1645, name: 'FOTOLITO,GRAVADOR A' },
  { value: 1646, name: 'FRENTISTA (CONSTRUCAO CIVIL)' },
  { value: 1647, name: 'FRENTISTA (POSTO DE GASOLINA)' },
  { value: 1648, name: 'FRENTISTA SEM ESPECIFICACAO' },
  { value: 1649, name: 'FRESADOR (FORA EXCECAO)' },
  { value: 1650, name: 'FRESADOR COPIADOR' },
  { value: 1651, name: 'FRESADOR SEM ESPECIFICACAO' },
  { value: 1652, name: 'FRUTEIRO' },
  { value: 1653, name: 'FRUTICULTOR' },
  { value: 1654, name: 'FUMICULTOR' },
  { value: 1655, name: 'FUNCIONARIO AUTARQUISTA' },
  { value: 1656, name: 'FUNCIONARIO DA JUSTICA' },
  { value: 1657, name: 'FUNCIONARIO PUBLICO' },
  { value: 1658, name: 'FUNCIONARIO PUBLICO SUPERIOR' },
  { value: 1659, name: 'FUNCIONARIO SEM ESPECIFICACAO' },
  { value: 1660, name: 'FUNDIDOR DE ESTEREOPLASTICO' },
  { value: 1661, name: 'FUNDIDOR DE JOALHERIA' },
  { value: 1662, name: 'FUNDIDOR DE METAIS' },
  { value: 1663, name: 'FUNDIDOR DE PRESSAO' },
  { value: 1664, name: 'FUNDIDOR DE VIDRO' },
  { value: 1665, name: 'FUNDIDOR METALURGICO (1a. FUSAO)' },
  { value: 1666, name: 'FUNDIDOR METALURGICO (2a. FUSAO)' },
  { value: 1667, name: 'FUNDIDOR SEM ESPECIFICACAO' },
  { value: 1668, name: 'FUNDIDOR VIDREIRO' },
  { value: 1669, name: 'FUNERARIO, AGENTE' },
  { value: 1670, name: 'FUNILEIRO' },
  { value: 1671, name: 'FURADOR (FORA EXCECAO)' },
  { value: 1672, name: 'FURADOR DE PECAS DE CERAMICA' },
  { value: 1673, name: 'FURADOR SEM ESPECIFICACAO' },
  { value: 1674, name: 'GAIOLEIRO' },
  { value: 1675, name: 'GALVANIZADOR' },
  { value: 1676, name: 'GALVANOPLASTA' },
  { value: 1677, name: 'GALVANOPLASTA (GRAFICO)' },
  { value: 1678, name: 'GARCOM' },
  { value: 1679, name: 'GARI' },
  { value: 1680, name: 'GARIMPEIRO' },
  { value: 1681, name: 'GASISTA' },
  { value: 1682, name: 'GENEALOGISTA' },
  { value: 1683, name: 'GEOFISICO' },
  { value: 1684, name: 'GEOGRAFO' },
  { value: 1685, name: 'GEOLOGO' },
  { value: 1686, name: 'GEOLOGO (SEM CURSO SUPERIOR)' },
  { value: 1687, name: 'GEOMETRA' },
  { value: 1688, name: 'GEOQUIMICO' },
  { value: 1689, name: 'GERADORISTA' },
  { value: 1690, name: 'GERENTE ADMINISTRATIVO' },
  { value: 1691, name: 'GERENTE AGRICOLA' },
  { value: 1692, name: 'GERENTE CINEMATOGRAFICO' },
  { value: 1693, name: 'GERENTE COMERCIAL' },
  { value: 1694, name: 'GERENTE DE AEROPORTO' },
  { value: 1695, name: 'GERENTE DE ARMAZEM' },
  { value: 1696, name: 'GERENTE DE BAR E LANCHONETE' },
  { value: 1697, name: 'GERENTE DE CAMBIO' },
  { value: 1698, name: 'GERENTE DE CANTINA' },
  { value: 1699, name: 'GERENTE DE CINEMA' },
  { value: 1700, name: 'GERENTE DE COMPRAS' },
  { value: 1701, name: 'GERENTE DE CONTROLE DE QUALIDADE' },
  { value: 1702, name: 'GERENTE DE CORREIOS E TELEGRAFOS' },
  { value: 1703, name: 'GERENTE DE CUSTOS' },
  { value: 1704, name: 'GERENTE DE DIVISAO DE PECAS' },
  { value: 1705, name: 'GERENTE DE ENGENHARIA INDUSTRIAL' },
  { value: 1706, name: 'GERENTE DE FROTA (TRANSPORTE)' },
  { value: 1707, name: 'GERENTE DE HOTEL' },
  { value: 1708, name: 'GERENTE DE IMPORTACAO' },
  { value: 1709, name: 'GERENTE DE LOJA' },
  { value: 1710, name: 'GERENTE DE MARKETING' },
  { value: 1711, name: 'GERENTE DE MATERIAIS' },
  { value: 1712, name: 'GERENTE DE MODERNIZACAO' },
  { value: 1713, name: 'GERENTE DE ORCAMENTOS' },
  { value: 1714, name: 'GERENTE DE PATRIMONIO' },
  { value: 1715, name: 'GERENTE DE PESQUISA E DESENVOLVIMENTO' },
  { value: 1716, name: 'GERENTE DE PESSOAL' },
  { value: 1717, name: 'GERENTE DE PLANEJAMENTO E ORGANIZACAO' },
  { value: 1718, name: 'GERENTE DE PRODUCAO' },
  { value: 1719, name: 'GERENTE DE PRODUTOS' },
  { value: 1720, name: 'GERENTE DE PROMOCAO' },
  { value: 1721, name: 'GERENTE DE PROPAGANDA' },
  { value: 1722, name: 'GERENTE DE PUBLICIDADE' },
  { value: 1723, name: 'GERENTE DE RECURSOS HUMANOS' },
  { value: 1724, name: 'GERENTE DE RELACOES INDUSTRIAIS' },
  { value: 1725, name: 'GERENTE DE RELACOES PUBLICAS' },
  { value: 1726, name: 'GERENTE DE RESTAURANTE' },
  { value: 1727, name: 'GERENTE DE SISTEMAS E METODOS' },
  { value: 1728, name: 'GERENTE DE TREINAMENTO' },
  { value: 1729, name: 'GERENTE DE VENDAS' },
  { value: 1730, name: 'GERENTE FINANCEIRO' },
  { value: 1731, name: 'GERENTE INDUSTRIAL' },
  { value: 1732, name: 'GERENTE OPERACIONAL' },
  { value: 1733, name: 'GERENTE' },
  { value: 1734, name: 'GERENTE TECNICO' },
  { value: 1735, name: 'GERENTE TESOUREIRO' },
  { value: 1736, name: 'GESSEIRO' },
  { value: 1737, name: 'GINECOLOGISTA' },
  { value: 1738, name: 'GOMEIRO' },
  { value: 1739, name: 'GOVERNADOR' },
  { value: 1740, name: 'GOVERNANTA' },
  { value: 1741, name: 'GRAFICO' },
  { value: 1742, name: 'GRAMPEADOR' },
  { value: 1743, name: 'GRAMPEIRO' },
  { value: 1744, name: 'GRANITADOR' },
  { value: 1745, name: 'GRANITEIRO' },
  { value: 1746, name: 'GRANJEIRO' },
  { value: 1747, name: 'GRANULADOR DE CAFE' },
  { value: 1748, name: 'GRAVADOR (ENCADERNACAO)' },
  { value: 1749, name: 'GRAVADOR (FOTOGRAVURA)' },
  { value: 1750, name: 'GRAVADOR (IMPRESSAO)' },
  { value: 1751, name: 'GRAVADOR (JOALHERIA)' },
  { value: 1752, name: 'GRAVADOR A AGUA FORTE' },
  { value: 1753, name: 'GRAVADOR ARTISTICO' },
  { value: 1754, name: 'GRAVADOR COM PANTOGRAFO' },
  { value: 1755, name: 'GRAVADOR DE AUTOTIPIA' },
  { value: 1756, name: 'GRAVADOR DE INSCRICAO EM PEDRA' },
  { value: 1757, name: 'GRAVADOR DE OSSO' },
  { value: 1758, name: 'GRAVADOR DE PEDRA' },
  { value: 1759, name: 'GRAVADOR DE PEDRAS LITOGRAFICAS' },
  { value: 1760, name: 'GRAVADOR DE PLASTICO' },
  { value: 1761, name: 'GRAVADOR DE RELEVOS EM PEDRA' },
  { value: 1762, name: 'GRAVADOR DE ROTOGRAVURA' },
  { value: 1763, name: 'GRAVADOR DE TRACO' },
  { value: 1764, name: 'GRAVADOR DE V.D.' },
  { value: 1765, name: 'GRAVADOR DE VIDRO' },
  { value: 1766, name: 'GRAVADOR SEM ESPECIFICACAO' },
  { value: 1767, name: 'GRAVADOR TRICOMISTA' },
  { value: 1768, name: 'GRAXEIRO' },
  { value: 1769, name: 'GROSADOR' },
  { value: 1770, name: 'GUARDA DE CAMPING' },
  { value: 1771, name: 'GUARDA DE PRESIDIO' },
  { value: 1772, name: 'GUARDA DE RETIRO (PECUARIA)' },
  { value: 1773, name: 'GUARDA DE SEGURANCA' },
  { value: 1774, name: 'GUARDA DE TRANSITO' },
  { value: 1775, name: 'GUARDA DE TRIBUNAIS' },
  { value: 1776, name: 'GUARDA DE VIGILANCIA' },
  { value: 1777, name: 'GUARDA SEM ESPECIFICACAO' },
  { value: 1778, name: 'GUARDA-CANCELA' },
  { value: 1779, name: 'GUARDA-CHAVES' },
  { value: 1780, name: 'GUARDA-CIVIL' },
  { value: 1781, name: 'GUARDA-COSTAS' },
  { value: 1782, name: 'GUARDA-FERRAMENTAS' },
  { value: 1783, name: 'GUARDA-FERROVIARIO' },
  { value: 1784, name: 'GUARDA-FIOS' },
  { value: 1785, name: 'GUARDA-FLORESTAL' },
  { value: 1786, name: 'GUARDA-FREIOS' },
  { value: 1787, name: 'GUARDA-LIVROS (CURSO SUPERIOR)' },
  { value: 1788, name: 'GUARDA-LIVROS (SEM CURSO SUPERIOR)' },
  { value: 1789, name: 'GUARDA-MUNICIPAL' },
  { value: 1790, name: 'GUARDA-NOTURNO' },
  { value: 1791, name: 'GUARDA-NOTURNO PARTICULAR' },
  { value: 1792, name: 'GUARDA-PORTUARIO' },
  { value: 1793, name: 'GUARDA-RODOVIARIO' },
  { value: 1794, name: 'GUARDA-ROUPA' },
  { value: 1795, name: 'GUARDA-SANITARIO' },
  { value: 1796, name: 'GUARDADOR DE VEICULOS' },
  { value: 1797, name: 'GUIA' },
  { value: 1798, name: 'GUILHOTINISTA' },
  { value: 1799, name: 'GUINCHEIRO' },
  { value: 1800, name: 'GUINDASTEIRO' },
  { value: 1801, name: 'HIDRAULICO (SEM CURSO SUPERIOR)' },
  { value: 1802, name: 'HIDROBIOLOGISTA' },
  { value: 1803, name: 'HIDROGENADOR DE OLEOS E GORDURAS' },
  { value: 1804, name: 'HIDROMETRISTA' },
  { value: 1805, name: 'HIGIENISTA (CURSO SUPERIOR)' },
  { value: 1806, name: 'HIGIENIZADOR DE LEITE' },
  { value: 1807, name: 'HISTORIADOR' },
  { value: 1808, name: 'HORTICULTOR' },
  { value: 1809, name: 'HOTELEIRO' },
  { value: 1810, name: 'ICTIOLOGO' },
  { value: 1811, name: 'IGUALADOR DE PELES' },
  { value: 1812, name: 'ILUMINADOR (TEATRO E TV)' },
  { value: 1813, name: 'ILUSTRADOR' },
  { value: 1814, name: 'IMEDIATO(NAVEGACAO)' },
  { value: 1815, name: 'IMPERMEABILIZADOR' },
  { value: 1816, name: 'IMPOSITOR' },
  { value: 1817, name: 'IMPREGNADOR DE BORRACHA' },
  { value: 1818, name: 'IMPREGNADOR DE MADEIRA' },
  { value: 1819, name: 'IMPREGNADOR DE PAPEL' },
  { value: 1820, name: 'IMPRESSOR (MULTILITH)' },
  { value: 1821, name: 'IMPRESSOR (PRENSA CILINDRICA)' },
  { value: 1822, name: 'IMPRESSOR (SERIGRAFIA)' },
  { value: 1823, name: 'IMPRESSOR DE OFFSET' },
  { value: 1824, name: 'IMPRESSOR DE PAPEIS DECORATIVOS' },
  { value: 1825, name: 'IMPRESSOR DE ROTOGRAVURA' },
  { value: 1826, name: 'IMPRESSOR DE SILK-SCREEN' },
  { value: 1827, name: 'IMPRESSOR GRAFICO MANUAL' },
  { value: 1828, name: 'IMPRESSOR LITOGRAFICO' },
  { value: 1829, name: 'IMPRESSOR MINERVISTA' },
  { value: 1830, name: 'IMPRESSOR SEM ESPECIFICACAO' },
  { value: 1831, name: 'IMPRESSOR TIPOGRAFICO' },
  { value: 1832, name: 'INATIVO' },
  { value: 1833, name: 'INCUBADOR' },
  { value: 1834, name: 'INDEXADOR' },
  { value: 1835, name: 'INDUSTRIAL' },
  { value: 1836, name: 'INDUSTRIARIO' },
  { value: 1837, name: 'INFORMANTE COMERCIAL' },
  { value: 1838, name: 'INFORMANTE DE CADASTRO' },
  { value: 1839, name: 'INFORMANTE SEM ESPECIFICACAO' },
  { value: 1840, name: 'INJETOR DE PLASTICO' },
  { value: 1841, name: 'INSEMINADOR' },
  { value: 1842, name: 'INSPETOR COMERCIAL' },
  { value: 1843, name: 'INSPETOR DE ALUNOS' },
  { value: 1844, name: 'INSPETOR DE ARMAZENAMENTO DE GRAOS' },
  { value: 1845, name: 'INSPETOR DE AVARIAS' },
  { value: 1846, name: 'INSPETOR DE AVIAO' },
  { value: 1847, name: 'INSPETOR DE CALDEIRARIA' },
  { value: 1848, name: 'INSPETOR DE CAMPO' },
  { value: 1849, name: 'INSPETOR DE CENTROS DE ABASTECIMENTO' },
  { value: 1850, name: 'INSPETOR DE COBRANCA' },
  { value: 1851, name: 'INSPETOR DE COMERCIALIZACAO DE PRODUTOS' },
  { value: 1852, name: 'INSPETOR DE ESCOLA' },
  { value: 1853, name: 'INSPETOR DE ESTACAO (FERROVIAS)' },
  { value: 1854, name: 'INSPETOR DE ESTAMPARIA' },
  { value: 1855, name: 'INSPETOR DE FERRAMENTAS' },
  { value: 1856, name: 'INSPETOR DE FUMO' },
  { value: 1857, name: 'INSPETOR DE FUNDICAO' },
  { value: 1858, name: 'INSPETOR DE HIGIENE E SEGURANCA DO TRABALHO' },
  { value: 1859, name: 'INSPETOR DE INSTALACOES INDUSTRIAIS' },
  { value: 1860, name: 'INSPETOR DE LABORATORIO' },
  { value: 1861, name: 'INSPETOR DE LICENCA URBANA' },
  { value: 1862, name: 'INSPETOR DE LICENCIAMENTO DE VEICULOS' },
  { value: 1863, name: 'INSPETOR DE LINHA DE PRODUCAO' },
  { value: 1864, name: 'INSPETOR DE MATERIAL' },
  { value: 1865, name: 'INSPETOR DE MATRIZES' },
  { value: 1866, name: 'INSPETOR DE METEOROLOGIA' },
  { value: 1867, name: 'INSPETOR DE MOVIMENTO (FERROVIAS)' },
  { value: 1868, name: 'INSPETOR DE OBRAS (SERVICO PUBLICO)' },
  { value: 1869, name: 'INSPETOR DE OBRAS SEM ESPECIFICACAO' },
  { value: 1870, name: 'INSPETOR DE POLICIA' },
  { value: 1871, name: 'INSPETOR DE PREVENCAO CONTRA INCENDIO' },
  { value: 1872, name: 'INSPETOR DE PRODUCAO' },
  { value: 1873, name: 'INSPETOR DE PROVAS' },
  { value: 1874, name: 'INSPETOR DE QUALIDADE' },
  { value: 1875, name: 'INSPETOR DE RECEBIMENTO' },
  { value: 1876, name: 'INSPETOR DE ROTAS' },
  { value: 1877, name: 'INSPETOR DE SEGURANCA' },
  { value: 1878, name: 'INSPETOR DE SEGURANCA DO TRABALHO' },
  { value: 1879, name: 'INSPETOR DE SEGURANCA INDUSTRIAL' },
  { value: 1880, name: 'INSPETOR DE SERVICO DE TRANSPORTE RODOVIARIO' },
  { value: 1881, name: 'INSPETOR DE TRABALHO' },
  { value: 1882, name: 'INSPETOR DE TRAFEGO (EXCETO FERROVIAS)' },
  { value: 1883, name: 'INSPETOR DE TRAFEGO (FERROVIAS)' },
  { value: 1884, name: 'INSPETOR DE TRANSPORTE (FERROVIAS)' },
  { value: 1885, name: 'INSPETOR DE TRANSPORTE COLETIVO' },
  { value: 1886, name: 'INSPETOR DE TREM' },
  { value: 1887, name: 'INSPETOR DE USINAGEM' },
  { value: 1888, name: 'INSPETOR DE VEICULOS' },
  { value: 1889, name: 'INSPETOR DE VENDAS' },
  { value: 1890, name: 'INSPETOR DE VIGILANCIA' },
  { value: 1891, name: 'INSPETOR GERAL' },
  { value: 1892, name: 'INSPETOR SEM ESPECIFICACAO' },
  { value: 1893, name: 'INSPETOR TECNICO DE VENDAS' },
  { value: 1894, name: 'INSPETOR TECNICO SEM ESPECIFICACAO' },
  { value: 1895, name: 'INSPETOR VISUAL (FUNDAMENTAL)' },
  { value: 1896, name: 'INST.ISOL.TERM.(CLIMATIZACAO E REFRIGERACAO)' },
  { value: 1897, name: 'INST.ISOLANTES TERM.(CALDEIRAS E TUBULACOES)' },
  { value: 1898, name: 'INSTALADOR DE CABOS E CORDAS (VEICULOS)' },
  { value: 1899, name: 'INSTALADOR DE EQUIPA/ DE LEVANTA/(CONSTRUCAO)' },
  { value: 1900, name: 'INSTALADOR DE FERRAMENTAS (ELETRONICAS)' },
  { value: 1901, name: 'INSTALADOR DE ISOLANTES ACUSTICOS' },
  { value: 1902, name: 'INSTALADOR DE LINHAS ELETRICAS' },
  { value: 1903, name: 'INSTALADOR DE MATERIAL ISOLANTE' },
  { value: 1904, name: 'INSTALADOR DE REDES DE ESGOTO' },
  { value: 1905, name: 'INSTALADOR DE TELEGRAFO E TELEFONIA' },
  { value: 1906, name: 'INSTALADOR DE TUBULACOES EM GERAL' },
  { value: 1907, name: 'INSTALADOR ELETRICISTA (REDE)' },
  { value: 1908, name: 'INSTALADOR ELETRICISTA SEM ESPECIFICACAO' },
  { value: 1909, name: 'INSTALADOR HIDRAULICO' },
  { value: 1910, name: 'INSTALADOR SEM ESPECIFICACAO' },
  { value: 1911, name: 'INSTRUMENTADOR CIRURGICO' },
  { value: 1912, name: 'INSTRUMENTISTA (MUSICO)' },
  { value: 1913, name: 'INSTRUMENTISTA DE AVIOES' },
  { value: 1914, name: 'INSTRUMENTISTA ELETRONICO (MONTAGEM)' },
  { value: 1915, name: 'INSTRUMENTISTA MECANICO' },
  { value: 1916, name: 'INSTRUTOR DE AUTO-ESCOLA' },
  { value: 1917, name: 'INSTRUTOR DE BALE' },
  { value: 1918, name: 'INSTRUTOR DE EDUCACAO FISICA' },
  { value: 1919, name: 'INSTRUTOR DE ESPORTE' },
  { value: 1920, name: 'INSTRUTOR DE FORMACAO PROFISSIONAL' },
  { value: 1921, name: 'INSTRUTOR DE OFICIO' },
  { value: 1922, name: 'INSTRUTOR DE VOO' },
  { value: 1923, name: 'INSTRUTOR SEM ESPECIFICACAO' },
  { value: 1924, name: 'INSTRUTOR TECNICO' },
  { value: 1925, name: 'INTENDENTE DE BORDO' },
  { value: 1926, name: 'INTERCALADOR SEM ESPECIFICACAO' },
  { value: 1927, name: 'INTERPRETE' },
  { value: 1928, name: 'INVALIDO' },
  { value: 1929, name: 'INVENTARIANTE (ABASTECIMENTO)' },
  { value: 1930, name: 'INVENTARIANTE FLORESTAL' },
  { value: 1931, name: 'INVENTARIANTE SEM ESPECIFICACAO' },
  { value: 1932, name: 'INVERNEIRO' },
  { value: 1933, name: 'INVESTIGADOR DE CADASTRO' },
  { value: 1934, name: 'INVESTIGADOR DE POLICIA' },
  { value: 1935, name: 'INVESTIGADOR SEM ESPECIFICACAO' },
  { value: 1936, name: 'JACALEIRO' },
  { value: 1937, name: 'JARDINEIRO (AGRICULTURA)' },
  { value: 1938, name: 'JARDINEIRO (RESIDENCIAS)' },
  { value: 1939, name: 'JARDINEIRO' },
  { value: 1940, name: 'JATEADOR' },
  { value: 1941, name: 'JATISTA' },
  { value: 1942, name: 'JOALHEIRO' },
  { value: 1943, name: 'JOQUEI' },
  { value: 1944, name: 'JORNALEIRO' },
  { value: 1945, name: 'JORNALISTA' },
  { value: 1946, name: 'JUIZ (FORA EXCECAO)' },
  { value: 1947, name: 'JUIZ DE LINHA' },
  { value: 1948, name: 'JUIZ' },
  { value: 1949, name: 'JURISTA' },
  { value: 1950, name: 'KARDEXISTA' },
  { value: 1951, name: 'LABORATORISTA (ANALISES CLINICAS)' },
  { value: 1952, name: 'LABORATORISTA INDUSTRIAL EM GERAL' },
  { value: 1953, name: 'LABORATORISTA QUIMICO' },
  { value: 1954, name: 'LABORATORISTA SEM ESPECIFICACAO' },
  { value: 1955, name: 'LACRADOR' },
  { value: 1956, name: 'LADRILEJADOR' },
  { value: 1957, name: 'LADRILHEIRO' },
  { value: 1958, name: 'LADRILHISTA' },
  { value: 1959, name: 'LAGAREIRO' },
  { value: 1960, name: 'LAJEADOR' },
  { value: 1961, name: 'LAMINADOR DE ACO' },
  { value: 1962, name: 'LAMINADOR DE CHAPAS DE VIDRO' },
  { value: 1963, name: 'LAMINADOR DE CRISTAIS DE OPTICA' },
  { value: 1964, name: 'LAMINADOR DE MADEIRA' },
  { value: 1965, name: 'LAMINADOR DE MASSAS ALIMENTICIAS' },
  { value: 1966, name: 'LAMINADOR DE METAIS' },
  { value: 1967, name: 'LAMINADOR DE PLASTICO' },
  { value: 1968, name: 'LAMINADOR SEM ESPECIFICACAO' },
  { value: 1969, name: 'LAMPISTA' },
  { value: 1970, name: 'LANCADOR DE CONTAS' },
  { value: 1971, name: 'LANCHEIRO' },
  { value: 1972, name: 'LANTERNEIRO' },
  { value: 1973, name: 'LAPIDADOR DE JOIAS' },
  { value: 1974, name: 'LAPIDADOR DE VIDROS E CRISTAIS' },
  { value: 1975, name: 'LAPIDADOR SEM ESPECIFICACAO' },
  { value: 1976, name: 'LAQUEADOR DE MOVEIS' },
  { value: 1977, name: 'LATOEIRO' },
  { value: 1978, name: 'LAVADEIRA' },
  { value: 1979, name: 'LAVADOR DE COUROS' },
  { value: 1980, name: 'LAVADOR DE FIBRAS' },
  { value: 1981, name: 'LAVADOR DE FRASCOS' },
  { value: 1982, name: 'LAVADOR DE LA' },
  { value: 1983, name: 'LAVADOR DE LOUCA' },
  { value: 1984, name: 'LAVADOR DE MATERIAL QUIMICO' },
  { value: 1985, name: 'LAVADOR DE MINERAIS' },
  { value: 1986, name: 'LAVADOR DE VASILHAME' },
  { value: 1987, name: 'LAVADOR DE VEICULOS' },
  { value: 1988, name: 'LAVADOR SEM ESPECIFICACAO' },
  { value: 1989, name: 'LAVANDEIRO' },
  { value: 1990, name: 'LAVRADOR (EMPREGADO)' },
  { value: 1991, name: 'LAVRADOR (PROPRIETARIO)' },
  { value: 1992, name: 'LAVRADOR SEM ESPECIFICACAO' },
  { value: 1993, name: 'LEILOEIRO' },
  { value: 1994, name: 'LEITEIRO' },
  { value: 1995, name: 'LEITOR DE VAZAO' },
  { value: 1996, name: 'LEITURISTA' },
  { value: 1997, name: 'LENHADOR' },
  { value: 1998, name: 'LENHEIRO' },
  { value: 1999, name: 'LETRISTA (LETREIROS)' },
  { value: 2000, name: 'LETRISTA (MUSICO)' },
  { value: 2001, name: 'LICORISTA' },
  { value: 2002, name: 'LIDER DE FABRICACAO' },
  { value: 2003, name: 'LIDER DE MONTAGEM' },
  { value: 2004, name: 'LIDER DE SEGURANCA' },
  { value: 2005, name: 'LIDER DE TURMA (EXCETO AGRICOLA)' },
  { value: 2006, name: 'LIDER DE USINAGEM' },
  { value: 2007, name: 'LIDER' },
  { value: 2008, name: 'LIGADOR DE TELEFONES' },
  { value: 2009, name: 'LIMADOR' },
  { value: 2010, name: 'LIMPADEIRA' },
  { value: 2011, name: 'LIMPADOR A SECO' },
  { value: 2012, name: 'LIMPADOR DE CHAMINES' },
  { value: 2013, name: 'LIMPADOR DE ESPULAS' },
  { value: 2014, name: 'LIMPADOR DE FACHADAS' },
  { value: 2015, name: 'LIMPADOR DE FACHADAS (A JATO)' },
  { value: 2016, name: 'LIMPADOR DE FRUTAS E LEGUMES' },
  { value: 2017, name: 'LIMPADOR DE JANELAS' },
  { value: 2018, name: 'LIMPADOR DE METAIS' },
  { value: 2019, name: 'LIMPADOR DE PISOS' },
  { value: 2020, name: 'LIMPADOR DE TEAR' },
  { value: 2021, name: 'LIMPADOR DE VEICULOS' },
  { value: 2022, name: 'LIMPADOR SEM ESPECIFICACAO' },
  { value: 2023, name: 'LINGOTADOR' },
  { value: 2024, name: 'LINOTIPISTA' },
  { value: 2025, name: 'LITOGRAFO' },
  { value: 2026, name: 'LIVREIRO' },
  { value: 2027, name: 'LIXADOR DE COUROS E PELES' },
  { value: 2028, name: 'LIXADOR DE PAPEL' },
  { value: 2029, name: 'LIXADOR DE PINTURA' },
  { value: 2030, name: 'LIXADOR DE SALTOS' },
  { value: 2031, name: 'LIXADOR DE SOLAS' },
  { value: 2032, name: 'LIXADOR SEM ESPECIFICACAO' },
  { value: 2033, name: 'LIXEIRO' },
  { value: 2034, name: 'LOCUTOR' },
  { value: 2035, name: 'LOMBADOR' },
  { value: 2036, name: 'LOTEADOR' },
  { value: 2037, name: 'LUBRIFICADOR DE EMBARCACOES' },
  { value: 2038, name: 'LUBRIFICADOR DE MAQUINAS' },
  { value: 2039, name: 'LUBRIFICADOR DE VEICULOS (EXCETO EMBARCACOES)' },
  { value: 2040, name: 'LUBRIFICADOR INDUSTRIAL' },
  { value: 2041, name: 'LUBRIFICADOR SEM ESPECIFICACAO' },
  { value: 2042, name: 'LUDLOWISTA' },
  { value: 2043, name: 'LUSTRADOR DE BORRACHA' },
  { value: 2044, name: 'LUSTRADOR DE CALCADOS (INDUSTRIA)' },
  { value: 2045, name: 'LUSTRADOR DE MOVEIS' },
  { value: 2046, name: 'LUSTRADOR DE PISOS' },
  { value: 2047, name: 'LUSTRADOR SEM ESPECIFICACAO' },
  { value: 2048, name: 'LUVEIRO' },
  { value: 2049, name: 'MACARIQUEIRO' },
  { value: 2050, name: 'MACAROQUEIRO' },
  { value: 2051, name: 'MACARRONEIRO (INDUSTRIA)' },
  { value: 2052, name: 'MACHADEIRO' },
  { value: 2053, name: 'MACHEIRO' },
  { value: 2054, name: 'MADEREIRO (PRODUCAO)' },
  { value: 2055, name: 'MADEREIRO (SUBSOLO)' },
  { value: 2056, name: 'MAESTRO' },
  { value: 2057, name: 'MAGAREFE' },
  { value: 2058, name: 'MAGISTRADO FEDERAL' },
  { value: 2059, name: 'MAITRE' },
  { value: 2060, name: 'MALABARISTA' },
  { value: 2061, name: 'MALEIRO' },
  { value: 2062, name: 'MALETEIRO' },
  { value: 2063, name: 'MALHARISTA' },
  { value: 2064, name: 'MALTEADOR (GERMINACAO)' },
  { value: 2065, name: 'MALVEIRO' },
  { value: 2066, name: 'MANCHEIRO' },
  { value: 2067, name: 'MANDIOQUEIRO' },
  { value: 2068, name: 'MANDRILADOR' },
  { value: 2069, name: 'MANEQUIM' },
  { value: 2070, name: 'MANICURE' },
  { value: 2071, name: 'MANIPULADOR (LOTERIA ESPORTIVA)' },
  { value: 2072, name: 'MANIPULADOR DE CHAPAS RADIOGRAFICAS' },
  { value: 2073, name: 'MANIPULADOR DE CORRESPONDENCIA' },
  { value: 2074, name: 'MANIPULADOR DE DROGAS (INDUSTRIA TEXTIL)' },
  { value: 2075, name: 'MANIPULADOR DE MATERIAIS (INDUSTRIA)' },
  { value: 2076, name: 'MANIPULADOR DE SOL. E SUBSTANCIAS QUIMICAS' },
  { value: 2077, name: 'MANIPULADOR DE SOLUCOES (MEDICAMETOS)' },
  { value: 2078, name: 'MANIPULANTE (CORRESPONDENCIA)' },
  { value: 2079, name: 'MANOBRADOR (FERROVIAS)' },
  { value: 2080, name: 'MANOBREIRO' },
  { value: 2081, name: 'MANOBRISTA (ESTACIONAMENTO)' },
  { value: 2082, name: 'MANOBRISTA (FABRICA)' },
  { value: 2083, name: 'MANOBRISTA (FERROVIA)' },
  { value: 2084, name: 'MANOBRISTA (GARAGEM)' },
  { value: 2085, name: 'MANOBRISTA SEM ESPECIFICACAO' },
  { value: 2086, name: 'MANTEIGUEIRO' },
  { value: 2087, name: 'MANUTENCAO (EDIFICIO)' },
  { value: 2088, name: 'MANUTENCAO (INDUSTRIA)' },
  { value: 2089, name: 'MANUTENCAO SEM ESPECIFICACAO' },
  { value: 2090, name: 'MAQUETISTA' },
  { value: 2091, name: 'MAQUILADOR' },
  { value: 2092, name: 'MAQUINISTA (INDUSTRIA DE BALAS)' },
  { value: 2093, name: 'MAQUINISTA DE ABRIDOR DE FIBRAS' },
  { value: 2094, name: 'MAQUINISTA DE CALANDRA (TECIDOS)' },
  { value: 2095, name: 'MAQUINISTA DE CARDA' },
  { value: 2096, name: 'MAQUINISTA DE CENARIO' },
  { value: 2097, name: 'MAQUINISTA DE COMPRESSOR DE AR' },
  { value: 2098, name: 'MAQUINISTA DE CONICALEIRA' },
  { value: 2099, name: 'MAQUINISTA DE ELEVADOR (MINAS)' },
  { value: 2100, name: 'MAQUINISTA DE EMBARCACAO' },
  { value: 2101, name: 'MAQUINISTA DE ENGOMADEIRA DE URDUME' },
  { value: 2102, name: 'MAQUINISTA DE ESPULADEIRA' },
  { value: 2103, name: 'MAQUINISTA DE FIACAO' },
  { value: 2104, name: 'MAQUINISTA DE FIANDEIRA' },
  { value: 2105, name: 'MAQUINISTA DE FILATORIO' },
  { value: 2106, name: 'MAQUINISTA DE LAMINADEIRA (TECIDOS)' },
  { value: 2107, name: 'MAQUINISTA DE MACAROQUEIRA' },
  { value: 2108, name: 'MAQUINISTA DE MARCENARIA' },
  { value: 2109, name: 'MAQUINISTA DE PASSADOR' },
  { value: 2110, name: 'MAQUINISTA DE PENTEADEIRA' },
  { value: 2111, name: 'MAQUINISTA DE RAMEUSE' },
  { value: 2112, name: 'MAQUINISTA DE RAMPA (MINAS)' },
  { value: 2113, name: 'MAQUINISTA DE RETORCEDEIRA' },
  { value: 2114, name: 'MAQUINISTA DE REUNIDEIRA' },
  { value: 2115, name: 'MAQUINISTA DE TREM' },
  { value: 2116, name: 'MAQUINISTA DE URDIDEIRA' },
  { value: 2117, name: 'MAQUINISTA INDUSTRIAL SEM ESPECIFICACAO' },
  { value: 2118, name: 'MAQUINISTA SEM ESPECIFICACAO' },
  { value: 2119, name: 'MARCADOR (PECUARIA)' },
  { value: 2120, name: 'MARCADOR DE EMBALAGEM' },
  { value: 2121, name: 'MARCADOR DE FARDOS' },
  { value: 2122, name: 'MARCADOR DE JORNAL' },
  { value: 2123, name: 'MARCADOR DE ROUPA' },
  { value: 2124, name: 'MARCADOR DESPORTIVO' },
  { value: 2125, name: 'MARCADOR SEM ESPECIFICACAO' },
  { value: 2126, name: 'MARCENEIRO (ARTIGOS ESPORTIVOS)' },
  { value: 2127, name: 'MARCENEIRO (CACHIMBOS)' },
  { value: 2128, name: 'MARCENEIRO (FORA EXCECOES)' },
  { value: 2129, name: 'MARCENEIRO (TAMANCOS)' },
  { value: 2130, name: 'MARCENEIRO' },
  { value: 2131, name: 'MARCHETEIRO' },
  { value: 2132, name: 'MARCINISTA DE PENTEADEIRA' },
  { value: 2133, name: 'MARGEADOR' },
  { value: 2134, name: 'MARINHEIRO' },
  { value: 2135, name: 'MARISCADOR' },
  { value: 2136, name: 'MARISQUEIRO' },
  { value: 2137, name: 'MARITIMO' },
  { value: 2138, name: 'MARMORISTA DE CONSTRUCAO' },
  { value: 2139, name: 'MARMORISTA' },
  { value: 2140, name: 'MARRETEIRO (COMERCIO)' },
  { value: 2141, name: 'MARRETEIRO (PEDREIRA)' },
  { value: 2142, name: 'MARRUEIRO' },
  { value: 2143, name: 'MARTELEIRO' },
  { value: 2144, name: 'MARTELETEIRO' },
  { value: 2145, name: 'MASCATE' },
  { value: 2146, name: 'MASSAGISTA' },
  { value: 2147, name: 'MASSEADOR (CERAMICA E VIDRARIA)' },
  { value: 2148, name: 'MASSEIRO (MASSAS ALIMENTICIAS)' },
  { value: 2149, name: 'MATA-MOSQUITO' },
  { value: 2150, name: 'MATADOR' },
  { value: 2151, name: 'MATEIRO (EXTRACAO DE MADEIRA)' },
  { value: 2152, name: 'MATEIRO (GUARDA-FLORESTAL)' },
  { value: 2153, name: 'MATEIRO (GUIA FLORESTAL)' },
  { value: 2154, name: 'MATEIRO (INVENTARIO FLORESTAL)' },
  { value: 2155, name: 'MATEIRO SEM ESPECIFICACAO' },
  { value: 2156, name: 'MATEMATICO' },
  { value: 2157, name: 'MATEMATICO-ESTATISTICO' },
  { value: 2158, name: 'MATRIZEIRO' },
  { value: 2159, name: 'MEADEIRO' },
  { value: 2160, name: 'MECANICO AJUSTADOR' },
  { value: 2161, name: 'MECANICO DE AERONAVES' },
  { value: 2162, name: 'MECANICO DE APARELHOS DE PRECISAO' },
  { value: 2163, name: 'MECANICO DE BICICLETA' },
  { value: 2164, name: 'MECANICO DE CARRO' },
  { value: 2165, name: 'MECANICO DE FOGAO' },
  { value: 2166, name: 'MECANICO DE MANUTENCAO (AERONAVES)' },
  { value: 2167, name: 'MECANICO DE MANUTENCAO (CENTRAL TELEFONICA)' },
  { value: 2168, name: 'MECANICO DE MANUTENCAO (MAQUINAS)' },
  { value: 2169, name: 'MECANICO DE MANUTENCAO (VEICULOS)' },
  { value: 2170, name: 'MECANICO DE MANUTENCAO INDUSTRIAL' },
  { value: 2171, name: 'MECANICO DE MANUTENCAO SEM ESPECIFICACAO' },
  { value: 2172, name: 'MECANICO DE MAQUINAS (FORA EXCECOES)' },
  { value: 2173, name: 'MECANICO DE MAQUINAS DE COSTURA' },
  { value: 2174, name: 'MECANICO DE MOTOR DE AVIAO' },
  { value: 2175, name: 'MECANICO DE MOTOR DE CARRO' },
  { value: 2176, name: 'MECANICO DE MOTORES (EXCETO AVIAO E CARRO)' },
  { value: 2177, name: 'MECANICO DE REFRIGERACAO' },
  { value: 2178, name: 'MECANICO DE SUSPENSAO' },
  { value: 2179, name: 'MECANICO DE TELEIMPRESSORES' },
  { value: 2180, name: 'MECANICO DE TELETIPO' },
  { value: 2181, name: 'MECANICO DE VEICULOS (EXCETO AVIAO)' },
  { value: 2182, name: 'MECANICO DE VOO' },
  { value: 2183, name: 'MECANICO GRAFICO' },
  { value: 2184, name: 'MECANICO HIDRAULICO' },
  { value: 2185, name: 'MECANICO INDUSTRIAL' },
  { value: 2186, name: 'MECANICO INSTRUMENTISTA' },
  { value: 2187, name: 'MECANICO LUBRIFICADOR (EMBARCACOES)' },
  { value: 2188, name: 'MECANICO MONTADOR (INSTRUMENTOS DE PRECISAO)' },
  { value: 2189, name: 'MECANICO MONTADOR (MAQUINAS)' },
  { value: 2190, name: 'MECANICO PLAINADOR' },
  { value: 2191, name: 'MECANICO' },
  { value: 2192, name: 'MECANICO TORNEIRO' },
  { value: 2193, name: 'MECANOGRAFO' },
  { value: 2194, name: 'MEDICO' },
  { value: 2195, name: 'MEDICO VETERINARIO' },
  { value: 2196, name: 'MEDIDOR DE ARVORES' },
  { value: 2197, name: 'MEDIDOR DE COUROS' },
  { value: 2198, name: 'MEDIDOR DE ESTRUTURAS NAVAIS' },
  { value: 2199, name: 'MEDIDOR DE MADEIRA' },
  { value: 2200, name: 'MEDIDOR DE PANO' },
  { value: 2201, name: 'MEDIDOR DE PECAS (TECELAGEM)' },
  { value: 2202, name: 'MEDIDOR DE TERRA' },
  { value: 2203, name: 'MEDIDOR SEM ESPECIFICACAO' },
  { value: 2204, name: 'MENSAGEIRO (ESCRITORIO)' },
  { value: 2205, name: 'MENSAGEIRO (FORA EXCECOES)' },
  { value: 2206, name: 'MENSAGEIRO (HOTEL)' },
  { value: 2207, name: 'MENSAGEIRO SEM ESPECIFICACAO' },
  { value: 2208, name: 'MERCADOLOGO' },
  { value: 2209, name: 'MERCEALIZADOR' },
  { value: 2210, name: 'MERCERIZADOR DE FIOS E TECIDOS' },
  { value: 2211, name: 'MERENDEIRO' },
  { value: 2212, name: 'MERGULHADOR' },
  { value: 2213, name: 'MESTRE (ELETRICIDADE, GAS E AGUA)' },
  { value: 2214, name: 'MESTRE (ESGOTO SANITARIO)' },
  { value: 2215, name: 'MESTRE (EXTRACAO DE SAL)' },
  { value: 2216, name: 'MESTRE (FONTES HIDROMINERAIS)' },
  { value: 2217, name: 'MESTRE (FORA EXCECOES)' },
  { value: 2218, name: 'MESTRE (LINHAS DE ALTA TENSAO)' },
  { value: 2219, name: 'MESTRE (MINAS E PEDREIRAS)' },
  { value: 2220, name: 'MESTRE (PETROLEO E GAS)' },
  { value: 2221, name: 'MESTRE ARRAIS' },
  { value: 2222, name: 'MESTRE DE CANOA' },
  { value: 2223, name: 'MESTRE SEM ESPECIFICACAO' },
  { value: 2224, name: 'MESTRE-DE-OBRAS' },
  { value: 2225, name: 'METALIZADOR' },
  { value: 2226, name: 'METALOGRAFISTA' },
  { value: 2227, name: 'METALURGICO' },
  { value: 2228, name: 'METEREOLOGISTA (CURSO SUPERIOR)' },
  { value: 2229, name: 'METEREOLOGISTA (SEM CURSO SUPERIOR)' },
  { value: 2230, name: 'METROLOGISTA' },
  { value: 2231, name: 'METROVIARIO SEM ESPECIFICACAO' },
  { value: 2232, name: 'MICROBIOLOGISTA' },
  { value: 2233, name: 'MILITAR' },
  { value: 2234, name: 'MIMEOGRAFISTA' },
  { value: 2235, name: 'MINEIRO' },
  { value: 2236, name: 'MINERADOR' },
  { value: 2237, name: 'MINIATURISTA' },
  { value: 2238, name: 'MINISTRO (DIPLOMACIA)' },
  { value: 2239, name: 'MINISTRO DE CULTO RELIGIOSO' },
  { value: 2240, name: 'MINISTRO DE ESTADO' },
  { value: 2241, name: 'MISSIONARIO' },
  { value: 2242, name: 'MISTURADOR (REFINO DE PETROLEO)' },
  { value: 2243, name: 'MISTURADOR DE CAFE' },
  { value: 2244, name: 'MISTURADOR DE CHA' },
  { value: 2245, name: 'MISTURADOR DE FIBRAS' },
  { value: 2246, name: 'MISTURADOR DE FUMO' },
  { value: 2247, name: 'MISTURADOR DE GRAOS' },
  { value: 2248, name: 'MISTURADOR DE TINTAS' },
  { value: 2249, name: 'MISTURADOR DE VIDRO' },
  { value: 2250, name: 'MISTURADOR DE VINHO' },
  { value: 2251, name: 'MIXADOR' },
  { value: 2252, name: 'MOCO DE CONVES' },
  { value: 2253, name: 'MODELADOR CERAMISTA' },
  { value: 2254, name: 'MODELADOR DE MADEIRA' },
  { value: 2255, name: 'MODELADOR DE METAL' },
  { value: 2256, name: 'MODELADOR DE PNEUMATICOS' },
  { value: 2257, name: 'MODELADOR SEM ESPECIFICACAO' },
  { value: 2258, name: 'MODELISTA DE CALCADOS' },
  { value: 2259, name: 'MODELISTA DE CHAPEUS' },
  { value: 2260, name: 'MODELISTA DE MADEIRA' },
  { value: 2261, name: 'MODELISTA DE ROUPAS' },
  { value: 2262, name: 'MODELISTA PELETEIRO' },
  { value: 2263, name: 'MODELISTA SEM ESPECIFICACAO' },
  { value: 2264, name: 'MODELO ARTISTICO' },
  { value: 2265, name: 'MODELO DE MODAS' },
  { value: 2266, name: 'MODELO FOTOGRAFICO' },
  { value: 2267, name: 'MODELO SEM ESPECIFICACAO' },
  { value: 2268, name: 'MODISTA' },
  { value: 2269, name: 'MOEDOR DE CACAU' },
  { value: 2270, name: 'MOEDOR DE CAFE' },
  { value: 2271, name: 'MOEDOR DE SAL' },
  { value: 2272, name: 'MOINHEIRO' },
  { value: 2273, name: 'MOLDADOR A MAO' },
  { value: 2274, name: 'MOLDADOR A MAQUINA' },
  { value: 2275, name: 'MOLDADOR CERAMISTA' },
  { value: 2276, name: 'MOLDADOR DE ABRASIVOS' },
  { value: 2277, name: 'MOLDADOR DE BLOCOS' },
  { value: 2278, name: 'MOLDADOR DE BORRACHA' },
  { value: 2279, name: 'MOLDADOR DE CERAMICA' },
  { value: 2280, name: 'MOLDADOR DE CHAPEUS' },
  { value: 2281, name: 'MOLDADOR DE CORPOS DE PROVA' },
  { value: 2282, name: 'MOLDADOR DE DIAMANTES INDUSTRIAIS' },
  { value: 2283, name: 'MOLDADOR DE LENTES' },
  { value: 2284, name: 'MOLDADOR DE METAIS' },
  { value: 2285, name: 'MOLDADOR DE PLASTICO' },
  { value: 2286, name: 'MOLDADOR EM AREIA' },
  { value: 2287, name: 'MOLDADOR EM BANCADA' },
  { value: 2288, name: 'MOLDADOR MECANICO' },
  { value: 2289, name: 'MOLDADOR SEM ESPECIFICACAO' },
  { value: 2290, name: 'MOLDEADOR DE MANTEIGA' },
  { value: 2291, name: 'MOLEIRO (FORA EXCECOES)' },
  { value: 2292, name: 'MOLEIRO (TRATAMENTOS QUIMICOS)' },
  { value: 2293, name: 'MOLEIRO DE MINERIOS' },
  { value: 2294, name: 'MOLEIRO SEM ESPECIFICACAO' },
  { value: 2295, name: 'MOLHADOR DE FUMO' },
  { value: 2296, name: 'MOLHEIRO' },
  { value: 2297, name: 'MONITOR DE BRAILLE' },
  { value: 2298, name: 'MONITOR DE EDUCACAO FISICA' },
  { value: 2299, name: 'MONITOR DE MENORES' },
  { value: 2300, name: 'MONITOR' },
  { value: 2301, name: 'MONOTIPISTA' },
  { value: 2302, name: 'MONT.ARTEFADOS DE COURO(EXC.ROUPAS E CALCADO)' },
  { value: 2303, name: 'MONT.TURBINAS(EXCETO AERONAVES E EMBARCACOES)' },
  { value: 2304, name: 'MONTADOR APARELHOS P/TRANSPORTES DE TRONCOS' },
  { value: 2305, name: 'MONTADOR DE ANDAIMES' },
  { value: 2306, name: 'MONTADOR DE APARELHOS ELETRICOS' },
  { value: 2307, name: 'MONTADOR DE APARELHOS ELETRONICOS' },
  { value: 2308, name: 'MONTADOR DE ARMACOES DE FERRO' },
  { value: 2309, name: 'MONTADOR DE ARTIGOS DE MADEIRA' },
  { value: 2310, name: 'MONTADOR DE BALANCAS' },
  { value: 2311, name: 'MONTADOR DE CABOS E PONTES' },
  { value: 2312, name: 'MONTADOR DE CAIXAS' },
  { value: 2313, name: 'MONTADOR DE CALCADOS' },
  { value: 2314, name: 'MONTADOR DE CARROS (EM SERIE)' },
  { value: 2315, name: 'MONTADOR DE CENTRAL TELEFONICA' },
  { value: 2316, name: 'MONTADOR DE CLICHES' },
  { value: 2317, name: 'MONTADOR DE CONTADORES DE CATRACA' },
  { value: 2318, name: 'MONTADOR DE EDIFICACOES PRE-FABRICADAS' },
  { value: 2319, name: 'MONTADOR DE EQUIPAMENTO DE LEVANTAMENTO' },
  { value: 2320, name: 'MONTADOR DE EQUIPAMENTO DE TELECOMUNICACOES' },
  { value: 2321, name: 'MONTADOR DE EQUIPAMETO ELETRICO' },
  { value: 2322, name: 'MONTADOR DE EQUIPAMETO ELETRONICO' },
  { value: 2323, name: 'MONTADOR DE EST.METALICAS (EXCETO AERONAVES)' },
  { value: 2324, name: 'MONTADOR DE ESTRUTURAS METALICAS (AERONAVES)' },
  { value: 2325, name: 'MONTADOR DE FECHADURAS' },
  { value: 2326, name: 'MONTADOR DE FERRAMENTAS' },
  { value: 2327, name: 'MONTADOR DE FILMES' },
  { value: 2328, name: 'MONTADOR DE FOTOLITO' },
  { value: 2329, name: 'MONTADOR DE INSTALACOES DE CALEFACAO' },
  { value: 2330, name: 'MONTADOR DE INSTRUMENTOS DE OTICA' },
  { value: 2331, name: 'MONTADOR DE INSTRUMENTOS DE PRECISAO' },
  { value: 2332, name: 'MONTADOR DE MAQUINAS' },
  { value: 2333, name: 'MONTADOR DE MOTORES' },
  { value: 2334, name: 'MONTADOR DE MOVEIS' },
  { value: 2335, name: 'MONTADOR DE PAINEIS DE CONTROLE' },
  { value: 2336, name: 'MONTADOR DE PECAS NAO ESPECIFICADAS' },
  { value: 2337, name: 'MONTADOR DE PNEUS' },
  { value: 2338, name: 'MONTADOR DE POLEAMES' },
  { value: 2339, name: 'MONTADOR DE PRODUCAO' },
  { value: 2340, name: 'MONTADOR DE PRODUTOS DE BORRACHA' },
  { value: 2341, name: 'MONTADOR DE PRODUTOS DE PLASTICO' },
  { value: 2342, name: 'MONTADOR DE ROLOS' },
  { value: 2343, name: 'MONTADOR DE TAXIMETROS' },
  { value: 2344, name: 'MONTADOR DE VELAMES' },
  { value: 2345, name: 'MONTADOR METALURGICO' },
  { value: 2346, name: 'MONTADOR NAVAL' },
  { value: 2347, name: 'MONTADOR' },
  { value: 2348, name: 'MORDOMO' },
  { value: 2349, name: 'MOROTAICO' },
  { value: 2350, name: 'MOSAISTA' },
  { value: 2351, name: 'MOTORISTA (FORA EXCECOES)' },
  { value: 2352, name: 'MOTORISTA DE BARCO' },
  { value: 2353, name: 'MOTORISTA DE EMPILHADEIRA' },
  { value: 2354, name: 'MOTORISTA DE PESCA' },
  { value: 2355, name: 'MOTORISTA SEM ESPECIFICACAO' },
  { value: 2356, name: 'MOTORNEIRO (MINAS)' },
  { value: 2357, name: 'MUSEOLOGO' },
  { value: 2358, name: 'MUSICO' },
  { value: 2359, name: 'MUSICOLOGO' },
  { value: 2360, name: 'NARRADOR ESPORTIVO' },
  { value: 2361, name: 'NAVEGADOR DE AERONAVES' },
  { value: 2362, name: 'NEGATIVISTA' },
  { value: 2363, name: 'NEUROLOGISTA' },
  { value: 2364, name: 'NIQUELADOR' },
  { value: 2365, name: 'NIVELADOR' },
  { value: 2366, name: 'NORMALIZADOR DE METAIS' },
  { value: 2367, name: 'NOTICIARISTA (TELEJORNAL)' },
  { value: 2368, name: 'NOTISTA' },
  { value: 2369, name: 'NOVELISTA' },
  { value: 2370, name: 'NUTRICIONISTA' },
  { value: 2371, name: 'OBSERVADOR METALURGICO' },
  { value: 2372, name: 'OBSTETRA' },
  { value: 2373, name: 'OBSTETRIZ (CURSO SUPERIOR)' },
  { value: 2374, name: 'OBSTETRIZ (SEM CURSO SUPERIOR)' },
  { value: 2375, name: 'OCEANOGRAFO' },
  { value: 2376, name: 'ODONTOLOGO (CURSO SUPERIOR)' },
  { value: 2377, name: 'OFFICE-BOY' },
  { value: 2378, name: 'OFICIAL ADMINISTRATIVO (SERVICO PUBLICO)' },
  { value: 2379, name: 'OFICIAL DE COBERTA' },
  { value: 2380, name: 'OFICIAL DE FARMACIA' },
  { value: 2381, name: 'OFICIAL DE GABINETE' },
  { value: 2382, name: 'OFICIAL DE JUSTICA' },
  { value: 2383, name: 'OFICIAL DE MANUTENCAO' },
  { value: 2384, name: 'OFICIAL DE NAVEGACAO MARITIMA E INTERIOR' },
  { value: 2385, name: 'OFICIAL DE SERVICOS DE ESGOTO' },
  { value: 2386, name: 'OFICIAL HIDRAULICO' },
  { value: 2387, name: 'OFICIAL MAQUINISTA (EMBARCACOES)' },
  { value: 2388, name: 'OFTALMOLOGISTA' },
  { value: 2389, name: 'OLEIRO' },
  { value: 2390, name: 'OLHEIRO DE PESCA' },
  { value: 2391, name: 'OPACADOR' },
  { value: 2392, name: 'OPERADOR AGRICOLA' },
  { value: 2393, name: 'OPERADOR CINEMATOGRAFICO (PROJECAO)' },
  { value: 2394, name: 'OPERADOR CONTABIL' },
  { value: 2395, name: 'OPERADOR DE ABREUGRAFIA' },
  { value: 2396, name: 'OPERADOR DE ACOES' },
  { value: 2397, name: 'OPERADOR DE BALANCA' },
  { value: 2398, name: 'OPERADOR DE BOLSA' },
  { value: 2399, name: 'OPERADOR DE BOMBEAMENTO (ESTACAO DE)' },
  { value: 2400, name: 'OPERADOR DE BRITADEIRA' },
  { value: 2401, name: 'OPERADOR DE CALDEIRA' },
  { value: 2402, name: 'OPERADOR DE CAMBIO' },
  { value: 2403, name: 'OPERADOR DE CAMERA CINEMATOGRAFICA' },
  { value: 2404, name: 'OPERADOR DE CENTRIFUGADORA' },
  { value: 2405, name: 'OPERADOR DE COMPOSER' },
  { value: 2406, name: 'OPERADOR DE COMPUTADOR' },
  { value: 2407, name: 'OPERADOR DE CONTAS CORRENTES' },
  { value: 2408, name: 'OPERADOR DE COSMETICOS' },
  { value: 2409, name: 'OPERADOR DE DADOS' },
  { value: 2410, name: 'OPERADOR DE ELETROEROSAO' },
  { value: 2411, name: 'OPERADOR DE EMPILHADEIRA' },
  { value: 2412, name: 'OPERADOR DE EQUIPAMENTO NAO ESPECIFICADO' },
  { value: 2413, name: 'OPERADOR DE EXAUSTOR' },
  { value: 2414, name: 'OPERADOR DE FILMES' },
  { value: 2415, name: 'OPERADOR DE FILTRAGEM' },
  { value: 2416, name: 'OPERADOR DE FORNO' },
  { value: 2417, name: 'OPERADOR DE FOTOMECANICA' },
  { value: 2418, name: 'OPERADOR DE GUINDASTE' },
  { value: 2419, name: 'OPERADOR DE I.O' },
  { value: 2420, name: 'OPERADOR DE INJETORA DE PLASTICO' },
  { value: 2421, name: 'OPERADOR DE LIOFILIZACAO' },
  { value: 2422, name: 'OPERADOR DE LOCOMOTIVA' },
  { value: 2423, name: 'OPERADOR DE MAQUINA DE DOBRAR CHAPAS' },
  { value: 2424, name: 'OPERADOR DE MAQUINA MISTURADEIRA' },
  { value: 2425, name: 'OPERADOR DE MAQUINA NAO ESPECIFICADA' },
  { value: 2426, name: 'OPERADOR DE MAQUINAS AGRICOLAS' },
  { value: 2427, name: 'OPERADOR DE MESA E BOLSA' },
  { value: 2428, name: 'OPERADOR DE MICROONDAS' },
  { value: 2429, name: 'OPERADOR DE OFFSET' },
  { value: 2430, name: 'OPERADOR DE PAINEL DE CALCINACAO' },
  { value: 2431, name: 'OPERADOR DE PAINEL DE COQUERIA' },
  { value: 2432, name: 'OPERADOR DE PAINEL DE REFIO DE PETROLEO' },
  { value: 2433, name: 'OPERADOR DE PAINEL DE SINTERIZACAO' },
  { value: 2434, name: 'OPERADOR DE PAINEL NAO ESPECIFICADO' },
  { value: 2435, name: 'OPERADOR DE PERFURATRIZ' },
  { value: 2436, name: 'OPERADOR DE PONTE ROLANTE' },
  { value: 2437, name: 'OPERADOR DE PRODUCAO' },
  { value: 2438, name: 'OPERADOR DE RAIOS X' },
  { value: 2439, name: 'OPERADOR DE REFINARIA (EXTRACAO MINERAL)' },
  { value: 2440, name: 'OPERADOR DE SERRA (EXPLORACAO FLORESTAL)' },
  { value: 2441, name: 'OPERADOR DE SISTEMA DE REVERSAO' },
  { value: 2442, name: 'OPERADOR DE SOM' },
  { value: 2443, name: 'OPERADOR DE SULFITACAO' },
  { value: 2444, name: 'OPERADOR DE TELECOMUNICACOES' },
  { value: 2445, name: 'OPERADOR DE TELEIMPRESSOR' },
  { value: 2446, name: 'OPERADOR DE TELEX' },
  { value: 2447, name: 'OPERADOR DE TERMINAL (PROCESSAMENTO DE DADOS)' },
  { value: 2448, name: 'OPERADOR DE TIROTEX' },
  { value: 2449, name: 'OPERADOR DE TRATAMENTO DE AGUA' },
  { value: 2450, name: 'OPERADOR DE TREMOEUSE' },
  { value: 2451, name: 'OPERADOR DE UTILIDADES' },
  { value: 2452, name: 'OPERADOR DE VALORES' },
  { value: 2453, name: 'OPERADOR DE VIDEO' },
  { value: 2454, name: 'OPERADOR DE XEROX' },
  { value: 2455, name: 'OPERADOR INDUSTRIAL' },
  { value: 2456, name: 'OPERADOR RADIAL' },
  { value: 2457, name: 'OPERADOR' },
  { value: 2458, name: 'OPERARIO SEM ESPECIFICACAO' },
  { value: 2459, name: 'OPTICO' },
  { value: 2460, name: 'OPTOMETRISTA' },
  { value: 2461, name: 'ORCAMENTISTA' },
  { value: 2462, name: 'ORDENHADOR' },
  { value: 2463, name: 'ORDITRIZ' },
  { value: 2464, name: 'ORGANEIRO' },
  { value: 2465, name: 'ORIENTADOR EDUCACIONAL' },
  { value: 2466, name: 'ORIENTADOR INFANTIL' },
  { value: 2467, name: 'ORIENTADOR PEDAGOGICO' },
  { value: 2468, name: 'ORIENTADOR PROFISSIONAL' },
  { value: 2469, name: 'ORIENTADOR' },
  { value: 2470, name: 'ORNAMENTISTA (PEDRA)' },
  { value: 2471, name: 'ORNITOLOGO' },
  { value: 2472, name: 'ORQUESTRADOR' },
  { value: 2473, name: 'ORTOPEDISTA' },
  { value: 2474, name: 'ORTOPTICO' },
  { value: 2475, name: 'ORTOPTISTA' },
  { value: 2476, name: 'ORTOTICO' },
  { value: 2477, name: 'OTICO' },
  { value: 2478, name: 'OTORRINOLARINGOLOGISTA' },
  { value: 2479, name: 'OURELADOR DE TECIDOS' },
  { value: 2480, name: 'OURIVES' },
  { value: 2481, name: 'OVERLOQUISTA' },
  { value: 2482, name: 'OXICORTADOR' },
  { value: 2483, name: 'OXIDADOR' },
  { value: 2484, name: 'PADEIRO' },
  { value: 2485, name: 'PADRONISTA DE BARRACAS' },
  { value: 2486, name: 'PADRONISTA DE CALCADOS' },
  { value: 2487, name: 'PADRONISTA DE CHAPEUS' },
  { value: 2488, name: 'PADRONISTA DE MATERIAIS' },
  { value: 2489, name: 'PADRONISTA DE PELETERIA' },
  { value: 2490, name: 'PADRONISTA DE ROUPAS' },
  { value: 2491, name: 'PADRONISTA DE VELAS (EMBARCACOES)' },
  { value: 2492, name: 'PAGINADOR' },
  { value: 2493, name: 'PAISAGISTA' },
  { value: 2494, name: 'PALECIONADOR' },
  { value: 2495, name: 'PALEONTOLOGO' },
  { value: 2496, name: 'PALHACO' },
  { value: 2497, name: 'PANIFICADOR' },
  { value: 2498, name: 'PANTOGRAFISTA' },
  { value: 2499, name: 'PAPELEIRO (FABRICACAO MANUAL)' },
  { value: 2500, name: 'PAPILOSCOPISTA POLICIAL' },
  { value: 2501, name: 'PARAFINEIRO' },
  { value: 2502, name: 'PARQUETEIRO' },
  { value: 2503, name: 'PARTEIRA (CURSO SUPERIOR)' },
  { value: 2504, name: 'PARTEIRA (SEM CURSO SUPERIOR)' },
  { value: 2505, name: 'PARTEIRA SEM ESPECIFICACAO' },
  { value: 2506, name: 'PASSADERA' },
  { value: 2507, name: 'PASSADOR DE ROUPAS' },
  { value: 2508, name: 'PASSADOR SEM ESPECIFICACAO' },
  { value: 2509, name: 'PASSAMANEIRO' },
  { value: 2510, name: 'PASSARINHEIRO' },
  { value: 2511, name: 'PASTELEIRO' },
  { value: 2512, name: 'PASTEURIZADOR' },
  { value: 2513, name: 'PASTILHEIRO' },
  { value: 2514, name: 'PASTOR PROTESTANTE' },
  { value: 2515, name: 'PASTOREADOR' },
  { value: 2516, name: 'PATENTEADOR' },
  { value: 2517, name: 'PATISSEIRO' },
  { value: 2518, name: 'PATOLOGISTA CLINICO' },
  { value: 2519, name: 'PATRAO DE PESCA' },
  { value: 2520, name: 'PATROLISTA' },
  { value: 2521, name: 'PATRULHEIRO AGRICOLA' },
  { value: 2522, name: 'PATRULHEIRO RODOVIARIO' },
  { value: 2523, name: 'PAUTADOR' },
  { value: 2524, name: 'PAVIMENTADOR (A MAQUINA)' },
  { value: 2525, name: 'PAVIMENTADOR (PAVIMENTO CONTINUO)' },
  { value: 2526, name: 'PAVIMENTADOR SEM ESPECIFICACAO' },
  { value: 2527, name: 'PAVONADOR DE METAIS' },
  { value: 2528, name: 'PEAO AGRICOLA' },
  { value: 2529, name: 'PEAO DE ESTABULO' },
  { value: 2530, name: 'PEAO DE PECUARIA' },
  { value: 2531, name: 'PECUARISTA' },
  { value: 2532, name: 'PEDAGOGO' },
  { value: 2533, name: 'PEDIATRA' },
  { value: 2534, name: 'PEDICURO' },
  { value: 2535, name: 'PEDREIRO (ESGOTOS E RECEPCAO DE AGUAS)' },
  { value: 2536, name: 'PEDREIRO (FORA EXCECOES)' },
  { value: 2537, name: 'PEDREIRO MARMORISTA' },
  { value: 2538, name: 'PEDREIRO' },
  { value: 2539, name: 'PEIXEIRO' },
  { value: 2540, name: 'PELETEIRO' },
  { value: 2541, name: 'PELICULADOR' },
  { value: 2542, name: 'PENSIONISTA' },
  { value: 2543, name: 'PENTEADOR (DE FIBRAS)' },
  { value: 2544, name: 'PERFILADOR SEM ESPECIFICACAO' },
  { value: 2545, name: 'PERFUMISTA (CURSO SUPERIOR)' },
  { value: 2546, name: 'PERFUMISTA (SEM CURSO SUPERIOR)' },
  { value: 2547, name: 'PERFURADOR (CARTOES E FITAS)' },
  { value: 2548, name: 'PERFURADOR (LOTERIA ESPORTIVA)' },
  { value: 2549, name: 'PERFURADOR DE CARTOES JACQUARD' },
  { value: 2550, name: 'PERFURADOR DE DADOS' },
  { value: 2551, name: 'PERFURADOR DE IBM' },
  { value: 2552, name: 'PERFURADOR DE POCOS (EXCETO PETROLEO)' },
  { value: 2553, name: 'PERFURADOR SEM ESPECIFICACAO' },
  { value: 2554, name: 'PERITO CONTABIL' },
  { value: 2555, name: 'PERITO CRIMINAL' },
  { value: 2556, name: 'PESADOR' },
  { value: 2557, name: 'PESCADOR ARTESANAL' },
  { value: 2558, name: 'PESCADOR DE ALGAS' },
  { value: 2559, name: 'PESCADOR INDUSTRIAL' },
  { value: 2560, name: 'PESCADOR' },
  { value: 2561, name: 'PESPONTADEIRA DE CALCADOS' },
  { value: 2562, name: 'PESPONTADEIRA DE COURO (EXCETO CALCADOS)' },
  { value: 2563, name: 'PESPONTADEIRA SEM ESPECIFICACAO' },
  { value: 2564, name: 'PESPONTADOR DE CALCADOS' },
  { value: 2565, name: 'PESPONTADOR DE COURO (EXCETO CALCADOS)' },
  { value: 2566, name: 'PESPONTADOR SEM ESPECIFICACAO' },
  { value: 2567, name: 'PESQUISADOR (CURSO SUPERIOR)' },
  { value: 2568, name: 'PIACAVEIRO' },
  { value: 2569, name: 'PESSOAS EM BUSCA DE SEU PRIMEIRO EMPREGO' },
  { value: 2570, name: 'PIANISTA' },
  { value: 2571, name: 'PICOTADOR DE CARTOES JACQUARD' },
  { value: 2572, name: 'PIEZOMETRISTA' },
  { value: 2573, name: 'PIGMENTADOR PLASTICO (CURSO SUPERIOR)' },
  { value: 2574, name: 'PIGMENTADOR PLASTICO (SEM CURSO SUPERIOR)' },
  { value: 2575, name: 'PILOTO CIVIL' },
  { value: 2576, name: 'PILOTO COMERCIAL' },
  { value: 2577, name: 'PILOTO DE AEROBARCO' },
  { value: 2578, name: 'PILOTO DE AVIACAO' },
  { value: 2579, name: 'PILOTO DE CORRIDA' },
  { value: 2580, name: 'PILOTO DE NAVEGACAO MARITIMA E INTERIOR' },
  { value: 2581, name: 'PINCADOR' },
  { value: 2582, name: 'PINCELEIRO' },
  { value: 2583, name: 'PINDOBADOR DE FUMO' },
  { value: 2584, name: 'PINEIRO' },
  { value: 2585, name: 'PINTOR ARTISTICO' },
  { value: 2586, name: 'PINTOR DE AVIOES' },
  { value: 2587, name: 'PINTOR DE CERAMICA' },
  { value: 2588, name: 'PINTOR DE CONSTRUCOES CENICAS' },
  { value: 2589, name: 'PINTOR DE EDIFICIOS' },
  { value: 2590, name: 'PINTOR DE EMBARCACOES' },
  { value: 2591, name: 'PINTOR DE ESTRUTURAS METALICAS' },
  { value: 2592, name: 'PINTOR DE IMERSAO (VEICULOS)' },
  { value: 2593, name: 'PINTOR DE LETREIROS' },
  { value: 2594, name: 'PINTOR DE MANUTENCAO' },
  { value: 2595, name: 'PINTOR DE MOVEIS' },
  { value: 2596, name: 'PINTOR DE OBRAS' },
  { value: 2597, name: 'PINTOR DE ROTULOS' },
  { value: 2598, name: 'PINTOR DE VEICULOS' },
  { value: 2599, name: 'PINTOR INDUSTRIAL' },
  { value: 2600, name: 'PINTOR POR IMERSAO' },
  { value: 2601, name: 'PINTOR SEM ESPECIFICACAO (SEM CURSO SUPERIOR)' },
  { value: 2602, name: 'PIPOQUEIRO' },
  { value: 2603, name: 'PIROMETRISTA' },
  { value: 2604, name: 'PISCICULTOR' },
  { value: 2605, name: 'PISTOLADOR' },
  { value: 2606, name: 'PIZZAIOLO' },
  { value: 2607, name: 'PLAINADOR AJUSTADOR' },
  { value: 2608, name: 'PLAINADOR DE MADEIRA' },
  { value: 2609, name: 'PLAINADOR DE METAIS' },
  { value: 2610, name: 'PLAINADOR FERRAMENTEIRO' },
  { value: 2611, name: 'PLAINADOR MECANICO' },
  { value: 2612, name: 'PLAINADOR SEM ESPECIFICACAO' },
  { value: 2613, name: 'PLAINEIRO (MADEIRA)' },
  { value: 2614, name: 'PLANCHADOR DE CALCADOS' },
  { value: 2615, name: 'PLANCHADOR SEM ESPECIFICACAO' },
  { value: 2616, name: 'PLANEJADOR DE PRODUCAO' },
  { value: 2617, name: 'PLANEJADOR SEM ESPECIFICACAO' },
  { value: 2618, name: 'PLANIFICADOR SEM ESPECIFICACAO' },
  { value: 2619, name: 'PLAQUEIRO' },
  { value: 2620, name: 'PLASTIFICADOR' },
  { value: 2621, name: 'PLATAFORMISTA (PETROLEO)' },
  { value: 2622, name: 'PLATINADOR' },
  { value: 2623, name: 'PLISSADOR DE PAPEL' },
  { value: 2624, name: 'PNEUMOTISIOLOGISTA' },
  { value: 2625, name: 'POCEIRO' },
  { value: 2626, name: 'PODADOR (AGRICOLA)' },
  { value: 2627, name: 'POLICIAL CIVIL' },
  { value: 2628, name: 'POLICIAL MILITAR' },
  { value: 2629, name: 'POLICIAL RODOVIARIO' },
  { value: 2630, name: 'POLICIA SEM ESPECIFICACAO' },
  { value: 2631, name: 'POLIDOR DE CALCADOS' },
  { value: 2632, name: 'POLIDOR DE FIEIRAS' },
  { value: 2633, name: 'POLIDOR DE METAIS' },
  { value: 2634, name: 'POLIDOR DE PECAS DE METAL' },
  { value: 2635, name: 'POLIDOR DE PEDRAS' },
  { value: 2636, name: 'POLIDOR DE PEDRAS PRECIOSAS' },
  { value: 2637, name: 'POLIDOR DE PRODUTOS PLASTICOS' },
  { value: 2638, name: 'POLIDOR DE RODAS DENTADAS' },
  { value: 2639, name: 'POLIDOR DE VIDROS E CRISTAIS' },
  { value: 2640, name: 'POLIDOR OPTICO' },
  { value: 2641, name: 'POLIDOR' },
  { value: 2642, name: 'POLITICOLOGO' },
  { value: 2643, name: 'PONTEADOR' },
  { value: 2644, name: 'PONTEIRO' },
  { value: 2645, name: 'PONTILHEIRO (MATADOURO)' },
  { value: 2646, name: 'PORTALO' },
  { value: 2647, name: 'PORTEIRO (FORA EXCECOES)' },
  { value: 2648, name: 'PORTEIRO DE CLUBE' },
  { value: 2649, name: 'PORTEIRO DE HOTEL' },
  { value: 2650, name: 'PORTEIRO DE LOCAIS DE DIVERSAO' },
  { value: 2651, name: 'PORTEIRO SEM ESPECIFICACAO' },
  { value: 2652, name: 'PORTUARIO' },
  { value: 2653, name: 'POSTALISTA' },
  { value: 2654, name: 'POSTEIRO' },
  { value: 2655, name: 'POSTICEIRA' },
  { value: 2656, name: 'PRACISTA' },
  { value: 2657, name: 'PRAIEIRO (PECUARIA)' },
  { value: 2658, name: 'PRANCHADOR SEM ESPECIFICACAO' },
  { value: 2659, name: 'PRATEADOR DE ESPELHOS' },
  { value: 2660, name: 'PRATEADOR DE METAIS' },
  { value: 2661, name: 'PRATICO DE ENFERMAGEM' },
  { value: 2662, name: 'PRATICO DE FARMACIA' },
  { value: 2663, name: 'PRATICO DE PORTO' },
  { value: 2664, name: 'PREFEITO' },
  { value: 2665, name: 'PREGADOR DE BOTOES' },
  { value: 2666, name: 'PREGADOR DE CAIXAS' },
  { value: 2667, name: 'PREGADOR DE PALMILHAS' },
  { value: 2668, name: 'PREGADOR DE PELES' },
  { value: 2669, name: 'PREGADOR DE SALTOS' },
  { value: 2670, name: 'PRELISTA' },
  { value: 2671, name: 'PRENDAS DOMESTICAS' },
  { value: 2672, name: 'PRENSADOR DE COUROS' },
  { value: 2673, name: 'PRENSADOR DE FRUTAS (EXCETO OLEOGINOSAS)' },
  { value: 2674, name: 'PRENSADOR DE LIXAS' },
  { value: 2675, name: 'PRENSADOR DE OLEOGINOSAS' },
  { value: 2676, name: 'PRENSEIRO DE FARINHA' },
  { value: 2677, name: 'PRENSISTA DE AGLOMERADOS' },
  { value: 2678, name: 'PRENSISTA DE BORRACHA' },
  { value: 2679, name: 'PRENSISTA DE CACAU' },
  { value: 2680, name: 'PRENSISTA DE COMPENSADOS' },
  { value: 2681, name: 'PRENSISTA DE MADEIRA' },
  { value: 2682, name: 'PRENSISTA DE MAMONA' },
  { value: 2683, name: 'PRENSISTA DE METAL' },
  { value: 2684, name: 'PRENSISTA DE PLASTICO' },
  { value: 2685, name: 'PRENSISTA FORJADOR' },
  { value: 2686, name: 'PRENSISTA SEM ESPECIFICACAO' },
  { value: 2687, name: 'PREPARADOR DE AGLOMERANTES' },
  { value: 2688, name: 'PREPARADOR DE ALIMENTOS CONCENTRADOS' },
  { value: 2689, name: 'PREPARADOR DE AMOSTRAS DE CARVAO,ACO E GUSA' },
  { value: 2690, name: 'PREPARADOR DE AMOSTRAS DE MINERIOS' },
  { value: 2691, name: 'PREPARADOR DE AREIA PARA FUNDICAO' },
  { value: 2692, name: 'PREPARADOR DE BARBOTINA' },
  { value: 2693, name: 'PREPARADOR DE CALCADOS' },
  { value: 2694, name: 'PREPARADOR DE CARGA' },
  { value: 2695, name: 'PREPARADOR DE COLA' },
  { value: 2696, name: 'PREPARADOR DE CORTE SEM ESPECIFICACAO' },
  { value: 2697, name: 'PREPARADOR DE COUROS E PELES CURTIDAS' },
  { value: 2698, name: 'PREPARADOR DE DADOS' },
  { value: 2699, name: 'PREPARADOR DE EMBALAGENS' },
  { value: 2700, name: 'PREPARADOR DE ESMALTES (CERAMICA)' },
  { value: 2701, name: 'PREPARADOR DE ESTENCEIS (SERIGRAFIA)' },
  { value: 2702, name: 'PREPARADOR DE ESTRUTURAS DE ACO' },
  { value: 2703, name: 'PREPARADOR DE ESTRUTURAS METALICAS' },
  { value: 2704, name: 'PREPARADOR DE FIBRAS ARTIFICIAIS' },
  { value: 2705, name: 'PREPARADOR DE FRESADORA' },
  { value: 2706, name: 'PREPARADOR DE GLICOSE' },
  { value: 2707, name: 'PREPARADOR DE GOMA' },
  { value: 2708, name: 'PREPARADOR DE GOMA (MADEIRA)' },
  { value: 2709, name: 'PREPARADOR DE INGREDIENTES NAO ESPECIFICADOS' },
  { value: 2710, name: 'PREPARADOR DE LEITE CONDENSADO' },
  { value: 2711, name: 'PREPARADOR DE LINGOTEIRAS' },
  { value: 2712, name: 'PREPARADOR DE MAQUINAS-FERRAMENTAS EM GERAL' },
  { value: 2713, name: 'PREPARADOR DE MASSA (ABRASIVOS)' },
  { value: 2714, name: 'PREPARADOR DE MASSA (ARGILA)' },
  { value: 2715, name: 'PREPARADOR DE MASSA (DE VIDRO)' },
  { value: 2716, name: 'PREPARADOR DE MASSA ALIMENTICIA' },
  { value: 2717, name: 'PREPARADOR DE MASSA REFRATARIA' },
  { value: 2718, name: 'PREPARADOR DE MASSA SEM ESPECIFICACAO' },
  { value: 2719, name: 'PREPARADOR DE MELADO E ESSENCIA (FUMO)' },
  { value: 2720, name: 'PREPARADOR DE MISCELANEA (RACOES BALANCEADAS)' },
  { value: 2721, name: 'PREPARADOR DE MOLDES (CERAMICA)' },
  { value: 2722, name: 'PREPARADOR DE MOLDES (FUNDICAO)' },
  { value: 2723, name: 'PREPARADOR DE MOLDES NAO ESPECIFICADOS' },
  { value: 2724, name: 'PREPARADOR DE PAINEIS DE PLASTICO' },
  { value: 2725, name: 'PREPARADOR DE PIGMENTOS' },
  { value: 2726, name: 'PREPARADOR DE PRANCHAS DE IMPRESSAO BRAILLE' },
  { value: 2727, name: 'PREPARADOR DE PRENSA' },
  { value: 2728, name: 'PREPARADOR DE RACAO NATURAL PARA GADO' },
  { value: 2729, name: 'PREPARADOR DE RACOES' },
  { value: 2730, name: 'PREPARADOR DE RAPE' },
  { value: 2731, name: 'PREPARADOR DE REMEDIOS' },
  { value: 2732, name: 'PREPARADOR DE SALTOS' },
  { value: 2733, name: 'PREPARADOR DE SOLAS' },
  { value: 2734, name: 'PREPARADOR DE TALO' },
  { value: 2735, name: 'PREPARADOR DE TELAS' },
  { value: 2736, name: 'PREPARADOR DE TINTAS' },
  { value: 2737, name: 'PREPARADOR FISICO' },
  { value: 2738, name: 'PREPARADOR QUIMICO' },
  { value: 2739, name: 'PREPARADOR SEM ESPECIFICACAO' },
  { value: 2740, name: 'PRESIDENTE DA REPUBLICA' },
  { value: 2741, name: 'PRESIDENTE DE SINDICATO' },
  { value: 2742, name: 'PRESTIDIGITADOR' },
  { value: 2743, name: 'PRESUNTEIRO' },
  { value: 2744, name: 'PRIMEIRO OFICIAL-MAQUINISTA (EMBARCACOES)' },
  { value: 2745, name: 'PROCTOLOGISTA (CURSO SUPERIOR)' },
  { value: 2746, name: 'PROCURADOR (TRIBUNAL MARITIMO)' },
  { value: 2747, name: 'PROCURADOR (TRIBUNAL MILITAR)' },
  { value: 2748, name: 'PROCURADOR AUTARQUICO' },
  { value: 2749, name: 'PROCURADOR DA FAZENDA NACIONAL' },
  { value: 2750, name: 'PROCURADOR DA JUSTICA' },
  { value: 2751, name: 'PROCURADOR DE EMPRESA' },
  { value: 2752, name: 'PROCURADOR' },
  { value: 2753, name: 'PRODUTOR AGRICOLA' },
  { value: 2754, name: 'PRODUTOR AGROPECUARIO' },
  { value: 2755, name: 'PRODUTOR CINEMATOGRAFICO' },
  { value: 2756, name: 'PRODUTOR DE RADIO E TELEVISAO' },
  { value: 2757, name: 'PRODUTOR DE SEMENTES' },
  { value: 2758, name: 'PRODUTOR MUSICAL' },
  { value: 2759, name: 'PRODUTOR PUBLICITARIO' },
  { value: 2760, name: 'PRODUTOR' },
  { value: 2761, name: 'PRODUTOR TEATRAL' },
  { value: 2762, name: 'PROFESSOR DE CEGOS' },
  { value: 2763, name: 'PROFESSOR DE DEFICIENTES' },
  { value: 2764, name: 'PROFESSOR DE ENSINO PRE-ESCOLAR' },
  { value: 2765, name: 'PROFESSOR DE ENSINO SUPERIOR' },
  { value: 2766, name: 'PROFESSOR DE FORMACAO PROFISSIONAL' },
  { value: 2767, name: 'PROFESSOR DE IOGA' },
  { value: 2768, name: 'PROFESSOR DE LINGUA' },
  { value: 2769, name: 'PROFESSOR DE MUSICA' },
  { value: 2770, name: 'PROFESSOR DE PRIMEIRO GRAU' },
  { value: 2771, name: 'PROFESSOR DE SEGUNDO GRAU' },
  { value: 2772, name: 'PROFESSOR DE SUPERDOTADOS' },
  { value: 2773, name: 'PROFESSOR DE SURDOS-MUDOS' },
  { value: 2774, name: 'PROFESSOR PARTICULAR S/ESPECIFICACAO DE GRAU' },
  { value: 2775, name: 'PROFESSOR SEM ESPECIFICACAO' },
  { value: 2776, name: 'PROFESSOR UNIVERSITARIO D/LINGUA E LITERATURA' },
  { value: 2777, name: 'PROFESSOR UNIVERSITARIO DE ADMINISTRACAO' },
  { value: 2778, name: 'PROFESSOR UNIVERSITARIO DE ANTROPOLOGIA' },
  { value: 2779, name: 'PROFESSOR UNIVERSITARIO DE ARQUITETURA' },
  { value: 2780, name: 'PROFESSOR UNIVERSITARIO DE ASTRONOMIA' },
  { value: 2781, name: 'PROFESSOR UNIVERSITARIO DE BIOLOGIA' },
  { value: 2782, name: 'PROFESSOR UNIVERSITARIO DE CIENCIAS POLITICAS' },
  { value: 2783, name: 'PROFESSOR UNIVERSITARIO DE CONTABILIDADE' },
  { value: 2784, name: 'PROFESSOR UNIVERSITARIO DE DEMOGRAFIA' },
  { value: 2785, name: 'PROFESSOR UNIVERSITARIO DE DIREITO' },
  { value: 2786, name: 'PROFESSOR UNIVERSITARIO DE ECONOMIA' },
  { value: 2787, name: 'PROFESSOR UNIVERSITARIO DE ENFERMAGEM' },
  { value: 2788, name: 'PROFESSOR UNIVERSITARIO DE ENGENHARIA' },
  { value: 2789, name: 'PROFESSOR UNIVERSITARIO DE ESTATISTICA' },
  { value: 2790, name: 'PROFESSOR UNIVERSITARIO DE FARMACOLOGIA' },
  { value: 2791, name: 'PROFESSOR UNIVERSITARIO DE FILOSOFIA' },
  { value: 2792, name: 'PROFESSOR UNIVERSITARIO DE FISICA' },
  { value: 2793, name: 'PROFESSOR UNIVERSITARIO DE GEOGRAFIA' },
  { value: 2794, name: 'PROFESSOR UNIVERSITARIO DE GEOLOGIA' },
  { value: 2795, name: 'PROFESSOR UNIVERSITARIO DE HISTORIA' },
  { value: 2796, name: 'PROFESSOR UNIVERSITARIO DE MATEMATICA' },
  { value: 2797, name: 'PROFESSOR UNIVERSITARIO DE MEDICINA' },
  { value: 2798, name: 'PROFESSOR UNIVERSITARIO DE PEDAGOGIA' },
  { value: 2799, name: 'PROFESSOR UNIVERSITARIO DE PESQ. OPERACIONAL' },
  { value: 2800, name: 'PROFESSOR UNIVERSITARIO DE PSICOLOGIA' },
  { value: 2801, name: 'PROFESSOR UNIVERSITARIO DE QUIMICA' },
  { value: 2802, name: 'PROFESSOR UNIVERSITARIO DE SOCIOLOGIA' },
  { value: 2803, name: 'PROFESSOR UNIVERSITARIO DE TOPOGRAFIA' },
  { value: 2804, name: 'PROGRAMADOR DE COMPUTADOR' },
  { value: 2805, name: 'PROGRAMADOR DE MATERIAIS' },
  { value: 2806, name: 'PROGRAMADOR DE OBRAS' },
  { value: 2807, name: 'PROGRAMADOR DE PRODUCAO' },
  { value: 2808, name: 'PROGRAMADOR DE SISTEMAS' },
  { value: 2809, name: 'PROJETISTA AERONAUTICO (CURSO SUPERIOR)' },
  { value: 2810, name: 'PROJETISTA CINEMATOGRAFICO' },
  { value: 2811, name: 'PROJETISTA DE FERRAMENTAS' },
  { value: 2812, name: 'PROJETISTA DE MOVEIS' },
  { value: 2813, name: 'PROJETISTA DESENHISTA' },
  { value: 2814, name: 'PROJETISTA ELETRICO' },
  { value: 2815, name: 'PROJETISTA NAVAL (CURSO SUPERIOR)' },
  { value: 2816, name: 'PROJETISTA SEM ESPECIFICACAO' },
  { value: 2817, name: 'PROMOTOR DE VENDAS' },
  { value: 2818, name: 'PROMOTOR PUBLICO' },
  { value: 2819, name: 'PROPAGANDISTA' },
  { value: 2820, name: 'PROPRIETARIO' },
  { value: 2821, name: 'PROTETICO-DENTARIO' },
  { value: 2822, name: 'PROTOCOLISTA' },
  { value: 2823, name: 'PROVADOR DE CACAU' },
  { value: 2824, name: 'PROVADOR DE CAFE' },
  { value: 2825, name: 'PROVADOR DE CHA' },
  { value: 2826, name: 'PROVADOR DE VINHOS E LICORES' },
  { value: 2827, name: 'PROVADOR SEM ESPECIFICACAO' },
  { value: 2828, name: 'PROVISTA DE CLICHERIA' },
  { value: 2829, name: 'PROVISTA DE FOTOLITO' },
  { value: 2830, name: 'PSICANALISTA' },
  { value: 2831, name: 'PSICOLOGO' },
  { value: 2832, name: 'PSICOMETRISTA (SUPERIOR OU SEGUNDO GRAU)' },
  { value: 2833, name: 'PSIQUIATRA' },
  { value: 2834, name: 'PUBLICISTA' },
  { value: 2835, name: 'PUBLICITARIO' },
  { value: 2836, name: 'PULVERIZADOR DE LEITE EM PO' },
  { value: 2837, name: 'PULVERIZADOR DE METAL' },
  { value: 2838, name: 'PUXADOR DE SISAL' },
  { value: 2839, name: 'QUADRISTA' },
  { value: 2840, name: 'QUEIJEIRO' },
  { value: 2841, name: 'QUIMICO' },
  { value: 2842, name: 'QUIMICO (SEM CURSO SUPERIOR)' },
  { value: 2843, name: 'QUIROPODISTA' },
  { value: 2844, name: 'QUIROPRATICO' },
  { value: 2845, name: 'QUITANDEIRO' },
  { value: 2846, name: 'RACHADOR DE COUROS E PELES' },
  { value: 2847, name: 'RACHADOR DE LENHA (PARA FAZER CARVAO)' },
  { value: 2848, name: 'RACHADOR DE LENHA SEM ESPECIFICACAO' },
  { value: 2849, name: 'RACIONEIRO' },
  { value: 2850, name: 'RADIALISTA' },
  { value: 2851, name: 'RADIATOR, RADIOATOR' },
  { value: 2852, name: 'RADIOLOGISTA (CURSO SUPERIOR)' },
  { value: 2853, name: 'RADIOPERADOR' },
  { value: 2854, name: 'RADIORREPORTER' },
  { value: 2855, name: 'RADIOTECNICO' },
  { value: 2856, name: 'RADIOTELEFONISTA' },
  { value: 2857, name: 'RADIOTELEGRAFISTA' },
  { value: 2858, name: 'RADIOTELETIPISTA' },
  { value: 2859, name: 'RAMISTA' },
  { value: 2860, name: 'RAMULADOR' },
  { value: 2861, name: 'RASPADOR DE MANDIOCA' },
  { value: 2862, name: 'RASPADOR DE TACOS' },
  { value: 2863, name: 'RASPADOR SEM ESPECIFICACAO' },
  { value: 2864, name: 'RASQUETEADOR (METAIS)' },
  { value: 2865, name: 'RASTREADOR DE SATELITES' },
  { value: 2866, name: 'RASURADOR DE COUROS E PELES' },
  { value: 2867, name: 'REBAIXADOR DE COUROS' },
  { value: 2868, name: 'REBARBADOR DE METAIS' },
  { value: 2869, name: 'REBARBADOR DE PRODUTOS PLASTICOS' },
  { value: 2870, name: 'REBARBADOR SEM ESPECIFICACAO' },
  { value: 2871, name: 'REBITADOR' },
  { value: 2872, name: 'REBOBINADOR SEM ESPECIFICACAO' },
  { value: 2873, name: 'RECAUCHUTADOR' },
  { value: 2874, name: 'RECEBEDOR DE APOSTAS' },
  { value: 2875, name: 'RECEBEDOR DE MATERIAL' },
  { value: 2876, name: 'RECEBEDOR SEM ESPECIFICACAO' },
  { value: 2877, name: 'RECEPCIONISTA' },
  { value: 2878, name: 'RECOLHEDOR DE BOLAS (ESPORTE)' },
  { value: 2879, name: 'RECORTADOR DE ESTRESIDORES DE METAL' },
  { value: 2880, name: 'RECORTADOR DE EXCESSOS (ARTIGOS DE PELE)' },
  { value: 2881, name: 'RECORTADOR DE SERIGRAFIA' },
  { value: 2882, name: 'RECORTADOR DE TAPETES' },
  { value: 2883, name: 'RECOZEDOR DE METAIS' },
  { value: 2884, name: 'RECOZEDOR DE VIDROS' },
  { value: 2885, name: 'RECRUTADOR DE PESSOAL' },
  { value: 2886, name: 'RECUPERADOR DE SOLAS' },
  { value: 2887, name: 'REDATOR' },
  { value: 2888, name: 'REDATOR DE PUBLICIDADE' },
  { value: 2889, name: 'REDEIRO' },
  { value: 2890, name: 'REDEIRO DE EMBARCACAO' },
  { value: 2891, name: 'REFILADOR' },
  { value: 2892, name: 'REFINADOR DE OLEOS' },
  { value: 2893, name: 'REFINADOR DE PASTA PARA PAPEL' },
  { value: 2894, name: 'REFINADOR DE SAL' },
  { value: 2895, name: 'REFINADOR DE TEREBENTINA' },
  { value: 2896, name: 'REFINADOR SEM ESPECIFICACAO' },
  { value: 2897, name: 'REFRATARISTA' },
  { value: 2898, name: 'REFRIGERADOR DE LEITE E AFINS' },
  { value: 2899, name: 'REGENTE (MUSICAL)' },
  { value: 2900, name: 'REGULADOR DE AGUA' },
  { value: 2901, name: 'REGULADOR DE PECAS' },
  { value: 2902, name: 'REITOR' },
  { value: 2903, name: 'RELACOES INDUSTRIAIS, GERENTE' },
  { value: 2904, name: 'RELACOES PUBLICAS' },
  { value: 2905, name: 'RELACOES PUBLICAS, GERENTE' },
  { value: 2906, name: 'RELADOR DE COUROS E PELES' },
  { value: 2907, name: 'RELIGIOSO' },
  { value: 2908, name: 'RELOJOEIRO' },
  { value: 2909, name: 'REMADOR' },
  { value: 2910, name: 'REMALHADEIRA' },
  { value: 2911, name: 'REMALHADOR' },
  { value: 2912, name: 'REMATADEIRA (CONFECCOES)' },
  { value: 2913, name: 'REMENDADOR DE TAPETES' },
  { value: 2914, name: 'REMETEDOR DE FIOS' },
  { value: 2915, name: 'REMETINA' },
  { value: 2916, name: 'RENDEIRO' },
  { value: 2917, name: 'REPARADOR D/AP.TELEGRAFICOS E TELEIMPRESSORES' },
  { value: 2918, name: 'REPARADOR DE ANTENAS' },
  { value: 2919, name: 'REPARADOR DE APARELHOS ELETRODOMESTICOS' },
  { value: 2920, name: 'REPARADOR DE APARELHOS ELETRONICOS' },
  { value: 2921, name: 'REPARADOR DE APARELHOS TELEFONICOS' },
  { value: 2922, name: 'REPARADOR DE CIRCUITOS ELETRONIC. INDUSTRIAIS' },
  { value: 2923, name: 'REPARADOR DE HIDROMETROS' },
  { value: 2924, name: 'REPARADOR DE INSTAL.TELEFONICAS E TELEGRAFICA' },
  { value: 2925, name: 'REPARADOR DE MAQUINAS' },
  { value: 2926, name: 'REPARADOR DE MOLDES SEM ESPECIFICACAO' },
  { value: 2927, name: 'REPARADOR DE TELEVISAO' },
  { value: 2928, name: 'REPORTER CINEGRAFISTA' },
  { value: 2929, name: 'REPORTER FOTOGRAFICO' },
  { value: 2930, name: 'REPORTER SEM ESPECIFICACAO' },
  { value: 2931, name: 'REPOSITOR (COMERCIO)' },
  { value: 2932, name: 'REPRESENTANTE COMERCIAL' },
  { value: 2933, name: 'REPRESENTANTE DE COBRANCA' },
  { value: 2934, name: 'REPRESENTANTE DE ENTIDADE SINDICAL' },
  { value: 2935, name: 'REPRESENTANTE DE VENDAS' },
  { value: 2936, name: 'REPRESENTANTE SEM ESPECIFICACAO' },
  { value: 2937, name: 'REPRESENTANTE TECNICO' },
  { value: 2938, name: 'REPUXADOR' },
  { value: 2939, name: 'RESERVA DE MAQUINA' },
  { value: 2940, name: 'RESINAS, TRABALHADOR DE' },
  { value: 2941, name: 'RESINEIRO (COLETA)' },
  { value: 2942, name: 'RESTAURADOR DE LIVROS E DOCUMENTOS' },
  { value: 2943, name: 'RESTAURADOR DE OBRAS DE ARTE' },
  { value: 2944, name: 'RETALHADOR DE CARNE' },
  { value: 2945, name: 'RETIFICADOR (FORA EXCECOES)' },
  { value: 2946, name: 'RETIFICADOR DE MOTORES' },
  { value: 2947, name: 'RETIFICADOR DE VIRABREQUIM' },
  { value: 2948, name: 'RETIFICADOR SEM ESPECIFICACAO' },
  { value: 2949, name: 'RETILINISTA' },
  { value: 2950, name: 'RETIREIRO' },
  { value: 2951, name: 'RETOCADOR CROMISTA' },
  { value: 2952, name: 'RETOCADOR DE CLICHES' },
  { value: 2953, name: 'RETOCADOR DE NEGATIVOS' },
  { value: 2954, name: 'RETOCADOR SEM ESPECIFICACAO' },
  { value: 2955, name: 'RETOQUISTA' },
  { value: 2956, name: 'RETORCEDOR DE FIBRAS' },
  { value: 2957, name: 'RETORCEDOR DE FIOS' },
  { value: 2958, name: 'RETRANQUISTA' },
  { value: 2959, name: 'RETRATISTA' },
  { value: 2960, name: 'RETROSISTA' },
  { value: 2961, name: 'REVELADOR DE FILMES' },
  { value: 2962, name: 'REVENDEDOR' },
  { value: 2963, name: 'REVESTIDOR' },
  { value: 2964, name: 'REVESTIDOR DE APARELHOS (BORRACHA)' },
  { value: 2965, name: 'REVESTIDOR DE CILINDROS (BORRACHA)' },
  { value: 2966, name: 'REVESTIDOR DE EDIFICACOES' },
  { value: 2967, name: 'REVESTIDOR DE INTERIORES(PAPEL DE PLASTICO)' },
  { value: 2968, name: 'REVESTIDOR DE MOVEIS DE MADEIRA' },
  { value: 2969, name: 'REVESTIDOR DE PANELAS' },
  { value: 2970, name: 'REVESTIDOR DE PAVIMENTOS CONTINUOS' },
  { value: 2971, name: 'REVESTIDOR DE PISOS E PAREDES COM LADRILHOS' },
  { value: 2972, name: 'REVISOR DE FILMES' },
  { value: 2973, name: 'REVISOR DE PROVAS TIPOGRAFICAS' },
  { value: 2974, name: 'REVISOR DE TECIDOS' },
  { value: 2975, name: 'REVISOR DE TEXTOS' },
  { value: 2976, name: 'REVISOR GRAFICO' },
  { value: 2977, name: 'REVISOR SEM ESPECIFICACAO (COM FUNDAMENTAL)' },
  { value: 2978, name: 'REVISOR SEM ESPECIFICACAO (COM SEG.GRAU)' },
  { value: 2979, name: 'REVISTADOR (SERVICOS)' },
  { value: 2980, name: 'RISCADEIRA' },
  { value: 2981, name: 'RISCADOR DE CHAPAS' },
  { value: 2982, name: 'RISCADOR DE ESTRUTURAS METALICAS' },
  { value: 2983, name: 'RISCADOR DE METAIS' },
  { value: 2984, name: 'RISCADOR DE ROUPAS' },
  { value: 2985, name: 'RISCADOR MECANICO' },
  { value: 2986, name: 'RISCADOR SEM ESPECIFICACAO' },
  { value: 2987, name: 'ROCADEIRA' },
  { value: 2988, name: 'RODOMOCA' },
  { value: 2989, name: 'ROLETEADOR' },
  { value: 2990, name: 'RONDA' },
  { value: 2991, name: 'RONDA-DE-FORMIGA' },
  { value: 2992, name: 'RONDANTE' },
  { value: 2993, name: 'ROQUEIRO' },
  { value: 2994, name: 'ROSQUEADOR' },
  { value: 2995, name: 'ROTEIRISTA (EXCURCOES)' },
  { value: 2996, name: 'ROTEIRISTA DE CINEMA' },
  { value: 2997, name: 'ROTEIRISTA DE JORNAL' },
  { value: 2998, name: 'ROTEIRISTA DE RADIO E TELEVISAO' },
  { value: 2999, name: 'ROTEIRISTA SEM ESPECIFICACAO' },
  { value: 3000, name: 'ROTISSEUR' },
  { value: 3001, name: 'ROTULADOR' },
  { value: 3002, name: 'ROUPEIRO' },
  { value: 3003, name: 'SABOEIRO' },
  { value: 3004, name: 'SACERDOTE' },
  { value: 3005, name: 'SACRISTAO' },
  { value: 3006, name: 'SALAMEIRO' },
  { value: 3007, name: 'SALGADOR DE ALIMENTOS' },
  { value: 3008, name: 'SALGADOR DE QUEIJOS' },
  { value: 3009, name: 'SALGADOR SEM ESPECIFICACAO' },
  { value: 3010, name: 'SALINEIRO' },
  { value: 3011, name: 'SALSICHEIRO' },
  { value: 3012, name: 'SALVA-VIDAS' },
  { value: 3013, name: 'SANGRADOR' },
  { value: 3014, name: 'SAPATEIRO' },
  { value: 3015, name: 'SAQUEIRO' },
  { value: 3016, name: 'SCHEDULER' },
  { value: 3017, name: 'SECADOR DE ARROZ' },
  { value: 3018, name: 'SECADOR DE CACAU' },
  { value: 3019, name: 'SECADOR DE FOTOGRAFIA' },
  { value: 3020, name: 'SECADOR DE FUMO' },
  { value: 3021, name: 'SECADOR DE LA' },
  { value: 3022, name: 'SECADOR DE MADEIRA' },
  { value: 3023, name: 'SECADOR DE PEIXE' },
  { value: 3024, name: 'SECADOR DE PRODUTOS QUIMICOS' },
  { value: 3025, name: 'SECADOR DE TECIDOS' },
  { value: 3026, name: 'SECRETARIO (DIPLOMACIA)' },
  { value: 3027, name: 'SECRETARIO (FORA EXCECOES)' },
  { value: 3028, name: 'SECRETARIO DE REDACAO' },
  { value: 3029, name: 'SECRETARIO' },
  { value: 3030, name: 'SECURITARIO' },
  { value: 3031, name: 'SEGURANCA' },
  { value: 3032, name: 'SELECIONADOR DE CALCADOS' },
  { value: 3033, name: 'SELECIONADOR DE COLHEITAS' },
  { value: 3034, name: 'SELECIONADOR DE CORRESPONDENCIA' },
  { value: 3035, name: 'SELECIONADOR DE PEDRAS' },
  { value: 3036, name: 'SELECIONADOR DE PESSOAL' },
  { value: 3037, name: 'SELECIONADOR SEM ESPECIFICACAO' },
  { value: 3038, name: 'SELEIRO' },
  { value: 3039, name: 'SEM PROFISSAO' },
  { value: 3040, name: 'SENADOR' },
  { value: 3041, name: 'SEPARADOR DE CORRESPONDENCIA' },
  { value: 3042, name: 'SEPARADOR DE ESTOQUE' },
  { value: 3043, name: 'SEPARADOR DE MERCADORIAS' },
  { value: 3044, name: 'SEPARADOR DE MINERIOS' },
  { value: 3045, name: 'SEPARADOR DE PEDIDOS' },
  { value: 3046, name: 'SEPARADOR DE PRODUTOS' },
  { value: 3047, name: 'SERICULTOR' },
  { value: 3048, name: 'SERIGRAFICO' },
  { value: 3049, name: 'SERIGRAFISTA' },
  { value: 3050, name: 'SERINGUEIRO' },
  { value: 3051, name: 'SERRADOR DE ADUELAS E BARRIS' },
  { value: 3052, name: 'SERRADOR DE ARVORES' },
  { value: 3053, name: 'SERRADOR DE BORDAS' },
  { value: 3054, name: 'SERRADOR DE CHIFRES' },
  { value: 3055, name: 'SERRADOR DE FITA' },
  { value: 3056, name: 'SERRADOR DE MADEIRA' },
  { value: 3057, name: 'SERRADOR DE PEDRAS' },
  { value: 3058, name: 'SERRADOR SEM ESPECIFICACAO' },
  { value: 3059, name: 'SERRALHEIRO (FORA EXCECAO)' },
  { value: 3060, name: 'SERRALHEIRO DE FECHADURAS' },
  { value: 3061, name: 'SERRALHEIRO MECANICO' },
  { value: 3062, name: 'SERRALHEIRO SEM ESPECIFICACAO' },
  { value: 3063, name: 'SERVENTE COMERCIAL' },
  { value: 3064, name: 'SERVENTE DE COZINHA' },
  { value: 3065, name: 'SERVENTE DE LIMPEZA' },
  { value: 3066, name: 'SERVENTE DE OBRAS' },
  { value: 3067, name: 'SERVENTE DE PEDREIRO' },
  { value: 3068, name: 'SERVENTE DE PRODUCAO' },
  { value: 3069, name: 'SERVENTE HOSPITALAR' },
  { value: 3070, name: 'SERVENTE SEM ESPECIFICACAO' },
  { value: 3071, name: 'SERVENTE SEM ESPECIFICACAO (FEMININO)' },
  { value: 3072, name: 'SERVENTUARIO DA JUSTICA' },
  { value: 3073, name: 'SERVICOS GERAIS' },
  { value: 3074, name: 'SERVICOS GERAIS (SEXO MASCULINO)' },
  { value: 3075, name: 'SERVIDOR DA JUSTICA' },
  { value: 3076, name: 'SEXADOR' },
  { value: 3077, name: 'SIDERURGICO' },
  { value: 3078, name: 'SIDERURGICO SEM ESPECIFICACAO' },
  { value: 3079, name: 'SINALEIRO (FERROVIAS)' },
  { value: 3080, name: 'SINALEIRO SEM ESPECIFICACAO' },
  { value: 3081, name: 'SINDICO' },
  { value: 3082, name: 'SINGERISTA' },
  { value: 3083, name: 'SITIANTE' },
  { value: 3084, name: 'SOCIOLOGO' },
  { value: 3085, name: 'SOCORRISTA' },
  { value: 3086, name: 'SOLADOR' },
  { value: 3087, name: 'SOLDADO' },
  { value: 3088, name: 'SOLDADOR EM GERAL' },
  { value: 3089, name: 'SONDADOR (FORA EXCECOES)' },
  { value: 3090, name: 'SONDADOR DE PETROLEO E GAS' },
  { value: 3091, name: 'SONDADOR DE XISTO' },
  { value: 3092, name: 'SONDADOR SEM ESPECIFICACAO' },
  { value: 3093, name: 'SONOPLASTA' },
  { value: 3094, name: 'SONOTECNICO' },
  { value: 3095, name: 'SOPRADOR DE FORNOS METALICOS' },
  { value: 3096, name: 'SOPRADOR DE VIDORS' },
  { value: 3097, name: 'SOROLOGISTA' },
  { value: 3098, name: 'SORVETEIRO (AMBULANTE)' },
  { value: 3099, name: 'SUCATEIRO' },
  { value: 3100, name: 'SUINOCULTOR' },
  { value: 3101, name: 'SULFACAGISTA' },
  { value: 3102, name: 'SULFATADOR' },
  { value: 3103, name: 'SULFITADOR (ACUCAR)' },
  { value: 3104, name: 'SUPERINT.DE APROVISIONAMENTO(NAVEG.MAR.E INT)' },
  { value: 3105, name: 'SUPERINTENDENTE COMERCIAL' },
  { value: 3106, name: 'SUPERINTENDENTE DE ARMAMENTO (EMBARCACOES)' },
  { value: 3107, name: 'SUPERINTENDENTE DE FABRICACAO' },
  { value: 3108, name: 'SUPERINTENDENTE FINANCEIRO' },
  { value: 3109, name: 'SUPERINTENDENTE INDUSTRIAL' },
  { value: 3110, name: 'SUPERINTENDENTE SEM ESPECIFICACAO' },
  { value: 3111, name: 'SUPERINTENDENTE TECNICO (EMBARCACOES)' },
  { value: 3112, name: 'SUPERVISOR COMERCIAL' },
  { value: 3113, name: 'SUPERVISOR DE COMPRAS' },
  { value: 3114, name: 'SUPERVISOR DE ESCRITORIO' },
  { value: 3115, name: 'SUPERVISOR DE LABORATORIO SEM ESPECIFICACAO' },
  { value: 3116, name: 'SUPERVISOR DE LINHA' },
  { value: 3117, name: 'SUPERVISOR DE MANUTENCAO' },
  { value: 3118, name: 'SUPERVISOR DE OBRAS' },
  { value: 3119, name: 'SUPERVISOR DE PRODUCAO' },
  { value: 3120, name: 'SUPERVISOR DE SEGURANCA' },
  { value: 3121, name: 'SUPERVISOR DE SEGURANCA DO TRABALHO' },
  { value: 3122, name: 'SUPERVISOR DE SEGURANCA INDUSTRIAL' },
  { value: 3123, name: 'SUPERVISOR DE SEGURANCA PATRIMONIAL' },
  { value: 3124, name: 'SUPERVISOR DE SERVICOS' },
  { value: 3125, name: 'SUPERVISOR DE VENDAS' },
  { value: 3126, name: 'SUPERVISOR DE VOO' },
  { value: 3127, name: 'SUPERVISOR EDUCACIONAL' },
  { value: 3128, name: 'SUPERVISOR FLORESTAL' },
  { value: 3129, name: 'SUPERVISOR' },
  { value: 3130, name: 'TABELIAO' },
  { value: 3131, name: 'TAIFEIRO' },
  { value: 3132, name: 'TAIPEIRO' },
  { value: 3133, name: 'TALHADOR DE CARNE' },
  { value: 3134, name: 'TAMANQUEIRO' },
  { value: 3135, name: 'TANGERINO' },
  { value: 3136, name: 'TANOEIRO' },
  { value: 3137, name: 'TAPECEIRO (FABRICACAO\\\0' },
  { value: 3138, name: 'TAPECEIRO (FORA EXCECAO)' },
  { value: 3139, name: 'TAPECEIRO SEM ESPECIFICACAO' },
  { value: 3140, name: 'TAQUEIRO' },
  { value: 3141, name: 'TAQUIGRAFO' },
  { value: 3142, name: 'TAREFEIRO (AGRICULTURA)' },
  { value: 3143, name: 'TAREFEIRO SEM ESPECIFICACAO' },
  { value: 3144, name: 'TARRAFEADOR' },
  { value: 3145, name: 'TATUADOR (PECUARIA)' },
  { value: 3146, name: 'TAXIDERMISTA' },
  { value: 3147, name: 'TAXISTA' },
  { value: 3148, name: 'TECELAO (FORA EXCECOES)' },
  { value: 3149, name: 'TECELAO DE MALHARIA' },
  { value: 3150, name: 'TECELAO DE MEIAS' },
  { value: 3151, name: 'TECELAO' },
  { value: 3152, name: 'TECLADISTA' },
  { value: 3153, name: 'TECLEADOR' },
  { value: 3154, name: 'TECNICO AEROFOTOGRAFICO' },
  { value: 3155, name: 'TECNICO AGRICOLA' },
  { value: 3156, name: 'TECNICO AGROPECUARIO' },
  { value: 3157, name: 'TECNICO COOPERATIVISTA' },
  { value: 3158, name: 'TECNICO DE ABASTECIMENTO DE AGUA' },
  { value: 3159, name: 'TECNICO DE ADMINISTRACAO' },
  { value: 3160, name: 'TECNICO DE AERONAVES' },
  { value: 3161, name: 'TECNICO DE AGRIMENSURA' },
  { value: 3162, name: 'TECNICO DE ALIMENTOS' },
  { value: 3163, name: 'TECNICO DE ANALISES CLINICAS' },
  { value: 3164, name: 'TECNICO DE APARELHOS HOSPITALARES' },
  { value: 3165, name: 'TECNICO DE ARTES GRAFICAS' },
  { value: 3166, name: 'TECNICO DE ATLETISMO' },
  { value: 3167, name: 'TECNICO DE AUTOMOVEIS' },
  { value: 3168, name: 'TECNICO DE AVIACAO' },
  { value: 3169, name: 'TECNICO DE BANCO DE SANGUE' },
  { value: 3170, name: 'TECNICO DE BIOQUIMICA' },
  { value: 3171, name: 'TECNICO DE CALCADOS' },
  { value: 3172, name: 'TECNICO DE CALDEIRARIA' },
  { value: 3173, name: 'TECNICO DE CALEFACAO' },
  { value: 3174, name: 'TECNICO DE CARNES' },
  { value: 3175, name: 'TECNICO DE CELULOSE E PAPEL' },
  { value: 3176, name: 'TECNICO DE CENSURA   ICAS' },
  { value: 3177, name: 'TECNICO DE CERAMICA' },
  { value: 3178, name: 'TECNICO DE COMERCIALIZACAO' },
  { value: 3179, name: 'TECNICO DE COMERCIO EXTERIOR' },
  { value: 3180, name: 'TECNICO DE COMPRAS' },
  { value: 3181, name: 'TECNICO DE COMPUTACAO' },
  { value: 3182, name: 'TECNICO DE COMUNICACAO' },
  { value: 3183, name: 'TECNICO DE COMUTACAO' },
  { value: 3184, name: 'TECNICO DE CONCRETO' },
  { value: 3185, name: 'TECNICO DE CONSTRUCAO' },
  { value: 3186, name: 'TECNICO DE CONTABILIDADE' },
  { value: 3187, name: 'TECNICO DE CONTROLE E QUALIDADE' },
  { value: 3188, name: 'TECNICO DE CURTUME' },
  { value: 3189, name: 'TECNICO DE CUSTOS' },
  { value: 3190, name: 'TECNICO DE DESENVOLVIMENTO DE PESSOAL' },
  { value: 3191, name: 'TECNICO DE DESENVOLVIMENTO DE PRODUTOS' },
  { value: 3192, name: 'TECNICO DE ECONOMIA DOMESTICA' },
  { value: 3193, name: 'TECNICO DE EDIFICACOES' },
  { value: 3194, name: 'TECNICO DE EDUCACAO' },
  { value: 3195, name: 'TECNICO DE ELETRICIDADE' },
  { value: 3196, name: 'TECNICO DE ELETROCARDIOGRAMA' },
  { value: 3197, name: 'TECNICO DE ELETROENCEFALOGRAMA' },
  { value: 3198, name: 'TECNICO DE ELETROMECANICA' },
  { value: 3199, name: 'TECNICO DE ELETRONICA' },
  { value: 3200, name: 'TECNICO DE ENFERMAGEM' },
  { value: 3201, name: 'TECNICO DE ENGENHARIA CIVIL' },
  { value: 3202, name: 'TECNICO DE ESMALTACAO' },
  { value: 3203, name: 'TECNICO DE ESPECIFICACAO E PADRONIZACAO' },
  { value: 3204, name: 'TECNICO DE ESPORTES' },
  { value: 3205, name: 'TECNICO DE ESTATISTICA' },
  { value: 3206, name: 'TECNICO DE ESTRADAS' },
  { value: 3207, name: 'TECNICO DE FARMACIA' },
  { value: 3208, name: 'TECNICO DE FOGOES' },
  { value: 3209, name: 'TECNICO DE FORMACAO PROFISSIONAL' },
  { value: 3210, name: 'TECNICO DE FUNDICAO' },
  { value: 3211, name: 'TECNICO DE GALVANIZACAO' },
  { value: 3212, name: 'TECNICO DE GEOFISICA' },
  { value: 3213, name: 'TECNICO DE GEOLOGIA' },
  { value: 3214, name: 'TECNICO DE HEMOTERAPIA' },
  { value: 3215, name: 'TECNICO DE HIDRAULICA' },
  { value: 3216, name: 'TECNICO DE HIDROGRAFIA' },
  { value: 3217, name: 'TECNICO DE HIGIENE E SAUDE PUBLICA' },
  { value: 3218, name: 'TECNICO DE HOTELARIA' },
  { value: 3219, name: 'TECNICO DE IDIOMA (SEGUNDO GRAU)' },
  { value: 3220, name: 'TECNICO DE IMPORTACAO E EXPORTACAO' },
  { value: 3221, name: 'TECNICO DE INSTRUMENTACAO' },
  { value: 3222, name: 'TECNICO DE LABORATORIO INDUSTRIAL' },
  { value: 3223, name: 'TECNICO DE LABORATORIO MEDICO' },
  { value: 3224, name: 'TECNICO DE LABORATORIO SEM ESPECIFICACAO' },
  { value: 3225, name: 'TECNICO DE LAMINACAO' },
  { value: 3226, name: 'TECNICO DE LATICINIOS' },
  { value: 3227, name: 'TECNICO DE MANUTENCAO DE AERONAVES' },
  { value: 3228, name: 'TECNICO DE MANUTENCAO DE COMPUTADOR' },
  { value: 3229, name: 'TECNICO DE MANUTENCAO DE MAQUINAS' },
  { value: 3230, name: 'TECNICO DE MANUTENCAO ELETRICA' },
  { value: 3231, name: 'TECNICO DE MANUTENCAO ELETRONICA' },
  { value: 3232, name: 'TECNICO DE MANUTENCAO MECANICA' },
  { value: 3233, name: 'TECNICO DE MANUTENCAO' },
  { value: 3234, name: 'TECNICO DE MAQUINAS' },
  { value: 3235, name: 'TECNICO DE MEDICOES' },
  { value: 3236, name: 'TECNICO DE METALIZACAO' },
  { value: 3237, name: 'TECNICO DE METALOGRAFIA E PETROGRAFIA' },
  { value: 3238, name: 'TECNICO DE METEOROLOGIA' },
  { value: 3239, name: 'TECNICO DE MICROBIOLOGIA' },
  { value: 3240, name: 'TECNICO DE MICROFILMAGEM' },
  { value: 3241, name: 'TECNICO DE MINAS' },
  { value: 3242, name: 'TECNICO DE MONTAGEM' },
  { value: 3243, name: 'TECNICO DE MONTAGEM DE TELECOMUNICACOES' },
  { value: 3244, name: 'TECNICO DE NUTRICAO' },
  { value: 3245, name: 'TECNICO DE OLEODUTOS' },
  { value: 3246, name: 'TECNICO DE ORGANIZACAO E METODOS' },
  { value: 3247, name: 'TECNICO DE ORGANIZACAO INDUSTRIAL' },
  { value: 3248, name: 'TECNICO DE ORIENTACAO PROFISSIONAL' },
  { value: 3249, name: 'TECNICO DE ORTOPEDIA' },
  { value: 3250, name: 'TECNICO DE PECUARIA' },
  { value: 3251, name: 'TECNICO DE PESCA' },
  { value: 3252, name: 'TECNICO DE PISCICULTURA' },
  { value: 3253, name: 'TECNICO DE PLANEJAMENTO' },
  { value: 3254, name: 'TECNICO DE PLASTICOS' },
  { value: 3255, name: 'TECNICO DE PREVENCAO DE INCENDIOS' },
  { value: 3256, name: 'TECNICO DE PROCESSAMENTO DE DADOS' },
  { value: 3257, name: 'TECNICO DE PROCESSOS' },
  { value: 3258, name: 'TECNICO DE PRODUCAO' },
  { value: 3259, name: 'TECNICO DE PROJETOS' },
  { value: 3260, name: 'TECNICO DE PROTESE ORTOPEDICA' },
  { value: 3261, name: 'TECNICO DE QUALIDADE' },
  { value: 3262, name: 'TECNICO DE RADIACOES' },
  { value: 3263, name: 'TECNICO DE RADIO E TELEVISAO' },
  { value: 3264, name: 'TECNICO DE RADIOISOTOPOS' },
  { value: 3265, name: 'TECNICO DE RADIOLOGIA MEDICA' },
  { value: 3266, name: 'TECNICO DE RADIOTERAPIA' },
  { value: 3267, name: 'TECNICO DE RAIOS X' },
  { value: 3268, name: 'TECNICO DE REABILITACAO' },
  { value: 3269, name: 'TECNICO DE REFRIGERACAO' },
  { value: 3270, name: 'TECNICO DE SANEAMENTO' },
  { value: 3271, name: 'TECNICO DE SEGURANCA DO TRABALHO' },
  { value: 3272, name: 'TECNICO DE SEGURANCA INDUSTRIAL' },
  { value: 3273, name: 'TECNICO DE SEGUROS' },
  { value: 3274, name: 'TECNICO DE SELECAO PROFISSIONAL' },
  { value: 3275, name: 'TECNICO DE SERICICULTURA' },
  { value: 3276, name: 'TECNICO DE SOM' },
  { value: 3277, name: 'TECNICO DE TECELAGEM' },
  { value: 3278, name: 'TECNICO DE TELECOMUNICACOES' },
  { value: 3279, name: 'TECNICO DE TELEFONIA' },
  { value: 3280, name: 'TECNICO DE TELEIMPRESSOR' },
  { value: 3281, name: 'TECNICO DE TEMPOS E METODOS' },
  { value: 3282, name: 'TECNICO DE TINTURARIA (FIACAO E TECELAGEM)' },
  { value: 3283, name: 'TECNICO DE TOPOGRAFIA' },
  { value: 3284, name: 'TECNICO DE TRAFEGO' },
  { value: 3285, name: 'TECNICO DE TRANSACOES IMOBILIARIAS' },
  { value: 3286, name: 'TECNICO DE TRANSMISSAO' },
  { value: 3287, name: 'TECNICO DE TREFILACAO' },
  { value: 3288, name: 'TECNICO DE TRIBUTOS' },
  { value: 3289, name: 'TECNICO DE TUBULACOES' },
  { value: 3290, name: 'TECNICO DE TURISMO' },
  { value: 3291, name: 'TECNICO DE VENDAS' },
  { value: 3292, name: 'TECNICO DE VETERINARIA' },
  { value: 3293, name: 'TECNICO DE VIDROS' },
  { value: 3294, name: 'TECNICO DE VULCANIZACAO' },
  { value: 3295, name: 'TECNICO DENTARIO' },
  { value: 3296, name: 'TECNICO ELETRICISTA' },
  { value: 3297, name: 'TECNICO ELETROMECANICO' },
  { value: 3298, name: 'TECNICO ELETRONICO' },
  { value: 3299, name: 'TECNICO EM AGRONOMIA' },
  { value: 3300, name: 'TECNICO EM ASSUNTOS FISCAIS E CONTABEIS' },
  { value: 3301, name: 'TECNICO EM BIOLOGIA' },
  { value: 3302, name: 'TECNICO EM BIOQUIMICA' },
  { value: 3303, name: 'TECNICO EM CIENCIAS FISICAS' },
  { value: 3304, name: 'TECNICO EM COMUNICACOES VISUAIS' },
  { value: 3305, name: 'TECNICO EM COURO' },
  { value: 3306, name: 'TECNICO EM EDUCACAO' },
  { value: 3307, name: 'TECNICO EM FINANCAS' },
  { value: 3308, name: 'TECNICO EM HIGIENE E SEGURANCA DO TRABALHO' },
  { value: 3309, name: 'TECNICO EM MONTAGEM' },
  { value: 3310, name: 'TECNICO EM REBAIXAMENTO' },
  { value: 3311, name: 'TECNICO EM RECURSOS HUMANOS' },
  { value: 3312, name: 'TECNICO EM TRAFEGO RODOVIARIO' },
  { value: 3313, name: 'TECNICO EM TRANSPORTES' },
  { value: 3314, name: 'TECNICO ESPORTIVO' },
  { value: 3315, name: 'TECNICO FERRAMENTAL' },
  { value: 3316, name: 'TECNICO FLORESTAL' },
  { value: 3317, name: 'TECNICO GRAFICO' },
  { value: 3318, name: 'TECNICO IMOBILIARIO' },
  { value: 3319, name: 'TECNICO INSTRUMENTISTA' },
  { value: 3320, name: 'TECNICO LABORATORISTA' },
  { value: 3321, name: 'TECNICO MADEIREIRO' },
  { value: 3322, name: 'TECNICO MECANICO' },
  { value: 3323, name: 'TECNICO METALURGICO' },
  { value: 3324, name: 'TECNICO NAVAL' },
  { value: 3325, name: 'TECNICO PROJETISTA' },
  { value: 3326, name: 'TECNICO QUIMICO' },
  { value: 3327, name: 'TECNICO REDATOR' },
  { value: 3328, name: 'TECNICO' },
  { value: 3329, name: 'TECNICO TEXTIL' },
  { value: 3330, name: 'TECNICOINDUSTRIAL SEM ESPECIFICACAO' },
  { value: 3331, name: 'TECNOLOGO DE ALIMENTOS (CURSO SUPERIOR)' },
  { value: 3332, name: 'TECNOLOGO' },
  { value: 3333, name: 'TELEATOR' },
  { value: 3334, name: 'TELEFONISTA' },
  { value: 3335, name: 'TELEGRAFISTA' },
  { value: 3336, name: 'TELEIMPRESSOR' },
  { value: 3337, name: 'TELETIPISTA' },
  { value: 3338, name: 'TELHADOR' },
  { value: 3339, name: 'TEMPERADOR DE METAIS' },
  { value: 3340, name: 'TEMPERADOR DE VIDROS' },
  { value: 3341, name: 'TERAPEUTA OCUPACIONAL' },
  { value: 3342, name: 'TERREIRISTA DE CAFE' },
  { value: 3343, name: 'TESOUREIRO' },
  { value: 3344, name: 'TESTADOR DE CIRCUITOS' },
  { value: 3345, name: 'TESTADOR DE FIOS (TECIDOS)' },
  { value: 3346, name: 'TESTADOR DE MOTORES' },
  { value: 3347, name: 'TESTADOR SEM ESPECIFICACAO' },
  { value: 3348, name: 'TEXTURIZADOR' },
  { value: 3349, name: 'TIJOLEIRO' },
  { value: 3350, name: 'TIMONEIRO' },
  { value: 3351, name: 'TINGIDOR DE COUROS E PELES' },
  { value: 3352, name: 'TINGIDOR DE FIOS E TECIDOS' },
  { value: 3353, name: 'TINTUREIRO (FORA EXCECOES)' },
  { value: 3354, name: 'TINTUREIRO DE FIBRAS' },
  { value: 3355, name: 'TINTUREIRO DE FIOS' },
  { value: 3356, name: 'TINTUREIRO SEM ESPECIFICACAO' },
  { value: 3357, name: 'TIPOGRAFO' },
  { value: 3358, name: 'TIRADOR DE LEITE' },
  { value: 3359, name: 'TITEREIRO' },
  { value: 3360, name: 'TITULADOR' },
  { value: 3361, name: 'TITULEIRO' },
  { value: 3362, name: 'TONELEIRO' },
  { value: 3363, name: 'TOPOGRAFO' },
  { value: 3364, name: 'TORCEDOR DE MECHAS' },
  { value: 3365, name: 'TORCEDOR DE URDIMENTO' },
  { value: 3366, name: 'TOREIRO' },
  { value: 3367, name: 'TORNEIRO (FORA EXCECOES)' },
  { value: 3368, name: 'TORNEIRO CERAMISTA' },
  { value: 3369, name: 'TORNEIRO COPIADOR' },
  { value: 3370, name: 'TORNEIRO DE MADEIRA' },
  { value: 3371, name: 'TORNEIRO DE PEDRA' },
  { value: 3372, name: 'TORNEIRO REVISOR' },
  { value: 3373, name: 'TORNEIRO REVOLVER' },
  { value: 3374, name: 'TORNEIRO SEM ESPECIFICACAO' },
  { value: 3375, name: 'TORRADOR DE CACAU' },
  { value: 3376, name: 'TORRADOR DE CAFE' },
  { value: 3377, name: 'TORRADOR SEM ESPECIFICACAO' },
  { value: 3378, name: 'TORRISTA (PETROLEO)' },
  { value: 3379, name: 'TOSADOR' },
  { value: 3380, name: 'TOSQUIADOR' },
  { value: 3381, name: 'TOXICOLOGISTA' },
  { value: 3382, name: 'TRAB.DA EXPLORACAO DE BABACU' },
  { value: 3383, name: 'TRAB.DA EXPLORACAO DE CARNAUBA' },
  { value: 3384, name: 'TRAB.DA EXPLORACAO DE CASTANHA-DO-PARA' },
  { value: 3385, name: 'TRAB.DA EXPLORACAO DE ERVA-MATE' },
  { value: 3386, name: 'TRAB.DA EXPLORACAO DE GUARANA' },
  { value: 3387, name: 'TRAB.EXP.ESPECIES PROD.SUBST.AROM.MED.E TOXIC' },
  { value: 3388, name: 'TRAB.EXP.OUTRAS ESP.PROD.FIBRAS,CERAS E OLEO' },
  { value: 3389, name: 'TRAB.EXP.OUTRAS ESP.PROD.SUBST.ALIMENTICIAS' },
  { value: 3390, name: 'TRABAL.CULT.PLANTAS PROD.SUBST.AROM.MED.E TOX' },
  { value: 3391, name: 'TRABAL.DA CULT.PLANTAS OLEAGINOSAS EM GERAL' },
  { value: 3392, name: 'TRABALHADOR BRACAL (AGRICULTURA)' },
  { value: 3393, name: 'TRABALHADOR BRACAL SEM ESPECIFICACAO' },
  { value: 3394, name: 'TRABALHADOR DA CULT.D/OUTRAS PLANTAS FIBROSAS' },
  { value: 3395, name: 'TRABALHADOR DA CULTURA DE ABACAXI' },
  { value: 3396, name: 'TRABALHADOR DA CULTURA DE ALFACE' },
  { value: 3397, name: 'TRABALHADOR DA CULTURA DE ALGODAO' },
  { value: 3398, name: 'TRABALHADOR DA CULTURA DE AMENDOIM' },
  { value: 3399, name: 'TRABALHADOR DA CULTURA DE ARROZ' },
  { value: 3400, name: 'TRABALHADOR DA CULTURA DE BANANA' },
  { value: 3401, name: 'TRABALHADOR DA CULTURA DE BATATA-INGLESA' },
  { value: 3402, name: 'TRABALHADOR DA CULTURA DE CAJU' },
  { value: 3403, name: 'TRABALHADOR DA CULTURA DE CEBOLA' },
  { value: 3404, name: 'TRABALHADOR DA CULTURA DE COCO' },
  { value: 3405, name: 'TRABALHADOR DA CULTURA DE DENDE' },
  { value: 3406, name: 'TRABALHADOR DA CULTURA DE ERVILHA' },
  { value: 3407, name: 'TRABALHADOR DA CULTURA DE FEIJAO' },
  { value: 3408, name: 'TRABALHADOR DA CULTURA DE JUTA' },
  { value: 3409, name: 'TRABALHADOR DA CULTURA DE LARANJA' },
  { value: 3410, name: 'TRABALHADOR DA CULTURA DE LENTILHA' },
  { value: 3411, name: 'TRABALHADOR DA CULTURA DE MAMONA' },
  { value: 3412, name: 'TRABALHADOR DA CULTURA DE MANDIOCA' },
  { value: 3413, name: 'TRABALHADOR DA CULTURA DE MANGA' },
  { value: 3414, name: 'TRABALHADOR DA CULTURA DE MILHO' },
  { value: 3415, name: 'TRABALHADOR DA CULTURA DE OUTRAS GRAMINEAS' },
  { value: 3416, name: 'TRABALHADOR DA CULTURA DE OUTRAS HORTALICAS' },
  { value: 3417, name: 'TRABALHADOR DA CULTURA DE OUTROS CITRICOS' },
  { value: 3418, name: 'TRABALHADOR DA CULTURA DE PESSEGO' },
  { value: 3419, name: 'TRABALHADOR DA CULTURA DE RAMI' },
  { value: 3420, name: 'TRABALHADOR DA CULTURA DE ROSAS' },
  { value: 3421, name: 'TRABALHADOR DA CULTURA DE SISAL' },
  { value: 3422, name: 'TRABALHADOR DA CULTURA DE SOJA' },
  { value: 3423, name: 'TRABALHADOR DA CULTURA DE TRIGO' },
  { value: 3424, name: 'TRABALHADOR DA CULTURA DE UVA' },
  { value: 3425, name: 'TRABALHADOR DA FLORICULTURA EM GERAL' },
  { value: 3426, name: 'TRABALHADOR DA FRUTICULTURA EM GERAL' },
  { value: 3427, name: 'TRABALHADOR SEM ESPECIFICAÇÃO' },
  { value: 3428, name: 'TRABALHADOR HORTIGRANJEIRO EM GERAL' },
  { value: 3429, name: 'TRABALHADOR VOLANTE' },
  { value: 3430, name: 'TRACADOR (CERAMICA)' },
  { value: 3431, name: 'TRACADOR DE CALDEIRARIA' },
  { value: 3432, name: 'TRACADOR DE ESTRUTURAS METALICAS' },
  { value: 3433, name: 'TRACADOR DE MARCENARIA' },
  { value: 3434, name: 'TRACADOR DE METAIS' },
  { value: 3435, name: 'TRACADOR DE PEDRAS' },
  { value: 3436, name: 'TRACADOR DE ROUPAS' },
  { value: 3437, name: 'TRACADOR DE VIDROS E CRISTAIS' },
  { value: 3438, name: 'TRACADOR MECANICO' },
  { value: 3439, name: 'TRACADOR SEM ESPECIFICACAO' },
  { value: 3440, name: 'TRADUTOR' },
  { value: 3441, name: 'TRAMISTA' },
  { value: 3442, name: 'TRANSADOR DE FIBRAS' },
  { value: 3443, name: 'TRANSPORTADOR DE ARVORES' },
  { value: 3444, name: 'TRANSPORTADOR DE ESPULAS' },
  { value: 3445, name: 'TRANSPORTADOR DE FIOS' },
  { value: 3446, name: 'TRANSPORTADOR DE JORNAL' },
  { value: 3447, name: 'TRANSPORTADOR DE LEITE' },
  { value: 3448, name: 'TRANSPORTADOR DE MACAROCAS' },
  { value: 3449, name: 'TRANSPORTADOR DE MADEIRA' },
  { value: 3450, name: 'TRANSPORTADOR DE TECIDOS' },
  { value: 3451, name: 'TRANSPORTADOR LITOGRAFICO' },
  { value: 3452, name: 'TRANSPORTADOR SEM ESPECIFICACAO' },
  { value: 3453, name: 'TRANSVASADOR DE VINHO' },
  { value: 3454, name: 'TRAPEIRO (PASTA DE PAPEL)' },
  { value: 3455, name: 'TRAPEZISTA' },
  { value: 3456, name: 'TRAPICHEIRO (CANA)' },
  { value: 3457, name: 'TRATADOR DE AGUA' },
  { value: 3458, name: 'TRATADOR DE ANIMAIS EM ZOOLOGICO' },
  { value: 3459, name: 'TRATADOR DE METAIS' },
  { value: 3460, name: 'TRATADOR SEM ESPECIFICACAO' },
  { value: 3461, name: 'TRATORISTA (FORA EXCECOES)' },
  { value: 3462, name: 'TRATORISTA AGRICOLA' },
  { value: 3463, name: 'TRATORISTA FLORESTAL' },
  { value: 3464, name: 'TRATORISTA SEM ESPECIFICACAO' },
  { value: 3465, name: 'TREFILADOR DE BORRACHA' },
  { value: 3466, name: 'TREFILADOR DE METAIS PRECIOSOS' },
  { value: 3467, name: 'TREFILADOR SEM ESPECIFICACAO' },
  { value: 3468, name: 'TREINADOR DE CAVALOS' },
  { value: 3469, name: 'TRICICLISTA' },
  { value: 3470, name: 'TRICOTEIRO' },
  { value: 3471, name: 'TRIGADOR AGRICOLA' },
  { value: 3472, name: 'TRINCHADOR' },
  { value: 3473, name: 'TRIPEIRO (VENDAS)' },
  { value: 3474, name: 'TRITURADOR DE MADEIRA' },
  { value: 3475, name: 'TRITURADOR DE PEDRAS' },
  { value: 3476, name: 'TROCADOR (TRANSPORTES)' },
  { value: 3477, name: 'TROCADOR DE ACESSORIOS' },
  { value: 3478, name: 'TROPEIRO' },
  { value: 3479, name: 'TRUQUEIRO (FERROVIAS)' },
  { value: 3480, name: 'TUPIEIRO' },
  { value: 3481, name: 'TUPISTA' },
  { value: 3482, name: 'TURBINEIRO (ACUCAR)' },
  { value: 3483, name: 'TURISTOLOGO (CURSO SUPERIOR)' },
  { value: 3484, name: 'TURISTOLOGO (SEGUNDO GRAU)' },
  { value: 3485, name: 'TURMEIRO (AGRICULTURA)' },
  { value: 3486, name: 'UMUDECEDOR DE FUMO' },
  { value: 3487, name: 'URBANISTA (CURSO SUPERIOR)' },
  { value: 3488, name: 'URDIDOR' },
  { value: 3489, name: 'URDITRIZ' },
  { value: 3490, name: 'URULOGISTA' },
  { value: 3491, name: 'VACINADOR' },
  { value: 3492, name: 'VAGALUME' },
  { value: 3493, name: 'VAGONETEIRO' },
  { value: 3494, name: 'VAPORIZADOR (TECIDOS)' },
  { value: 3495, name: 'VAQUEIRO' },
  { value: 3496, name: 'VARREDOR DE RUAS' },
  { value: 3497, name: 'VASSOUREIRO' },
  { value: 3498, name: 'VAZADOR DE CERAMICA' },
  { value: 3499, name: 'VAZADOR SEM ESPECIFICACAO' },
  { value: 3500, name: 'VELEIRO (VELAS DE CERA)' },
  { value: 3501, name: 'VELEIRO (VELAS DE PANO)' },
  { value: 3502, name: 'VENDEDOR (FORA EXCECOES)' },
  { value: 3503, name: 'VENDEDOR AMBULANTE' },
  { value: 3504, name: 'VENDEDOR DE APOSTAS (LOTERIA ESPORTIVA,TURFE)' },
  { value: 3505, name: 'VENDEDOR DE BILHETES' },
  { value: 3506, name: 'VENDEDOR DE JORNAIS' },
  { value: 3507, name: 'VENDEDOR DE LOTERIA (AMBULANTE)' },
  { value: 3508, name: 'VENDEDOR DE LOTERIA (ESTABELECIDO)' },
  { value: 3509, name: 'VENDEDOR DE PASSAGENS' },
  { value: 3510, name: 'VENDEDOR DE PEIXES' },
  { value: 3511, name: 'VENDEDOR DE PIPOCA' },
  { value: 3512, name: 'VENDEDOR DE PRODUTOS FARMACEUTICOS' },
  { value: 3513, name: 'VENDEDOR DE SORVETE' },
  { value: 3514, name: 'VENDEDOR DE SUCATA' },
  { value: 3515, name: 'VENDEDOR DE TRIPAS E MIUDOS' },
  { value: 3516, name: 'VENDEDOR DE VEICULOS' },
  { value: 3517, name: 'VENDEDOR PRACISTA' },
  { value: 3518, name: 'VENDEDOR SEM ESPECIFICACAO' },
  { value: 3519, name: 'VENDEDOR TECNICO' },
  { value: 3520, name: 'VENDEDOR VIAJANTE' },
  { value: 3521, name: 'VENTRILOQUO' },
  { value: 3522, name: 'VERDUREIRO' },
  { value: 3523, name: 'VEREADOR' },
  { value: 3524, name: 'VESTIARISTA' },
  { value: 3525, name: 'VETERINARIO (CURSO SUPERIOR)' },
  { value: 3526, name: 'VETERINARIO (SEGUNDO GRAU)' },
  { value: 3527, name: 'VIAJANTE' },
  { value: 3528, name: 'VIDRACEIROS (VITRAIS E VEICULOS)' },
  { value: 3529, name: 'VIDREIRO (FORA EXCECAO)' },
  { value: 3530, name: 'VIDREIRO ARTISTICO' },
  { value: 3531, name: 'VIDREIRO SEM ESPECIFICACAO' },
  { value: 3532, name: 'VIGARIO' },
  { value: 3533, name: 'VIGIA (FORA EXCECOES)' },
  { value: 3534, name: 'VIGIA DE PESCA ARTESANAL' },
  { value: 3535, name: 'VIGIA DE TORRE (FLORESTAL)' },
  { value: 3536, name: 'VIGIA SEM ESPECIFICACAO' },
  { value: 3537, name: 'VIGILANTE BANCARIO' },
  { value: 3538, name: 'VIGILANTE DE AEROPORTO' },
  { value: 3539, name: 'VIGILANTE SANITARIO' },
  { value: 3540, name: 'VIGILANTE SEM ESPECIFICACAO' },
  { value: 3541, name: 'VINAGREIRO' },
  { value: 3542, name: 'VINHATEIRO' },
  { value: 3543, name: 'VIOLINISTA' },
  { value: 3544, name: 'VIOLONCELISTA' },
  { value: 3545, name: 'VIOLONISTA' },
  { value: 3546, name: 'VISADEIRA SEM ESPECIFICACAO' },
  { value: 3547, name: 'VISITADOR DE SAUDE PUBLICA' },
  { value: 3548, name: 'VISITADOR DE SINISTROS' },
  { value: 3549, name: 'VISITADOR DOMICILIAR' },
  { value: 3550, name: 'VISITADOR SANITARIO' },
  { value: 3551, name: 'VISITADOR SOCIAL' },
  { value: 3552, name: 'VITRINISTA' },
  { value: 3553, name: 'VIVEIRISTA' },
  { value: 3554, name: 'VOLANTE (AGRICULTURA)' },
  { value: 3555, name: 'VULCANIZADOR' },
  { value: 3556, name: 'XAROPEIRO' },
  { value: 3557, name: 'XEROCOPISTA' },
  { value: 3558, name: 'ZELADOR (FORA EXCECOES)' },
  { value: 3559, name: 'ZELADOR DE BOMBAS' },
  { value: 3560, name: 'ZELADOR DE VESTIARIOS' },
  { value: 3561, name: 'ZELADOR SEM ESPECIFICACAO' },
  { value: 3562, name: 'ZINCADOR' },
  { value: 3563, name: 'ZOOLOGO' },
  { value: 3564, name: 'ZOOTECNISTA' },
  { value: 3565, name: 'DIRETOR EXECUTIVO' },
  { value: 3566, name: 'DIRETOR COMERCIAL' },
  { value: 3567, name: 'AGENTE PENITENCIÁRIO' },
  { value: 3568, name: 'ENCARREGADO ELETRICISTA DE INSTALAÇÕES' },
  { value: 3569, name: 'AGRICULTORA' },
  { value: 3570, name: 'ADMINITRADORA SEM ESPECIFICACAO' },
  { value: 3571, name: 'ADMINISTRADORA AGRICOLA' },
  { value: 3572, name: 'DONO-DE-CASA' },
  { value: 3573, name: 'ADMINISTRADORA DE EMPRESAS' },
  { value: 3574, name: 'AGRONOMA' },
  { value: 3575, name: 'APOSENTADA' },
  { value: 3576, name: 'ARQUITETA' },
  { value: 3577, name: 'AUTONOMA' },
  { value: 3578, name: 'ARRENDATARIA' },
  { value: 3579, name: 'DIRETORA AGRICOLA' },
  { value: 3580, name: 'DOMESTICO' },
  { value: 3581, name: 'ENGENHEIRO AGRONOMO' },
  { value: 3582, name: 'ENGENHEIRA SEM ESPECIFICACAO' },
  { value: 3583, name: 'MEDICA' },
  { value: 3584, name: 'MEDICA VETERINARIA' },
  { value: 3585, name: 'PREFEITA' },
  { value: 3586, name: 'PRODUTORA AGRICOLA' },
  { value: 3587, name: 'PROFESSORA SEM ESPECIFICACAO' },
  { value: 3588, name: 'ENGENHEIRA AGRONOMA' },
  { value: 3589, name: 'ENGENHEIRA DE MATERIAIS' },
  { value: 3590, name: 'EMPRESARIA SEM ESPECIFICACAO' },
  { value: 3591, name: 'APICULTOR' },
  { value: 3592, name: 'DESIGNER DE MODA' },
  { value: 3593, name: 'CUIDADOR' },
  { value: 3594, name: 'DESEMBARGADOR' },
  { value: 3595, name: 'ENGENHEIRO SEM ESPECIFICACAO' },
  { value: 3596, name: 'PRODUTOR DE EVENTOS' },
  { value: 3597, name: 'TÉCNICO EM LOGÍSTICA' },
  { value: 3598, name: 'PSICOPEDAGOGO' },
  { value: 3599, name: 'ASSESSOR AMBIENTAL' },
];

const nationality = [
  'Afegã',
  'Sul-africana',
  'Albanesa',
  'Alemã',
  'Andorrana',
  'Angolana',
  'Antiguana',
  'Antilhana Holandesa',
  'Saudita',
  'Argelina',
  'Argentina',
  'Armênia',
  'Arubana',
  'Australiana',
  'Austríaca',
  'Azerbaidjana',
  'Bahamense',
  'Bengalesa',
  'Barbadiana',
  'Barenita',
  'Bielo-russa',
  'Belga',
  'Belizenha',
  'Beninense',
  'Bermudiana',
  'Boliviana',
  'Bósnia',
  'Betchuana',
  'Brasileira',
  'Bruneiana',
  'Búlgara',
  'Burquinense',
  'Burundinesa',
  'Butanesa',
  'Caboverdiana',
  'Camoronesa',
  'Cambojana',
  'Canadense',
  'Catariana',
  'Cazaque',
  'Chadiana',
  'Chilena',
  'Chinesa',
  'Cipriota',
  'Cingapuriana',
  'Colombiana',
  'Comorense',
  'Congolesa',
  'Norte-coreana',
  'Sul-coreana',
  'Marfinense',
  'Costarriquenha',
  'Croata',
  'Cubana',
  'Dinamarquesa',
  'Djibutiano',
  'Dominicana',
  'Egípcia',
  'Salvadorenha',
  'Árabe',
  'Equatoriana',
  'Eritréia',
  'Eslovaca',
  'Eslovena',
  'Espanhola',
  'Estadunidense',
  'Estoniana',
  'Etíope',
  'Russa',
  'Fijiana',
  'Filipina',
  'Finlandesa',
  'Francesa',
  'Gabonesa',
  'Gambiana',
  'Ganense',
  'Georgiana',
  'Inglesa',
  'Granadina',
  'Grega',
  'Groelandês',
  'Guamesa',
  'Guatemalteca',
  'Guianesa',
  'Guianense',
  'Guineense',
  'Guinéu-equatoriana ',
  'Guineense',
  'Haitiana',
  'Holandesa',
  'Hondurenha',
  'Honconguesa',
  'Húngara',
  'Iemenita',
  'Norfolkiana',
  'Caimanesa',
  'Feroês',
  'Malvinense',
  'Marshallina',
  'Pitcairnesa',
  'Reunionesa',
  'Salomônica',
  'Toquelauana',
  'Turco-caiquense',
  'Virginense',
  'Virginiana',
  'Wallisiana',
  'Indiana',
  'Indonésia',
  'Iraniana',
  'Iraquiana',
  'Irlandesa',
  'Islandesa',
  'Israelense',
  'Italiana',
  'Iugoslava',
  'Jamaicana',
  'Japonsesa',
  'Jordaniana',
  'Kiribatiana',
  'Kuweitiana',
  'Laosiana',
  'Lesota',
  'Letã',
  'Libanesa',
  'Liberiana',
  'Líbia',
  'Liechtensteiniense',
  'Lituana',
  'Luxemburguesa',
  'Macedônia',
  'Malgaxe',
  'Malaia',
  'Malauiana',
  'Maldívia',
  'Malinesa',
  'Maltesa',
  'Marroquina',
  'Mauriciana',
  'Mauritana',
  'Mexicana',
  'Birbanesa',
  'Micronésia',
  'Moçambicana',
  'Moldávia',
  'Monegasca',
  'Mongol',
  'Namibiana',
  'Nauruana',
  'Nepalesa',
  'Nicaraguense',
  'Nigeriana',
  'Nigeriana',
  'Niueana',
  'Norueguesa',
  'Neocaledônia',
  'Neozelandesa',
  'Omani',
  'Palauense',
  'Panamenha',
  'Papuásia',
  'Paquistanesa',
  'Paraguaia',
  'Peruana',
  'Franco-polinésia',
  'Polonesa',
  'Porto-riqueinha',
  'Portuguesa',
  'Queniana',
  'Quirguiz',
  'Centro-africana',
  'Dominicana',
  'Tcheca',
  'Romena',
  'Ruandesa',
  'Saaráui',
  'Samoana',
  'Samoana',
  'Samarinesa',
  'Santa-lucense',
  'São-cristovense',
  'São-tomeense',
  'São-vicentina',
  'Seichelense',
  'Senegalesa',
  'Leonesa',
  'Síria',
  'Somali',
  'Cingalesa',
  'Suazi',
  'Sudanesa',
  'Suéca',
  'Suíça',
  'Surinamesa',
  'Tadjique',
  'Tailandesa',
  'Taiuanesa',
  'Tanzaniana',
  'Timorense',
  'Togolesa',
  'Tonganesa',
  'Trinitina',
  'Tunisiana',
  'Turcomana',
  'Turca',
  'Tuvaluana',
  'Ucraniana',
  'Ugandense',
  'Uruguaia',
  'Uzbeque',
  'Vanuatense',
  'Vaticana',
  'Venezuelana',
  'Vietnamita',
  'Zambiana',
  'Zimbabuana',
];

const countries = [
  'Afeganistão',
  'África do Sul',
  'Albânia',
  'Alemanha',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antártida',
  'Antígua e Barbuda',
  'Antilhas Holandesas',
  'Arábia Saudita',
  'Argélia',
  'Argentina',
  'Armênia',
  'Aruba',
  'Austrália',
  'Áustria',
  'Azerbaijão',
  'Bahamas',
  'Bahrein',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Bélgica',
  'Belize',
  'Benin',
  'Bermudas',
  'Bolívia',
  'Bósnia-Herzegóvina',
  'Botsuana',
  'Brasil',
  'Brunei',
  'Bulgária',
  'Burkina Fasso',
  'Burundi',
  'Butão',
  'Cabo Verde',
  'Camarões',
  'Camboja',
  'Canadá',
  'Cazaquistão',
  'Chade',
  'Chile',
  'China',
  'Chipre',
  'Cingapura',
  'Colômbia',
  'Congo',
  'Coréia do Norte',
  'Coréia do Sul',
  'Costa do Marfim',
  'Costa Rica',
  'Croácia (Hrvatska)',
  'Cuba',
  'Dinamarca',
  'Djibuti',
  'Dominica',
  'Egito',
  'El Salvador',
  'Emirados Árabes Unidos',
  'Equador',
  'Eritréia',
  'Eslováquia',
  'Eslovênia',
  'Espanha',
  'Estados Unidos',
  'Estônia',
  'Etiópia',
  'Fiji',
  'Filipinas',
  'Finlândia',
  'França',
  'Gabão',
  'Gâmbia',
  'Gana',
  'Geórgia',
  'Gibraltar',
  'Grã-Bretanha (Reino Unido, UK)',
  'Granada',
  'Grécia',
  'Groelândia',
  'Guadalupe',
  'Guam (Território dos Estados Unidos)',
  'Guatemala',
  'Guernsey',
  'Guiana',
  'Guiana Francesa',
  'Guiné',
  'Guiné Equatorial',
  'Guiné-Bissau',
  'Haiti',
  'Holanda',
  'Honduras',
  'Hong Kong',
  'Hungria',
  'Iêmen',
  'Ilha Bouvet (Território da Noruega)',
  'Ilha do Homem',
  'Ilha Natal',
  'Ilha Pitcairn',
  'Ilha Reunião',
  'Ilhas Aland',
  'Ilhas Cayman',
  'Ilhas Cocos',
  'Ilhas Comores',
  'Ilhas Cook',
  'Ilhas Faroes',
  'Ilhas Falkland (Malvinas)',
  'Ilhas Geórgia do Sul e Sandwich do Sul',
  'Ilhas Heard e McDonald (Território da Austrália)',
  'Ilhas Marianas do Norte',
  'Ilhas Marshall',
  'Ilhas Menores dos Estados Unidos',
  'Ilhas Norfolk',
  'Ilhas Seychelles',
  'Ilhas Solomão',
  'Ilhas Svalbard e Jan Mayen',
  'Ilhas Tokelau',
  'Ilhas Turks e Caicos',
  'Ilhas Virgens (Estados Unidos)',
  'Ilhas Virgens (Inglaterra)',
  'Ilhas Wallis e Futuna',
  'índia',
  'Indonésia',
  'Irã',
  'Iraque',
  'Irlanda',
  'Islândia',
  'Israel',
  'Itália',
  'Jamaica',
  'Japão',
  'Jersey',
  'Jordânia',
  'Kênia',
  'Kiribati',
  'Kuait',
  'Laos',
  'Látvia',
  'Lesoto',
  'Líbano',
  'Libéria',
  'Líbia',
  'Liechtenstein',
  'Lituânia',
  'Luxemburgo',
  'Macau',
  'Macedônia (República Yugoslava)',
  'Madagascar',
  'Malásia',
  'Malaui',
  'Maldivas',
  'Mali',
  'Malta',
  'Marrocos',
  'Martinica',
  'Maurício',
  'Mauritânia',
  'Mayotte',
  'México',
  'Micronésia',
  'Moçambique',
  'Moldova',
  'Mônaco',
  'Mongólia',
  'Montenegro',
  'Montserrat',
  'Myanma',
  'Namíbia',
  'Nauru',
  'Nepal',
  'Nicarágua',
  'Níger',
  'Nigéria',
  'Niue',
  'Noruega',
  'Nova Caledônia',
  'Nova Zelândia',
  'Omã',
  'Palau',
  'Panamá',
  'Papua-Nova Guiné',
  'Paquistão',
  'Paraguai',
  'Peru',
  'Polinésia Francesa',
  'Polônia',
  'Porto Rico',
  'Portugal',
  'Qatar',
  'Quirguistão',
  'República Centro-Africana',
  'República Democrática do Congo',
  'República Dominicana',
  'República Tcheca',
  'Romênia',
  'Ruanda',
  'Rússia (antiga URSS) - Federação Russa',
  'Saara Ocidental',
  'Saint Vincente e Granadinas',
  'Samoa Americana',
  'Samoa Ocidental',
  'San Marino',
  'Santa Helena',
  'Santa Lúcia',
  'São Bartolomeu',
  'São Cristóvão e Névis',
  'São Martim',
  'São Tomé e Príncipe',
  'Senegal',
  'Serra Leoa',
  'Sérvia',
  'Síria',
  'Somália',
  'Sri Lanka',
  'St. Pierre and Miquelon',
  'Suazilândia',
  'Sudão',
  'Suécia',
  'Suíça',
  'Suriname',
  'Tadjiquistão',
  'Tailândia',
  'Taiwan',
  'Tanzânia',
  'Território Britânico do Oceano índico',
  'Territórios do Sul da França',
  'Territórios Palestinos Ocupados',
  'Timor Leste',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunísia',
  'Turcomenistão',
  'Turquia',
  'Tuvalu',
  'Ucrânia',
  'Uganda',
  'Uruguai',
  'Uzbequistão',
  'Vanuatu',
  'Vaticano',
  'Venezuela',
  'Vietnã',
  'Zâmbia',
  'Zimbábue',
];

const pepOptions = [
  'Não se aplica',
  'Detentores de mandatos eletivos dos Poderes Executivo e Legislativo da União;  Natureza Especial ou equivalente;',
  'Ocupantes de cargo, no Poder Executivo da União, de: Ministro de Estado ou equiparado, ou, presidente, vice-presidente e diretor, ou equivalentes, de entidades da administração pública indireta; e ou, Grupo Direção e Assessoramento Superiores (DAS), nível 6, ou equivalente; ',
  'Membros do Conselho Nacional de Justiça, do Supremo Tribunal Federal, dos Tribunais Superiores, dos Tribunais Regionais Federais, dos Tribunais Regionais do Trabalho, dos Tribunais Regionais Eleitorais, do Conselho Superior da Justiça do Trabalho e do Conselho da Justiça Federal; ',
  'Membros do Conselho Nacional do Ministério Público, o Procurador-Geral da República, o Vice-Procurador-Geral da República, o Procurador-Geral do Trabalho, o Procurador-Geral da Justiça Militar, os Subprocuradores-Gerais da República e os Procuradores[1]Gerais de Justiça dos Estados e do Distrito Federal; ',
  'Membros do Tribunal de Contas da União, o Procurador-Geral e os Subprocuradores-Gerais do Ministério Público junto ao Tribunal de Contas da União; ',
  'Presidentes e os tesoureiros nacionais, ou equivalentes, de partidos políticos; ',
  'Governadores e os Secretários de Estado e do Distrito Federal, os Deputados Estaduais e Distritais, os presidentes, ou equivalentes, de entidades da administração pública indireta estadual e distrital e os presidentes de Tribunais de Justiça, Tribunais Militares, Tribunais de Contas ou equivalentes dos Estados e do Distrito Federal; ',
  'Prefeitos, os Vereadores, os Secretários Municipais, os presidentes, ou equivalentes, de entidades da administração pública indireta municipal e os Presidentes de Tribunais de Contas ou equivalentes dos Municípios. ',
  'Pessoas que no exterior, sejam: chefes de estado ou de governo; ou, políticos de escalões superiores; ou ocupantes de cargos governamentais de escalões superiores; ou IV - oficiais-generais e membros de escalões superiores do Poder Judiciário; ou executivos de escalões superiores de empresas públicas; ou  dirigentes de partidos políticos. ',
];

const documentOptions = [
  { name: 'Carteira de Identidade', value: 'CARTEIRA_DE_IDENTIDADE' },
  { name: 'Registro Nacional de Estrangeiro - RNE', value: 'REGISTRO_NACIONAL_DE_ESTRANGEIRO' },
  { name: 'Carteira de Entidade de Classe', value: 'CARTEIRA_DE_ENTIDADE_DE_CLASSE' },
  { name: 'Carteira Nacional de Habilitação', value: 'CARTEIRA_NACIONAL_DE_HABILITACAO' },
  { name: 'Passaporte', value: 'PASSAPORTE' },
  { name: 'Carteira de Trabalho', value: 'CARTEIRA_DE_TRABALHO' },
  { name: 'Nova Carteira de Identdade Nacional - CIN', value: 'NOVA_CARTEIRA_DE_IDENTIDADE_NACIONAL_CIN' },
];

const maritalStatus = [
  { name: 'Comunhão Universal de Bens', value: 'COMUNHAO_TOTAL_DE_BENS' },
  { name: 'Comunhão Parcial de Bens', value: 'COMUNHAO_PARCIAL_DE_BENS' },
  { name: 'Separação Total de Bens', value: 'SEPARACAO_TOTAL_DE_BENS' },
  { name: 'Participação Final nos Aquestos', value: 'PARTICIPACAO_FINAL_NOS_AQUESTOS' },
  { name: 'Separação Obrigatória de Bens', value: 'SEPARACAO_OBRIGATORIA_DE_BENS' },
];

const genderOptions = [
  { name: 'Masculino', value: 'MASCULINO' },
  { name: 'Feminino', value: 'FEMININO' },

];
const municipalities = [
  { value: '1', name: 'Porto Velho', uf: '11' },
  { value: '2', name: 'Nova Mamoré', uf: '11' },
  { value: '3', name: 'Buritis', uf: '11' },
  { value: '4', name: 'Campo Novo de Rondônia', uf: '11' },
  { value: '5', name: 'Candeias do Jamari', uf: '11' },
  { value: '6', name: 'Cujubim', uf: '11' },
  { value: '7', name: 'Itapuã do Oeste', uf: '11' },
  { value: '8', name: 'Costa Marques', uf: '11' },
  { value: '9', name: 'Guajará-Mirim', uf: '11' },
  { value: '10', name: 'São Francisco do Guaporé', uf: '11' },
  { value: '11', name: 'Ariquemes', uf: '11' },
  { value: '12', name: "Machadinho D'Oeste", uf: '11' },
  { value: '13', name: 'Rio Crespo', uf: '11' },
  { value: '14', name: 'Alto Paraíso', uf: '11' },
  { value: '15', name: 'Cacaulândia', uf: '11' },
  { value: '16', name: 'Monte Negro', uf: '11' },
  { value: '17', name: 'Vale do Anari', uf: '11' },
  { value: '18', name: 'Jaru', uf: '11' },
  { value: '19', name: 'Ji-Paraná', uf: '11' },
  { value: '20', name: 'Ouro Preto do Oeste', uf: '11' },
  { value: '21', name: 'Presidente Médici', uf: '11' },
  { value: '22', name: 'Governador Jorge Teixeira', uf: '11' },
  { value: '23', name: 'Mirante da Serra', uf: '11' },
  { value: '24', name: 'Nova União', uf: '11' },
  { value: '25', name: 'Teixeirópolis', uf: '11' },
  { value: '26', name: 'Theobroma', uf: '11' },
  { value: '27', name: 'Urupá', uf: '11' },
  { value: '28', name: 'Vale do Paraíso', uf: '11' },
  { value: '29', name: "Nova Brasilândia D'Oeste", uf: '11' },
  { value: '30', name: 'São Miguel do Guaporé', uf: '11' },
  { value: '31', name: "Alvorada D'Oeste", uf: '11' },
  { value: '32', name: 'Seringueiras', uf: '11' },
  { value: '33', name: "Alta Floresta D'Oeste", uf: '11' },
  { value: '34', name: 'Cacoal', uf: '11' },
  { value: '35', name: "Espigão D'Oeste", uf: '11' },
  { value: '36', name: 'Rolim de Moura', uf: '11' },
  { value: '37', name: "Santa Luzia D'Oeste", uf: '11' },
  { value: '38', name: 'Alto Alegre dos Parecis', uf: '11' },
  { value: '39', name: 'Novo Horizonte do Oeste', uf: '11' },
  { value: '40', name: 'Castanheiras', uf: '11' },
  { value: '41', name: 'Ministro Andreazza', uf: '11' },
  { value: '42', name: 'Pimenta Bueno', uf: '11' },
  { value: '43', name: 'Vilhena', uf: '11' },
  { value: '44', name: 'Chupinguaia', uf: '11' },
  { value: '45', name: 'Parecis', uf: '11' },
  { value: '46', name: 'Primavera de Rondônia', uf: '11' },
  { value: '47', name: "São Felipe D'Oeste", uf: '11' },
  { value: '48', name: 'Cabixi', uf: '11' },
  { value: '49', name: 'Cerejeiras', uf: '11' },
  { value: '50', name: 'Colorado do Oeste', uf: '11' },
  { value: '51', name: 'Corumbiara', uf: '11' },
  { value: '52', name: 'Pimenteiras do Oeste', uf: '11' },
  { value: '53', name: 'Cruzeiro do Sul', uf: '12' },
  { value: '54', name: 'Mâncio Lima', uf: '12' },
  { value: '55', name: 'Marechal Thaumaturgo', uf: '12' },
  { value: '56', name: 'Porto Walter', uf: '12' },
  { value: '57', name: 'Rodrigues Alves', uf: '12' },
  { value: '58', name: 'Feijó', uf: '12' },
  { value: '59', name: 'Jordão', uf: '12' },
  { value: '60', name: 'Tarauacá', uf: '12' },
  { value: '61', name: 'Manoel Urbano', uf: '12' },
  { value: '62', name: 'Santa Rosa do Purus', uf: '12' },
  { value: '63', name: 'Sena Madureira', uf: '12' },
  { value: '64', name: 'Acrelândia', uf: '12' },
  { value: '65', name: 'Bujari', uf: '12' },
  { value: '66', name: 'Capixaba', uf: '12' },
  { value: '67', name: 'Plácido de Castro', uf: '12' },
  { value: '68', name: 'Rio Branco', uf: '12' },
  { value: '69', name: 'Senador Guiomard', uf: '12' },
  { value: '70', name: 'Porto Acre', uf: '12' },
  { value: '71', name: 'Assis Brasil', uf: '12' },
  { value: '72', name: 'Brasiléia', uf: '12' },
  { value: '73', name: 'Epitaciolândia', uf: '12' },
  { value: '74', name: 'Xapuri', uf: '12' },
  { value: '75', name: 'Barcelos', uf: '13' },
  { value: '76', name: 'Novo Airão', uf: '13' },
  { value: '77', name: 'Santa Isabel do Rio Negro', uf: '13' },
  { value: '78', name: 'São Gabriel da Cachoeira', uf: '13' },
  { value: '79', name: 'Japurá', uf: '13' },
  { value: '80', name: 'Maraã', uf: '13' },
  { value: '81', name: 'Amaturá', uf: '13' },
  { value: '82', name: 'Atalaia do Norte', uf: '13' },
  { value: '83', name: 'Benjamin Constant', uf: '13' },
  { value: '84', name: 'Fonte Boa', uf: '13' },
  { value: '85', name: 'Jutaí', uf: '13' },
  { value: '86', name: 'Santo Antônio do Içá', uf: '13' },
  { value: '87', name: 'São Paulo de Olivença', uf: '13' },
  { value: '88', name: 'Tabatinga', uf: '13' },
  { value: '89', name: 'Tonantins', uf: '13' },
  { value: '90', name: 'Carauari', uf: '13' },
  { value: '91', name: 'Eirunepé', uf: '13' },
  { value: '92', name: 'Envira', uf: '13' },
  { value: '93', name: 'Guajará', uf: '13' },
  { value: '94', name: 'Ipixuna', uf: '13' },
  { value: '95', name: 'Itamarati', uf: '13' },
  { value: '96', name: 'Juruá', uf: '13' },
  { value: '97', name: 'Alvarães', uf: '13' },
  { value: '98', name: 'Tefé', uf: '13' },
  { value: '99', name: 'Uarini', uf: '13' },
  { value: '100', name: 'Anamã', uf: '13' },
  { value: '101', name: 'Anori', uf: '13' },
  { value: '102', name: 'Beruri', uf: '13' },
  { value: '103', name: 'Caapiranga', uf: '13' },
  { value: '104', name: 'Coari', uf: '13' },
  { value: '105', name: 'Codajás', uf: '13' },
  { value: '106', name: 'Autazes', uf: '13' },
  { value: '107', name: 'Araruna', uf: '41' },
  { value: '108', name: 'Barbosa Ferraz', uf: '41' },
  { value: '109', name: 'Campo Mourão', uf: '41' },
  { value: '110', name: 'Corumbataí do Sul', uf: '41' },
  { value: '111', name: 'Engenheiro Beltrão', uf: '41' },
  { value: '112', name: 'Ipecaetá', uf: '29' },
  { value: '113', name: 'Ipirá', uf: '29' },
  { value: '114', name: 'Irará', uf: '29' },
  { value: '115', name: 'Itatim', uf: '29' },
  { value: '116', name: 'Ouriçangas', uf: '29' },
  { value: '117', name: 'Pedrão', uf: '29' },
  { value: '118', name: 'Pintadas', uf: '29' },
  { value: '119', name: 'Rafael Jambeiro', uf: '29' },
  { value: '120', name: 'Santa Bárbara', uf: '29' },
  { value: '121', name: 'Santanópolis', uf: '29' },
  { value: '122', name: 'Santa Teresinha', uf: '29' },
  { value: '123', name: 'Santo Estêvão', uf: '29' },
  { value: '124', name: 'São Gonçalo dos Campos', uf: '29' },
  { value: '125', name: 'Serra Preta', uf: '29' },
  { value: '126', name: 'Tanquinho', uf: '29' },
  { value: '127', name: 'Teodoro Sampaio', uf: '29' },
  { value: '128', name: 'Coronel João Sá', uf: '29' },
  { value: '129', name: 'Jeremoabo', uf: '29' },
  { value: '130', name: 'Pedro Alexandre', uf: '29' },
  { value: '131', name: 'Santa Brígida', uf: '29' },
  { value: '132', name: 'Sítio do Quinto', uf: '29' },
  { value: '133', name: 'Cansanção', uf: '29' },
  { value: '134', name: 'Canudos', uf: '29' },
  { value: '135', name: 'Euclides da Cunha', uf: '29' },
  { value: '136', name: 'Monte Santo', uf: '29' },
  { value: '137', name: 'Nordestina', uf: '29' },
  { value: '138', name: 'Queimadas', uf: '29' },
  { value: '139', name: 'Quijingue', uf: '29' },
  { value: '140', name: 'Tucano', uf: '29' },
  { value: '141', name: 'Uauá', uf: '29' },
  { value: '142', name: 'Adustina', uf: '29' },
  { value: '143', name: 'Antas', uf: '29' },
  { value: '144', name: 'Banzaê', uf: '29' },
  { value: '145', name: 'Cícero Dantas', uf: '29' },
  { value: '146', name: 'Cipó', uf: '29' },
  { value: '147', name: 'Fátima', uf: '29' },
  { value: '148', name: 'Heliópolis', uf: '29' },
  { value: '149', name: 'Itapicuru', uf: '29' },
  { value: '150', name: 'Nova Soure', uf: '29' },
  { value: '151', name: 'Novo Triunfo', uf: '29' },
  { value: '152', name: 'Olindina', uf: '29' },
  { value: '153', name: 'Paripiranga', uf: '29' },
  { value: '154', name: 'Ribeira do Amparo', uf: '29' },
  { value: '155', name: 'Ribeira do Pombal', uf: '29' },
  { value: '156', name: 'Araci', uf: '29' },
  { value: '157', name: 'Barrocas', uf: '29' },
  { value: '158', name: 'Biritinga', uf: '29' },
  { value: '159', name: 'Candeal', uf: '29' },
  { value: '160', name: 'Santana', uf: '29' },
  { value: '161', name: 'São Félix do Coribe', uf: '29' },
  { value: '162', name: 'Serra Dourada', uf: '29' },
  { value: '163', name: 'Campo Alegre de Lourdes', uf: '29' },
  { value: '164', name: 'Casa Nova', uf: '29' },
  { value: '165', name: 'Curaçá', uf: '29' },
  { value: '166', name: 'Juazeiro', uf: '29' },
  { value: '167', name: 'Pilão Arcado', uf: '29' },
  { value: '168', name: 'Remanso', uf: '29' },
  { value: '169', name: 'Sento Sé', uf: '29' },
  { value: '170', name: 'Sobradinho', uf: '29' },
  { value: '171', name: 'Abaré', uf: '29' },
  { value: '172', name: 'Chorrochó', uf: '29' },
  { value: '173', name: 'Glória', uf: '29' },
  { value: '174', name: 'Macururé', uf: '29' },
  { value: '175', name: 'Paulo Afonso', uf: '29' },
  { value: '176', name: 'Rodelas', uf: '29' },
  { value: '177', name: 'Barra', uf: '29' },
  { value: '178', name: 'Buritirama', uf: '29' },
  { value: '179', name: 'Ibotirama', uf: '29' },
  { value: '180', name: 'Itaguaçu da Bahia', uf: '29' },
  { value: '181', name: 'Morpará', uf: '29' },
  { value: '182', name: 'Muquém do São Francisco', uf: '29' },
  { value: '183', name: 'Xique-Xique', uf: '29' },
  { value: '184', name: 'Bom Jesus da Lapa', uf: '29' },
  { value: '185', name: 'Carinhanha', uf: '29' },
  { value: '186', name: 'Feira da Mata', uf: '29' },
  { value: '187', name: 'Paratinga', uf: '29' },
  { value: '188', name: 'Serra do Ramalho', uf: '29' },
  { value: '189', name: 'Sítio do Mato', uf: '29' },
  { value: '190', name: 'Andorinha', uf: '29' },
  { value: '191', name: 'Antônio Gonçalves', uf: '29' },
  { value: '192', name: 'Campo Formoso', uf: '29' },
  { value: '193', name: 'Filadélfia', uf: '29' },
  { value: '194', name: 'Itiúba', uf: '29' },
  { value: '195', name: 'Jaguarari', uf: '29' },
  { value: '196', name: 'Pindobaçu', uf: '29' },
  { value: '197', name: 'Senhor do Bonfim', uf: '29' },
  { value: '198', name: 'Umburanas', uf: '29' },
  { value: '199', name: 'América Dourada', uf: '29' },
  { value: '200', name: 'Barra do Mendes', uf: '29' },
  { value: '201', name: 'Barro Alto', uf: '29' },
  { value: '202', name: 'Cafarnaum', uf: '29' },
  { value: '203', name: 'Canarana', uf: '29' },
  { value: '204', name: 'Central', uf: '29' },
  { value: '205', name: 'Gentio do Ouro', uf: '29' },
  { value: '206', name: 'Ibipeba', uf: '29' },
  { value: '207', name: 'Ibititá', uf: '29' },
  { value: '208', name: 'Iraquara', uf: '29' },
  { value: '209', name: 'Irecê', uf: '29' },
  { value: '210', name: 'João Dourado', uf: '29' },
  { value: '211', name: 'Jussara', uf: '29' },
  { value: '212', name: 'Lapão', uf: '29' },
  { value: '213', name: 'Mulungu do Morro', uf: '29' },
  { value: '214', name: 'Presidente Dutra', uf: '29' },
  { value: '215', name: 'São Gabriel', uf: '29' },
  { value: '216', name: 'Souto Soares', uf: '29' },
  { value: '217', name: 'Uibaí', uf: '29' },
  { value: '218', name: 'Caém', uf: '29' },
  { value: '219', name: 'Caldeirão Grande', uf: '29' },
  { value: '220', name: 'Capim Grosso', uf: '29' },
  { value: '221', name: 'Jacobina', uf: '29' },
  { value: '222', name: 'Miguel Calmon', uf: '29' },
  { value: '223', name: 'Mirangaba', uf: '29' },
  { value: '224', name: 'Morro do Chapéu', uf: '29' },
  { value: '225', name: 'Ourolândia', uf: '29' },
  { value: '226', name: 'Piritiba', uf: '29' },
  { value: '227', name: 'Ponto Novo', uf: '29' },
  { value: '228', name: 'Quixabeira', uf: '29' },
  { value: '229', name: 'São José do Jacuípe', uf: '29' },
  { value: '230', name: 'Saúde', uf: '29' },
  { value: '231', name: 'Serrolândia', uf: '29' },
  { value: '232', name: 'Várzea do Poço', uf: '29' },
  { value: '233', name: 'Várzea Nova', uf: '29' },
  { value: '234', name: 'Baixa Grande', uf: '29' },
  { value: '235', name: 'Boa Vista do Tupim', uf: '29' },
  { value: '236', name: 'Iaçu', uf: '29' },
  { value: '237', name: 'Ibiquera', uf: '29' },
  { value: '238', name: 'Itaberaba', uf: '29' },
  { value: '239', name: 'Lajedinho', uf: '29' },
  { value: '240', name: 'Macajuba', uf: '29' },
  { value: '241', name: 'Mairi', uf: '29' },
  { value: '242', name: 'Mundo Novo', uf: '29' },
  { value: '243', name: 'Ruy Barbosa', uf: '29' },
  { value: '244', name: 'Tapiramutá', uf: '29' },
  { value: '245', name: 'Várzea da Roça', uf: '29' },
  { value: '246', name: 'Água Fria', uf: '29' },
  { value: '247', name: 'Anguera', uf: '29' },
  { value: '248', name: 'Antônio Cardoso', uf: '29' },
  { value: '249', name: 'Conceição da Feira', uf: '29' },
  { value: '250', name: 'Conceição do Jacuípe', uf: '29' },
  { value: '251', name: 'Coração de Maria', uf: '29' },
  { value: '252', name: 'Elísio Medrado', uf: '29' },
  { value: '253', name: 'Feira de Santana', uf: '29' },
  { value: '254', name: 'Matriz de Camaragibe', uf: '27' },
  { value: '255', name: 'Messias', uf: '27' },
  { value: '256', name: 'Murici', uf: '27' },
  { value: '257', name: 'Novo Lino', uf: '27' },
  { value: '258', name: 'Porto Calvo', uf: '27' },
  { value: '259', name: 'São Luís do Quitunde', uf: '27' },
  { value: '260', name: 'Japaratinga', uf: '27' },
  { value: '261', name: 'Maragogi', uf: '27' },
  { value: '262', name: 'Passo de Camaragibe', uf: '27' },
  { value: '263', name: 'Porto de Pedras', uf: '27' },
  { value: '264', name: 'São Miguel dos Milagres', uf: '27' },
  { value: '265', name: 'Barra de Santo Antônio', uf: '27' },
  { value: '266', name: 'Barra de São Miguel', uf: '27' },
  { value: '267', name: 'Coqueiro Seco', uf: '27' },
  { value: '268', name: 'Maceió', uf: '27' },
  { value: '269', name: 'Marechal Deodoro', uf: '27' },
  { value: '270', name: 'Paripueira', uf: '27' },
  { value: '271', name: 'Pilar', uf: '27' },
  { value: '272', name: 'Rio Largo', uf: '27' },
  { value: '273', name: 'Santa Luzia do Norte', uf: '27' },
  { value: '274', name: 'Satuba', uf: '27' },
  { value: '275', name: 'Anadia', uf: '27' },
  { value: '276', name: 'Boca da Mata', uf: '27' },
  { value: '277', name: 'Campo Alegre', uf: '27' },
  { value: '278', name: 'Coruripe', uf: '27' },
  { value: '279', name: 'Jequiá da Praia', uf: '27' },
  { value: '280', name: 'Junqueiro', uf: '27' },
  { value: '281', name: 'Roteiro', uf: '27' },
  { value: '282', name: 'São Miguel dos Campos', uf: '27' },
  { value: '283', name: 'Teotônio Vilela', uf: '27' },
  { value: '284', name: 'Feliz Deserto', uf: '27' },
  { value: '285', name: 'Igreja Nova', uf: '27' },
  { value: '286', name: 'Penedo', uf: '27' },
  { value: '287', name: 'Piaçabuçu', uf: '27' },
  { value: '288', name: 'Porto Real do Colégio', uf: '27' },
  { value: '289', name: 'Canindé de São Francisco', uf: '28' },
  { value: '290', name: 'Feira Nova', uf: '28' },
  { value: '291', name: 'Gararu', uf: '28' },
  { value: '292', name: 'Gracho Cardoso', uf: '28' },
  { value: '293', name: 'Itabi', uf: '28' },
  { value: '294', name: 'Monte Alegre de Sergipe', uf: '28' },
  { value: '295', name: 'Nossa Senhora da Glória', uf: '28' },
  { value: '296', name: 'Poço Redondo', uf: '28' },
  { value: '297', name: 'Porto da Folha', uf: '28' },
  { value: '298', name: 'Carira', uf: '28' },
  { value: '299', name: 'Frei Paulo', uf: '28' },
  { value: '300', name: 'Nossa Senhora Aparecida', uf: '28' },
  { value: '301', name: 'Pedra Mole', uf: '28' },
  { value: '302', name: 'Pinhão', uf: '28' },
  { value: '303', name: 'Ribeirópolis', uf: '28' },
  { value: '304', name: 'Aquidabã', uf: '28' },
  { value: '305', name: 'Cumbe', uf: '28' },
  { value: '306', name: 'Malhada dos Bois', uf: '28' },
  { value: '307', name: 'Muribeca', uf: '28' },
  { value: '308', name: 'Nossa Senhora das Dores', uf: '28' },
  { value: '309', name: 'São Miguel do Aleixo', uf: '28' },
  { value: '310', name: 'Areia Branca', uf: '28' },
  { value: '311', name: 'Campo do Brito', uf: '28' },
  { value: '312', name: 'Itabaiana', uf: '28' },
  { value: '313', name: 'Macambira', uf: '28' },
  { value: '314', name: 'Malhador', uf: '28' },
  { value: '315', name: 'Moita Bonita', uf: '28' },
  { value: '316', name: 'São Domingos', uf: '28' },
  { value: '317', name: 'Poço Verde', uf: '28' },
  { value: '318', name: 'Simão Dias', uf: '28' },
  { value: '319', name: 'Tobias Barreto', uf: '28' },
  { value: '320', name: 'Lagarto', uf: '28' },
  { value: '321', name: 'Riachão do Dantas', uf: '28' },
  { value: '322', name: 'Amparo de São Francisco', uf: '28' },
  { value: '323', name: 'Brejo Grande', uf: '28' },
  { value: '324', name: 'Canhoba', uf: '28' },
  { value: '325', name: 'Cedro de São João', uf: '28' },
  { value: '326', name: 'Ilha das Flores', uf: '28' },
  { value: '327', name: 'Neópolis', uf: '28' },
  { value: '328', name: 'Nossa Senhora de Lourdes', uf: '28' },
  { value: '329', name: 'Propriá', uf: '28' },
  { value: '330', name: 'Santana do São Francisco', uf: '28' },
  { value: '331', name: 'Telha', uf: '28' },
  { value: '332', name: 'Capela', uf: '28' },
  { value: '333', name: 'Divina Pastora', uf: '28' },
  { value: '334', name: 'Santa Rosa de Lima', uf: '28' },
  { value: '335', name: 'Siriri', uf: '28' },
  { value: '336', name: 'Japaratuba', uf: '28' },
  { value: '337', name: 'Japoatã', uf: '28' },
  { value: '338', name: 'Pacatuba', uf: '28' },
  { value: '339', name: 'Pirambu', uf: '28' },
  { value: '340', name: 'São Francisco', uf: '28' },
  { value: '341', name: 'Carmópolis', uf: '28' },
  { value: '342', name: 'General Maynard', uf: '28' },
  { value: '343', name: 'Laranjeiras', uf: '28' },
  { value: '344', name: 'Maruim', uf: '28' },
  { value: '345', name: 'Riachuelo', uf: '28' },
  { value: '346', name: 'Rosário do Catete', uf: '28' },
  { value: '347', name: 'Santo Amaro das Brotas', uf: '28' },
  { value: '348', name: 'Aracaju', uf: '28' },
  { value: '349', name: 'Barra dos Coqueiros', uf: '28' },
  { value: '350', name: 'Nossa Senhora do Socorro', uf: '28' },
  { value: '351', name: 'São Cristóvão', uf: '28' },
  { value: '352', name: 'Arauá', uf: '28' },
  { value: '353', name: 'Boquim', uf: '28' },
  { value: '354', name: 'Cristinápolis', uf: '28' },
  { value: '355', name: 'Itabaianinha', uf: '28' },
  { value: '356', name: 'Pedrinhas', uf: '28' },
  { value: '357', name: 'Salgado', uf: '28' },
  { value: '358', name: 'Tomar do Geru', uf: '28' },
  { value: '359', name: 'Umbaúba', uf: '28' },
  { value: '360', name: 'Estância', uf: '28' },
  { value: '361', name: 'Indiaroba', uf: '28' },
  { value: '362', name: "Itaporanga d'Ajuda", uf: '28' },
  { value: '363', name: 'Santa Luzia do Itanhy', uf: '28' },
  { value: '364', name: 'Baianópolis', uf: '29' },
  { value: '365', name: 'Barreiras', uf: '29' },
  { value: '366', name: 'Catolândia', uf: '29' },
  { value: '367', name: 'Formosa do Rio Preto', uf: '29' },
  { value: '368', name: 'Luís Eduardo Magalhães', uf: '29' },
  { value: '369', name: 'Riachão das Neves', uf: '29' },
  { value: '370', name: 'São Desidério', uf: '29' },
  { value: '371', name: 'Angical', uf: '29' },
  { value: '372', name: 'Brejolândia', uf: '29' },
  { value: '373', name: 'Cotegipe', uf: '29' },
  { value: '374', name: 'Cristópolis', uf: '29' },
  { value: '375', name: 'Mansidão', uf: '29' },
  { value: '376', name: 'Santa Rita de Cássia', uf: '29' },
  { value: '377', name: 'Tabocas do Brejo Velho', uf: '29' },
  { value: '378', name: 'Wanderley', uf: '29' },
  { value: '379', name: 'Canápolis', uf: '29' },
  { value: '380', name: 'Cocos', uf: '29' },
  { value: '381', name: 'Coribe', uf: '29' },
  { value: '382', name: 'Correntina', uf: '29' },
  { value: '383', name: 'Jaborandi', uf: '29' },
  { value: '384', name: 'Santa Maria da Vitória', uf: '29' },
  { value: '385', name: 'Farol', uf: '41' },
  { value: '386', name: 'Fênix', uf: '41' },
  { value: '387', name: 'Capela do Alto Alegre', uf: '29' },
  { value: '388', name: 'Conceição do Coité', uf: '29' },
  { value: '389', name: 'Gavião', uf: '29' },
  { value: '390', name: 'Ichu', uf: '29' },
  { value: '391', name: 'Lamarão', uf: '29' },
  { value: '392', name: 'Nova Fátima', uf: '29' },
  { value: '393', name: 'Pé de Serra', uf: '29' },
  { value: '394', name: 'Retirolândia', uf: '29' },
  { value: '395', name: 'Riachão do Jacuípe', uf: '29' },
  { value: '396', name: 'Santaluz', uf: '29' },
  { value: '397', name: 'São Domingos', uf: '29' },
  { value: '398', name: 'Serrinha', uf: '29' },
  { value: '399', name: 'Teofilândia', uf: '29' },
  { value: '400', name: 'Valente', uf: '29' },
  { value: '401', name: 'Acajutiba', uf: '29' },
  { value: '402', name: 'Alagoinhas', uf: '29' },
  { value: '403', name: 'Aporá', uf: '29' },
  { value: '404', name: 'Araças', uf: '29' },
  { value: '405', name: 'Iretama', uf: '41' },
  { value: '406', name: 'Luiziana', uf: '41' },
  { value: '407', name: 'Goianira', uf: '52' },
  { value: '408', name: 'Guapó', uf: '52' },
  { value: '409', name: 'Hidrolândia', uf: '52' },
  { value: '410', name: 'Leopoldo de Bulhões', uf: '52' },
  { value: '411', name: 'Nerópolis', uf: '52' },
  { value: '412', name: 'Santo Antônio de Goiás', uf: '52' },
  { value: '413', name: 'Senador Canedo', uf: '52' },
  { value: '414', name: 'Terezópolis de Goiás', uf: '52' },
  { value: '415', name: 'Trindade', uf: '52' },
  { value: '416', name: 'Alvorada do Norte', uf: '52' },
  { value: '417', name: 'Buritinópolis', uf: '52' },
  { value: '418', name: 'Damianópolis', uf: '52' },
  { value: '419', name: 'Flores de Goiás', uf: '52' },
  { value: '420', name: 'Divinópolis de Goiás', uf: '52' },
  { value: '421', name: 'Guarani de Goiás', uf: '52' },
  { value: '422', name: 'Iaciara', uf: '52' },
  { value: '423', name: 'Mambaí', uf: '52' },
  { value: '424', name: 'Posse', uf: '52' },
  { value: '425', name: 'São Domingos', uf: '52' },
  { value: '426', name: 'Simolândia', uf: '52' },
  { value: '427', name: "Sítio d'Abadia", uf: '52' },
  { value: '428', name: 'Abadiânia', uf: '52' },
  { value: '429', name: 'Água Fria de Goiás', uf: '52' },
  { value: '430', name: 'Águas Lindas de Goiás', uf: '52' },
  { value: '431', name: 'Alexânia', uf: '52' },
  { value: '432', name: 'Cabeceiras', uf: '52' },
  { value: '433', name: 'Cidade Ocidental', uf: '52' },
  { value: '434', name: 'Cocalzinho de Goiás', uf: '52' },
  { value: '435', name: 'Corumbá de Goiás', uf: '52' },
  { value: '436', name: 'Cristalina', uf: '52' },
  { value: '437', name: 'Formosa', uf: '52' },
  { value: '438', name: 'Luziânia', uf: '52' },
  { value: '439', name: 'Mimoso de Goiás', uf: '52' },
  { value: '440', name: 'Novo Gama', uf: '52' },
  { value: '441', name: 'Padre Bernardo', uf: '52' },
  { value: '442', name: 'Pirenópolis', uf: '52' },
  { value: '443', name: 'Planaltina', uf: '52' },
  { value: '444', name: 'Santo Antônio do Descoberto', uf: '52' },
  { value: '445', name: 'Valparaíso de Goiás', uf: '52' },
  { value: '446', name: 'Vila Boa', uf: '52' },
  { value: '447', name: 'Vila Propício', uf: '52' },
  { value: '448', name: 'Aparecida do Rio Doce', uf: '52' },
  { value: '449', name: 'Aporé', uf: '52' },
  { value: '450', name: 'Caiapônia', uf: '52' },
  { value: '451', name: 'Castelândia', uf: '52' },
  { value: '452', name: 'Chapadão do Céu', uf: '52' },
  { value: '453', name: 'Doverlândia', uf: '52' },
  { value: '454', name: 'Jataí', uf: '52' },
  { value: '455', name: 'Maurilândia', uf: '52' },
  { value: '456', name: 'Mineiros', uf: '52' },
  { value: '457', name: 'Montividiu', uf: '52' },
  { value: '458', name: 'Palestina de Goiás', uf: '52' },
  { value: '459', name: 'Perolândia', uf: '52' },
  { value: '460', name: 'Portelândia', uf: '52' },
  { value: '461', name: 'Rio Verde', uf: '52' },
  { value: '462', name: 'Santa Helena de Goiás', uf: '52' },
  { value: '463', name: 'Santa Rita do Araguaia', uf: '52' },
  { value: '464', name: 'Santo Antônio da Barra', uf: '52' },
  { value: '465', name: 'Serranópolis', uf: '52' },
  { value: '466', name: 'Acreúna', uf: '52' },
  { value: '467', name: 'Campestre de Goiás', uf: '52' },
  { value: '468', name: 'Cezarina', uf: '52' },
  { value: '469', name: 'Edealina', uf: '52' },
  { value: '470', name: 'Edéia', uf: '52' },
  { value: '471', name: 'Indiara', uf: '52' },
  { value: '472', name: 'Jandaia', uf: '52' },
  { value: '473', name: 'Palmeiras de Goiás', uf: '52' },
  { value: '474', name: 'Palminópolis', uf: '52' },
  { value: '475', name: 'Paraúna', uf: '52' },
  { value: '476', name: 'São João da Paraúna', uf: '52' },
  { value: '477', name: 'Turvelândia', uf: '52' },
  { value: '478', name: 'Varjão', uf: '52' },
  { value: '479', name: 'Água Limpa', uf: '52' },
  { value: '480', name: 'Aloândia', uf: '52' },
  { value: '481', name: 'Bom Jesus de Goiás', uf: '52' },
  { value: '482', name: 'Buriti Alegre', uf: '52' },
  { value: '483', name: 'Cachoeira Dourada', uf: '52' },
  { value: '484', name: 'Caldas Novas', uf: '52' },
  { value: '485', name: 'Cromínia', uf: '52' },
  { value: '486', name: 'Goiatuba', uf: '52' },
  { value: '487', name: 'Inaciolândia', uf: '52' },
  { value: '488', name: 'Itumbiara', uf: '52' },
  { value: '489', name: 'Joviânia', uf: '52' },
  { value: '490', name: 'Mairipotaba', uf: '52' },
  { value: '491', name: 'Marzagão', uf: '52' },
  { value: '492', name: 'Morrinhos', uf: '52' },
  { value: '493', name: 'Panamá', uf: '52' },
  { value: '494', name: 'Piracanjuba', uf: '52' },
  { value: '495', name: 'Pontalina', uf: '52' },
  { value: '496', name: 'Porteirão', uf: '52' },
  { value: '497', name: 'Professor Jamil', uf: '52' },
  { value: '498', name: 'Rio Quente', uf: '52' },
  { value: '499', name: 'Vicentinópolis', uf: '52' },
  { value: '500', name: 'Cristianópolis', uf: '52' },
  { value: '501', name: 'Gameleira de Goiás', uf: '52' },
  { value: '502', name: 'Orizona', uf: '52' },
  { value: '503', name: 'Palmelo', uf: '52' },
  { value: '504', name: 'Pires do Rio', uf: '52' },
  { value: '505', name: 'Santa Cruz de Goiás', uf: '52' },
  { value: '506', name: 'São Miguel do Passa Quatro', uf: '52' },
  { value: '507', name: 'Silvânia', uf: '52' },
  { value: '508', name: 'Urutaí', uf: '52' },
  { value: '509', name: 'Vianópolis', uf: '52' },
  { value: '510', name: 'Anhanguera', uf: '52' },
  { value: '511', name: 'Campo Alegre de Goiás', uf: '52' },
  { value: '512', name: 'Catalão', uf: '52' },
  { value: '513', name: 'Corumbaíba', uf: '52' },
  { value: '514', name: 'Cumari', uf: '52' },
  { value: '515', name: 'Davinópolis', uf: '52' },
  { value: '516', name: 'Goiandira', uf: '52' },
  { value: '517', name: 'Ipameri', uf: '52' },
  { value: '518', name: 'Nova Aurora', uf: '52' },
  { value: '519', name: 'Ouvidor', uf: '52' },
  { value: '520', name: 'Três Ranchos', uf: '52' },
  { value: '521', name: 'Cachoeira Alta', uf: '52' },
  { value: '522', name: 'Caçu', uf: '52' },
  { value: '523', name: 'Gouvelândia', uf: '52' },
  { value: '524', name: 'Itajá', uf: '52' },
  { value: '525', name: 'Itarumã', uf: '52' },
  { value: '526', name: 'Lagoa Santa', uf: '52' },
  { value: '527', name: 'Paranaiguara', uf: '52' },
  { value: '528', name: 'Quirinópolis', uf: '52' },
  { value: '529', name: 'São Simão', uf: '52' },
  { value: '530', name: 'Brasília', uf: '53' },
  { value: '531', name: 'Faina', uf: '52' },
  { value: '532', name: 'Goiás', uf: '52' },
  { value: '533', name: 'Itapirapuã', uf: '52' },
  { value: '534', name: 'Jussara', uf: '52' },
  { value: '535', name: 'Matrinchã', uf: '52' },
  { value: '536', name: 'Santa Fé de Goiás', uf: '52' },
  { value: '537', name: 'Aragarças', uf: '52' },
  { value: '538', name: 'Arenópolis', uf: '52' },
  { value: '539', name: 'Baliza', uf: '52' },
  { value: '540', name: 'Bom Jardim de Goiás', uf: '52' },
  { value: '541', name: 'Diorama', uf: '52' },
  { value: '542', name: 'Montes Claros de Goiás', uf: '52' },
  { value: '543', name: 'Piranhas', uf: '52' },
  { value: '544', name: 'Alto Horizonte', uf: '52' },
  { value: '545', name: 'Amaralina', uf: '52' },
  { value: '546', name: 'Bonópolis', uf: '52' },
  { value: '547', name: 'Campinaçu', uf: '52' },
  { value: '548', name: 'Campinorte', uf: '52' },
  { value: '549', name: 'Campos Verdes', uf: '52' },
  { value: '550', name: 'Estrela do Norte', uf: '52' },
  { value: '551', name: 'Formoso', uf: '52' },
  { value: '552', name: 'Mara Rosa', uf: '52' },
  { value: '553', name: 'Minaçu', uf: '52' },
  { value: '554', name: 'Montividiu do Norte', uf: '52' },
  { value: '555', name: 'Mutunópolis', uf: '52' },
  { value: '556', name: 'Niquelândia', uf: '52' },
  { value: '557', name: 'Nova Iguaçu de Goiás', uf: '52' },
  { value: '558', name: 'Porangatu', uf: '52' },
  { value: '559', name: 'Santa Tereza de Goiás', uf: '52' },
  { value: '560', name: 'Santa Terezinha de Goiás', uf: '52' },
  { value: '561', name: 'Trombas', uf: '52' },
  { value: '562', name: 'Uruaçu', uf: '52' },
  { value: '563', name: 'Alto Paraíso de Goiás', uf: '52' },
  { value: '564', name: 'Campos Belos', uf: '52' },
  { value: '565', name: 'Cavalcante', uf: '52' },
  { value: '566', name: 'Colinas do Sul', uf: '52' },
  { value: '567', name: 'Monte Alegre de Goiás', uf: '52' },
  { value: '568', name: 'Nova Roma', uf: '52' },
  { value: '569', name: "São João d'Aliança", uf: '52' },
  { value: '570', name: 'Teresina de Goiás', uf: '52' },
  { value: '571', name: 'Barro Alto', uf: '52' },
  { value: '572', name: 'Carmo do Rio Verde', uf: '52' },
  { value: '573', name: 'Ceres', uf: '52' },
  { value: '574', name: 'Goianésia', uf: '52' },
  { value: '575', name: 'Guaraíta', uf: '52' },
  { value: '576', name: 'Guarinos', uf: '52' },
  { value: '577', name: 'Hidrolina', uf: '52' },
  { value: '578', name: 'Ipiranga de Goiás', uf: '52' },
  { value: '579', name: 'Itapaci', uf: '52' },
  { value: '580', name: 'Itapuranga', uf: '52' },
  { value: '581', name: 'Morro Agudo de Goiás', uf: '52' },
  { value: '582', name: 'Nova América', uf: '52' },
  { value: '583', name: 'Nova Glória', uf: '52' },
  { value: '584', name: 'Pilar de Goiás', uf: '52' },
  { value: '585', name: 'Rialma', uf: '52' },
  { value: '586', name: 'Rianápolis', uf: '52' },
  { value: '587', name: 'Rubiataba', uf: '52' },
  { value: '588', name: 'Santa Isabel', uf: '52' },
  { value: '589', name: 'Santa Rita do Novo Destino', uf: '52' },
  { value: '590', name: 'São Luíz do Norte', uf: '52' },
  { value: '591', name: 'São Patrício', uf: '52' },
  { value: '592', name: 'Uruana', uf: '52' },
  { value: '593', name: 'Anápolis', uf: '52' },
  { value: '594', name: 'Araçu', uf: '52' },
  { value: '595', name: 'Brazabrantes', uf: '52' },
  { value: '596', name: 'Campo Limpo de Goiás', uf: '52' },
  { value: '597', name: 'Caturaí', uf: '52' },
  { value: '598', name: 'Damolândia', uf: '52' },
  { value: '599', name: 'Heitoraí', uf: '52' },
  { value: '600', name: 'Inhumas', uf: '52' },
  { value: '601', name: 'Itaberaí', uf: '52' },
  { value: '602', name: 'Itaguari', uf: '52' },
  { value: '603', name: 'Itaguaru', uf: '52' },
  { value: '604', name: 'Itauçu', uf: '52' },
  { value: '605', name: 'Jaraguá', uf: '52' },
  { value: '606', name: 'Jesúpolis', uf: '52' },
  { value: '607', name: 'Nova Veneza', uf: '52' },
  { value: '608', name: 'Ouro Verde de Goiás', uf: '52' },
  { value: '609', name: 'Petrolina de Goiás', uf: '52' },
  { value: '610', name: 'Santa Rosa de Goiás', uf: '52' },
  { value: '611', name: 'São Francisco de Goiás', uf: '52' },
  { value: '612', name: 'Taquaral de Goiás', uf: '52' },
  { value: '613', name: 'Amorinópolis', uf: '52' },
  { value: '614', name: 'Cachoeira de Goiás', uf: '52' },
  { value: '615', name: 'Córrego do Ouro', uf: '52' },
  { value: '616', name: 'Fazenda Nova', uf: '52' },
  { value: '617', name: 'Iporá', uf: '52' },
  { value: '618', name: 'Israelândia', uf: '52' },
  { value: '619', name: 'Ivolândia', uf: '52' },
  { value: '620', name: 'Jaupaci', uf: '52' },
  { value: '621', name: 'Moiporá', uf: '52' },
  { value: '622', name: 'Novo Brasil', uf: '52' },
  { value: '623', name: 'Adelândia', uf: '52' },
  { value: '624', name: 'Americano do Brasil', uf: '52' },
  { value: '625', name: 'Anicuns', uf: '52' },
  { value: '626', name: 'Aurilândia', uf: '52' },
  { value: '627', name: 'Avelinópolis', uf: '52' },
  { value: '628', name: 'Buriti de Goiás', uf: '52' },
  { value: '629', name: 'Firminópolis', uf: '52' },
  { value: '630', name: 'Mossâmedes', uf: '52' },
  { value: '631', name: 'Nazário', uf: '52' },
  { value: '632', name: 'Sanclerlândia', uf: '52' },
  { value: '633', name: 'Santa Bárbara de Goiás', uf: '52' },
  { value: '634', name: 'São Luís de Montes Belos', uf: '52' },
  { value: '635', name: 'Turvânia', uf: '52' },
  { value: '636', name: 'Abadia de Goiás', uf: '52' },
  { value: '637', name: 'Aparecida de Goiânia', uf: '52' },
  { value: '638', name: 'Aragoiânia', uf: '52' },
  { value: '639', name: 'Bela Vista de Goiás', uf: '52' },
  { value: '640', name: 'Bonfinópolis', uf: '52' },
  { value: '641', name: 'Caldazinha', uf: '52' },
  { value: '642', name: 'Goianápolis', uf: '52' },
  { value: '643', name: 'Goiânia', uf: '52' },
  { value: '644', name: 'Santa Rita do Trivelato', uf: '51' },
  { value: '645', name: 'Sorriso', uf: '51' },
  { value: '646', name: 'Tapurah', uf: '51' },
  { value: '647', name: 'Cláudia', uf: '51' },
  { value: '648', name: 'Feliz Natal', uf: '51' },
  { value: '649', name: 'Itaúba', uf: '51' },
  { value: '650', name: 'Marcelândia', uf: '51' },
  { value: '651', name: 'Nova Santa Helena', uf: '51' },
  { value: '652', name: 'Santa Carmem', uf: '51' },
  { value: '653', name: 'Sinop', uf: '51' },
  { value: '654', name: 'União do Sul', uf: '51' },
  { value: '655', name: 'Vera', uf: '51' },
  { value: '656', name: 'Gaúcha do Norte', uf: '51' },
  { value: '657', name: 'Nova Brasilândia', uf: '51' },
  { value: '658', name: 'Paranatinga', uf: '51' },
  { value: '659', name: 'Planalto da Serra', uf: '51' },
  { value: '660', name: 'Alto Boa Vista', uf: '51' },
  { value: '661', name: 'Bom Jesus do Araguaia', uf: '51' },
  { value: '662', name: 'Canabrava do Norte', uf: '51' },
  { value: '663', name: 'Confresa', uf: '51' },
  { value: '664', name: 'Luciára', uf: '51' },
  { value: '665', name: 'Novo Santo Antônio', uf: '51' },
  { value: '666', name: 'Porto Alegre do Norte', uf: '51' },
  { value: '667', name: 'Ribeirão Cascalheira', uf: '51' },
  { value: '668', name: 'São José do Xingu', uf: '51' },
  { value: '669', name: 'Santa Cruz do Xingu', uf: '51' },
  { value: '670', name: 'Santa Terezinha', uf: '51' },
  { value: '671', name: 'São Félix do Araguaia', uf: '51' },
  { value: '672', name: 'Serra Nova Dourada', uf: '51' },
  { value: '673', name: 'Vila Rica', uf: '51' },
  { value: '674', name: 'Água Boa', uf: '51' },
  { value: '675', name: 'Campinápolis', uf: '51' },
  { value: '676', name: 'Canarana', uf: '51' },
  { value: '677', name: 'Nova Nazaré', uf: '51' },
  { value: '678', name: 'Nova Xavantina', uf: '51' },
  { value: '679', name: 'Novo São Joaquim', uf: '51' },
  { value: '680', name: 'Querência', uf: '51' },
  { value: '681', name: 'Santo Antônio do Leste', uf: '51' },
  { value: '682', name: 'Araguaiana', uf: '51' },
  { value: '683', name: 'Barra do Garças', uf: '51' },
  { value: '684', name: 'Cocalinho', uf: '51' },
  { value: '685', name: "Conquista D'Oeste", uf: '51' },
  { value: '686', name: 'Vila Bela da Santíssima Trindade', uf: '51' },
  { value: '687', name: 'Nova Lacerda', uf: '51' },
  { value: '688', name: 'Pontes e Lacerda', uf: '51' },
  { value: '689', name: 'Vale de São Domingos', uf: '51' },
  { value: '690', name: 'Barra do Bugres', uf: '51' },
  { value: '691', name: 'Denise', uf: '51' },
  { value: '692', name: 'Nova Olímpia', uf: '51' },
  { value: '693', name: 'Porto Estrela', uf: '51' },
  { value: '694', name: 'Tangará da Serra', uf: '51' },
  { value: '695', name: 'Araputanga', uf: '51' },
  { value: '696', name: "Figueirópolis D'Oeste", uf: '51' },
  { value: '697', name: "Glória D'Oeste", uf: '51' },
  { value: '698', name: 'Indiavaí', uf: '51' },
  { value: '699', name: 'Jauru', uf: '51' },
  { value: '700', name: "Lambari D'Oeste", uf: '51' },
  { value: '701', name: "Mirassol d'Oeste", uf: '51' },
  { value: '702', name: 'Porto Esperidião', uf: '51' },
  { value: '703', name: 'São José dos Quatro Marcos', uf: '51' },
  { value: '704', name: 'Reserva do Cabaçal', uf: '51' },
  { value: '705', name: 'Rio Branco', uf: '51' },
  { value: '706', name: 'Salto do Céu', uf: '51' },
  { value: '707', name: 'Alto Paraguai', uf: '51' },
  { value: '708', name: 'Arenápolis', uf: '51' },
  { value: '709', name: 'Nortelândia', uf: '51' },
  { value: '710', name: 'Santo Afonso', uf: '51' },
  { value: '711', name: 'Nova Marilândia', uf: '51' },
  { value: '712', name: 'Acorizal', uf: '51' },
  { value: '713', name: 'Jangada', uf: '51' },
  { value: '714', name: 'Rosário Oeste', uf: '51' },
  { value: '715', name: 'Chapada dos Guimarães', uf: '51' },
  { value: '716', name: 'Cuiabá', uf: '51' },
  { value: '717', name: 'Nossa Senhora do Livramento', uf: '51' },
  { value: '718', name: 'Santo Antônio do Leverger', uf: '51' },
  { value: '719', name: 'Várzea Grande', uf: '51' },
  { value: '720', name: 'Barão de Melgaço', uf: '51' },
  { value: '721', name: 'Cáceres', uf: '51' },
  { value: '722', name: 'Curvelândia', uf: '51' },
  { value: '723', name: 'Poconé', uf: '51' },
  { value: '724', name: 'Campo Verde', uf: '51' },
  { value: '725', name: 'Primavera do Leste', uf: '51' },
  { value: '726', name: 'Araguainha', uf: '51' },
  { value: '727', name: 'General Carneiro', uf: '51' },
  { value: '728', name: 'Guiratinga', uf: '51' },
  { value: '729', name: 'Pontal do Araguaia', uf: '51' },
  { value: '730', name: 'Ponte Branca', uf: '51' },
  { value: '731', name: 'Poxoréo', uf: '51' },
  { value: '732', name: 'Ribeirãozinho', uf: '51' },
  { value: '733', name: 'Tesouro', uf: '51' },
  { value: '734', name: 'Torixoréu', uf: '51' },
  { value: '735', name: 'Dom Aquino', uf: '51' },
  { value: '736', name: 'Itiquira', uf: '51' },
  { value: '737', name: 'Jaciara', uf: '51' },
  { value: '738', name: 'Juscimeira', uf: '51' },
  { value: '739', name: 'Pedra Preta', uf: '51' },
  { value: '740', name: 'São José do Povo', uf: '51' },
  { value: '741', name: 'São Pedro da Cipa', uf: '51' },
  { value: '742', name: 'Rondonópolis', uf: '51' },
  { value: '743', name: 'Alto Araguaia', uf: '51' },
  { value: '744', name: 'Alto Garças', uf: '51' },
  { value: '745', name: 'Alto Taquari', uf: '51' },
  { value: '746', name: 'Crixás', uf: '52' },
  { value: '747', name: 'Mozarlândia', uf: '52' },
  { value: '748', name: 'Mundo Novo', uf: '52' },
  { value: '749', name: 'Nova Crixás', uf: '52' },
  { value: '750', name: 'Novo Planalto', uf: '52' },
  { value: '751', name: 'São Miguel do Araguaia', uf: '52' },
  { value: '752', name: 'Uirapuru', uf: '52' },
  { value: '753', name: 'Araguapaz', uf: '52' },
  { value: '754', name: 'Aruanã', uf: '52' },
  { value: '755', name: 'Britânia', uf: '52' },
  { value: '756', name: 'Camapuã', uf: '50' },
  { value: '757', name: 'Coxim', uf: '50' },
  { value: '758', name: 'Figueirão', uf: '50' },
  { value: '759', name: 'Pedro Gomes', uf: '50' },
  { value: '760', name: 'Rio Verde de Mato Grosso', uf: '50' },
  { value: '761', name: 'São Gabriel do Oeste', uf: '50' },
  { value: '762', name: 'Sonora', uf: '50' },
  { value: '763', name: 'Bandeirantes', uf: '50' },
  { value: '764', name: 'Campo Grande', uf: '50' },
  { value: '765', name: 'Corguinho', uf: '50' },
  { value: '766', name: 'Jaraguari', uf: '50' },
  { value: '767', name: 'Rio Negro', uf: '50' },
  { value: '768', name: 'Rochedo', uf: '50' },
  { value: '769', name: 'Sidrolândia', uf: '50' },
  { value: '770', name: 'Terenos', uf: '50' },
  { value: '771', name: 'Cassilândia', uf: '50' },
  { value: '772', name: 'Chapadão do Sul', uf: '50' },
  { value: '773', name: 'Costa Rica', uf: '50' },
  { value: '774', name: 'Aparecida do Taboado', uf: '50' },
  { value: '775', name: 'Inocência', uf: '50' },
  { value: '776', name: 'Paranaíba', uf: '50' },
  { value: '777', name: 'Selvíria', uf: '50' },
  { value: '778', name: 'Água Clara', uf: '50' },
  { value: '779', name: 'Brasilândia', uf: '50' },
  { value: '780', name: 'Ribas do Rio Pardo', uf: '50' },
  { value: '781', name: 'Santa Rita do Pardo', uf: '50' },
  { value: '782', name: 'Três Lagoas', uf: '50' },
  { value: '783', name: 'Anaurilândia', uf: '50' },
  { value: '784', name: 'Bataguassu', uf: '50' },
  { value: '785', name: 'Batayporã', uf: '50' },
  { value: '786', name: 'Nova Andradina', uf: '50' },
  { value: '787', name: 'Taquarussu', uf: '50' },
  { value: '788', name: 'Bela Vista', uf: '50' },
  { value: '789', name: 'Bodoquena', uf: '50' },
  { value: '790', name: 'Bonito', uf: '50' },
  { value: '791', name: 'Caracol', uf: '50' },
  { value: '792', name: 'Guia Lopes da Laguna', uf: '50' },
  { value: '793', name: 'Jardim', uf: '50' },
  { value: '794', name: 'Nioaque', uf: '50' },
  { value: '795', name: 'Amambaí', uf: '50' },
  { value: '796', name: 'Antônio João', uf: '50' },
  { value: '797', name: 'Aral Moreira', uf: '50' },
  { value: '798', name: 'Caarapó', uf: '50' },
  { value: '799', name: 'Douradina', uf: '50' },
  { value: '800', name: 'Dourados', uf: '50' },
  { value: '801', name: 'Fátima do Sul', uf: '50' },
  { value: '802', name: 'Itaporã', uf: '50' },
  { value: '803', name: 'Juti', uf: '50' },
  { value: '804', name: 'Laguna Carapã', uf: '50' },
  { value: '805', name: 'Maracaju', uf: '50' },
  { value: '806', name: 'Nova Alvorada do Sul', uf: '50' },
  { value: '807', name: 'Ponta Porã', uf: '50' },
  { value: '808', name: 'Rio Brilhante', uf: '50' },
  { value: '809', name: 'Vicentina', uf: '50' },
  { value: '810', name: 'Angélica', uf: '50' },
  { value: '811', name: 'Coronel Sapucaia', uf: '50' },
  { value: '812', name: 'Deodápolis', uf: '50' },
  { value: '813', name: 'Eldorado', uf: '50' },
  { value: '814', name: 'Glória de Dourados', uf: '50' },
  { value: '815', name: 'Iguatemi', uf: '50' },
  { value: '816', name: 'Itaquiraí', uf: '50' },
  { value: '817', name: 'Ivinhema', uf: '50' },
  { value: '818', name: 'Japorã', uf: '50' },
  { value: '819', name: 'Jateí', uf: '50' },
  { value: '820', name: 'Mundo Novo', uf: '50' },
  { value: '821', name: 'Naviraí', uf: '50' },
  { value: '822', name: 'Novo Horizonte do Sul', uf: '50' },
  { value: '823', name: 'Paranhos', uf: '50' },
  { value: '824', name: 'Sete Quedas', uf: '50' },
  { value: '825', name: 'Tacuru', uf: '50' },
  { value: '826', name: 'Aripuanã', uf: '51' },
  { value: '827', name: 'Brasnorte', uf: '51' },
  { value: '828', name: 'Castanheira', uf: '51' },
  { value: '829', name: 'Colniza', uf: '51' },
  { value: '830', name: 'Cotriguaçu', uf: '51' },
  { value: '831', name: 'Juína', uf: '51' },
  { value: '832', name: 'Juruena', uf: '51' },
  { value: '833', name: 'Rondolândia', uf: '51' },
  { value: '834', name: 'Alta Floresta', uf: '51' },
  { value: '835', name: 'Apiacás', uf: '51' },
  { value: '836', name: 'Carlinda', uf: '51' },
  { value: '837', name: 'Nova Bandeirantes', uf: '51' },
  { value: '838', name: 'Paranaíta', uf: '51' },
  { value: '839', name: 'Nova Monte Verde', uf: '51' },
  { value: '840', name: 'Colíder', uf: '51' },
  { value: '841', name: 'Guarantã do Norte', uf: '51' },
  { value: '842', name: 'Matupá', uf: '51' },
  { value: '843', name: 'Nova Canaã do Norte', uf: '51' },
  { value: '844', name: 'Novo Mundo', uf: '51' },
  { value: '845', name: 'Peixoto de Azevedo', uf: '51' },
  { value: '846', name: 'Terra Nova do Norte', uf: '51' },
  { value: '847', name: 'Nova Guarita', uf: '51' },
  { value: '848', name: 'Campo Novo do Parecis', uf: '51' },
  { value: '849', name: 'Campos de Júlio', uf: '51' },
  { value: '850', name: 'Comodoro', uf: '51' },
  { value: '851', name: 'Diamantino', uf: '51' },
  { value: '852', name: 'Sapezal', uf: '51' },
  { value: '853', name: 'Juara', uf: '51' },
  { value: '854', name: 'Novo Horizonte do Norte', uf: '51' },
  { value: '855', name: 'Porto dos Gaúchos', uf: '51' },
  { value: '856', name: 'São José do Rio Claro', uf: '51' },
  { value: '857', name: 'Tabaporã', uf: '51' },
  { value: '858', name: 'Nova Maringá', uf: '51' },
  { value: '859', name: 'Ipiranga do Norte', uf: '51' },
  { value: '860', name: 'Itanhangá', uf: '51' },
  { value: '861', name: 'Lucas do Rio Verde', uf: '51' },
  { value: '862', name: 'Nobres', uf: '51' },
  { value: '863', name: 'Nova Mutum', uf: '51' },
  { value: '864', name: 'Nova Ubiratã', uf: '51' },
  { value: '865', name: 'Mostardas', uf: '43' },
  { value: '866', name: 'Osório', uf: '43' },
  { value: '867', name: 'Palmares do Sul', uf: '43' },
  { value: '868', name: 'Santo Antônio da Patrulha', uf: '43' },
  { value: '869', name: 'Tavares', uf: '43' },
  { value: '870', name: 'Terra de Areia', uf: '43' },
  { value: '871', name: 'Torres', uf: '43' },
  { value: '872', name: 'Tramandaí', uf: '43' },
  { value: '873', name: 'Três Cachoeiras', uf: '43' },
  { value: '874', name: 'Três Forquilhas', uf: '43' },
  { value: '875', name: 'Xangri-lá', uf: '43' },
  { value: '876', name: 'Arambaré', uf: '43' },
  { value: '877', name: 'Barra do Ribeiro', uf: '43' },
  { value: '878', name: 'Camaquã', uf: '43' },
  { value: '879', name: 'Cerro Grande do Sul', uf: '43' },
  { value: '880', name: 'Chuvisca', uf: '43' },
  { value: '881', name: 'Dom Feliciano', uf: '43' },
  { value: '882', name: 'Sentinela do Sul', uf: '43' },
  { value: '883', name: 'Tapes', uf: '43' },
  { value: '884', name: 'Alegrete', uf: '43' },
  { value: '885', name: 'Barra do Quaraí', uf: '43' },
  { value: '886', name: 'Garruchos', uf: '43' },
  { value: '887', name: 'Itaqui', uf: '43' },
  { value: '888', name: 'Maçambara', uf: '43' },
  { value: '889', name: 'Manoel Viana', uf: '43' },
  { value: '890', name: 'Quaraí', uf: '43' },
  { value: '891', name: 'São Borja', uf: '43' },
  { value: '892', name: 'São Francisco de Assis', uf: '43' },
  { value: '893', name: 'Uruguaiana', uf: '43' },
  { value: '894', name: 'Rosário do Sul', uf: '43' },
  { value: '895', name: 'Santa Margarida do Sul', uf: '43' },
  { value: '896', name: 'Santana do Livramento', uf: '43' },
  { value: '897', name: 'São Gabriel', uf: '43' },
  { value: '898', name: 'Aceguá', uf: '43' },
  { value: '899', name: 'Bagé', uf: '43' },
  { value: '900', name: 'Dom Pedrito', uf: '43' },
  { value: '901', name: 'Hulha Negra', uf: '43' },
  { value: '902', name: 'Lavras do Sul', uf: '43' },
  { value: '903', name: 'Amaral Ferrador', uf: '43' },
  { value: '904', name: 'Caçapava do Sul', uf: '43' },
  { value: '905', name: 'Candiota', uf: '43' },
  { value: '906', name: 'Encruzilhada do Sul', uf: '43' },
  { value: '907', name: 'Pedras Altas', uf: '43' },
  { value: '908', name: 'Pinheiro Machado', uf: '43' },
  { value: '909', name: 'Piratini', uf: '43' },
  { value: '910', name: 'Santana da Boa Vista', uf: '43' },
  { value: '911', name: 'Arroio do Padre', uf: '43' },
  { value: '912', name: 'Canguçu', uf: '43' },
  { value: '913', name: 'Capão do Leão', uf: '43' },
  { value: '914', name: 'Cerrito', uf: '43' },
  { value: '915', name: 'Cristal', uf: '43' },
  { value: '916', name: 'Morro Redondo', uf: '43' },
  { value: '917', name: 'Pedro Osório', uf: '43' },
  { value: '918', name: 'Pelotas', uf: '43' },
  { value: '919', name: 'São Lourenço do Sul', uf: '43' },
  { value: '920', name: 'Turuçu', uf: '43' },
  { value: '921', name: 'Arroio Grande', uf: '43' },
  { value: '922', name: 'Herval', uf: '43' },
  { value: '923', name: 'Jaguarão', uf: '43' },
  { value: '924', name: 'Chuí', uf: '43' },
  { value: '925', name: 'Rio Grande', uf: '43' },
  { value: '926', name: 'Santa Vitória do Palmar', uf: '43' },
  { value: '927', name: 'São José do Norte', uf: '43' },
  { value: '928', name: 'Corumbá', uf: '50' },
  { value: '929', name: 'Ladário', uf: '50' },
  { value: '930', name: 'Porto Murtinho', uf: '50' },
  { value: '931', name: 'Anastácio', uf: '50' },
  { value: '932', name: 'Aquidauana', uf: '50' },
  { value: '933', name: 'Dois Irmãos do Buriti', uf: '50' },
  { value: '934', name: 'Miranda', uf: '50' },
  { value: '935', name: 'Alcinópolis', uf: '50' },
  { value: '936', name: 'Bom Retiro do Sul', uf: '43' },
  { value: '937', name: 'Boqueirão do Leão', uf: '43' },
  { value: '938', name: 'Canudos do Vale', uf: '43' },
  { value: '939', name: 'Capitão', uf: '43' },
  { value: '940', name: 'Colinas', uf: '43' },
  { value: '941', name: 'Coqueiro Baixo', uf: '43' },
  { value: '942', name: 'Cruzeiro do Sul', uf: '43' },
  { value: '943', name: 'Doutor Ricardo', uf: '43' },
  { value: '944', name: 'Encantado', uf: '43' },
  { value: '945', name: 'Estrela', uf: '43' },
  { value: '946', name: 'Fazenda Vilanova', uf: '43' },
  { value: '947', name: 'Forquetinha', uf: '43' },
  { value: '948', name: 'Imigrante', uf: '43' },
  { value: '949', name: 'Lajeado', uf: '43' },
  { value: '950', name: 'Marques de Souza', uf: '43' },
  { value: '951', name: 'Muçum', uf: '43' },
  { value: '952', name: 'Nova Bréscia', uf: '43' },
  { value: '953', name: 'Paverama', uf: '43' },
  { value: '954', name: 'Pouso Novo', uf: '43' },
  { value: '955', name: 'Progresso', uf: '43' },
  { value: '956', name: 'Relvado', uf: '43' },
  { value: '957', name: 'Roca Sales', uf: '43' },
  { value: '958', name: 'Santa Clara do Sul', uf: '43' },
  { value: '959', name: 'Sério', uf: '43' },
  { value: '960', name: 'Tabaí', uf: '43' },
  { value: '961', name: 'Taquari', uf: '43' },
  { value: '962', name: 'Teutônia', uf: '43' },
  { value: '963', name: 'Travesseiro', uf: '43' },
  { value: '964', name: 'Vespasiano Correa', uf: '43' },
  { value: '965', name: 'Westfalia', uf: '43' },
  { value: '966', name: 'Cachoeira do Sul', uf: '43' },
  { value: '967', name: 'Cerro Branco', uf: '43' },
  { value: '968', name: 'Novo Cabrais', uf: '43' },
  { value: '969', name: 'Pantano Grande', uf: '43' },
  { value: '970', name: 'Paraíso do Sul', uf: '43' },
  { value: '971', name: 'Passo do Sobrado', uf: '43' },
  { value: '972', name: 'Rio Pardo', uf: '43' },
  { value: '973', name: 'Alto Feliz', uf: '43' },
  { value: '974', name: 'Barão', uf: '43' },
  { value: '975', name: 'Bom Princípio', uf: '43' },
  { value: '976', name: 'Brochier', uf: '43' },
  { value: '977', name: 'Capela de Santana', uf: '43' },
  { value: '978', name: 'Feliz', uf: '43' },
  { value: '979', name: 'Harmonia', uf: '43' },
  { value: '980', name: 'Linha Nova', uf: '43' },
  { value: '981', name: 'Maratá', uf: '43' },
  { value: '982', name: 'Montenegro', uf: '43' },
  { value: '983', name: 'Pareci Novo', uf: '43' },
  { value: '984', name: 'Poço das Antas', uf: '43' },
  { value: '985', name: 'Portão', uf: '43' },
  { value: '986', name: 'Salvador do Sul', uf: '43' },
  { value: '987', name: 'São José do Hortêncio', uf: '43' },
  { value: '988', name: 'São José do Sul', uf: '43' },
  { value: '989', name: 'São Pedro da Serra', uf: '43' },
  { value: '990', name: 'São Sebastião do Caí', uf: '43' },
  { value: '991', name: 'São Vendelino', uf: '43' },
  { value: '992', name: 'Tupandi', uf: '43' },
  { value: '993', name: 'Vale Real', uf: '43' },
  { value: '994', name: 'Canela', uf: '43' },
  { value: '995', name: 'Dois Irmãos', uf: '43' },
  { value: '996', name: 'Gramado', uf: '43' },
  { value: '997', name: 'Igrejinha', uf: '43' },
  { value: '998', name: 'Ivoti', uf: '43' },
  { value: '999', name: 'Lindolfo Collor', uf: '43' },
  { value: '1000', name: 'Morro Reuter', uf: '43' },
  { value: '1001', name: 'Nova Petrópolis', uf: '43' },
  { value: '1002', name: 'Picada Café', uf: '43' },
  { value: '1003', name: 'Presidente Lucena', uf: '43' },
  { value: '1004', name: 'Riozinho', uf: '43' },
  { value: '1005', name: 'Rolante', uf: '43' },
  { value: '1006', name: 'Santa Maria do Herval', uf: '43' },
  { value: '1007', name: 'Taquara', uf: '43' },
  { value: '1008', name: 'Três Coroas', uf: '43' },
  { value: '1009', name: 'Arroio dos Ratos', uf: '43' },
  { value: '1010', name: 'Barão do Triunfo', uf: '43' },
  { value: '1011', name: 'Butiá', uf: '43' },
  { value: '1012', name: 'Charqueadas', uf: '43' },
  { value: '1013', name: 'General Câmara', uf: '43' },
  { value: '1014', name: 'Minas do Leão', uf: '43' },
  { value: '1015', name: 'São Jerônimo', uf: '43' },
  { value: '1016', name: 'Triunfo', uf: '43' },
  { value: '1017', name: 'Vale Verde', uf: '43' },
  { value: '1018', name: 'Alvorada', uf: '43' },
  { value: '1019', name: 'Araricá', uf: '43' },
  { value: '1020', name: 'Cachoeirinha', uf: '43' },
  { value: '1021', name: 'Campo Bom', uf: '43' },
  { value: '1022', name: 'Canoas', uf: '43' },
  { value: '1023', name: 'Eldorado do Sul', uf: '43' },
  { value: '1024', name: 'Estância Velha', uf: '43' },
  { value: '1025', name: 'Esteio', uf: '43' },
  { value: '1026', name: 'Glorinha', uf: '43' },
  { value: '1027', name: 'Gravataí', uf: '43' },
  { value: '1028', name: 'Guaíba', uf: '43' },
  { value: '1029', name: 'Mariana Pimentel', uf: '43' },
  { value: '1030', name: 'Nova Hartz', uf: '43' },
  { value: '1031', name: 'Nova Santa Rita', uf: '43' },
  { value: '1032', name: 'Novo Hamburgo', uf: '43' },
  { value: '1033', name: 'Parobé', uf: '43' },
  { value: '1034', name: 'Porto Alegre', uf: '43' },
  { value: '1035', name: 'São Leopoldo', uf: '43' },
  { value: '1036', name: 'Sapiranga', uf: '43' },
  { value: '1037', name: 'Sapucaia do Sul', uf: '43' },
  { value: '1038', name: 'Sertão Santana', uf: '43' },
  { value: '1039', name: 'Viamão', uf: '43' },
  { value: '1040', name: 'Arroio do Sal', uf: '43' },
  { value: '1041', name: 'Balneário Pinhal', uf: '43' },
  { value: '1042', name: 'Capão da Canoa', uf: '43' },
  { value: '1043', name: 'Capivari do Sul', uf: '43' },
  { value: '1044', name: 'Caraá', uf: '43' },
  { value: '1045', name: 'Cidreira', uf: '43' },
  { value: '1046', name: 'Dom Pedro de Alcântara', uf: '43' },
  { value: '1047', name: 'Imbé', uf: '43' },
  { value: '1048', name: 'Itati', uf: '43' },
  { value: '1049', name: 'Mampituba', uf: '43' },
  { value: '1050', name: 'Maquiné', uf: '43' },
  { value: '1051', name: 'Morrinhos do Sul', uf: '43' },
  { value: '1052', name: 'Paraí', uf: '43' },
  { value: '1053', name: 'Protásio Alves', uf: '43' },
  { value: '1054', name: 'Putinga', uf: '43' },
  { value: '1055', name: 'São Jorge', uf: '43' },
  { value: '1056', name: 'São Valentim do Sul', uf: '43' },
  { value: '1057', name: 'Serafina Corrêa', uf: '43' },
  { value: '1058', name: 'União da Serra', uf: '43' },
  { value: '1059', name: 'Vista Alegre do Prata', uf: '43' },
  { value: '1060', name: 'Bom Jesus', uf: '43' },
  { value: '1061', name: 'Cambará do Sul', uf: '43' },
  { value: '1062', name: 'Campestre da Serra', uf: '43' },
  { value: '1063', name: 'Capão Bonito do Sul', uf: '43' },
  { value: '1064', name: 'Esmeralda', uf: '43' },
  { value: '1065', name: 'Ipê', uf: '43' },
  { value: '1066', name: 'Jaquirana', uf: '43' },
  { value: '1067', name: 'Lagoa Vermelha', uf: '43' },
  { value: '1068', name: 'Monte Alegre dos Campos', uf: '43' },
  { value: '1069', name: 'Muitos Capões', uf: '43' },
  { value: '1070', name: 'Pinhal da Serra', uf: '43' },
  { value: '1071', name: 'São Francisco de Paula', uf: '43' },
  { value: '1072', name: 'São José dos Ausentes', uf: '43' },
  { value: '1073', name: 'Vacaria', uf: '43' },
  { value: '1074', name: 'Antônio Prado', uf: '43' },
  { value: '1075', name: 'Bento Gonçalves', uf: '43' },
  { value: '1076', name: 'Boa Vista do Sul', uf: '43' },
  { value: '1077', name: 'Carlos Barbosa', uf: '43' },
  { value: '1078', name: 'Caxias do Sul', uf: '43' },
  { value: '1079', name: 'Coronel Pilar', uf: '43' },
  { value: '1080', name: 'Cotiporã', uf: '43' },
  { value: '1081', name: 'Fagundes Varela', uf: '43' },
  { value: '1082', name: 'Farroupilha', uf: '43' },
  { value: '1083', name: 'Flores da Cunha', uf: '43' },
  { value: '1084', name: 'Garibaldi', uf: '43' },
  { value: '1085', name: 'Monte Belo do Sul', uf: '43' },
  { value: '1086', name: 'Nova Pádua', uf: '43' },
  { value: '1087', name: 'Nova Roma do Sul', uf: '43' },
  { value: '1088', name: 'Santa Tereza', uf: '43' },
  { value: '1089', name: 'São Marcos', uf: '43' },
  { value: '1090', name: 'Veranópolis', uf: '43' },
  { value: '1091', name: 'Vila Flores', uf: '43' },
  { value: '1092', name: 'Capão do Cipó', uf: '43' },
  { value: '1093', name: 'Itacurubi', uf: '43' },
  { value: '1094', name: 'Jari', uf: '43' },
  { value: '1095', name: 'Júlio de Castilhos', uf: '43' },
  { value: '1096', name: 'Pinhal Grande', uf: '43' },
  { value: '1097', name: 'Quevedos', uf: '43' },
  { value: '1098', name: 'Santiago', uf: '43' },
  { value: '1099', name: 'Tupanciretã', uf: '43' },
  { value: '1100', name: 'Unistalda', uf: '43' },
  { value: '1101', name: 'Cacequi', uf: '43' },
  { value: '1102', name: 'Dilermando de Aguiar', uf: '43' },
  { value: '1103', name: 'Itaara', uf: '43' },
  { value: '1104', name: 'Jaguari', uf: '43' },
  { value: '1105', name: 'Mata', uf: '43' },
  { value: '1106', name: 'Nova Esperança do Sul', uf: '43' },
  { value: '1107', name: 'Santa Maria', uf: '43' },
  { value: '1108', name: 'São Martinho da Serra', uf: '43' },
  { value: '1109', name: 'São Pedro do Sul', uf: '43' },
  { value: '1110', name: 'São Sepé', uf: '43' },
  { value: '1111', name: 'São Vicente do Sul', uf: '43' },
  { value: '1112', name: 'Toropi', uf: '43' },
  { value: '1113', name: 'Vila Nova do Sul', uf: '43' },
  { value: '1114', name: 'Agudo', uf: '43' },
  { value: '1115', name: 'Dona Francisca', uf: '43' },
  { value: '1116', name: 'Faxinal do Soturno', uf: '43' },
  { value: '1117', name: 'Formigueiro', uf: '43' },
  { value: '1118', name: 'Ivorá', uf: '43' },
  { value: '1119', name: 'Nova Palma', uf: '43' },
  { value: '1120', name: 'Restinga Seca', uf: '43' },
  { value: '1121', name: 'São João do Polêsine', uf: '43' },
  { value: '1122', name: 'Silveira Martins', uf: '43' },
  { value: '1123', name: 'Arroio do Tigre', uf: '43' },
  { value: '1124', name: 'Candelária', uf: '43' },
  { value: '1125', name: 'Estrela Velha', uf: '43' },
  { value: '1126', name: 'Gramado Xavier', uf: '43' },
  { value: '1127', name: 'Herveiras', uf: '43' },
  { value: '1128', name: 'Ibarama', uf: '43' },
  { value: '1129', name: 'Lagoa Bonita do Sul', uf: '43' },
  { value: '1130', name: 'Mato Leitão', uf: '43' },
  { value: '1131', name: 'Passa Sete', uf: '43' },
  { value: '1132', name: 'Santa Cruz do Sul', uf: '43' },
  { value: '1133', name: 'Segredo', uf: '43' },
  { value: '1134', name: 'Sinimbu', uf: '43' },
  { value: '1135', name: 'Sobradinho', uf: '43' },
  { value: '1136', name: 'Vale do Sol', uf: '43' },
  { value: '1137', name: 'Venâncio Aires', uf: '43' },
  { value: '1138', name: 'Vera Cruz', uf: '43' },
  { value: '1139', name: 'Arroio do Meio', uf: '43' },
  { value: '1140', name: 'Coronel Bicaco', uf: '43' },
  { value: '1141', name: 'Ijuí', uf: '43' },
  { value: '1142', name: 'Inhacorá', uf: '43' },
  { value: '1143', name: 'Nova Ramada', uf: '43' },
  { value: '1144', name: 'Panambi', uf: '43' },
  { value: '1145', name: 'Pejuçara', uf: '43' },
  { value: '1146', name: 'Santo Augusto', uf: '43' },
  { value: '1147', name: 'São Valério do Sul', uf: '43' },
  { value: '1148', name: 'Almirante Tamandaré do Sul', uf: '43' },
  { value: '1149', name: 'Barra Funda', uf: '43' },
  { value: '1150', name: 'Boa Vista das Missões', uf: '43' },
  { value: '1151', name: 'Carazinho', uf: '43' },
  { value: '1152', name: 'Cerro Grande', uf: '43' },
  { value: '1153', name: 'Chapada', uf: '43' },
  { value: '1154', name: 'Coqueiros do Sul', uf: '43' },
  { value: '1155', name: 'Jaboticaba', uf: '43' },
  { value: '1156', name: 'Lajeado do Bugre', uf: '43' },
  { value: '1157', name: 'Nova Boa Vista', uf: '43' },
  { value: '1158', name: 'Novo Barreiro', uf: '43' },
  { value: '1159', name: 'Palmeira das Missões', uf: '43' },
  { value: '1160', name: 'Pinhal', uf: '43' },
  { value: '1161', name: 'Sagrada Família', uf: '43' },
  { value: '1162', name: 'Santo Antônio do Planalto', uf: '43' },
  { value: '1163', name: 'São José das Missões', uf: '43' },
  { value: '1164', name: 'São Pedro das Missões', uf: '43' },
  { value: '1165', name: 'Sarandi', uf: '43' },
  { value: '1166', name: 'Água Santa', uf: '43' },
  { value: '1167', name: 'Camargo', uf: '43' },
  { value: '1168', name: 'Casca', uf: '43' },
  { value: '1169', name: 'Caseiros', uf: '43' },
  { value: '1170', name: 'Charrua', uf: '43' },
  { value: '1171', name: 'Ciríaco', uf: '43' },
  { value: '1172', name: 'Coxilha', uf: '43' },
  { value: '1173', name: 'David Canabarro', uf: '43' },
  { value: '1174', name: 'Ernestina', uf: '43' },
  { value: '1175', name: 'Gentil', uf: '43' },
  { value: '1176', name: 'Ibiraiaras', uf: '43' },
  { value: '1177', name: 'Marau', uf: '43' },
  { value: '1178', name: 'Mato Castelhano', uf: '43' },
  { value: '1179', name: 'Muliterno', uf: '43' },
  { value: '1180', name: 'Nicolau Vergueiro', uf: '43' },
  { value: '1181', name: 'Passo Fundo', uf: '43' },
  { value: '1182', name: 'Pontão', uf: '43' },
  { value: '1183', name: 'Ronda Alta', uf: '43' },
  { value: '1184', name: 'Santa Cecília do Sul', uf: '43' },
  { value: '1185', name: 'Santo Antônio do Palma', uf: '43' },
  { value: '1186', name: 'São Domingos do Sul', uf: '43' },
  { value: '1187', name: 'Sertão', uf: '43' },
  { value: '1188', name: 'Tapejara', uf: '43' },
  { value: '1189', name: 'Vanini', uf: '43' },
  { value: '1190', name: 'Vila Lângaro', uf: '43' },
  { value: '1191', name: 'Vila Maria', uf: '43' },
  { value: '1192', name: 'Alto Alegre', uf: '43' },
  { value: '1193', name: 'Boa Vista do Cadeado', uf: '43' },
  { value: '1194', name: 'Boa Vista do Incra', uf: '43' },
  { value: '1195', name: 'Campos Borges', uf: '43' },
  { value: '1196', name: 'Cruz Alta', uf: '43' },
  { value: '1197', name: 'Espumoso', uf: '43' },
  { value: '1198', name: 'Fortaleza dos Valos', uf: '43' },
  { value: '1199', name: 'Ibirubá', uf: '43' },
  { value: '1200', name: 'Jacuizinho', uf: '43' },
  { value: '1201', name: 'Jóia', uf: '43' },
  { value: '1202', name: 'Quinze de Novembro', uf: '43' },
  { value: '1203', name: 'Saldanha Marinho', uf: '43' },
  { value: '1204', name: 'Salto do Jacuí', uf: '43' },
  { value: '1205', name: 'Santa Bárbara do Sul', uf: '43' },
  { value: '1206', name: 'Colorado', uf: '43' },
  { value: '1207', name: 'Lagoa dos Três Cantos', uf: '43' },
  { value: '1208', name: 'Não-Me-Toque', uf: '43' },
  { value: '1209', name: 'Selbach', uf: '43' },
  { value: '1210', name: 'Tapera', uf: '43' },
  { value: '1211', name: 'Tio Hugo', uf: '43' },
  { value: '1212', name: 'Victor Graeff', uf: '43' },
  { value: '1213', name: 'Barros Cassal', uf: '43' },
  { value: '1214', name: 'Fontoura Xavier', uf: '43' },
  { value: '1215', name: 'Ibirapuitã', uf: '43' },
  { value: '1216', name: 'Lagoão', uf: '43' },
  { value: '1217', name: 'Mormaço', uf: '43' },
  { value: '1218', name: 'São José do Herval', uf: '43' },
  { value: '1219', name: 'Soledade', uf: '43' },
  { value: '1220', name: 'Tunas', uf: '43' },
  { value: '1221', name: 'André da Rocha', uf: '43' },
  { value: '1222', name: 'Anta Gorda', uf: '43' },
  { value: '1223', name: 'Arvorezinha', uf: '43' },
  { value: '1224', name: 'Dois Lajeados', uf: '43' },
  { value: '1225', name: 'Guabiju', uf: '43' },
  { value: '1226', name: 'Guaporé', uf: '43' },
  { value: '1227', name: 'Ilópolis', uf: '43' },
  { value: '1228', name: 'Itapuca', uf: '43' },
  { value: '1229', name: 'Montauri', uf: '43' },
  { value: '1230', name: 'Nova Alvorada', uf: '43' },
  { value: '1231', name: 'Nova Araçá', uf: '43' },
  { value: '1232', name: 'Nova Bassano', uf: '43' },
  { value: '1233', name: 'Nova Prata', uf: '43' },
  { value: '1234', name: 'Vista Gaúcha', uf: '43' },
  { value: '1235', name: 'Alpestre', uf: '43' },
  { value: '1236', name: 'Ametista do Sul', uf: '43' },
  { value: '1237', name: 'Caiçara', uf: '43' },
  { value: '1238', name: 'Constantina', uf: '43' },
  { value: '1239', name: 'Cristal do Sul', uf: '43' },
  { value: '1240', name: 'Dois Irmãos das Missões', uf: '43' },
  { value: '1241', name: 'Engenho Velho', uf: '43' },
  { value: '1242', name: 'Erval Seco', uf: '43' },
  { value: '1243', name: 'Frederico Westphalen', uf: '43' },
  { value: '1244', name: 'Gramado dos Loureiros', uf: '43' },
  { value: '1245', name: 'Iraí', uf: '43' },
  { value: '1246', name: 'Liberato Salzano', uf: '43' },
  { value: '1247', name: 'Nonoai', uf: '43' },
  { value: '1248', name: 'Novo Tiradentes', uf: '43' },
  { value: '1249', name: 'Novo Xingu', uf: '43' },
  { value: '1250', name: 'Palmitinho', uf: '43' },
  { value: '1251', name: 'Pinheirinho do Vale', uf: '43' },
  { value: '1252', name: 'Planalto', uf: '43' },
  { value: '1253', name: 'Rio dos Índios', uf: '43' },
  { value: '1254', name: 'Rodeio Bonito', uf: '43' },
  { value: '1255', name: 'Rondinha', uf: '43' },
  { value: '1256', name: 'Seberi', uf: '43' },
  { value: '1257', name: 'Taquaruçu do Sul', uf: '43' },
  { value: '1258', name: 'Três Palmeiras', uf: '43' },
  { value: '1259', name: 'Trindade do Sul', uf: '43' },
  { value: '1260', name: 'Vicente Dutra', uf: '43' },
  { value: '1261', name: 'Vista Alegre', uf: '43' },
  { value: '1262', name: 'Aratiba', uf: '43' },
  { value: '1263', name: 'Áurea', uf: '43' },
  { value: '1264', name: 'Barão de Cotegipe', uf: '43' },
  { value: '1265', name: 'Barra do Rio Azul', uf: '43' },
  { value: '1266', name: 'Benjamin Constant do Sul', uf: '43' },
  { value: '1267', name: 'Campinas do Sul', uf: '43' },
  { value: '1268', name: 'Carlos Gomes', uf: '43' },
  { value: '1269', name: 'Centenário', uf: '43' },
  { value: '1270', name: 'Cruzaltense', uf: '43' },
  { value: '1271', name: 'Entre Rios do Sul', uf: '43' },
  { value: '1272', name: 'Erebango', uf: '43' },
  { value: '1273', name: 'Erechim', uf: '43' },
  { value: '1274', name: 'Erval Grande', uf: '43' },
  { value: '1275', name: 'Estação', uf: '43' },
  { value: '1276', name: 'Faxinalzinho', uf: '43' },
  { value: '1277', name: 'Floriano Peixoto', uf: '43' },
  { value: '1278', name: 'Gaurama', uf: '43' },
  { value: '1279', name: 'Getúlio Vargas', uf: '43' },
  { value: '1280', name: 'Ipiranga do Sul', uf: '43' },
  { value: '1281', name: 'Itatiba do Sul', uf: '43' },
  { value: '1282', name: 'Jacutinga', uf: '43' },
  { value: '1283', name: 'Marcelino Ramos', uf: '43' },
  { value: '1284', name: 'Mariano Moro', uf: '43' },
  { value: '1285', name: 'Paulo Bento', uf: '43' },
  { value: '1286', name: 'Ponte Preta', uf: '43' },
  { value: '1287', name: 'Quatro Irmãos', uf: '43' },
  { value: '1288', name: 'São Valentim', uf: '43' },
  { value: '1289', name: 'Severiano de Almeida', uf: '43' },
  { value: '1290', name: 'Três Arroios', uf: '43' },
  { value: '1291', name: 'Viadutos', uf: '43' },
  { value: '1292', name: 'Barracão', uf: '43' },
  { value: '1293', name: 'Cacique Doble', uf: '43' },
  { value: '1294', name: 'Ibiaçá', uf: '43' },
  { value: '1295', name: 'Machadinho', uf: '43' },
  { value: '1296', name: 'Maximiliano de Almeida', uf: '43' },
  { value: '1297', name: 'Paim Filho', uf: '43' },
  { value: '1298', name: 'Sananduva', uf: '43' },
  { value: '1299', name: 'Santo Expedito do Sul', uf: '43' },
  { value: '1300', name: 'São João da Urtiga', uf: '43' },
  { value: '1301', name: 'São José do Ouro', uf: '43' },
  { value: '1302', name: 'Tupanci do Sul', uf: '43' },
  { value: '1303', name: 'Caibaté', uf: '43' },
  { value: '1304', name: 'Campina das Missões', uf: '43' },
  { value: '1305', name: 'Cerro Largo', uf: '43' },
  { value: '1306', name: 'Guarani das Missões', uf: '43' },
  { value: '1307', name: 'Mato Queimado', uf: '43' },
  { value: '1308', name: 'Porto Xavier', uf: '43' },
  { value: '1309', name: 'Roque Gonzales', uf: '43' },
  { value: '1310', name: 'Salvador das Missões', uf: '43' },
  { value: '1311', name: 'São Paulo das Missões', uf: '43' },
  { value: '1312', name: 'São Pedro do Butiá', uf: '43' },
  { value: '1313', name: 'Sete de Setembro', uf: '43' },
  { value: '1314', name: 'Bossoroca', uf: '43' },
  { value: '1315', name: 'Catuípe', uf: '43' },
  { value: '1316', name: 'Dezesseis de Novembro', uf: '43' },
  { value: '1317', name: 'ENTRE-IJUIS', uf: '43' },
  { value: '1318', name: 'Eugênio de Castro', uf: '43' },
  { value: '1319', name: 'Giruá', uf: '43' },
  { value: '1320', name: 'Pirapó', uf: '43' },
  { value: '1321', name: 'Rolador', uf: '43' },
  { value: '1322', name: 'Santo Ângelo', uf: '43' },
  { value: '1323', name: 'Santo Antônio das Missões', uf: '43' },
  { value: '1324', name: 'São Luiz Gonzaga', uf: '43' },
  { value: '1325', name: 'São Miguel das Missões', uf: '43' },
  { value: '1326', name: 'São Nicolau', uf: '43' },
  { value: '1327', name: 'Senador Salgado Filho', uf: '43' },
  { value: '1328', name: 'Ubiretama', uf: '43' },
  { value: '1329', name: 'Vitória das Missões', uf: '43' },
  { value: '1330', name: 'Ajuricaba', uf: '43' },
  { value: '1331', name: 'Alegria', uf: '43' },
  { value: '1332', name: 'Augusto Pestana', uf: '43' },
  { value: '1333', name: 'Bozano', uf: '43' },
  { value: '1334', name: 'Chiapetta', uf: '43' },
  { value: '1335', name: 'Condor', uf: '43' },
  { value: '1336', name: 'Coronel Barros', uf: '43' },
  { value: '1337', name: 'Ilhota', uf: '42' },
  { value: '1338', name: 'Itajaí', uf: '42' },
  { value: '1339', name: 'Itapema', uf: '42' },
  { value: '1340', name: 'Navegantes', uf: '42' },
  { value: '1341', name: 'Penha', uf: '42' },
  { value: '1342', name: 'Balneário Piçarras', uf: '42' },
  { value: '1343', name: 'Porto Belo', uf: '42' },
  { value: '1344', name: 'São João do Itaperiú', uf: '42' },
  { value: '1345', name: 'Agrolândia', uf: '42' },
  { value: '1346', name: 'Atalanta', uf: '42' },
  { value: '1347', name: 'Chapadão do Lageado', uf: '42' },
  { value: '1348', name: 'Imbuia', uf: '42' },
  { value: '1349', name: 'Ituporanga', uf: '42' },
  { value: '1350', name: 'Petrolândia', uf: '42' },
  { value: '1351', name: 'Vidal Ramos', uf: '42' },
  { value: '1352', name: 'Angelina', uf: '42' },
  { value: '1353', name: 'Canelinha', uf: '42' },
  { value: '1354', name: 'Leoberto Leal', uf: '42' },
  { value: '1355', name: 'Major Gercino', uf: '42' },
  { value: '1356', name: 'Nova Trento', uf: '42' },
  { value: '1357', name: 'São João Batista', uf: '42' },
  { value: '1358', name: 'Tijucas', uf: '42' },
  { value: '1359', name: 'Antônio Carlos', uf: '42' },
  { value: '1360', name: 'Biguaçu', uf: '42' },
  { value: '1361', name: 'Florianópolis', uf: '42' },
  { value: '1362', name: 'Governador Celso Ramos', uf: '42' },
  { value: '1363', name: 'Palhoça', uf: '42' },
  { value: '1364', name: 'Paulo Lopes', uf: '42' },
  { value: '1365', name: 'Santo Amaro da Imperatriz', uf: '42' },
  { value: '1366', name: 'São José', uf: '42' },
  { value: '1367', name: 'São Pedro de Alcântara', uf: '42' },
  { value: '1368', name: 'Águas Mornas', uf: '42' },
  { value: '1369', name: 'Alfredo Wagner', uf: '42' },
  { value: '1370', name: 'Anitápolis', uf: '42' },
  { value: '1371', name: 'Rancho Queimado', uf: '42' },
  { value: '1372', name: 'São Bonifácio', uf: '42' },
  { value: '1373', name: 'Armazém', uf: '42' },
  { value: '1374', name: 'Braço do Norte', uf: '42' },
  { value: '1375', name: 'Capivari de Baixo', uf: '42' },
  { value: '1376', name: 'Garopaba', uf: '42' },
  { value: '1377', name: 'Grão Pará', uf: '42' },
  { value: '1378', name: 'Gravatal', uf: '42' },
  { value: '1379', name: 'Imaruí', uf: '42' },
  { value: '1380', name: 'Imbituba', uf: '42' },
  { value: '1381', name: 'Jaguaruna', uf: '42' },
  { value: '1382', name: 'Laguna', uf: '42' },
  { value: '1383', name: 'Orleans', uf: '42' },
  { value: '1384', name: 'Pedras Grandes', uf: '42' },
  { value: '1385', name: 'Rio Fortuna', uf: '42' },
  { value: '1386', name: 'Sangão', uf: '42' },
  { value: '1387', name: 'Santa Rosa de Lima', uf: '42' },
  { value: '1388', name: 'São Ludgero', uf: '42' },
  { value: '1389', name: 'São Martinho', uf: '42' },
  { value: '1390', name: 'Treze de Maio', uf: '42' },
  { value: '1391', name: 'Tubarão', uf: '42' },
  { value: '1392', name: 'Cocal do Sul', uf: '42' },
  { value: '1393', name: 'Criciúma', uf: '42' },
  { value: '1394', name: 'Forquilhinha', uf: '42' },
  { value: '1395', name: 'Içara', uf: '42' },
  { value: '1396', name: 'Lauro Muller', uf: '42' },
  { value: '1397', name: 'Morro da Fumaça', uf: '42' },
  { value: '1398', name: 'Nova Veneza', uf: '42' },
  { value: '1399', name: 'Siderópolis', uf: '42' },
  { value: '1400', name: 'Treviso', uf: '42' },
  { value: '1401', name: 'Urussanga', uf: '42' },
  { value: '1402', name: 'Araranguá', uf: '42' },
  { value: '1403', name: 'Balneário Arroio do Silva', uf: '42' },
  { value: '1404', name: 'Balneário Gaivota', uf: '42' },
  { value: '1405', name: 'Ermo', uf: '42' },
  { value: '1406', name: 'Jacinto Machado', uf: '42' },
  { value: '1407', name: 'Maracajá', uf: '42' },
  { value: '1408', name: 'Meleiro', uf: '42' },
  { value: '1409', name: 'Morro Grande', uf: '42' },
  { value: '1410', name: 'Passo de Torres', uf: '42' },
  { value: '1411', name: 'Praia Grande', uf: '42' },
  { value: '1412', name: 'Santa Rosa do Sul', uf: '42' },
  { value: '1413', name: 'São João do Sul', uf: '42' },
  { value: '1414', name: 'Sombrio', uf: '42' },
  { value: '1415', name: 'Timbé do Sul', uf: '42' },
  { value: '1416', name: 'Turvo', uf: '42' },
  { value: '1417', name: 'Alecrim', uf: '43' },
  { value: '1418', name: 'Cândido Godói', uf: '43' },
  { value: '1419', name: 'Independência', uf: '43' },
  { value: '1420', name: 'Novo Machado', uf: '43' },
  { value: '1421', name: 'Porto Lucena', uf: '43' },
  { value: '1422', name: 'Porto Mauá', uf: '43' },
  { value: '1423', name: 'Porto Vera Cruz', uf: '43' },
  { value: '1424', name: 'Santa Rosa', uf: '43' },
  { value: '1425', name: 'Santo Cristo', uf: '43' },
  { value: '1426', name: 'São José do Inhacorá', uf: '43' },
  { value: '1427', name: 'Três de Maio', uf: '43' },
  { value: '1428', name: 'Tucunduva', uf: '43' },
  { value: '1429', name: 'Tuparendi', uf: '43' },
  { value: '1430', name: 'Barra do Guarita', uf: '43' },
  { value: '1431', name: 'Boa Vista do Buricá', uf: '43' },
  { value: '1432', name: 'Bom Progresso', uf: '43' },
  { value: '1433', name: 'Braga', uf: '43' },
  { value: '1434', name: 'Campo Novo', uf: '43' },
  { value: '1435', name: 'Crissiumal', uf: '43' },
  { value: '1436', name: 'Derrubadas', uf: '43' },
  { value: '1437', name: 'Doutor Maurício Cardoso', uf: '43' },
  { value: '1438', name: 'Esperança do Sul', uf: '43' },
  { value: '1439', name: 'Horizontina', uf: '43' },
  { value: '1440', name: 'Humaitá', uf: '43' },
  { value: '1441', name: 'Miraguaí', uf: '43' },
  { value: '1442', name: 'Nova Candelária', uf: '43' },
  { value: '1443', name: 'Redentora', uf: '43' },
  { value: '1444', name: 'São Martinho', uf: '43' },
  { value: '1445', name: 'Sede Nova', uf: '43' },
  { value: '1446', name: 'Tenente Portela', uf: '43' },
  { value: '1447', name: 'Tiradentes do Sul', uf: '43' },
  { value: '1448', name: 'Três Passos', uf: '43' },
  { value: '1449', name: 'Ibicaré', uf: '42' },
  { value: '1450', name: 'Iomerê', uf: '42' },
  { value: '1451', name: 'Jaborá', uf: '42' },
  { value: '1452', name: 'Joaçaba', uf: '42' },
  { value: '1453', name: 'Lacerdópolis', uf: '42' },
  { value: '1454', name: 'Lebon Régis', uf: '42' },
  { value: '1455', name: 'Luzerna', uf: '42' },
  { value: '1456', name: 'Macieira', uf: '42' },
  { value: '1457', name: 'Matos Costa', uf: '42' },
  { value: '1458', name: 'Ouro', uf: '42' },
  { value: '1459', name: 'Pinheiro Preto', uf: '42' },
  { value: '1460', name: 'Rio das Antas', uf: '42' },
  { value: '1461', name: 'Salto Veloso', uf: '42' },
  { value: '1462', name: 'Tangará', uf: '42' },
  { value: '1463', name: 'Treze Tílias', uf: '42' },
  { value: '1464', name: 'Vargem Bonita', uf: '42' },
  { value: '1465', name: 'Videira', uf: '42' },
  { value: '1466', name: 'Alto Bela Vista', uf: '42' },
  { value: '1467', name: 'Arabutã', uf: '42' },
  { value: '1468', name: 'Arvoredo', uf: '42' },
  { value: '1469', name: 'Concórdia', uf: '42' },
  { value: '1470', name: 'Ipira', uf: '42' },
  { value: '1471', name: 'Ipumirim', uf: '42' },
  { value: '1472', name: 'Irani', uf: '42' },
  { value: '1473', name: 'Itá', uf: '42' },
  { value: '1474', name: 'Lindóia do Sul', uf: '42' },
  { value: '1475', name: 'Paial', uf: '42' },
  { value: '1476', name: 'Peritiba', uf: '42' },
  { value: '1477', name: 'Piratuba', uf: '42' },
  { value: '1478', name: 'Presidente Castello Branco', uf: '42' },
  { value: '1479', name: 'Seara', uf: '42' },
  { value: '1480', name: 'Xavantina', uf: '42' },
  { value: '1481', name: 'Bela Vista do Toldo', uf: '42' },
  { value: '1482', name: 'Canoinhas', uf: '42' },
  { value: '1483', name: 'Irineópolis', uf: '42' },
  { value: '1484', name: 'Itaiópolis', uf: '42' },
  { value: '1485', name: 'Mafra', uf: '42' },
  { value: '1486', name: 'Major Vieira', uf: '42' },
  { value: '1487', name: 'Monte Castelo', uf: '42' },
  { value: '1488', name: 'Papanduva', uf: '42' },
  { value: '1489', name: 'Porto União', uf: '42' },
  { value: '1490', name: 'Santa Terezinha', uf: '42' },
  { value: '1491', name: 'Timbó Grande', uf: '42' },
  { value: '1492', name: 'Três Barras', uf: '42' },
  { value: '1493', name: 'Campo Alegre', uf: '42' },
  { value: '1494', name: 'Rio Negrinho', uf: '42' },
  { value: '1495', name: 'São Bento do Sul', uf: '42' },
  { value: '1496', name: 'Araquari', uf: '42' },
  { value: '1497', name: 'Balneário Barra do Sul', uf: '42' },
  { value: '1498', name: 'Corupá', uf: '42' },
  { value: '1499', name: 'Garuva', uf: '42' },
  { value: '1500', name: 'Guaramirim', uf: '42' },
  { value: '1501', name: 'Itapoá', uf: '42' },
  { value: '1502', name: 'Jaraguá do Sul', uf: '42' },
  { value: '1503', name: 'Joinville', uf: '42' },
  { value: '1504', name: 'Massaranduba', uf: '42' },
  { value: '1505', name: 'São Francisco do Sul', uf: '42' },
  { value: '1506', name: 'Schroeder', uf: '42' },
  { value: '1507', name: 'Abdon Batista', uf: '42' },
  { value: '1508', name: 'Brunópolis', uf: '42' },
  { value: '1509', name: 'Campos Novos', uf: '42' },
  { value: '1510', name: 'Curitibanos', uf: '42' },
  { value: '1511', name: 'Frei Rogério', uf: '42' },
  { value: '1512', name: 'Monte Carlo', uf: '42' },
  { value: '1513', name: 'Ponte Alta', uf: '42' },
  { value: '1514', name: 'Ponte Alta do Norte', uf: '42' },
  { value: '1515', name: 'Santa Cecília', uf: '42' },
  { value: '1516', name: 'São Cristovão do Sul', uf: '42' },
  { value: '1517', name: 'Vargem', uf: '42' },
  { value: '1518', name: 'Zortéa', uf: '42' },
  { value: '1519', name: 'Anita Garibaldi', uf: '42' },
  { value: '1520', name: 'Bocaina do Sul', uf: '42' },
  { value: '1521', name: 'Bom Jardim da Serra', uf: '42' },
  { value: '1522', name: 'Bom Retiro', uf: '42' },
  { value: '1523', name: 'Capão Alto', uf: '42' },
  { value: '1524', name: 'Campo Belo do Sul', uf: '42' },
  { value: '1525', name: 'Celso Ramos', uf: '42' },
  { value: '1526', name: 'Cerro Negro', uf: '42' },
  { value: '1527', name: 'Correia Pinto', uf: '42' },
  { value: '1528', name: 'Lages', uf: '42' },
  { value: '1529', name: 'Otacílio Costa', uf: '42' },
  { value: '1530', name: 'Painel', uf: '42' },
  { value: '1531', name: 'Palmeira', uf: '42' },
  { value: '1532', name: 'Rio Rufino', uf: '42' },
  { value: '1533', name: 'São Joaquim', uf: '42' },
  { value: '1534', name: 'São José do Cerrito', uf: '42' },
  { value: '1535', name: 'Urubici', uf: '42' },
  { value: '1536', name: 'Urupema', uf: '42' },
  { value: '1537', name: 'Agronômica', uf: '42' },
  { value: '1538', name: 'Aurora', uf: '42' },
  { value: '1539', name: 'Braço do Trombudo', uf: '42' },
  { value: '1540', name: 'Dona Emma', uf: '42' },
  { value: '1541', name: 'Ibirama', uf: '42' },
  { value: '1542', name: 'José Boiteux', uf: '42' },
  { value: '1543', name: 'Laurentino', uf: '42' },
  { value: '1544', name: 'Lontras', uf: '42' },
  { value: '1545', name: 'Mirim Doce', uf: '42' },
  { value: '1546', name: 'Pouso Redondo', uf: '42' },
  { value: '1547', name: 'Presidente Getúlio', uf: '42' },
  { value: '1548', name: 'Presidente Nereu', uf: '42' },
  { value: '1549', name: 'Rio do Campo', uf: '42' },
  { value: '1550', name: 'Rio do Oeste', uf: '42' },
  { value: '1551', name: 'Rio do Sul', uf: '42' },
  { value: '1552', name: 'Salete', uf: '42' },
  { value: '1553', name: 'Taió', uf: '42' },
  { value: '1554', name: 'Trombudo Central', uf: '42' },
  { value: '1555', name: 'Vitor Meireles', uf: '42' },
  { value: '1556', name: 'Witmarsum', uf: '42' },
  { value: '1557', name: 'Apiúna', uf: '42' },
  { value: '1558', name: 'Ascurra', uf: '42' },
  { value: '1559', name: 'Benedito Novo', uf: '42' },
  { value: '1560', name: 'Blumenau', uf: '42' },
  { value: '1561', name: 'Botuverá', uf: '42' },
  { value: '1562', name: 'Brusque', uf: '42' },
  { value: '1563', name: 'Doutor Pedrinho', uf: '42' },
  { value: '1564', name: 'Gaspar', uf: '42' },
  { value: '1565', name: 'Guabiruba', uf: '42' },
  { value: '1566', name: 'Indaial', uf: '42' },
  { value: '1567', name: 'Luiz Alves', uf: '42' },
  { value: '1568', name: 'Pomerode', uf: '42' },
  { value: '1569', name: 'Rio dos Cedros', uf: '42' },
  { value: '1570', name: 'Rodeio', uf: '42' },
  { value: '1571', name: 'Timbó', uf: '42' },
  { value: '1572', name: 'Balneário Camboriú', uf: '42' },
  { value: '1573', name: 'Barra Velha', uf: '42' },
  { value: '1574', name: 'Bombinhas', uf: '42' },
  { value: '1575', name: 'Camboriú', uf: '42' },
  { value: '1576', name: 'São João do Triunfo', uf: '41' },
  { value: '1577', name: 'São Mateus do Sul', uf: '41' },
  { value: '1578', name: 'Adrianópolis', uf: '41' },
  { value: '1579', name: 'Cerro Azul', uf: '41' },
  { value: '1580', name: 'Doutor Ulysses', uf: '41' },
  { value: '1581', name: 'Lapa', uf: '41' },
  { value: '1582', name: 'Porto Amazonas', uf: '41' },
  { value: '1583', name: 'Almirante Tamandaré', uf: '41' },
  { value: '1584', name: 'Araucária', uf: '41' },
  { value: '1585', name: 'Balsa Nova', uf: '41' },
  { value: '1586', name: 'Bocaiúva do Sul', uf: '41' },
  { value: '1587', name: 'Campina Grande do Sul', uf: '41' },
  { value: '1588', name: 'Campo Largo', uf: '41' },
  { value: '1589', name: 'Campo Magro', uf: '41' },
  { value: '1590', name: 'Colombo', uf: '41' },
  { value: '1591', name: 'Contenda', uf: '41' },
  { value: '1592', name: 'Curitiba', uf: '41' },
  { value: '1593', name: 'Fazenda Rio Grande', uf: '41' },
  { value: '1594', name: 'Itaperuçu', uf: '41' },
  { value: '1595', name: 'Mandirituba', uf: '41' },
  { value: '1596', name: 'Pinhais', uf: '41' },
  { value: '1597', name: 'Piraquara', uf: '41' },
  { value: '1598', name: 'Quatro Barras', uf: '41' },
  { value: '1599', name: 'Rio Branco do Sul', uf: '41' },
  { value: '1600', name: 'São José dos Pinhais', uf: '41' },
  { value: '1601', name: 'Tunas do Paraná', uf: '41' },
  { value: '1602', name: 'Antonina', uf: '41' },
  { value: '1603', name: 'Guaraqueçaba', uf: '41' },
  { value: '1604', name: 'Guaratuba', uf: '41' },
  { value: '1605', name: 'Matinhos', uf: '41' },
  { value: '1606', name: 'Morretes', uf: '41' },
  { value: '1607', name: 'Paranaguá', uf: '41' },
  { value: '1608', name: 'Pontal do Paraná', uf: '41' },
  { value: '1609', name: 'Agudos do Sul', uf: '41' },
  { value: '1610', name: 'Campo do Tenente', uf: '41' },
  { value: '1611', name: 'Piên', uf: '41' },
  { value: '1612', name: 'Quitandinha', uf: '41' },
  { value: '1613', name: 'Rio Negro', uf: '41' },
  { value: '1614', name: 'Tijucas do Sul', uf: '41' },
  { value: '1615', name: 'Anchieta', uf: '42' },
  { value: '1616', name: 'Bandeirante', uf: '42' },
  { value: '1617', name: 'Barra Bonita', uf: '42' },
  { value: '1618', name: 'Belmonte', uf: '42' },
  { value: '1619', name: 'Descanso', uf: '42' },
  { value: '1620', name: 'Dionísio Cerqueira', uf: '42' },
  { value: '1621', name: 'Guaraciaba', uf: '42' },
  { value: '1622', name: 'Guarujá do Sul', uf: '42' },
  { value: '1623', name: 'Iporã do Oeste', uf: '42' },
  { value: '1624', name: 'Itapiranga', uf: '42' },
  { value: '1625', name: 'Mondaí', uf: '42' },
  { value: '1626', name: 'Palma Sola', uf: '42' },
  { value: '1627', name: 'Paraíso', uf: '42' },
  { value: '1628', name: 'Princesa', uf: '42' },
  { value: '1629', name: 'Riqueza', uf: '42' },
  { value: '1630', name: 'Romelândia', uf: '42' },
  { value: '1631', name: 'Santa Helena', uf: '42' },
  { value: '1632', name: 'São João do Oeste', uf: '42' },
  { value: '1633', name: 'São José do Cedro', uf: '42' },
  { value: '1634', name: 'São Miguel do Oeste', uf: '42' },
  { value: '1635', name: 'Tunápolis', uf: '42' },
  { value: '1636', name: 'Águas de Chapecó', uf: '42' },
  { value: '1637', name: 'Águas Frias', uf: '42' },
  { value: '1638', name: 'Bom Jesus do Oeste', uf: '42' },
  { value: '1639', name: 'Caibi', uf: '42' },
  { value: '1640', name: 'Campo Erê', uf: '42' },
  { value: '1641', name: 'Caxambu do Sul', uf: '42' },
  { value: '1642', name: 'Chapecó', uf: '42' },
  { value: '1643', name: 'Cordilheira Alta', uf: '42' },
  { value: '1644', name: 'Coronel Freitas', uf: '42' },
  { value: '1645', name: 'Cunha Porã', uf: '42' },
  { value: '1646', name: 'Cunhataí', uf: '42' },
  { value: '1647', name: 'Flor do Sertão', uf: '42' },
  { value: '1648', name: 'Formosa do Sul', uf: '42' },
  { value: '1649', name: 'Guatambú', uf: '42' },
  { value: '1650', name: 'Iraceminha', uf: '42' },
  { value: '1651', name: 'Irati', uf: '42' },
  { value: '1652', name: 'Jardinópolis', uf: '42' },
  { value: '1653', name: 'Maravilha', uf: '42' },
  { value: '1654', name: 'Modelo', uf: '42' },
  { value: '1655', name: 'Nova Erechim', uf: '42' },
  { value: '1656', name: 'Nova Itaberaba', uf: '42' },
  { value: '1657', name: 'Novo Horizonte', uf: '42' },
  { value: '1658', name: 'Palmitos', uf: '42' },
  { value: '1659', name: 'Pinhalzinho', uf: '42' },
  { value: '1660', name: 'Planalto Alegre', uf: '42' },
  { value: '1661', name: 'Quilombo', uf: '42' },
  { value: '1662', name: 'Saltinho', uf: '42' },
  { value: '1663', name: 'Santa Terezinha do Progresso', uf: '42' },
  { value: '1664', name: 'Santiago do Sul', uf: '42' },
  { value: '1665', name: 'São Bernardino', uf: '42' },
  { value: '1666', name: 'São Carlos', uf: '42' },
  { value: '1667', name: 'São Lourenço do Oeste', uf: '42' },
  { value: '1668', name: 'São Miguel da Boa Vista', uf: '42' },
  { value: '1669', name: 'Saudades', uf: '42' },
  { value: '1670', name: 'Serra Alta', uf: '42' },
  { value: '1671', name: 'Sul Brasil', uf: '42' },
  { value: '1672', name: 'Tigrinhos', uf: '42' },
  { value: '1673', name: 'União do Oeste', uf: '42' },
  { value: '1674', name: 'Abelardo Luz', uf: '42' },
  { value: '1675', name: 'Bom Jesus', uf: '42' },
  { value: '1676', name: 'Coronel Martins', uf: '42' },
  { value: '1677', name: 'Entre Rios', uf: '42' },
  { value: '1678', name: 'Faxinal dos Guedes', uf: '42' },
  { value: '1679', name: 'Galvão', uf: '42' },
  { value: '1680', name: 'Ipuaçu', uf: '42' },
  { value: '1681', name: 'Jupiá', uf: '42' },
  { value: '1682', name: 'Lajeado Grande', uf: '42' },
  { value: '1683', name: 'Marema', uf: '42' },
  { value: '1684', name: 'Ouro Verde', uf: '42' },
  { value: '1685', name: 'Passos Maia', uf: '42' },
  { value: '1686', name: 'Ponte Serrada', uf: '42' },
  { value: '1687', name: 'São Domingos', uf: '42' },
  { value: '1688', name: 'Vargeão', uf: '42' },
  { value: '1689', name: 'Xanxerê', uf: '42' },
  { value: '1690', name: 'Xaxim', uf: '42' },
  { value: '1691', name: 'Água Doce', uf: '42' },
  { value: '1692', name: 'Arroio Trinta', uf: '42' },
  { value: '1693', name: 'Caçador', uf: '42' },
  { value: '1694', name: 'Calmon', uf: '42' },
  { value: '1695', name: 'Capinzal', uf: '42' },
  { value: '1696', name: 'Catanduvas', uf: '42' },
  { value: '1697', name: 'Erval Velho', uf: '42' },
  { value: '1698', name: 'Fraiburgo', uf: '42' },
  { value: '1699', name: "Herval d'Oeste", uf: '42' },
  { value: '1700', name: 'Ibiam', uf: '42' },
  { value: '1701', name: 'Catanduvas', uf: '41' },
  { value: '1702', name: 'Corbélia', uf: '41' },
  { value: '1703', name: 'Diamante do Sul', uf: '41' },
  { value: '1704', name: 'Guaraniaçu', uf: '41' },
  { value: '1705', name: 'Ibema', uf: '41' },
  { value: '1706', name: 'Iguatu', uf: '41' },
  { value: '1707', name: 'Lindoeste', uf: '41' },
  { value: '1708', name: 'Nova Aurora', uf: '41' },
  { value: '1709', name: 'Santa Lúcia', uf: '41' },
  { value: '1710', name: 'Santa Tereza do Oeste', uf: '41' },
  { value: '1711', name: 'Três Barras do Paraná', uf: '41' },
  { value: '1712', name: 'Céu Azul', uf: '41' },
  { value: '1713', name: 'Foz do Iguaçu', uf: '41' },
  { value: '1714', name: 'Itaipulândia', uf: '41' },
  { value: '1715', name: 'Matelândia', uf: '41' },
  { value: '1716', name: 'Medianeira', uf: '41' },
  { value: '1717', name: 'Missal', uf: '41' },
  { value: '1718', name: 'Ramilândia', uf: '41' },
  { value: '1719', name: 'Santa Terezinha de Itaipu', uf: '41' },
  { value: '1720', name: 'São Miguel do Iguaçu', uf: '41' },
  { value: '1721', name: 'Serranópolis do Iguaçu', uf: '41' },
  { value: '1722', name: 'Vera Cruz do Oeste', uf: '41' },
  { value: '1723', name: 'Ampére', uf: '41' },
  { value: '1724', name: 'Bela Vista da Caroba', uf: '41' },
  { value: '1725', name: 'Capanema', uf: '41' },
  { value: '1726', name: "Pérola d'Oeste", uf: '41' },
  { value: '1727', name: 'Planalto', uf: '41' },
  { value: '1728', name: 'Pranchita', uf: '41' },
  { value: '1729', name: 'Realeza', uf: '41' },
  { value: '1730', name: 'Santa Izabel do Oeste', uf: '41' },
  { value: '1731', name: 'Barracão', uf: '41' },
  { value: '1732', name: 'Boa Esperança do Iguaçu', uf: '41' },
  { value: '1733', name: 'Bom Jesus do Sul', uf: '41' },
  { value: '1734', name: 'Cruzeiro do Iguaçu', uf: '41' },
  { value: '1735', name: 'Dois Vizinhos', uf: '41' },
  { value: '1736', name: 'Enéas Marques', uf: '41' },
  { value: '1737', name: 'Flor da Serra do Sul', uf: '41' },
  { value: '1738', name: 'Francisco Beltrão', uf: '41' },
  { value: '1739', name: 'Manfrinópolis', uf: '41' },
  { value: '1740', name: 'Marmeleiro', uf: '41' },
  { value: '1741', name: 'Nova Esperança do Sudoeste', uf: '41' },
  { value: '1742', name: 'Nova Prata do Iguaçu', uf: '41' },
  { value: '1743', name: 'Pinhal de São Bento', uf: '41' },
  { value: '1744', name: 'Renascença', uf: '41' },
  { value: '1745', name: 'Salgado Filho', uf: '41' },
  { value: '1746', name: 'Salto do Lontra', uf: '41' },
  { value: '1747', name: 'Santo Antônio do Sudoeste', uf: '41' },
  { value: '1748', name: "São Jorge d'Oeste", uf: '41' },
  { value: '1749', name: 'Verê', uf: '41' },
  { value: '1750', name: 'Bom Sucesso do Sul', uf: '41' },
  { value: '1751', name: 'Chopinzinho', uf: '41' },
  { value: '1752', name: 'Coronel Vivida', uf: '41' },
  { value: '1753', name: "Itapejara d'Oeste", uf: '41' },
  { value: '1754', name: 'Mariópolis', uf: '41' },
  { value: '1755', name: 'Pato Branco', uf: '41' },
  { value: '1756', name: 'São João', uf: '41' },
  { value: '1757', name: 'Saudade do Iguaçu', uf: '41' },
  { value: '1758', name: 'Sulina', uf: '41' },
  { value: '1759', name: 'Vitorino', uf: '41' },
  { value: '1760', name: 'Boa Ventura de São Roque', uf: '41' },
  { value: '1761', name: 'Laranjal', uf: '41' },
  { value: '1762', name: 'Mato Rico', uf: '41' },
  { value: '1763', name: 'Palmital', uf: '41' },
  { value: '1764', name: 'Pitanga', uf: '41' },
  { value: '1765', name: 'Santa Maria do Oeste', uf: '41' },
  { value: '1766', name: 'Campina do Simão', uf: '41' },
  { value: '1767', name: 'Candói', uf: '41' },
  { value: '1768', name: 'Cantagalo', uf: '41' },
  { value: '1769', name: 'Espigão Alto do Iguaçu', uf: '41' },
  { value: '1770', name: 'Foz do Jordão', uf: '41' },
  { value: '1771', name: 'Goioxim', uf: '41' },
  { value: '1772', name: 'Guarapuava', uf: '41' },
  { value: '1773', name: 'Inácio Martins', uf: '41' },
  { value: '1774', name: 'Laranjeiras do Sul', uf: '41' },
  { value: '1775', name: 'Marquinho', uf: '41' },
  { value: '1776', name: 'Nova Laranjeiras', uf: '41' },
  { value: '1777', name: 'Pinhão', uf: '41' },
  { value: '1778', name: 'Porto Barreiro', uf: '41' },
  { value: '1779', name: 'Quedas do Iguaçu', uf: '41' },
  { value: '1780', name: 'Reserva do Iguaçu', uf: '41' },
  { value: '1781', name: 'Rio Bonito do Iguaçu', uf: '41' },
  { value: '1782', name: 'Turvo', uf: '41' },
  { value: '1783', name: 'Virmond', uf: '41' },
  { value: '1784', name: 'Clevelândia', uf: '41' },
  { value: '1785', name: 'Coronel Domingos Soares', uf: '41' },
  { value: '1786', name: 'Honório Serpa', uf: '41' },
  { value: '1787', name: 'Mangueirinha', uf: '41' },
  { value: '1788', name: 'Palmas', uf: '41' },
  { value: '1789', name: 'Fernandes Pinheiro', uf: '41' },
  { value: '1790', name: 'Guamiranga', uf: '41' },
  { value: '1791', name: 'Imbituva', uf: '41' },
  { value: '1792', name: 'Ipiranga', uf: '41' },
  { value: '1793', name: 'Ivaí', uf: '41' },
  { value: '1794', name: 'Prudentópolis', uf: '41' },
  { value: '1795', name: 'Teixeira Soares', uf: '41' },
  { value: '1796', name: 'Irati', uf: '41' },
  { value: '1797', name: 'Mallet', uf: '41' },
  { value: '1798', name: 'Rebouças', uf: '41' },
  { value: '1799', name: 'Rio Azul', uf: '41' },
  { value: '1800', name: 'Bituruna', uf: '41' },
  { value: '1801', name: 'Cruz Machado', uf: '41' },
  { value: '1802', name: 'General Carneiro', uf: '41' },
  { value: '1803', name: 'Paula Freitas', uf: '41' },
  { value: '1804', name: 'Paulo Frontin', uf: '41' },
  { value: '1805', name: 'Porto Vitória', uf: '41' },
  { value: '1806', name: 'União da Vitória', uf: '41' },
  { value: '1807', name: 'Antônio Olinto', uf: '41' },
  { value: '1808', name: 'Conceição do Mato Dentro', uf: '31' },
  { value: '1809', name: 'Congonhas do Norte', uf: '31' },
  { value: '1810', name: 'Dom Joaquim', uf: '31' },
  { value: '1811', name: 'Itambé do Mato Dentro', uf: '31' },
  { value: '1812', name: 'Morro do Pilar', uf: '31' },
  { value: '1813', name: 'Passabém', uf: '31' },
  { value: '1814', name: 'Rio Vermelho', uf: '31' },
  { value: '1815', name: 'Santo Antônio do Itambé', uf: '31' },
  { value: '1816', name: 'Santo Antônio do Rio Abaixo', uf: '31' },
  { value: '1817', name: 'São Sebastião do Rio Preto', uf: '31' },
  { value: '1818', name: 'Serra Azul de Minas', uf: '31' },
  { value: '1819', name: 'Serro', uf: '31' },
  { value: '1820', name: 'Lidianópolis', uf: '41' },
  { value: '1821', name: 'Lunardelli', uf: '41' },
  { value: '1822', name: 'Manoel Ribas', uf: '41' },
  { value: '1823', name: 'Nova Tebas', uf: '41' },
  { value: '1824', name: 'Rio Branco do Ivaí', uf: '41' },
  { value: '1825', name: 'Rosário do Ivaí', uf: '41' },
  { value: '1826', name: 'São João do Ivaí', uf: '41' },
  { value: '1827', name: 'São Pedro do Ivaí', uf: '41' },
  { value: '1828', name: 'Assaí', uf: '41' },
  { value: '1829', name: 'Jataizinho', uf: '41' },
  { value: '1830', name: 'Nova Santa Bárbara', uf: '41' },
  { value: '1831', name: 'Rancho Alegre', uf: '41' },
  { value: '1832', name: 'Santa Cecília do Pavão', uf: '41' },
  { value: '1833', name: 'São Jerônimo da Serra', uf: '41' },
  { value: '1834', name: 'São Sebastião da Amoreira', uf: '41' },
  { value: '1835', name: 'Uraí', uf: '41' },
  { value: '1836', name: 'Abatiá', uf: '41' },
  { value: '1837', name: 'Andirá', uf: '41' },
  { value: '1838', name: 'Bandeirantes', uf: '41' },
  { value: '1839', name: 'Congonhinhas', uf: '41' },
  { value: '1840', name: 'Cornélio Procópio', uf: '41' },
  { value: '1841', name: 'Itambaracá', uf: '41' },
  { value: '1842', name: 'Leópolis', uf: '41' },
  { value: '1843', name: 'Nova América da Colina', uf: '41' },
  { value: '1844', name: 'Nova Fátima', uf: '41' },
  { value: '1845', name: 'Ribeirão do Pinhal', uf: '41' },
  { value: '1846', name: 'Santa Amélia', uf: '41' },
  { value: '1847', name: 'Santa Mariana', uf: '41' },
  { value: '1848', name: 'Santo Antônio do Paraíso', uf: '41' },
  { value: '1849', name: 'Sertaneja', uf: '41' },
  { value: '1850', name: 'Barra do Jacaré', uf: '41' },
  { value: '1851', name: 'Cambará', uf: '41' },
  { value: '1852', name: 'Jacarezinho', uf: '41' },
  { value: '1853', name: 'Jundiaí do Sul', uf: '41' },
  { value: '1854', name: 'Ribeirão Claro', uf: '41' },
  { value: '1855', name: 'Santo Antônio da Platina', uf: '41' },
  { value: '1856', name: 'Conselheiro Mairinck', uf: '41' },
  { value: '1857', name: 'Curiúva', uf: '41' },
  { value: '1858', name: 'Figueira', uf: '41' },
  { value: '1859', name: 'Ibaiti', uf: '41' },
  { value: '1860', name: 'Jaboti', uf: '41' },
  { value: '1861', name: 'Japira', uf: '41' },
  { value: '1862', name: 'Pinhalão', uf: '41' },
  { value: '1863', name: 'Sapopema', uf: '41' },
  { value: '1864', name: 'Carlópolis', uf: '41' },
  { value: '1865', name: 'Guapirama', uf: '41' },
  { value: '1866', name: 'Joaquim Távora', uf: '41' },
  { value: '1867', name: 'Quatiguá', uf: '41' },
  { value: '1868', name: 'Salto do Itararé', uf: '41' },
  { value: '1869', name: 'Santana do Itararé', uf: '41' },
  { value: '1870', name: 'São José da Boa Vista', uf: '41' },
  { value: '1871', name: 'Siqueira Campos', uf: '41' },
  { value: '1872', name: 'Tomazina', uf: '41' },
  { value: '1873', name: 'Wenceslau Braz', uf: '41' },
  { value: '1874', name: 'Imbaú', uf: '41' },
  { value: '1875', name: 'Ortigueira', uf: '41' },
  { value: '1876', name: 'Reserva', uf: '41' },
  { value: '1877', name: 'Telêmaco Borba', uf: '41' },
  { value: '1878', name: 'Tibagi', uf: '41' },
  { value: '1879', name: 'Ventania', uf: '41' },
  { value: '1880', name: 'Arapoti', uf: '41' },
  { value: '1881', name: 'Jaguariaíva', uf: '41' },
  { value: '1882', name: 'Piraí do Sul', uf: '41' },
  { value: '1883', name: 'Sengés', uf: '41' },
  { value: '1884', name: 'Carambeí', uf: '41' },
  { value: '1885', name: 'Castro', uf: '41' },
  { value: '1886', name: 'Palmeira', uf: '41' },
  { value: '1887', name: 'Ponta Grossa', uf: '41' },
  { value: '1888', name: 'Assis Chateaubriand', uf: '41' },
  { value: '1889', name: "Diamante D'Oeste", uf: '41' },
  { value: '1890', name: 'Entre Rios do Oeste', uf: '41' },
  { value: '1891', name: 'Formosa do Oeste', uf: '41' },
  { value: '1892', name: 'Guaíra', uf: '41' },
  { value: '1893', name: 'Iracema do Oeste', uf: '41' },
  { value: '1894', name: 'Jesuítas', uf: '41' },
  { value: '1895', name: 'Marechal Cândido Rondon', uf: '41' },
  { value: '1896', name: 'Maripá', uf: '41' },
  { value: '1897', name: 'Mercedes', uf: '41' },
  { value: '1898', name: 'Nova Santa Rosa', uf: '41' },
  { value: '1899', name: 'Ouro Verde do Oeste', uf: '41' },
  { value: '1900', name: 'Palotina', uf: '41' },
  { value: '1901', name: 'Pato Bragado', uf: '41' },
  { value: '1902', name: 'Quatro Pontes', uf: '41' },
  { value: '1903', name: 'Santa Helena', uf: '41' },
  { value: '1904', name: 'São José das Palmeiras', uf: '41' },
  { value: '1905', name: 'São Pedro do Iguaçu', uf: '41' },
  { value: '1906', name: 'Terra Roxa', uf: '41' },
  { value: '1907', name: 'Toledo', uf: '41' },
  { value: '1908', name: 'Tupãssi', uf: '41' },
  { value: '1909', name: 'Anahy', uf: '41' },
  { value: '1910', name: 'Boa Vista da Aparecida', uf: '41' },
  { value: '1911', name: 'Braganey', uf: '41' },
  { value: '1912', name: 'Cafelândia', uf: '41' },
  { value: '1913', name: 'Campo Bonito', uf: '41' },
  { value: '1914', name: 'Capitão Leônidas Marques', uf: '41' },
  { value: '1915', name: 'Cascavel', uf: '41' },
  { value: '1916', name: 'Araporã', uf: '31' },
  { value: '1917', name: 'Canápolis', uf: '31' },
  { value: '1918', name: 'Cascalho Rico', uf: '31' },
  { value: '1919', name: 'Centralina', uf: '31' },
  { value: '1920', name: 'Indianópolis', uf: '31' },
  { value: '1921', name: 'Monte Alegre de Minas', uf: '31' },
  { value: '1922', name: 'Prata', uf: '31' },
  { value: '1923', name: 'Tupaciguara', uf: '31' },
  { value: '1924', name: 'Uberlândia', uf: '31' },
  { value: '1925', name: 'Abadia dos Dourados', uf: '31' },
  { value: '1926', name: 'Coromandel', uf: '31' },
  { value: '1927', name: 'Cruzeiro da Fortaleza', uf: '31' },
  { value: '1928', name: 'Douradoquara', uf: '31' },
  { value: '1929', name: 'Estrela do Sul', uf: '31' },
  { value: '1930', name: 'Grupiara', uf: '31' },
  { value: '1931', name: 'Iraí de Minas', uf: '31' },
  { value: '1932', name: 'Monte Carmelo', uf: '31' },
  { value: '1933', name: 'Patrocínio', uf: '31' },
  { value: '1934', name: 'Romaria', uf: '31' },
  { value: '1935', name: 'Serra do Salitre', uf: '31' },
  { value: '1936', name: 'Arapuá', uf: '31' },
  { value: '1937', name: 'Carmo do Paranaíba', uf: '31' },
  { value: '1938', name: 'Guimarânia', uf: '31' },
  { value: '1939', name: 'Lagoa Formosa', uf: '31' },
  { value: '1940', name: 'Matutina', uf: '31' },
  { value: '1941', name: 'Patos de Minas', uf: '31' },
  { value: '1942', name: 'Rio Paranaíba', uf: '31' },
  { value: '1943', name: 'Santa Rosa da Serra', uf: '31' },
  { value: '1944', name: 'São Gotardo', uf: '31' },
  { value: '1945', name: 'Tiros', uf: '31' },
  { value: '1946', name: 'Campina Verde', uf: '31' },
  { value: '1947', name: 'Carneirinho', uf: '31' },
  { value: '1948', name: 'Comendador Gomes', uf: '31' },
  { value: '1949', name: 'Fronteira', uf: '31' },
  { value: '1950', name: 'Frutal', uf: '31' },
  { value: '1951', name: 'Itapagipe', uf: '31' },
  { value: '1952', name: 'Iturama', uf: '31' },
  { value: '1953', name: 'Limeira do Oeste', uf: '31' },
  { value: '1954', name: 'Pirajuba', uf: '31' },
  { value: '1955', name: 'Planura', uf: '31' },
  { value: '1956', name: 'São Francisco de Sales', uf: '31' },
  { value: '1957', name: 'União de Minas', uf: '31' },
  { value: '1958', name: 'Água Comprida', uf: '31' },
  { value: '1959', name: 'Campo Florido', uf: '31' },
  { value: '1960', name: 'Conceição das Alagoas', uf: '31' },
  { value: '1961', name: 'Conquista', uf: '31' },
  { value: '1962', name: 'Delta', uf: '31' },
  { value: '1963', name: 'Uberaba', uf: '31' },
  { value: '1964', name: 'Veríssimo', uf: '31' },
  { value: '1965', name: 'Araxá', uf: '31' },
  { value: '1966', name: 'Campos Altos', uf: '31' },
  { value: '1967', name: 'Ibiá', uf: '31' },
  { value: '1968', name: 'Nova Ponte', uf: '31' },
  { value: '1969', name: 'Pedrinópolis', uf: '31' },
  { value: '1970', name: 'Perdizes', uf: '31' },
  { value: '1971', name: 'Pratinha', uf: '31' },
  { value: '1972', name: 'Sacramento', uf: '31' },
  { value: '1973', name: 'Santa Juliana', uf: '31' },
  { value: '1974', name: 'Tapira', uf: '31' },
  { value: '1975', name: 'Abaeté', uf: '31' },
  { value: '1976', name: 'Biquinhas', uf: '31' },
  { value: '1977', name: 'Cedro do Abaeté', uf: '31' },
  { value: '1978', name: 'Morada Nova de Minas', uf: '31' },
  { value: '1979', name: 'Paineiras', uf: '31' },
  { value: '1980', name: 'Pompéu', uf: '31' },
  { value: '1981', name: 'Três Marias', uf: '31' },
  { value: '1982', name: 'Augusto de Lima', uf: '31' },
  { value: '1983', name: 'Buenópolis', uf: '31' },
  { value: '1984', name: 'Corinto', uf: '31' },
  { value: '1985', name: 'Curvelo', uf: '31' },
  { value: '1986', name: 'Felixlândia', uf: '31' },
  { value: '1987', name: 'Inimutaba', uf: '31' },
  { value: '1988', name: 'Joaquim Felício', uf: '31' },
  { value: '1989', name: 'Monjolos', uf: '31' },
  { value: '1990', name: 'Morro da Garça', uf: '31' },
  { value: '1991', name: 'Presidente Juscelino', uf: '31' },
  { value: '1992', name: 'Santo Hipólito', uf: '31' },
  { value: '1993', name: 'Araújos', uf: '31' },
  { value: '1994', name: 'Bom Despacho', uf: '31' },
  { value: '1995', name: 'Dores do Indaiá', uf: '31' },
  { value: '1996', name: 'Estrela do Indaiá', uf: '31' },
  { value: '1997', name: 'Japaraíba', uf: '31' },
  { value: '1998', name: 'Lagoa da Prata', uf: '31' },
  { value: '1999', name: 'Leandro Ferreira', uf: '31' },
  { value: '2000', name: 'Luz', uf: '31' },
  { value: '2001', name: 'Martinho Campos', uf: '31' },
  { value: '2002', name: 'Moema', uf: '31' },
  { value: '2003', name: 'Quartel Geral', uf: '31' },
  { value: '2004', name: 'Serra da Saudade', uf: '31' },
  { value: '2005', name: 'Araçaí', uf: '31' },
  { value: '2006', name: 'Baldim', uf: '31' },
  { value: '2007', name: 'Cachoeira da Prata', uf: '31' },
  { value: '2008', name: 'Caetanópolis', uf: '31' },
  { value: '2009', name: 'Capim Branco', uf: '31' },
  { value: '2010', name: 'Cordisburgo', uf: '31' },
  { value: '2011', name: 'Fortuna de Minas', uf: '31' },
  { value: '2012', name: 'Funilândia', uf: '31' },
  { value: '2013', name: 'Inhaúma', uf: '31' },
  { value: '2014', name: 'Jaboticatubas', uf: '31' },
  { value: '2015', name: 'Jequitibá', uf: '31' },
  { value: '2016', name: 'Maravilhas', uf: '31' },
  { value: '2017', name: 'Matozinhos', uf: '31' },
  { value: '2018', name: 'Papagaios', uf: '31' },
  { value: '2019', name: 'Paraopeba', uf: '31' },
  { value: '2020', name: 'Pequi', uf: '31' },
  { value: '2021', name: 'Prudente de Morais', uf: '31' },
  { value: '2022', name: 'Santana de Pirapama', uf: '31' },
  { value: '2023', name: 'Santana do Riacho', uf: '31' },
  { value: '2024', name: 'Sete Lagoas', uf: '31' },
  { value: '2025', name: 'Alvorada de Minas', uf: '31' },
  { value: '2026', name: 'Glaucilândia', uf: '31' },
  { value: '2027', name: 'Ibiracatu', uf: '31' },
  { value: '2028', name: 'Japonvar', uf: '31' },
  { value: '2029', name: 'Juramento', uf: '31' },
  { value: '2030', name: 'Lontra', uf: '31' },
  { value: '2031', name: 'Luislândia', uf: '31' },
  { value: '2032', name: 'Mirabela', uf: '31' },
  { value: '2033', name: 'Montes Claros', uf: '31' },
  { value: '2034', name: 'Patis', uf: '31' },
  { value: '2035', name: 'Ponto Chique', uf: '31' },
  { value: '2036', name: 'São João da Lagoa', uf: '31' },
  { value: '2037', name: 'São João da Ponte', uf: '31' },
  { value: '2038', name: 'São João do Pacuí', uf: '31' },
  { value: '2039', name: 'Ubaí', uf: '31' },
  { value: '2040', name: 'Varzelândia', uf: '31' },
  { value: '2041', name: 'Verdelândia', uf: '31' },
  { value: '2042', name: 'Botumirim', uf: '31' },
  { value: '2043', name: 'Cristália', uf: '31' },
  { value: '2044', name: 'Grão Mogol', uf: '31' },
  { value: '2045', name: 'Itacambira', uf: '31' },
  { value: '2046', name: 'Josenópolis', uf: '31' },
  { value: '2047', name: 'Padre Carvalho', uf: '31' },
  { value: '2048', name: 'Bocaiúva', uf: '31' },
  { value: '2049', name: 'Engenheiro Navarro', uf: '31' },
  { value: '2050', name: 'Francisco Dumont', uf: '31' },
  { value: '2051', name: 'Guaraciama', uf: '31' },
  { value: '2052', name: "Olhos-d'Água", uf: '31' },
  { value: '2053', name: 'Couto de Magalhães de Minas', uf: '31' },
  { value: '2054', name: 'Datas', uf: '31' },
  { value: '2055', name: 'Diamantina', uf: '31' },
  { value: '2056', name: 'Felício dos Santos', uf: '31' },
  { value: '2057', name: 'São Gonçalo do Rio Preto', uf: '31' },
  { value: '2058', name: 'Gouveia', uf: '31' },
  { value: '2059', name: 'Presidente Kubitschek', uf: '31' },
  { value: '2060', name: 'Senador Modestino Gonçalves', uf: '31' },
  { value: '2061', name: 'Angelândia', uf: '31' },
  { value: '2062', name: 'Aricanduva', uf: '31' },
  { value: '2063', name: 'Berilo', uf: '31' },
  { value: '2064', name: 'Capelinha', uf: '31' },
  { value: '2065', name: 'Carbonita', uf: '31' },
  { value: '2066', name: 'Chapada do Norte', uf: '31' },
  { value: '2067', name: 'Francisco Badaró', uf: '31' },
  { value: '2068', name: 'Itamarandiba', uf: '31' },
  { value: '2069', name: 'Jenipapo de Minas', uf: '31' },
  { value: '2070', name: 'José Gonçalves de Minas', uf: '31' },
  { value: '2071', name: 'Leme do Prado', uf: '31' },
  { value: '2072', name: 'Minas Novas', uf: '31' },
  { value: '2073', name: 'Turmalina', uf: '31' },
  { value: '2074', name: 'Veredinha', uf: '31' },
  { value: '2075', name: 'Araçuaí', uf: '31' },
  { value: '2076', name: 'Caraí', uf: '31' },
  { value: '2077', name: 'Coronel Murta', uf: '31' },
  { value: '2078', name: 'Itinga', uf: '31' },
  { value: '2079', name: 'Novo Cruzeiro', uf: '31' },
  { value: '2080', name: 'Padre Paraíso', uf: '31' },
  { value: '2081', name: 'Ponto dos Volantes', uf: '31' },
  { value: '2082', name: 'Virgem da Lapa', uf: '31' },
  { value: '2083', name: 'Cachoeira de Pajeú', uf: '31' },
  { value: '2084', name: 'Comercinho', uf: '31' },
  { value: '2085', name: 'Itaobim', uf: '31' },
  { value: '2086', name: 'Medina', uf: '31' },
  { value: '2087', name: 'Pedra Azul', uf: '31' },
  { value: '2088', name: 'Almenara', uf: '31' },
  { value: '2089', name: 'Bandeira', uf: '31' },
  { value: '2090', name: 'Divisópolis', uf: '31' },
  { value: '2091', name: 'Felisburgo', uf: '31' },
  { value: '2092', name: 'Jacinto', uf: '31' },
  { value: '2093', name: 'Jequitinhonha', uf: '31' },
  { value: '2094', name: 'Joaíma', uf: '31' },
  { value: '2095', name: 'Jordânia', uf: '31' },
  { value: '2096', name: 'Mata Verde', uf: '31' },
  { value: '2097', name: 'Monte Formoso', uf: '31' },
  { value: '2098', name: 'Palmópolis', uf: '31' },
  { value: '2099', name: 'Rio do Prado', uf: '31' },
  { value: '2100', name: 'Rubim', uf: '31' },
  { value: '2101', name: 'Salto da Divisa', uf: '31' },
  { value: '2102', name: 'Santa Maria do Salto', uf: '31' },
  { value: '2103', name: 'Santo Antônio do Jacinto', uf: '31' },
  { value: '2104', name: 'Ataléia', uf: '31' },
  { value: '2105', name: 'Catuji', uf: '31' },
  { value: '2106', name: 'Franciscópolis', uf: '31' },
  { value: '2107', name: 'Frei Gaspar', uf: '31' },
  { value: '2108', name: 'Itaipé', uf: '31' },
  { value: '2109', name: 'Ladainha', uf: '31' },
  { value: '2110', name: 'Malacacheta', uf: '31' },
  { value: '2111', name: 'Novo Oriente de Minas', uf: '31' },
  { value: '2112', name: 'Ouro Verde de Minas', uf: '31' },
  { value: '2113', name: 'Pavão', uf: '31' },
  { value: '2114', name: 'Poté', uf: '31' },
  { value: '2115', name: 'Setubinha', uf: '31' },
  { value: '2116', name: 'Teófilo Otoni', uf: '31' },
  { value: '2117', name: 'Águas Formosas', uf: '31' },
  { value: '2118', name: 'Bertópolis', uf: '31' },
  { value: '2119', name: 'Carlos Chagas', uf: '31' },
  { value: '2120', name: 'Crisólita', uf: '31' },
  { value: '2121', name: 'Fronteira dos Vales', uf: '31' },
  { value: '2122', name: 'Machacalis', uf: '31' },
  { value: '2123', name: 'Nanuque', uf: '31' },
  { value: '2124', name: 'Santa Helena de Minas', uf: '31' },
  { value: '2125', name: 'Serra dos Aimorés', uf: '31' },
  { value: '2126', name: 'Umburatiba', uf: '31' },
  { value: '2127', name: 'Cachoeira Dourada', uf: '31' },
  { value: '2128', name: 'Capinópolis', uf: '31' },
  { value: '2129', name: 'Gurinhatã', uf: '31' },
  { value: '2130', name: 'Ipiaçu', uf: '31' },
  { value: '2131', name: 'Ituiutaba', uf: '31' },
  { value: '2132', name: 'Santa Vitória', uf: '31' },
  { value: '2133', name: 'Araguari', uf: '31' },
  { value: '2134', name: 'Ubaitaba', uf: '29' },
  { value: '2135', name: 'Ubatã', uf: '29' },
  { value: '2136', name: 'Una', uf: '29' },
  { value: '2137', name: 'Uruçuca', uf: '29' },
  { value: '2138', name: 'Wenceslau Guimarães', uf: '29' },
  { value: '2139', name: 'Alcobaça', uf: '29' },
  { value: '2140', name: 'Caravelas', uf: '29' },
  { value: '2141', name: 'Eunápolis', uf: '29' },
  { value: '2142', name: 'Guaratinga', uf: '29' },
  { value: '2143', name: 'Ibirapuã', uf: '29' },
  { value: '2144', name: 'Itabela', uf: '29' },
  { value: '2145', name: 'Itagimirim', uf: '29' },
  { value: '2146', name: 'Itamaraju', uf: '29' },
  { value: '2147', name: 'Itanhém', uf: '29' },
  { value: '2148', name: 'Jucuruçu', uf: '29' },
  { value: '2149', name: 'Lajedão', uf: '29' },
  { value: '2150', name: 'Medeiros Neto', uf: '29' },
  { value: '2151', name: 'Mucuri', uf: '29' },
  { value: '2152', name: 'Nova Viçosa', uf: '29' },
  { value: '2153', name: 'Porto Seguro', uf: '29' },
  { value: '2154', name: 'Prado', uf: '29' },
  { value: '2155', name: 'Santa Cruz Cabrália', uf: '29' },
  { value: '2156', name: 'Teixeira de Freitas', uf: '29' },
  { value: '2157', name: 'Vereda', uf: '29' },
  { value: '2158', name: 'Arinos', uf: '31' },
  { value: '2159', name: 'Bonfinópolis de Minas', uf: '31' },
  { value: '2160', name: 'Buritis', uf: '31' },
  { value: '2161', name: 'Cabeceira Grande', uf: '31' },
  { value: '2162', name: 'Dom Bosco', uf: '31' },
  { value: '2163', name: 'Formoso', uf: '31' },
  { value: '2164', name: 'Natalândia', uf: '31' },
  { value: '2165', name: 'Unaí', uf: '31' },
  { value: '2166', name: 'Uruana de Minas', uf: '31' },
  { value: '2167', name: 'Brasilândia de Minas', uf: '31' },
  { value: '2168', name: 'Guarda-Mor', uf: '31' },
  { value: '2169', name: 'João Pinheiro', uf: '31' },
  { value: '2170', name: 'Lagamar', uf: '31' },
  { value: '2171', name: 'Lagoa Grande', uf: '31' },
  { value: '2172', name: 'Paracatu', uf: '31' },
  { value: '2173', name: 'Presidente Olegário', uf: '31' },
  { value: '2174', name: 'São Gonçalo do Abaeté', uf: '31' },
  { value: '2175', name: 'Varjão de Minas', uf: '31' },
  { value: '2176', name: 'Vazante', uf: '31' },
  { value: '2177', name: 'Bonito de Minas', uf: '31' },
  { value: '2178', name: 'Chapada Gaúcha', uf: '31' },
  { value: '2179', name: 'Cônego Marinho', uf: '31' },
  { value: '2180', name: 'Icaraí de Minas', uf: '31' },
  { value: '2181', name: 'Itacarambi', uf: '31' },
  { value: '2182', name: 'Januária', uf: '31' },
  { value: '2183', name: 'Juvenília', uf: '31' },
  { value: '2184', name: 'Manga', uf: '31' },
  { value: '2185', name: 'Matias Cardoso', uf: '31' },
  { value: '2186', name: 'Miravânia', uf: '31' },
  { value: '2187', name: 'Montalvânia', uf: '31' },
  { value: '2188', name: 'Pedras de Maria da Cruz', uf: '31' },
  { value: '2189', name: 'Pintópolis', uf: '31' },
  { value: '2190', name: 'São Francisco', uf: '31' },
  { value: '2191', name: 'São João das Missões', uf: '31' },
  { value: '2192', name: 'Urucuia', uf: '31' },
  { value: '2193', name: 'Catuti', uf: '31' },
  { value: '2194', name: 'Espinosa', uf: '31' },
  { value: '2195', name: 'Gameleiras', uf: '31' },
  { value: '2196', name: 'Jaíba', uf: '31' },
  { value: '2197', name: 'Janaúba', uf: '31' },
  { value: '2198', name: 'Mamonas', uf: '31' },
  { value: '2199', name: 'Mato Verde', uf: '31' },
  { value: '2200', name: 'Monte Azul', uf: '31' },
  { value: '2201', name: 'Nova Porteirinha', uf: '31' },
  { value: '2202', name: 'Pai Pedro', uf: '31' },
  { value: '2203', name: 'Porteirinha', uf: '31' },
  { value: '2204', name: 'Riacho dos Machados', uf: '31' },
  { value: '2205', name: 'Serranópolis de Minas', uf: '31' },
  { value: '2206', name: 'Águas Vermelhas', uf: '31' },
  { value: '2207', name: 'Berizal', uf: '31' },
  { value: '2208', name: 'Curral de Dentro', uf: '31' },
  { value: '2209', name: 'Divisa Alegre', uf: '31' },
  { value: '2210', name: 'Fruta de Leite', uf: '31' },
  { value: '2211', name: 'Indaiabira', uf: '31' },
  { value: '2212', name: 'Montezuma', uf: '31' },
  { value: '2213', name: 'Ninheira', uf: '31' },
  { value: '2214', name: 'Novorizonte', uf: '31' },
  { value: '2215', name: 'Rio Pardo de Minas', uf: '31' },
  { value: '2216', name: 'Rubelita', uf: '31' },
  { value: '2217', name: 'Salinas', uf: '31' },
  { value: '2218', name: 'Santa Cruz de Salinas', uf: '31' },
  { value: '2219', name: 'Santo Antônio do Retiro', uf: '31' },
  { value: '2220', name: 'São João do Paraíso', uf: '31' },
  { value: '2221', name: 'Taiobeiras', uf: '31' },
  { value: '2222', name: 'Vargem Grande do Rio Pardo', uf: '31' },
  { value: '2223', name: 'Buritizeiro', uf: '31' },
  { value: '2224', name: 'Ibiaí', uf: '31' },
  { value: '2225', name: 'Jequitaí', uf: '31' },
  { value: '2226', name: 'Lagoa dos Patos', uf: '31' },
  { value: '2227', name: 'Lassance', uf: '31' },
  { value: '2228', name: 'Pirapora', uf: '31' },
  { value: '2229', name: 'Riachinho', uf: '31' },
  { value: '2230', name: 'Santa Fé de Minas', uf: '31' },
  { value: '2231', name: 'São Romão', uf: '31' },
  { value: '2232', name: 'Várzea da Palma', uf: '31' },
  { value: '2233', name: 'Brasília de Minas', uf: '31' },
  { value: '2234', name: 'Campo Azul', uf: '31' },
  { value: '2235', name: 'Capitão Enéas', uf: '31' },
  { value: '2236', name: 'Claro dos Poções', uf: '31' },
  { value: '2237', name: 'Coração de Jesus', uf: '31' },
  { value: '2238', name: 'Francisco Sá', uf: '31' },
  { value: '2239', name: 'Santa Inês', uf: '29' },
  { value: '2240', name: 'São Miguel das Matas', uf: '29' },
  { value: '2241', name: 'Ubaíra', uf: '29' },
  { value: '2242', name: 'Érico Cardoso', uf: '29' },
  { value: '2243', name: 'Dom Basílio', uf: '29' },
  { value: '2244', name: 'Livramento de Nossa Senhora', uf: '29' },
  { value: '2245', name: 'Paramirim', uf: '29' },
  { value: '2246', name: 'Rio do Pires', uf: '29' },
  { value: '2247', name: 'Caculé', uf: '29' },
  { value: '2248', name: 'Caetité', uf: '29' },
  { value: '2249', name: 'Candiba', uf: '29' },
  { value: '2250', name: 'Guanambi', uf: '29' },
  { value: '2251', name: 'Ibiassucê', uf: '29' },
  { value: '2252', name: 'Igaporã', uf: '29' },
  { value: '2253', name: 'Iuiú', uf: '29' },
  { value: '2254', name: 'Jacaraci', uf: '29' },
  { value: '2255', name: 'Lagoa Real', uf: '29' },
  { value: '2256', name: 'Licínio de Almeida', uf: '29' },
  { value: '2257', name: 'Malhada', uf: '29' },
  { value: '2258', name: 'Matina', uf: '29' },
  { value: '2259', name: 'Mortugaba', uf: '29' },
  { value: '2260', name: 'Palmas de Monte Alto', uf: '29' },
  { value: '2261', name: 'Pindaí', uf: '29' },
  { value: '2262', name: 'Riacho de Santana', uf: '29' },
  { value: '2263', name: 'Sebastião Laranjeiras', uf: '29' },
  { value: '2264', name: 'Urandi', uf: '29' },
  { value: '2265', name: 'Aracatu', uf: '29' },
  { value: '2266', name: 'Brumado', uf: '29' },
  { value: '2267', name: 'Caraíbas', uf: '29' },
  { value: '2268', name: 'Condeúba', uf: '29' },
  { value: '2269', name: 'Cordeiros', uf: '29' },
  { value: '2270', name: 'Guajeru', uf: '29' },
  { value: '2271', name: 'Ituaçu', uf: '29' },
  { value: '2272', name: 'Maetinga', uf: '29' },
  { value: '2273', name: 'Malhada de Pedras', uf: '29' },
  { value: '2274', name: 'Piripá', uf: '29' },
  { value: '2275', name: 'Presidente Jânio Quadros', uf: '29' },
  { value: '2276', name: 'Rio do Antônio', uf: '29' },
  { value: '2277', name: 'Tanhaçu', uf: '29' },
  { value: '2278', name: 'Tremedal', uf: '29' },
  { value: '2279', name: 'Anagé', uf: '29' },
  { value: '2280', name: 'Barra do Choça', uf: '29' },
  { value: '2281', name: 'Belo Campo', uf: '29' },
  { value: '2282', name: 'Boa Nova', uf: '29' },
  { value: '2283', name: 'Bom Jesus da Serra', uf: '29' },
  { value: '2284', name: 'Caatiba', uf: '29' },
  { value: '2285', name: 'Caetanos', uf: '29' },
  { value: '2286', name: 'Cândido Sales', uf: '29' },
  { value: '2287', name: 'Dário Meira', uf: '29' },
  { value: '2288', name: 'Ibicuí', uf: '29' },
  { value: '2289', name: 'Iguaí', uf: '29' },
  { value: '2290', name: 'Manoel Vitorino', uf: '29' },
  { value: '2291', name: 'Mirante', uf: '29' },
  { value: '2292', name: 'Nova Canaã', uf: '29' },
  { value: '2293', name: 'Planalto', uf: '29' },
  { value: '2294', name: 'Poções', uf: '29' },
  { value: '2295', name: 'Vitória da Conquista', uf: '29' },
  { value: '2296', name: 'Encruzilhada', uf: '29' },
  { value: '2297', name: 'Itambé', uf: '29' },
  { value: '2298', name: 'Itapetinga', uf: '29' },
  { value: '2299', name: 'Itarantim', uf: '29' },
  { value: '2300', name: 'Itororó', uf: '29' },
  { value: '2301', name: 'Macarani', uf: '29' },
  { value: '2302', name: 'Maiquinique', uf: '29' },
  { value: '2303', name: 'Potiraguá', uf: '29' },
  { value: '2304', name: 'Ribeirão do Largo', uf: '29' },
  { value: '2305', name: 'Cairu', uf: '29' },
  { value: '2306', name: 'Camamu', uf: '29' },
  { value: '2307', name: 'Igrapiúna', uf: '29' },
  { value: '2308', name: 'Ituberá', uf: '29' },
  { value: '2309', name: 'Maraú', uf: '29' },
  { value: '2310', name: 'Nilo Peçanha', uf: '29' },
  { value: '2311', name: 'Piraí do Norte', uf: '29' },
  { value: '2312', name: 'Presidente Tancredo Neves', uf: '29' },
  { value: '2313', name: 'Taperoá', uf: '29' },
  { value: '2314', name: 'Valença', uf: '29' },
  { value: '2315', name: 'Almadina', uf: '29' },
  { value: '2316', name: 'Arataca', uf: '29' },
  { value: '2317', name: 'Aurelino Leal', uf: '29' },
  { value: '2318', name: 'Barra do Rocha', uf: '29' },
  { value: '2319', name: 'Barro Preto', uf: '29' },
  { value: '2320', name: 'Belmonte', uf: '29' },
  { value: '2321', name: 'Buerarema', uf: '29' },
  { value: '2322', name: 'Camacan', uf: '29' },
  { value: '2323', name: 'Canavieiras', uf: '29' },
  { value: '2324', name: 'Coaraci', uf: '29' },
  { value: '2325', name: 'Firmino Alves', uf: '29' },
  { value: '2326', name: 'Floresta Azul', uf: '29' },
  { value: '2327', name: 'Gandu', uf: '29' },
  { value: '2328', name: 'Gongogi', uf: '29' },
  { value: '2329', name: 'Ibicaraí', uf: '29' },
  { value: '2330', name: 'Ibirapitanga', uf: '29' },
  { value: '2331', name: 'Ibirataia', uf: '29' },
  { value: '2332', name: 'Ilhéus', uf: '29' },
  { value: '2333', name: 'Ipiaú', uf: '29' },
  { value: '2334', name: 'Itabuna', uf: '29' },
  { value: '2335', name: 'Itacaré', uf: '29' },
  { value: '2336', name: 'Itagibá', uf: '29' },
  { value: '2337', name: 'Itaju do Colônia', uf: '29' },
  { value: '2338', name: 'Itajuípe', uf: '29' },
  { value: '2339', name: 'Itamari', uf: '29' },
  { value: '2340', name: 'Itapé', uf: '29' },
  { value: '2341', name: 'Itapebi', uf: '29' },
  { value: '2342', name: 'Itapitanga', uf: '29' },
  { value: '2343', name: 'Jussari', uf: '29' },
  { value: '2344', name: 'Mascote', uf: '29' },
  { value: '2345', name: 'Nova Ibiá', uf: '29' },
  { value: '2346', name: 'Pau Brasil', uf: '29' },
  { value: '2347', name: 'Santa Cruz da Vitória', uf: '29' },
  { value: '2348', name: 'Santa Luzia', uf: '29' },
  { value: '2349', name: 'São José da Vitória', uf: '29' },
  { value: '2350', name: 'Teolândia', uf: '29' },
  { value: '2351', name: 'Aramari', uf: '29' },
  { value: '2352', name: 'Crisópolis', uf: '29' },
  { value: '2353', name: 'Inhambupe', uf: '29' },
  { value: '2354', name: 'Rio Real', uf: '29' },
  { value: '2355', name: 'Sátiro Dias', uf: '29' },
  { value: '2356', name: 'Cardeal da Silva', uf: '29' },
  { value: '2357', name: 'Conde', uf: '29' },
  { value: '2358', name: 'Entre Rios', uf: '29' },
  { value: '2359', name: 'Esplanada', uf: '29' },
  { value: '2360', name: 'Jandaíra', uf: '29' },
  { value: '2361', name: 'Amélia Rodrigues', uf: '29' },
  { value: '2362', name: 'Catu', uf: '29' },
  { value: '2363', name: 'Itanagra', uf: '29' },
  { value: '2364', name: 'Mata de São João', uf: '29' },
  { value: '2365', name: 'Pojuca', uf: '29' },
  { value: '2366', name: 'São Sebastião do Passé', uf: '29' },
  { value: '2367', name: 'Terra Nova', uf: '29' },
  { value: '2368', name: 'Aratuípe', uf: '29' },
  { value: '2369', name: 'Cabaceiras do Paraguaçu', uf: '29' },
  { value: '2370', name: 'Cachoeira', uf: '29' },
  { value: '2371', name: 'Castro Alves', uf: '29' },
  { value: '2372', name: 'Conceição do Almeida', uf: '29' },
  { value: '2373', name: 'Cruz das Almas', uf: '29' },
  { value: '2374', name: 'Dom Macedo Costa', uf: '29' },
  { value: '2375', name: 'Governador Mangabeira', uf: '29' },
  { value: '2376', name: 'Jaguaripe', uf: '29' },
  { value: '2377', name: 'Maragogipe', uf: '29' },
  { value: '2378', name: 'Muniz Ferreira', uf: '29' },
  { value: '2379', name: 'Muritiba', uf: '29' },
  { value: '2380', name: 'Nazaré', uf: '29' },
  { value: '2381', name: 'Salinas da Margarida', uf: '29' },
  { value: '2382', name: 'Santo Amaro', uf: '29' },
  { value: '2383', name: 'Santo Antônio de Jesus', uf: '29' },
  { value: '2384', name: 'São Félix', uf: '29' },
  { value: '2385', name: 'São Felipe', uf: '29' },
  { value: '2386', name: 'Sapeaçu', uf: '29' },
  { value: '2387', name: 'Saubara', uf: '29' },
  { value: '2388', name: 'Varzedo', uf: '29' },
  { value: '2389', name: 'Camaçari', uf: '29' },
  { value: '2390', name: 'Candeias', uf: '29' },
  { value: '2391', name: "Dias d'Ávila", uf: '29' },
  { value: '2392', name: 'Itaparica', uf: '29' },
  { value: '2393', name: 'Lauro de Freitas', uf: '29' },
  { value: '2394', name: 'Madre de Deus', uf: '29' },
  { value: '2395', name: 'Salvador', uf: '29' },
  { value: '2396', name: 'São Francisco do Conde', uf: '29' },
  { value: '2397', name: 'Simões Filho', uf: '29' },
  { value: '2398', name: 'Vera Cruz', uf: '29' },
  { value: '2399', name: 'Boquira', uf: '29' },
  { value: '2400', name: 'Botuporã', uf: '29' },
  { value: '2401', name: 'Brotas de Macaúbas', uf: '29' },
  { value: '2402', name: 'Caturama', uf: '29' },
  { value: '2403', name: 'Ibipitanga', uf: '29' },
  { value: '2404', name: 'Ibitiara', uf: '29' },
  { value: '2405', name: 'Ipupiara', uf: '29' },
  { value: '2406', name: 'Macaúbas', uf: '29' },
  { value: '2407', name: 'Novo Horizonte', uf: '29' },
  { value: '2408', name: 'Oliveira dos Brejinhos', uf: '29' },
  { value: '2409', name: 'Tanque Novo', uf: '29' },
  { value: '2410', name: 'Abaíra', uf: '29' },
  { value: '2411', name: 'Andaraí', uf: '29' },
  { value: '2412', name: 'Barra da Estiva', uf: '29' },
  { value: '2413', name: 'Boninal', uf: '29' },
  { value: '2414', name: 'Bonito', uf: '29' },
  { value: '2415', name: 'Contendas do Sincorá', uf: '29' },
  { value: '2416', name: 'Ibicoara', uf: '29' },
  { value: '2417', name: 'Itaeté', uf: '29' },
  { value: '2418', name: 'Jussiape', uf: '29' },
  { value: '2419', name: 'Lençóis', uf: '29' },
  { value: '2420', name: 'Mucugê', uf: '29' },
  { value: '2421', name: 'Nova Redenção', uf: '29' },
  { value: '2422', name: 'Palmeiras', uf: '29' },
  { value: '2423', name: 'Piatã', uf: '29' },
  { value: '2424', name: 'Rio de Contas', uf: '29' },
  { value: '2425', name: 'Seabra', uf: '29' },
  { value: '2426', name: 'Utinga', uf: '29' },
  { value: '2427', name: 'Wagner', uf: '29' },
  { value: '2428', name: 'Aiquara', uf: '29' },
  { value: '2429', name: 'Amargosa', uf: '29' },
  { value: '2430', name: 'Apuarema', uf: '29' },
  { value: '2431', name: 'Brejões', uf: '29' },
  { value: '2432', name: 'Cravolândia', uf: '29' },
  { value: '2433', name: 'Irajuba', uf: '29' },
  { value: '2434', name: 'Iramaia', uf: '29' },
  { value: '2435', name: 'Itagi', uf: '29' },
  { value: '2436', name: 'Itaquara', uf: '29' },
  { value: '2437', name: 'Itiruçu', uf: '29' },
  { value: '2438', name: 'Jaguaquara', uf: '29' },
  { value: '2439', name: 'Jequié', uf: '29' },
  { value: '2440', name: 'Jiquiriçá', uf: '29' },
  { value: '2441', name: 'Jitaúna', uf: '29' },
  { value: '2442', name: 'Lafaiete Coutinho', uf: '29' },
  { value: '2443', name: 'Laje', uf: '29' },
  { value: '2444', name: 'Lajedo do Tabocal', uf: '29' },
  { value: '2445', name: 'Maracás', uf: '29' },
  { value: '2446', name: 'Marcionílio Souza', uf: '29' },
  { value: '2447', name: 'Milagres', uf: '29' },
  { value: '2448', name: 'Mutuípe', uf: '29' },
  { value: '2449', name: 'Nova Itarana', uf: '29' },
  { value: '2450', name: 'Planaltino', uf: '29' },
  { value: '2451', name: 'Mamborê', uf: '41' },
  { value: '2452', name: 'Peabiru', uf: '41' },
  { value: '2453', name: 'Quinta do Sol', uf: '41' },
  { value: '2454', name: 'Roncador', uf: '41' },
  { value: '2455', name: 'Terra Boa', uf: '41' },
  { value: '2456', name: 'Ângulo', uf: '41' },
  { value: '2457', name: 'Astorga', uf: '41' },
  { value: '2458', name: 'Atalaia', uf: '41' },
  { value: '2459', name: 'Cafeara', uf: '41' },
  { value: '2460', name: 'Centenário do Sul', uf: '41' },
  { value: '2461', name: 'Colorado', uf: '41' },
  { value: '2462', name: 'Flórida', uf: '41' },
  { value: '2463', name: 'Guaraci', uf: '41' },
  { value: '2464', name: 'Iguaraçu', uf: '41' },
  { value: '2465', name: 'Itaguajé', uf: '41' },
  { value: '2466', name: 'Jaguapitã', uf: '41' },
  { value: '2467', name: 'Lobato', uf: '41' },
  { value: '2468', name: 'Lupionópolis', uf: '41' },
  { value: '2469', name: 'Mandaguaçu', uf: '41' },
  { value: '2470', name: 'Munhoz de Melo', uf: '41' },
  { value: '2471', name: 'Nossa Senhora das Graças', uf: '41' },
  { value: '2472', name: 'Nova Esperança', uf: '41' },
  { value: '2473', name: 'Presidente Castelo Branco', uf: '41' },
  { value: '2474', name: 'Santa Fé', uf: '41' },
  { value: '2475', name: 'Santa Inês', uf: '41' },
  { value: '2476', name: 'Santo Inácio', uf: '41' },
  { value: '2477', name: 'Uniflor', uf: '41' },
  { value: '2478', name: 'Alvorada do Sul', uf: '41' },
  { value: '2479', name: 'Bela Vista do Paraíso', uf: '41' },
  { value: '2480', name: 'Florestópolis', uf: '41' },
  { value: '2481', name: 'Miraselva', uf: '41' },
  { value: '2482', name: 'Porecatu', uf: '41' },
  { value: '2483', name: 'Prado Ferreira', uf: '41' },
  { value: '2484', name: 'Primeiro de Maio', uf: '41' },
  { value: '2485', name: 'Sertanópolis', uf: '41' },
  { value: '2486', name: 'Doutor Camargo', uf: '41' },
  { value: '2487', name: 'Floraí', uf: '41' },
  { value: '2488', name: 'Floresta', uf: '41' },
  { value: '2489', name: 'Itambé', uf: '41' },
  { value: '2490', name: 'Ivatuba', uf: '41' },
  { value: '2491', name: 'Ourizona', uf: '41' },
  { value: '2492', name: 'São Jorge do Ivaí', uf: '41' },
  { value: '2493', name: 'Mandaguari', uf: '41' },
  { value: '2494', name: 'Marialva', uf: '41' },
  { value: '2495', name: 'Maringá', uf: '41' },
  { value: '2496', name: 'Paiçandu', uf: '41' },
  { value: '2497', name: 'Sarandi', uf: '41' },
  { value: '2498', name: 'Apucarana', uf: '41' },
  { value: '2499', name: 'Arapongas', uf: '41' },
  { value: '2500', name: 'Califórnia', uf: '41' },
  { value: '2501', name: 'Cambira', uf: '41' },
  { value: '2502', name: 'Jandaia do Sul', uf: '41' },
  { value: '2503', name: 'Marilândia do Sul', uf: '41' },
  { value: '2504', name: 'Mauá da Serra', uf: '41' },
  { value: '2505', name: 'Novo Itacolomi', uf: '41' },
  { value: '2506', name: 'Sabáudia', uf: '41' },
  { value: '2507', name: 'Cambé', uf: '41' },
  { value: '2508', name: 'Ibiporã', uf: '41' },
  { value: '2509', name: 'Londrina', uf: '41' },
  { value: '2510', name: 'Pitangueiras', uf: '41' },
  { value: '2511', name: 'Rolândia', uf: '41' },
  { value: '2512', name: 'Tamarana', uf: '41' },
  { value: '2513', name: 'Bom Sucesso', uf: '41' },
  { value: '2514', name: 'Borrazópolis', uf: '41' },
  { value: '2515', name: 'Cruzmaltina', uf: '41' },
  { value: '2516', name: 'Faxinal', uf: '41' },
  { value: '2517', name: 'Kaloré', uf: '41' },
  { value: '2518', name: 'Marumbi', uf: '41' },
  { value: '2519', name: 'Rio Bom', uf: '41' },
  { value: '2520', name: 'Arapuã', uf: '41' },
  { value: '2521', name: 'Ariranha do Ivaí', uf: '41' },
  { value: '2522', name: 'Cândido de Abreu', uf: '41' },
  { value: '2523', name: 'Godoy Moreira', uf: '41' },
  { value: '2524', name: 'Grandes Rios', uf: '41' },
  { value: '2525', name: 'Ivaiporã', uf: '41' },
  { value: '2526', name: 'Jardim Alegre', uf: '41' },
  { value: '2527', name: 'Biritiba-Mirim', uf: '35' },
  { value: '2528', name: 'Ferraz de Vasconcelos', uf: '35' },
  { value: '2529', name: 'Guararema', uf: '35' },
  { value: '2530', name: 'Itaquaquecetuba', uf: '35' },
  { value: '2531', name: 'Mogi das Cruzes', uf: '35' },
  { value: '2532', name: 'Poá', uf: '35' },
  { value: '2533', name: 'Salesópolis', uf: '35' },
  { value: '2534', name: 'Suzano', uf: '35' },
  { value: '2535', name: 'Bertioga', uf: '35' },
  { value: '2536', name: 'Cubatão', uf: '35' },
  { value: '2537', name: 'Guarujá', uf: '35' },
  { value: '2538', name: 'Praia Grande', uf: '35' },
  { value: '2539', name: 'Santos', uf: '35' },
  { value: '2540', name: 'São Vicente', uf: '35' },
  { value: '2541', name: 'Alto Paraná', uf: '41' },
  { value: '2542', name: 'Amaporã', uf: '41' },
  { value: '2543', name: 'Cruzeiro do Sul', uf: '41' },
  { value: '2544', name: 'Diamante do Norte', uf: '41' },
  { value: '2545', name: 'Guairaçá', uf: '41' },
  { value: '2546', name: 'Inajá', uf: '41' },
  { value: '2547', name: 'Itaúna do Sul', uf: '41' },
  { value: '2548', name: 'Jardim Olinda', uf: '41' },
  { value: '2549', name: 'Loanda', uf: '41' },
  { value: '2550', name: 'Marilena', uf: '41' },
  { value: '2551', name: 'Mirador', uf: '41' },
  { value: '2552', name: 'Nova Aliança do Ivaí', uf: '41' },
  { value: '2553', name: 'Nova Londrina', uf: '41' },
  { value: '2554', name: 'Paraíso do Norte', uf: '41' },
  { value: '2555', name: 'Paranacity', uf: '41' },
  { value: '2556', name: 'Paranapoema', uf: '41' },
  { value: '2557', name: 'Paranavaí', uf: '41' },
  { value: '2558', name: 'Planaltina do Paraná', uf: '41' },
  { value: '2559', name: 'Porto Rico', uf: '41' },
  { value: '2560', name: 'Querência do Norte', uf: '41' },
  { value: '2561', name: 'Santa Cruz de Monte Castelo', uf: '41' },
  { value: '2562', name: 'Santa Isabel do Ivaí', uf: '41' },
  { value: '2563', name: 'Santa Mônica', uf: '41' },
  { value: '2564', name: 'Santo Antônio do Caiuá', uf: '41' },
  { value: '2565', name: 'São Carlos do Ivaí', uf: '41' },
  { value: '2566', name: 'São João do Caiuá', uf: '41' },
  { value: '2567', name: 'São Pedro do Paraná', uf: '41' },
  { value: '2568', name: 'Tamboara', uf: '41' },
  { value: '2569', name: 'Terra Rica', uf: '41' },
  { value: '2570', name: 'Altônia', uf: '41' },
  { value: '2571', name: 'Alto Piquiri', uf: '41' },
  { value: '2572', name: 'Brasilândia do Sul', uf: '41' },
  { value: '2573', name: 'Cafezal do Sul', uf: '41' },
  { value: '2574', name: 'Cruzeiro do Oeste', uf: '41' },
  { value: '2575', name: 'Douradina', uf: '41' },
  { value: '2576', name: 'Esperança Nova', uf: '41' },
  { value: '2577', name: 'Francisco Alves', uf: '41' },
  { value: '2578', name: 'Icaraíma', uf: '41' },
  { value: '2579', name: 'Iporã', uf: '41' },
  { value: '2580', name: 'Ivaté', uf: '41' },
  { value: '2581', name: 'Maria Helena', uf: '41' },
  { value: '2582', name: 'Mariluz', uf: '41' },
  { value: '2583', name: 'Nova Olímpia', uf: '41' },
  { value: '2584', name: 'Perobal', uf: '41' },
  { value: '2585', name: 'Pérola', uf: '41' },
  { value: '2586', name: 'São Jorge do Patrocínio', uf: '41' },
  { value: '2587', name: 'Tapira', uf: '41' },
  { value: '2588', name: 'Umuarama', uf: '41' },
  { value: '2589', name: 'Alto Paraíso', uf: '41' },
  { value: '2590', name: 'Xambrê', uf: '41' },
  { value: '2591', name: 'Cianorte', uf: '41' },
  { value: '2592', name: 'Cidade Gaúcha', uf: '41' },
  { value: '2593', name: 'Guaporema', uf: '41' },
  { value: '2594', name: 'Indianópolis', uf: '41' },
  { value: '2595', name: 'Japurá', uf: '41' },
  { value: '2596', name: 'Jussara', uf: '41' },
  { value: '2597', name: 'Rondon', uf: '41' },
  { value: '2598', name: 'São Manoel do Paraná', uf: '41' },
  { value: '2599', name: 'São Tomé', uf: '41' },
  { value: '2600', name: 'Tapejara', uf: '41' },
  { value: '2601', name: 'Tuneiras do Oeste', uf: '41' },
  { value: '2602', name: 'Altamira do Paraná', uf: '41' },
  { value: '2603', name: 'Boa Esperança', uf: '41' },
  { value: '2604', name: 'Campina da Lagoa', uf: '41' },
  { value: '2605', name: 'Goioerê', uf: '41' },
  { value: '2606', name: 'Janiópolis', uf: '41' },
  { value: '2607', name: 'Juranda', uf: '41' },
  { value: '2608', name: 'Moreira Sales', uf: '41' },
  { value: '2609', name: 'Nova Cantu', uf: '41' },
  { value: '2610', name: 'Quarto Centenário', uf: '41' },
  { value: '2611', name: "Rancho Alegre D'Oeste", uf: '41' },
  { value: '2612', name: 'Ubiratã', uf: '41' },
  { value: '2613', name: 'Bragança Paulista', uf: '35' },
  { value: '2614', name: 'Itatiba', uf: '35' },
  { value: '2615', name: 'Jarinu', uf: '35' },
  { value: '2616', name: 'Joanópolis', uf: '35' },
  { value: '2617', name: 'Morungaba', uf: '35' },
  { value: '2618', name: 'Nazaré Paulista', uf: '35' },
  { value: '2619', name: 'Piracaia', uf: '35' },
  { value: '2620', name: 'Tuiuti', uf: '35' },
  { value: '2621', name: 'Vargem', uf: '35' },
  { value: '2622', name: 'Campos do Jordão', uf: '35' },
  { value: '2623', name: 'Monteiro Lobato', uf: '35' },
  { value: '2624', name: 'Santo Antônio do Pinhal', uf: '35' },
  { value: '2625', name: 'São Bento do Sapucaí', uf: '35' },
  { value: '2626', name: 'Caçapava', uf: '35' },
  { value: '2627', name: 'Igaratá', uf: '35' },
  { value: '2628', name: 'Jacareí', uf: '35' },
  { value: '2629', name: 'Pindamonhangaba', uf: '35' },
  { value: '2630', name: 'Santa Branca', uf: '35' },
  { value: '2631', name: 'São José dos Campos', uf: '35' },
  { value: '2632', name: 'Taubaté', uf: '35' },
  { value: '2633', name: 'Tremembé', uf: '35' },
  { value: '2634', name: 'Aparecida', uf: '35' },
  { value: '2635', name: 'Cachoeira Paulista', uf: '35' },
  { value: '2636', name: 'Canas', uf: '35' },
  { value: '2637', name: 'Cruzeiro', uf: '35' },
  { value: '2638', name: 'Guaratinguetá', uf: '35' },
  { value: '2639', name: 'Lavrinhas', uf: '35' },
  { value: '2640', name: 'Lorena', uf: '35' },
  { value: '2641', name: 'Piquete', uf: '35' },
  { value: '2642', name: 'Potim', uf: '35' },
  { value: '2643', name: 'Queluz', uf: '35' },
  { value: '2644', name: 'Roseira', uf: '35' },
  { value: '2645', name: 'Arapeí', uf: '35' },
  { value: '2646', name: 'Areias', uf: '35' },
  { value: '2647', name: 'Bananal', uf: '35' },
  { value: '2648', name: 'São José do Barreiro', uf: '35' },
  { value: '2649', name: 'Silveiras', uf: '35' },
  { value: '2650', name: 'Cunha', uf: '35' },
  { value: '2651', name: 'Jambeiro', uf: '35' },
  { value: '2652', name: 'Lagoinha', uf: '35' },
  { value: '2653', name: 'Natividade da Serra', uf: '35' },
  { value: '2654', name: 'Paraibuna', uf: '35' },
  { value: '2655', name: 'Redenção da Serra', uf: '35' },
  { value: '2656', name: 'São Luís do Paraitinga', uf: '35' },
  { value: '2657', name: 'Caraguatatuba', uf: '35' },
  { value: '2658', name: 'Ilhabela', uf: '35' },
  { value: '2659', name: 'São Sebastião', uf: '35' },
  { value: '2660', name: 'Ubatuba', uf: '35' },
  { value: '2661', name: 'Barra do Turvo', uf: '35' },
  { value: '2662', name: 'Cajati', uf: '35' },
  { value: '2663', name: 'Cananéia', uf: '35' },
  { value: '2664', name: 'Eldorado', uf: '35' },
  { value: '2665', name: 'Iguape', uf: '35' },
  { value: '2666', name: 'Ilha Comprida', uf: '35' },
  { value: '2667', name: 'Jacupiranga', uf: '35' },
  { value: '2668', name: 'Juquiá', uf: '35' },
  { value: '2669', name: 'Miracatu', uf: '35' },
  { value: '2670', name: 'Pariquera-Açu', uf: '35' },
  { value: '2671', name: 'Registro', uf: '35' },
  { value: '2672', name: 'Sete Barras', uf: '35' },
  { value: '2673', name: 'Itanhaém', uf: '35' },
  { value: '2674', name: 'Itariri', uf: '35' },
  { value: '2675', name: 'Mongaguá', uf: '35' },
  { value: '2676', name: 'Pedro de Toledo', uf: '35' },
  { value: '2677', name: 'Peruíbe', uf: '35' },
  { value: '2678', name: 'Barueri', uf: '35' },
  { value: '2679', name: 'Cajamar', uf: '35' },
  { value: '2680', name: 'Carapicuíba', uf: '35' },
  { value: '2681', name: 'Itapevi', uf: '35' },
  { value: '2682', name: 'Jandira', uf: '35' },
  { value: '2683', name: 'Osasco', uf: '35' },
  { value: '2684', name: 'Pirapora do Bom Jesus', uf: '35' },
  { value: '2685', name: 'Santana de Parnaíba', uf: '35' },
  { value: '2686', name: 'Caieiras', uf: '35' },
  { value: '2687', name: 'Francisco Morato', uf: '35' },
  { value: '2688', name: 'Franco da Rocha', uf: '35' },
  { value: '2689', name: 'Mairiporã', uf: '35' },
  { value: '2690', name: 'Arujá', uf: '35' },
  { value: '2691', name: 'Guarulhos', uf: '35' },
  { value: '2692', name: 'Santa Isabel', uf: '35' },
  { value: '2693', name: 'Cotia', uf: '35' },
  { value: '2694', name: 'Embu', uf: '35' },
  { value: '2695', name: 'Embu-Guaçu', uf: '35' },
  { value: '2696', name: 'Itapecerica da Serra', uf: '35' },
  { value: '2697', name: 'Juquitiba', uf: '35' },
  { value: '2698', name: 'São Lourenço da Serra', uf: '35' },
  { value: '2699', name: 'Taboão da Serra', uf: '35' },
  { value: '2700', name: 'Vargem Grande Paulista', uf: '35' },
  { value: '2701', name: 'Diadema', uf: '35' },
  { value: '2702', name: 'Mauá', uf: '35' },
  { value: '2703', name: 'Ribeirão Pires', uf: '35' },
  { value: '2704', name: 'Rio Grande da Serra', uf: '35' },
  { value: '2705', name: 'Santo André', uf: '35' },
  { value: '2706', name: 'São Bernardo do Campo', uf: '35' },
  { value: '2707', name: 'São Caetano do Sul', uf: '35' },
  { value: '2708', name: 'São Paulo', uf: '35' },
  { value: '2709', name: 'Álvaro de Carvalho', uf: '35' },
  { value: '2710', name: 'Alvinlândia', uf: '35' },
  { value: '2711', name: 'Echaporã', uf: '35' },
  { value: '2712', name: 'Fernão', uf: '35' },
  { value: '2713', name: 'Gália', uf: '35' },
  { value: '2714', name: 'Garça', uf: '35' },
  { value: '2715', name: 'Lupércio', uf: '35' },
  { value: '2716', name: 'Marília', uf: '35' },
  { value: '2717', name: 'Ocauçu', uf: '35' },
  { value: '2718', name: 'Oriente', uf: '35' },
  { value: '2719', name: 'Oscar Bressane', uf: '35' },
  { value: '2720', name: 'Pompéia', uf: '35' },
  { value: '2721', name: 'Vera Cruz', uf: '35' },
  { value: '2722', name: 'Assis', uf: '35' },
  { value: '2723', name: 'Borá', uf: '35' },
  { value: '2724', name: 'Campos Novos Paulista', uf: '35' },
  { value: '2725', name: 'Cândido Mota', uf: '35' },
  { value: '2726', name: 'Cruzália', uf: '35' },
  { value: '2727', name: 'Florínia', uf: '35' },
  { value: '2728', name: 'Ibirarema', uf: '35' },
  { value: '2729', name: 'Iepê', uf: '35' },
  { value: '2730', name: 'Lutécia', uf: '35' },
  { value: '2731', name: 'Maracaí', uf: '35' },
  { value: '2732', name: 'Nantes', uf: '35' },
  { value: '2733', name: 'Palmital', uf: '35' },
  { value: '2734', name: 'Paraguaçu Paulista', uf: '35' },
  { value: '2735', name: 'Pedrinhas Paulista', uf: '35' },
  { value: '2736', name: 'Platina', uf: '35' },
  { value: '2737', name: 'Quatá', uf: '35' },
  { value: '2738', name: 'Tarumã', uf: '35' },
  { value: '2739', name: 'Bernardino de Campos', uf: '35' },
  { value: '2740', name: 'Canitar', uf: '35' },
  { value: '2741', name: 'Espírito Santo do Turvo', uf: '35' },
  { value: '2742', name: 'Fartura', uf: '35' },
  { value: '2743', name: 'Ipaussu', uf: '35' },
  { value: '2744', name: 'Manduri', uf: '35' },
  { value: '2745', name: 'Óleo', uf: '35' },
  { value: '2746', name: 'Ourinhos', uf: '35' },
  { value: '2747', name: 'Piraju', uf: '35' },
  { value: '2748', name: 'Ribeirão do Sul', uf: '35' },
  { value: '2749', name: 'Salto Grande', uf: '35' },
  { value: '2750', name: 'Santa Cruz do Rio Pardo', uf: '35' },
  { value: '2751', name: 'São Pedro do Turvo', uf: '35' },
  { value: '2752', name: 'Sarutaiá', uf: '35' },
  { value: '2753', name: 'Taguaí', uf: '35' },
  { value: '2754', name: 'Tejupá', uf: '35' },
  { value: '2755', name: 'Timburi', uf: '35' },
  { value: '2756', name: 'Chavantes', uf: '35' },
  { value: '2757', name: 'Barão de Antonina', uf: '35' },
  { value: '2758', name: 'Bom Sucesso de Itararé', uf: '35' },
  { value: '2759', name: 'Buri', uf: '35' },
  { value: '2760', name: 'Coronel Macedo', uf: '35' },
  { value: '2761', name: 'Itaberá', uf: '35' },
  { value: '2762', name: 'Itapeva', uf: '35' },
  { value: '2763', name: 'Itaporanga', uf: '35' },
  { value: '2764', name: 'Itararé', uf: '35' },
  { value: '2765', name: 'Nova Campina', uf: '35' },
  { value: '2766', name: 'Riversul', uf: '35' },
  { value: '2767', name: 'Taquarituba', uf: '35' },
  { value: '2768', name: 'Taquarivaí', uf: '35' },
  { value: '2769', name: 'Alambari', uf: '35' },
  { value: '2770', name: 'Angatuba', uf: '35' },
  { value: '2771', name: 'Campina do Monte Alegre', uf: '35' },
  { value: '2772', name: 'Guareí', uf: '35' },
  { value: '2773', name: 'Itapetininga', uf: '35' },
  { value: '2774', name: 'Boituva', uf: '35' },
  { value: '2775', name: 'Cerquilho', uf: '35' },
  { value: '2776', name: 'Cesário Lange', uf: '35' },
  { value: '2777', name: 'Laranjal Paulista', uf: '35' },
  { value: '2778', name: 'Pereiras', uf: '35' },
  { value: '2779', name: 'Porangaba', uf: '35' },
  { value: '2780', name: 'Quadra', uf: '35' },
  { value: '2781', name: 'Tatuí', uf: '35' },
  { value: '2782', name: 'Torre de Pedra', uf: '35' },
  { value: '2783', name: 'Apiaí', uf: '35' },
  { value: '2784', name: 'Barra do Chapéu', uf: '35' },
  { value: '2785', name: 'Capão Bonito', uf: '35' },
  { value: '2786', name: 'Guapiara', uf: '35' },
  { value: '2787', name: 'Iporanga', uf: '35' },
  { value: '2788', name: 'Itaóca', uf: '35' },
  { value: '2789', name: 'Itapirapuã Paulista', uf: '35' },
  { value: '2790', name: 'Ribeira', uf: '35' },
  { value: '2791', name: 'Ribeirão Branco', uf: '35' },
  { value: '2792', name: 'Ribeirão Grande', uf: '35' },
  { value: '2793', name: 'Ibiúna', uf: '35' },
  { value: '2794', name: 'Piedade', uf: '35' },
  { value: '2795', name: 'Pilar do Sul', uf: '35' },
  { value: '2796', name: 'São Miguel Arcanjo', uf: '35' },
  { value: '2797', name: 'Tapiraí', uf: '35' },
  { value: '2798', name: 'Alumínio', uf: '35' },
  { value: '2799', name: 'Araçariguama', uf: '35' },
  { value: '2800', name: 'Araçoiaba da Serra', uf: '35' },
  { value: '2801', name: 'Cabreúva', uf: '35' },
  { value: '2802', name: 'Capela do Alto', uf: '35' },
  { value: '2803', name: 'Iperó', uf: '35' },
  { value: '2804', name: 'Itu', uf: '35' },
  { value: '2805', name: 'Mairinque', uf: '35' },
  { value: '2806', name: 'Porto Feliz', uf: '35' },
  { value: '2807', name: 'Salto', uf: '35' },
  { value: '2808', name: 'Salto de Pirapora', uf: '35' },
  { value: '2809', name: 'São Roque', uf: '35' },
  { value: '2810', name: 'Sarapuí', uf: '35' },
  { value: '2811', name: 'Sorocaba', uf: '35' },
  { value: '2812', name: 'Votorantim', uf: '35' },
  { value: '2813', name: 'Campo Limpo Paulista', uf: '35' },
  { value: '2814', name: 'Itupeva', uf: '35' },
  { value: '2815', name: 'Jundiaí', uf: '35' },
  { value: '2816', name: 'Louveira', uf: '35' },
  { value: '2817', name: 'Várzea Paulista', uf: '35' },
  { value: '2818', name: 'Atibaia', uf: '35' },
  { value: '2819', name: 'Bom Jesus dos Perdões', uf: '35' },
  { value: '2820', name: 'Rafard', uf: '35' },
  { value: '2821', name: 'Rio das Pedras', uf: '35' },
  { value: '2822', name: 'Saltinho', uf: '35' },
  { value: '2823', name: 'Santa Maria da Serra', uf: '35' },
  { value: '2824', name: 'São Pedro', uf: '35' },
  { value: '2825', name: 'Tietê', uf: '35' },
  { value: '2826', name: 'Aguaí', uf: '35' },
  { value: '2827', name: 'Pirassununga', uf: '35' },
  { value: '2828', name: 'Porto Ferreira', uf: '35' },
  { value: '2829', name: 'Santa Cruz das Palmeiras', uf: '35' },
  { value: '2830', name: 'Águas da Prata', uf: '35' },
  { value: '2831', name: 'Caconde', uf: '35' },
  { value: '2832', name: 'Casa Branca', uf: '35' },
  { value: '2833', name: 'Divinolândia', uf: '35' },
  { value: '2834', name: 'Espírito Santo do Pinhal', uf: '35' },
  { value: '2835', name: 'Itobi', uf: '35' },
  { value: '2836', name: 'Mococa', uf: '35' },
  { value: '2837', name: 'Santo Antônio do Jardim', uf: '35' },
  { value: '2838', name: 'São João da Boa Vista', uf: '35' },
  { value: '2839', name: 'São José do Rio Pardo', uf: '35' },
  { value: '2840', name: 'São Sebastião da Grama', uf: '35' },
  { value: '2841', name: 'Tambaú', uf: '35' },
  { value: '2842', name: 'Tapiratiba', uf: '35' },
  { value: '2843', name: 'Vargem Grande do Sul', uf: '35' },
  { value: '2844', name: 'Artur Nogueira', uf: '35' },
  { value: '2845', name: 'Engenheiro Coelho', uf: '35' },
  { value: '2846', name: 'Itapira', uf: '35' },
  { value: '2847', name: 'Mogi Guaçu', uf: '35' },
  { value: '2848', name: 'Mogi Mirim', uf: '35' },
  { value: '2849', name: 'Santo Antônio de Posse', uf: '35' },
  { value: '2850', name: 'Estiva Gerbi', uf: '35' },
  { value: '2851', name: 'Americana', uf: '35' },
  { value: '2852', name: 'Campinas', uf: '35' },
  { value: '2853', name: 'Cosmópolis', uf: '35' },
  { value: '2854', name: 'Elias Fausto', uf: '35' },
  { value: '2855', name: 'Holambra', uf: '35' },
  { value: '2856', name: 'Hortolândia', uf: '35' },
  { value: '2857', name: 'Indaiatuba', uf: '35' },
  { value: '2858', name: 'Jaguariúna', uf: '35' },
  { value: '2859', name: 'Monte Mor', uf: '35' },
  { value: '2860', name: 'Nova Odessa', uf: '35' },
  { value: '2861', name: 'Paulínia', uf: '35' },
  { value: '2862', name: 'Pedreira', uf: '35' },
  { value: '2863', name: "Santa Bárbara d'Oeste", uf: '35' },
  { value: '2864', name: 'Sumaré', uf: '35' },
  { value: '2865', name: 'Valinhos', uf: '35' },
  { value: '2866', name: 'Vinhedo', uf: '35' },
  { value: '2867', name: 'Águas de Lindóia', uf: '35' },
  { value: '2868', name: 'Amparo', uf: '35' },
  { value: '2869', name: 'Lindóia', uf: '35' },
  { value: '2870', name: 'Monte Alegre do Sul', uf: '35' },
  { value: '2871', name: 'Pedra Bela', uf: '35' },
  { value: '2872', name: 'Pinhalzinho', uf: '35' },
  { value: '2873', name: 'Serra Negra', uf: '35' },
  { value: '2874', name: 'Socorro', uf: '35' },
  { value: '2875', name: 'Dracena', uf: '35' },
  { value: '2876', name: 'Junqueirópolis', uf: '35' },
  { value: '2877', name: 'Monte Castelo', uf: '35' },
  { value: '2878', name: 'Nova Guataporanga', uf: '35' },
  { value: '2879', name: 'Ouro Verde', uf: '35' },
  { value: '2880', name: 'Panorama', uf: '35' },
  { value: '2881', name: 'Paulicéia', uf: '35' },
  { value: '2882', name: 'Santa Mercedes', uf: '35' },
  { value: '2883', name: "São João do Pau d'Alho", uf: '35' },
  { value: '2884', name: 'Tupi Paulista', uf: '35' },
  { value: '2885', name: 'Adamantina', uf: '35' },
  { value: '2886', name: 'Flora Rica', uf: '35' },
  { value: '2887', name: 'Flórida Paulista', uf: '35' },
  { value: '2888', name: 'Inúbia Paulista', uf: '35' },
  { value: '2889', name: 'Irapuru', uf: '35' },
  { value: '2890', name: 'Lucélia', uf: '35' },
  { value: '2891', name: 'Mariápolis', uf: '35' },
  { value: '2892', name: 'Osvaldo Cruz', uf: '35' },
  { value: '2893', name: 'Pacaembu', uf: '35' },
  { value: '2894', name: 'Parapuã', uf: '35' },
  { value: '2895', name: 'Pracinha', uf: '35' },
  { value: '2896', name: 'Rinópolis', uf: '35' },
  { value: '2897', name: 'Sagres', uf: '35' },
  { value: '2898', name: 'Salmourão', uf: '35' },
  { value: '2899', name: 'Alfredo Marcondes', uf: '35' },
  { value: '2900', name: 'Álvares Machado', uf: '35' },
  { value: '2901', name: 'Anhumas', uf: '35' },
  { value: '2902', name: 'Caiabu', uf: '35' },
  { value: '2903', name: 'Caiuá', uf: '35' },
  { value: '2904', name: 'Emilianópolis', uf: '35' },
  { value: '2905', name: 'Estrela do Norte', uf: '35' },
  { value: '2906', name: 'Euclides da Cunha Paulista', uf: '35' },
  { value: '2907', name: 'Indiana', uf: '35' },
  { value: '2908', name: 'João Ramalho', uf: '35' },
  { value: '2909', name: 'Marabá Paulista', uf: '35' },
  { value: '2910', name: 'Martinópolis', uf: '35' },
  { value: '2911', name: 'Mirante do Paranapanema', uf: '35' },
  { value: '2912', name: 'Narandiba', uf: '35' },
  { value: '2913', name: 'Piquerobi', uf: '35' },
  { value: '2914', name: 'Pirapozinho', uf: '35' },
  { value: '2915', name: 'Presidente Bernardes', uf: '35' },
  { value: '2916', name: 'Presidente Epitácio', uf: '35' },
  { value: '2917', name: 'Presidente Prudente', uf: '35' },
  { value: '2918', name: 'Presidente Venceslau', uf: '35' },
  { value: '2919', name: 'Rancharia', uf: '35' },
  { value: '2920', name: 'Regente Feijó', uf: '35' },
  { value: '2921', name: 'Ribeirão dos Índios', uf: '35' },
  { value: '2922', name: 'Rosana', uf: '35' },
  { value: '2923', name: 'Sandovalina', uf: '35' },
  { value: '2924', name: 'Santo Anastácio', uf: '35' },
  { value: '2925', name: 'Santo Expedito', uf: '35' },
  { value: '2926', name: 'Taciba', uf: '35' },
  { value: '2927', name: 'Tarabai', uf: '35' },
  { value: '2928', name: 'Teodoro Sampaio', uf: '35' },
  { value: '2929', name: 'Arco-Íris', uf: '35' },
  { value: '2930', name: 'Bastos', uf: '35' },
  { value: '2931', name: 'Herculândia', uf: '35' },
  { value: '2932', name: 'Iacri', uf: '35' },
  { value: '2933', name: 'Queiroz', uf: '35' },
  { value: '2934', name: 'Quintana', uf: '35' },
  { value: '2935', name: 'Tupã', uf: '35' },
  { value: '2936', name: 'Avanhandava', uf: '35' },
  { value: '2937', name: 'Barbosa', uf: '35' },
  { value: '2938', name: 'Bilac', uf: '35' },
  { value: '2939', name: 'Birigui', uf: '35' },
  { value: '2940', name: 'Braúna', uf: '35' },
  { value: '2941', name: 'Brejo Alegre', uf: '35' },
  { value: '2942', name: 'Buritama', uf: '35' },
  { value: '2943', name: 'Clementina', uf: '35' },
  { value: '2944', name: 'Coroados', uf: '35' },
  { value: '2945', name: 'Gabriel Monteiro', uf: '35' },
  { value: '2946', name: 'Glicério', uf: '35' },
  { value: '2947', name: 'Lourdes', uf: '35' },
  { value: '2948', name: 'Luiziânia', uf: '35' },
  { value: '2949', name: 'Penápolis', uf: '35' },
  { value: '2950', name: 'Piacatu', uf: '35' },
  { value: '2951', name: 'Santópolis do Aguapeí', uf: '35' },
  { value: '2952', name: 'Turiúba', uf: '35' },
  { value: '2953', name: 'Cafelândia', uf: '35' },
  { value: '2954', name: 'Getulina', uf: '35' },
  { value: '2955', name: 'Guaiçara', uf: '35' },
  { value: '2956', name: 'Guaimbê', uf: '35' },
  { value: '2957', name: 'Júlio Mesquita', uf: '35' },
  { value: '2958', name: 'Lins', uf: '35' },
  { value: '2959', name: 'Promissão', uf: '35' },
  { value: '2960', name: 'Sabino', uf: '35' },
  { value: '2961', name: 'Agudos', uf: '35' },
  { value: '2962', name: 'Arealva', uf: '35' },
  { value: '2963', name: 'Areiópolis', uf: '35' },
  { value: '2964', name: 'Avaí', uf: '35' },
  { value: '2965', name: 'Balbinos', uf: '35' },
  { value: '2966', name: 'Bauru', uf: '35' },
  { value: '2967', name: 'Borebi', uf: '35' },
  { value: '2968', name: 'Cabrália Paulista', uf: '35' },
  { value: '2969', name: 'Duartina', uf: '35' },
  { value: '2970', name: 'Guarantã', uf: '35' },
  { value: '2971', name: 'Iacanga', uf: '35' },
  { value: '2972', name: 'Lençóis Paulista', uf: '35' },
  { value: '2973', name: 'Lucianópolis', uf: '35' },
  { value: '2974', name: 'Paulistânia', uf: '35' },
  { value: '2975', name: 'Pirajuí', uf: '35' },
  { value: '2976', name: 'Piratininga', uf: '35' },
  { value: '2977', name: 'Pongaí', uf: '35' },
  { value: '2978', name: 'Presidente Alves', uf: '35' },
  { value: '2979', name: 'Reginópolis', uf: '35' },
  { value: '2980', name: 'Ubirajara', uf: '35' },
  { value: '2981', name: 'Uru', uf: '35' },
  { value: '2982', name: 'Bariri', uf: '35' },
  { value: '2983', name: 'Barra Bonita', uf: '35' },
  { value: '2984', name: 'Bocaina', uf: '35' },
  { value: '2985', name: 'Boracéia', uf: '35' },
  { value: '2986', name: 'Dois Córregos', uf: '35' },
  { value: '2987', name: 'Igaraçu do Tietê', uf: '35' },
  { value: '2988', name: 'Itaju', uf: '35' },
  { value: '2989', name: 'Itapuí', uf: '35' },
  { value: '2990', name: 'Jaú', uf: '35' },
  { value: '2991', name: 'Macatuba', uf: '35' },
  { value: '2992', name: 'Mineiros do Tietê', uf: '35' },
  { value: '2993', name: 'Pederneiras', uf: '35' },
  { value: '2994', name: 'Águas de Santa Bárbara', uf: '35' },
  { value: '2995', name: 'Arandu', uf: '35' },
  { value: '2996', name: 'Avaré', uf: '35' },
  { value: '2997', name: 'Cerqueira César', uf: '35' },
  { value: '2998', name: 'Iaras', uf: '35' },
  { value: '2999', name: 'Itaí', uf: '35' },
  { value: '3000', name: 'Itatinga', uf: '35' },
  { value: '3001', name: 'Paranapanema', uf: '35' },
  { value: '3002', name: 'Anhembi', uf: '35' },
  { value: '3003', name: 'Bofete', uf: '35' },
  { value: '3004', name: 'Botucatu', uf: '35' },
  { value: '3005', name: 'Conchas', uf: '35' },
  { value: '3006', name: 'Pardinho', uf: '35' },
  { value: '3007', name: 'Pratânia', uf: '35' },
  { value: '3008', name: 'São Manuel', uf: '35' },
  { value: '3009', name: 'Américo Brasiliense', uf: '35' },
  { value: '3010', name: 'Araraquara', uf: '35' },
  { value: '3011', name: 'Boa Esperança do Sul', uf: '35' },
  { value: '3012', name: 'Borborema', uf: '35' },
  { value: '3013', name: 'Dobrada', uf: '35' },
  { value: '3014', name: 'Gavião Peixoto', uf: '35' },
  { value: '3015', name: 'Ibitinga', uf: '35' },
  { value: '3016', name: 'Itápolis', uf: '35' },
  { value: '3017', name: 'Matão', uf: '35' },
  { value: '3018', name: 'Motuca', uf: '35' },
  { value: '3019', name: 'Nova Europa', uf: '35' },
  { value: '3020', name: 'Rincão', uf: '35' },
  { value: '3021', name: 'Santa Lúcia', uf: '35' },
  { value: '3022', name: 'Tabatinga', uf: '35' },
  { value: '3023', name: 'Trabiju', uf: '35' },
  { value: '3024', name: 'Analândia', uf: '35' },
  { value: '3025', name: 'Descalvado', uf: '35' },
  { value: '3026', name: 'Dourado', uf: '35' },
  { value: '3027', name: 'Ibaté', uf: '35' },
  { value: '3028', name: 'Ribeirão Bonito', uf: '35' },
  { value: '3029', name: 'São Carlos', uf: '35' },
  { value: '3030', name: 'Brotas', uf: '35' },
  { value: '3031', name: 'Corumbataí', uf: '35' },
  { value: '3032', name: 'Ipeúna', uf: '35' },
  { value: '3033', name: 'Itirapina', uf: '35' },
  { value: '3034', name: 'Rio Claro', uf: '35' },
  { value: '3035', name: 'Torrinha', uf: '35' },
  { value: '3036', name: 'Araras', uf: '35' },
  { value: '3037', name: 'Conchal', uf: '35' },
  { value: '3038', name: 'Cordeirópolis', uf: '35' },
  { value: '3039', name: 'Iracemápolis', uf: '35' },
  { value: '3040', name: 'Leme', uf: '35' },
  { value: '3041', name: 'Limeira', uf: '35' },
  { value: '3042', name: 'Santa Cruz da Conceição', uf: '35' },
  { value: '3043', name: 'Santa Gertrudes', uf: '35' },
  { value: '3044', name: 'Águas de São Pedro', uf: '35' },
  { value: '3045', name: 'Capivari', uf: '35' },
  { value: '3046', name: 'Charqueada', uf: '35' },
  { value: '3047', name: 'Jumirim', uf: '35' },
  { value: '3048', name: 'Mombuca', uf: '35' },
  { value: '3049', name: 'Piracicaba', uf: '35' },
  { value: '3050', name: 'Elisiário', uf: '35' },
  { value: '3051', name: 'Embaúba', uf: '35' },
  { value: '3052', name: 'Novais', uf: '35' },
  { value: '3053', name: 'Palmares Paulista', uf: '35' },
  { value: '3054', name: 'Paraíso', uf: '35' },
  { value: '3055', name: 'Pindorama', uf: '35' },
  { value: '3056', name: 'Santa Adélia', uf: '35' },
  { value: '3057', name: 'Severínia', uf: '35' },
  { value: '3058', name: 'Tabapuã', uf: '35' },
  { value: '3059', name: 'Auriflama', uf: '35' },
  { value: '3060', name: 'Floreal', uf: '35' },
  { value: '3061', name: 'Gastão Vidigal', uf: '35' },
  { value: '3062', name: 'General Salgado', uf: '35' },
  { value: '3063', name: 'Guzolândia', uf: '35' },
  { value: '3064', name: 'Magda', uf: '35' },
  { value: '3065', name: 'Nova Castilho', uf: '35' },
  { value: '3066', name: 'Nova Luzitânia', uf: '35' },
  { value: '3067', name: 'São João de Iracema', uf: '35' },
  { value: '3068', name: 'Macaubal', uf: '35' },
  { value: '3069', name: 'Monções', uf: '35' },
  { value: '3070', name: 'Monte Aprazível', uf: '35' },
  { value: '3071', name: 'Neves Paulista', uf: '35' },
  { value: '3072', name: 'Nhandeara', uf: '35' },
  { value: '3073', name: 'Nipoã', uf: '35' },
  { value: '3074', name: 'Poloni', uf: '35' },
  { value: '3075', name: 'Sebastianópolis do Sul', uf: '35' },
  { value: '3076', name: 'União Paulista', uf: '35' },
  { value: '3077', name: 'Irapuã', uf: '35' },
  { value: '3078', name: 'Itajobi', uf: '35' },
  { value: '3079', name: 'Marapoama', uf: '35' },
  { value: '3080', name: 'Novo Horizonte', uf: '35' },
  { value: '3081', name: 'Sales', uf: '35' },
  { value: '3082', name: 'Urupês', uf: '35' },
  { value: '3083', name: 'Barretos', uf: '35' },
  { value: '3084', name: 'Colina', uf: '35' },
  { value: '3085', name: 'Colômbia', uf: '35' },
  { value: '3086', name: 'Guaíra', uf: '35' },
  { value: '3087', name: 'Ipuã', uf: '35' },
  { value: '3088', name: 'Jaborandi', uf: '35' },
  { value: '3089', name: 'Miguelópolis', uf: '35' },
  { value: '3090', name: 'Morro Agudo', uf: '35' },
  { value: '3091', name: 'Nuporanga', uf: '35' },
  { value: '3092', name: 'Orlândia', uf: '35' },
  { value: '3093', name: 'Sales Oliveira', uf: '35' },
  { value: '3094', name: 'São Joaquim da Barra', uf: '35' },
  { value: '3095', name: 'Aramina', uf: '35' },
  { value: '3096', name: 'Buritizal', uf: '35' },
  { value: '3097', name: 'Guará', uf: '35' },
  { value: '3098', name: 'Igarapava', uf: '35' },
  { value: '3099', name: 'Ituverava', uf: '35' },
  { value: '3100', name: 'Cristais Paulista', uf: '35' },
  { value: '3101', name: 'Franca', uf: '35' },
  { value: '3102', name: 'Itirapuã', uf: '35' },
  { value: '3103', name: 'Jeriquara', uf: '35' },
  { value: '3104', name: 'Patrocínio Paulista', uf: '35' },
  { value: '3105', name: 'Pedregulho', uf: '35' },
  { value: '3106', name: 'Restinga', uf: '35' },
  { value: '3107', name: 'Ribeirão Corrente', uf: '35' },
  { value: '3108', name: 'Rifaina', uf: '35' },
  { value: '3109', name: 'São José da Bela Vista', uf: '35' },
  { value: '3110', name: 'Bebedouro', uf: '35' },
  { value: '3111', name: 'Cândido Rodrigues', uf: '35' },
  { value: '3112', name: 'Fernando Prestes', uf: '35' },
  { value: '3113', name: 'Guariba', uf: '35' },
  { value: '3114', name: 'Jaboticabal', uf: '35' },
  { value: '3115', name: 'Monte Alto', uf: '35' },
  { value: '3116', name: 'Monte Azul Paulista', uf: '35' },
  { value: '3117', name: 'Pirangi', uf: '35' },
  { value: '3118', name: 'Pitangueiras', uf: '35' },
  { value: '3119', name: 'Santa Ernestina', uf: '35' },
  { value: '3120', name: 'Taiaçu', uf: '35' },
  { value: '3121', name: 'Taiúva', uf: '35' },
  { value: '3122', name: 'Taquaral', uf: '35' },
  { value: '3123', name: 'Taquaritinga', uf: '35' },
  { value: '3124', name: 'Terra Roxa', uf: '35' },
  { value: '3125', name: 'Viradouro', uf: '35' },
  { value: '3126', name: 'Vista Alegre do Alto', uf: '35' },
  { value: '3127', name: 'Barrinha', uf: '35' },
  { value: '3128', name: 'Brodowski', uf: '35' },
  { value: '3129', name: 'Cravinhos', uf: '35' },
  { value: '3130', name: 'Dumont', uf: '35' },
  { value: '3131', name: 'Guatapará', uf: '35' },
  { value: '3132', name: 'Jardinópolis', uf: '35' },
  { value: '3133', name: 'Luís Antônio', uf: '35' },
  { value: '3134', name: 'Pontal', uf: '35' },
  { value: '3135', name: 'Pradópolis', uf: '35' },
  { value: '3136', name: 'Ribeirão Preto', uf: '35' },
  { value: '3137', name: 'Santa Rita do Passa Quatro', uf: '35' },
  { value: '3138', name: 'Santa Rosa de Viterbo', uf: '35' },
  { value: '3139', name: 'São Simão', uf: '35' },
  { value: '3140', name: 'Serra Azul', uf: '35' },
  { value: '3141', name: 'Serrana', uf: '35' },
  { value: '3142', name: 'Sertãozinho', uf: '35' },
  { value: '3143', name: 'Altinópolis', uf: '35' },
  { value: '3144', name: 'Batatais', uf: '35' },
  { value: '3145', name: 'Cajuru', uf: '35' },
  { value: '3146', name: 'Cássia dos Coqueiros', uf: '35' },
  { value: '3147', name: 'Santa Cruz da Esperança', uf: '35' },
  { value: '3148', name: 'Santo Antônio da Alegria', uf: '35' },
  { value: '3149', name: 'Andradina', uf: '35' },
  { value: '3150', name: 'Castilho', uf: '35' },
  { value: '3151', name: 'Guaraçaí', uf: '35' },
  { value: '3152', name: 'Ilha Solteira', uf: '35' },
  { value: '3153', name: 'Itapura', uf: '35' },
  { value: '3154', name: 'Mirandópolis', uf: '35' },
  { value: '3155', name: 'Murutinga do Sul', uf: '35' },
  { value: '3156', name: 'Nova Independência', uf: '35' },
  { value: '3157', name: 'Pereira Barreto', uf: '35' },
  { value: '3158', name: 'Sud Mennucci', uf: '35' },
  { value: '3159', name: 'Suzanápolis', uf: '35' },
  { value: '3160', name: 'Araçatuba', uf: '35' },
  { value: '3161', name: 'Bento de Abreu', uf: '35' },
  { value: '3162', name: 'Guararapes', uf: '35' },
  { value: '3163', name: 'Lavínia', uf: '35' },
  { value: '3164', name: 'Rubiácea', uf: '35' },
  { value: '3165', name: 'Santo Antônio do Aracanguá', uf: '35' },
  { value: '3166', name: 'Valparaíso', uf: '35' },
  { value: '3167', name: 'Alto Alegre', uf: '35' },
  { value: '3168', name: 'Seropédica', uf: '33' },
  { value: '3169', name: 'Belford Roxo', uf: '33' },
  { value: '3170', name: 'Duque de Caxias', uf: '33' },
  { value: '3171', name: 'Guapimirim', uf: '33' },
  { value: '3172', name: 'Itaboraí', uf: '33' },
  { value: '3173', name: 'Japeri', uf: '33' },
  { value: '3174', name: 'Magé', uf: '33' },
  { value: '3175', name: 'Maricá', uf: '33' },
  { value: '3176', name: 'Mesquita', uf: '33' },
  { value: '3177', name: 'Nilópolis', uf: '33' },
  { value: '3178', name: 'Niterói', uf: '33' },
  { value: '3179', name: 'Nova Iguaçu', uf: '33' },
  { value: '3180', name: 'Queimados', uf: '33' },
  { value: '3181', name: 'Rio de Janeiro', uf: '33' },
  { value: '3182', name: 'São Gonçalo', uf: '33' },
  { value: '3183', name: 'São João de Meriti', uf: '33' },
  { value: '3184', name: 'Tanguá', uf: '33' },
  { value: '3185', name: "Aparecida d'Oeste", uf: '35' },
  { value: '3186', name: 'Aspásia', uf: '35' },
  { value: '3187', name: 'Dirce Reis', uf: '35' },
  { value: '3188', name: 'Dolcinópolis', uf: '35' },
  { value: '3189', name: 'Jales', uf: '35' },
  { value: '3190', name: 'Marinópolis', uf: '35' },
  { value: '3191', name: 'Mesópolis', uf: '35' },
  { value: '3192', name: 'Nova Canaã Paulista', uf: '35' },
  { value: '3193', name: "Palmeira d'Oeste", uf: '35' },
  { value: '3194', name: 'Paranapuã', uf: '35' },
  { value: '3195', name: 'Pontalinda', uf: '35' },
  { value: '3196', name: 'Populina', uf: '35' },
  { value: '3197', name: 'Rubinéia', uf: '35' },
  { value: '3198', name: 'Santa Albertina', uf: '35' },
  { value: '3199', name: "Santa Clara d'Oeste", uf: '35' },
  { value: '3200', name: 'Santa Fé do Sul', uf: '35' },
  { value: '3201', name: 'Santana da Ponte Pensa', uf: '35' },
  { value: '3202', name: "Santa Rita d'Oeste", uf: '35' },
  { value: '3203', name: 'Santa Salete', uf: '35' },
  { value: '3204', name: 'São Francisco', uf: '35' },
  { value: '3205', name: 'Três Fronteiras', uf: '35' },
  { value: '3206', name: 'Urânia', uf: '35' },
  { value: '3207', name: 'Vitória Brasil', uf: '35' },
  { value: '3208', name: "Estrela d'Oeste", uf: '35' },
  { value: '3209', name: 'Fernandópolis', uf: '35' },
  { value: '3210', name: "Guarani d'Oeste", uf: '35' },
  { value: '3211', name: 'Indiaporã', uf: '35' },
  { value: '3212', name: 'Macedônia', uf: '35' },
  { value: '3213', name: 'Meridiano', uf: '35' },
  { value: '3214', name: 'Mira Estrela', uf: '35' },
  { value: '3215', name: 'Ouroeste', uf: '35' },
  { value: '3216', name: 'Pedranópolis', uf: '35' },
  { value: '3217', name: 'São João das Duas Pontes', uf: '35' },
  { value: '3218', name: 'Turmalina', uf: '35' },
  { value: '3219', name: 'Álvares Florence', uf: '35' },
  { value: '3220', name: 'Américo de Campos', uf: '35' },
  { value: '3221', name: 'Cardoso', uf: '35' },
  { value: '3222', name: 'Cosmorama', uf: '35' },
  { value: '3223', name: 'Parisi', uf: '35' },
  { value: '3224', name: 'Pontes Gestal', uf: '35' },
  { value: '3225', name: 'Riolândia', uf: '35' },
  { value: '3226', name: 'Valentim Gentil', uf: '35' },
  { value: '3227', name: 'Votuporanga', uf: '35' },
  { value: '3228', name: 'Adolfo', uf: '35' },
  { value: '3229', name: 'Altair', uf: '35' },
  { value: '3230', name: 'Bady Bassitt', uf: '35' },
  { value: '3231', name: 'Bálsamo', uf: '35' },
  { value: '3232', name: 'Cedral', uf: '35' },
  { value: '3233', name: 'Guapiaçu', uf: '35' },
  { value: '3234', name: 'Guaraci', uf: '35' },
  { value: '3235', name: 'Ibirá', uf: '35' },
  { value: '3236', name: 'Icém', uf: '35' },
  { value: '3237', name: 'Ipiguá', uf: '35' },
  { value: '3238', name: 'Jaci', uf: '35' },
  { value: '3239', name: 'José Bonifácio', uf: '35' },
  { value: '3240', name: 'Mendonça', uf: '35' },
  { value: '3241', name: 'Mirassol', uf: '35' },
  { value: '3242', name: 'Mirassolândia', uf: '35' },
  { value: '3243', name: 'Nova Aliança', uf: '35' },
  { value: '3244', name: 'Nova Granada', uf: '35' },
  { value: '3245', name: 'Olímpia', uf: '35' },
  { value: '3246', name: 'Onda Verde', uf: '35' },
  { value: '3247', name: 'Orindiúva', uf: '35' },
  { value: '3248', name: 'Palestina', uf: '35' },
  { value: '3249', name: 'Paulo de Faria', uf: '35' },
  { value: '3250', name: 'Planalto', uf: '35' },
  { value: '3251', name: 'Potirendaba', uf: '35' },
  { value: '3252', name: 'São José do Rio Preto', uf: '35' },
  { value: '3253', name: 'Tanabi', uf: '35' },
  { value: '3254', name: 'Ubarana', uf: '35' },
  { value: '3255', name: 'Uchoa', uf: '35' },
  { value: '3256', name: 'Zacarias', uf: '35' },
  { value: '3257', name: 'Ariranha', uf: '35' },
  { value: '3258', name: 'Cajobi', uf: '35' },
  { value: '3259', name: 'Catanduva', uf: '35' },
  { value: '3260', name: 'Catiguá', uf: '35' },
  { value: '3261', name: 'Cardoso Moreira', uf: '33' },
  { value: '3262', name: 'São Francisco de Itabapoana', uf: '33' },
  { value: '3263', name: 'São Fidélis', uf: '33' },
  { value: '3264', name: 'São João da Barra', uf: '33' },
  { value: '3265', name: 'Carapebus', uf: '33' },
  { value: '3266', name: 'Conceição de Macabu', uf: '33' },
  { value: '3267', name: 'Macaé', uf: '33' },
  { value: '3268', name: 'Quissamã', uf: '33' },
  { value: '3269', name: 'Areal', uf: '33' },
  { value: '3270', name: 'Comendador Levy Gasparian', uf: '33' },
  { value: '3271', name: 'Paraíba do Sul', uf: '33' },
  { value: '3272', name: 'Sapucaia', uf: '33' },
  { value: '3273', name: 'Três Rios', uf: '33' },
  { value: '3274', name: 'Cantagalo', uf: '33' },
  { value: '3275', name: 'Carmo', uf: '33' },
  { value: '3276', name: 'Cordeiro', uf: '33' },
  { value: '3277', name: 'Macuco', uf: '33' },
  { value: '3278', name: 'Bom Jardim', uf: '33' },
  { value: '3279', name: 'Duas Barras', uf: '33' },
  { value: '3280', name: 'Nova Friburgo', uf: '33' },
  { value: '3281', name: 'Sumidouro', uf: '33' },
  { value: '3282', name: 'Santa Maria Madalena', uf: '33' },
  { value: '3283', name: 'São Sebastião do Alto', uf: '33' },
  { value: '3284', name: 'Trajano de Morais', uf: '33' },
  { value: '3285', name: 'Casimiro de Abreu', uf: '33' },
  { value: '3286', name: 'Rio das Ostras', uf: '33' },
  { value: '3287', name: 'Silva Jardim', uf: '33' },
  { value: '3288', name: 'Araruama', uf: '33' },
  { value: '3289', name: 'Armação dos Búzios', uf: '33' },
  { value: '3290', name: 'Arraial do Cabo', uf: '33' },
  { value: '3291', name: 'Cabo Frio', uf: '33' },
  { value: '3292', name: 'Iguaba Grande', uf: '33' },
  { value: '3293', name: 'São Pedro da Aldeia', uf: '33' },
  { value: '3294', name: 'Saquarema', uf: '33' },
  { value: '3295', name: 'Barra Mansa', uf: '33' },
  { value: '3296', name: 'Itatiaia', uf: '33' },
  { value: '3297', name: 'Pinheiral', uf: '33' },
  { value: '3298', name: 'Piraí', uf: '33' },
  { value: '3299', name: 'Porto Real', uf: '33' },
  { value: '3300', name: 'Quatis', uf: '33' },
  { value: '3301', name: 'Resende', uf: '33' },
  { value: '3302', name: 'Rio Claro', uf: '33' },
  { value: '3303', name: 'Volta Redonda', uf: '33' },
  { value: '3304', name: 'Barra do Piraí', uf: '33' },
  { value: '3305', name: 'Rio das Flores', uf: '33' },
  { value: '3306', name: 'Valença', uf: '33' },
  { value: '3307', name: 'Angra dos Reis', uf: '33' },
  { value: '3308', name: 'Parati', uf: '33' },
  { value: '3309', name: 'Engenheiro Paulo de Frontin', uf: '33' },
  { value: '3310', name: 'Mendes', uf: '33' },
  { value: '3311', name: 'Miguel Pereira', uf: '33' },
  { value: '3312', name: 'Paracambi', uf: '33' },
  { value: '3313', name: 'Paty do Alferes', uf: '33' },
  { value: '3314', name: 'Vassouras', uf: '33' },
  { value: '3315', name: 'Petrópolis', uf: '33' },
  { value: '3316', name: 'São José do Vale do Rio Preto', uf: '33' },
  { value: '3317', name: 'Teresópolis', uf: '33' },
  { value: '3318', name: 'Cachoeiras de Macacu', uf: '33' },
  { value: '3319', name: 'Rio Bonito', uf: '33' },
  { value: '3320', name: 'Itaguaí', uf: '33' },
  { value: '3321', name: 'Mangaratiba', uf: '33' },
  { value: '3322', name: 'Afonso Cláudio', uf: '32' },
  { value: '3323', name: 'Brejetuba', uf: '32' },
  { value: '3324', name: 'Conceição do Castelo', uf: '32' },
  { value: '3325', name: 'Domingos Martins', uf: '32' },
  { value: '3326', name: 'Laranja da Terra', uf: '32' },
  { value: '3327', name: 'Marechal Floriano', uf: '32' },
  { value: '3328', name: 'Venda Nova do Imigrante', uf: '32' },
  { value: '3329', name: 'Itaguaçu', uf: '32' },
  { value: '3330', name: 'Itarana', uf: '32' },
  { value: '3331', name: 'Santa Leopoldina', uf: '32' },
  { value: '3332', name: 'Santa Maria de Jetibá', uf: '32' },
  { value: '3333', name: 'Santa Teresa', uf: '32' },
  { value: '3334', name: 'São Roque do Canaã', uf: '32' },
  { value: '3335', name: 'Cariacica', uf: '32' },
  { value: '3336', name: 'Serra', uf: '32' },
  { value: '3337', name: 'Viana', uf: '32' },
  { value: '3338', name: 'Vila Velha', uf: '32' },
  { value: '3339', name: 'Vitória', uf: '32' },
  { value: '3340', name: 'Alfredo Chaves', uf: '32' },
  { value: '3341', name: 'Anchieta', uf: '32' },
  { value: '3342', name: 'Guarapari', uf: '32' },
  { value: '3343', name: 'Iconha', uf: '32' },
  { value: '3344', name: 'Piúma', uf: '32' },
  { value: '3345', name: 'Rio Novo do Sul', uf: '32' },
  { value: '3346', name: 'Alegre', uf: '32' },
  { value: '3347', name: 'Divino de São Lourenço', uf: '32' },
  { value: '3348', name: 'Dores do Rio Preto', uf: '32' },
  { value: '3349', name: 'Guaçuí', uf: '32' },
  { value: '3350', name: 'Ibatiba', uf: '32' },
  { value: '3351', name: 'Ibitirama', uf: '32' },
  { value: '3352', name: 'Irupi', uf: '32' },
  { value: '3353', name: 'Iúna', uf: '32' },
  { value: '3354', name: 'Muniz Freire', uf: '32' },
  { value: '3355', name: 'Apiacá', uf: '32' },
  { value: '3356', name: 'Atilio Vivacqua', uf: '32' },
  { value: '3357', name: 'Bom Jesus do Norte', uf: '32' },
  { value: '3358', name: 'Cachoeiro de Itapemirim', uf: '32' },
  { value: '3359', name: 'Castelo', uf: '32' },
  { value: '3360', name: 'Jerônimo Monteiro', uf: '32' },
  { value: '3361', name: 'Mimoso do Sul', uf: '32' },
  { value: '3362', name: 'Muqui', uf: '32' },
  { value: '3363', name: 'São José do Calçado', uf: '32' },
  { value: '3364', name: 'Vargem Alta', uf: '32' },
  { value: '3365', name: 'Itapemirim', uf: '32' },
  { value: '3366', name: 'Marataízes', uf: '32' },
  { value: '3367', name: 'Presidente Kennedy', uf: '32' },
  { value: '3368', name: 'Bom Jesus do Itabapoana', uf: '33' },
  { value: '3369', name: 'Italva', uf: '33' },
  { value: '3370', name: 'Itaperuna', uf: '33' },
  { value: '3371', name: 'Laje do Muriaé', uf: '33' },
  { value: '3372', name: 'Natividade', uf: '33' },
  { value: '3373', name: 'Porciúncula', uf: '33' },
  { value: '3374', name: 'Varre-Sai', uf: '33' },
  { value: '3375', name: 'Aperibé', uf: '33' },
  { value: '3376', name: 'Cambuci', uf: '33' },
  { value: '3377', name: 'Itaocara', uf: '33' },
  { value: '3378', name: 'Miracema', uf: '33' },
  { value: '3379', name: 'Santo Antônio de Pádua', uf: '33' },
  { value: '3380', name: 'São José de Ubá', uf: '33' },
  { value: '3381', name: 'Campos dos Goytacazes', uf: '33' },
  { value: '3382', name: 'Belmiro Braga', uf: '31' },
  { value: '3383', name: 'Bias Fortes', uf: '31' },
  { value: '3384', name: 'Bicas', uf: '31' },
  { value: '3385', name: 'Chácara', uf: '31' },
  { value: '3386', name: 'Chiador', uf: '31' },
  { value: '3387', name: 'Coronel Pacheco', uf: '31' },
  { value: '3388', name: 'Descoberto', uf: '31' },
  { value: '3389', name: 'Ewbank da Câmara', uf: '31' },
  { value: '3390', name: 'Goianá', uf: '31' },
  { value: '3391', name: 'Guarará', uf: '31' },
  { value: '3392', name: 'Juiz de Fora', uf: '31' },
  { value: '3393', name: 'Lima Duarte', uf: '31' },
  { value: '3394', name: 'Mar de Espanha', uf: '31' },
  { value: '3395', name: 'Maripá de Minas', uf: '31' },
  { value: '3396', name: 'Matias Barbosa', uf: '31' },
  { value: '3397', name: 'Olaria', uf: '31' },
  { value: '3398', name: 'Oliveira Fortes', uf: '31' },
  { value: '3399', name: 'Paiva', uf: '31' },
  { value: '3400', name: 'Pedro Teixeira', uf: '31' },
  { value: '3401', name: 'Pequeri', uf: '31' },
  { value: '3402', name: 'Piau', uf: '31' },
  { value: '3403', name: 'Rio Novo', uf: '31' },
  { value: '3404', name: 'Rio Preto', uf: '31' },
  { value: '3405', name: 'Rochedo de Minas', uf: '31' },
  { value: '3406', name: 'Santa Bárbara do Monte Verde', uf: '31' },
  { value: '3407', name: 'Santana do Deserto', uf: '31' },
  { value: '3408', name: 'Santa Rita de Jacutinga', uf: '31' },
  { value: '3409', name: 'Santa Rita de Ibitipoca', uf: '31' },
  { value: '3410', name: 'Santos Dumont', uf: '31' },
  { value: '3411', name: 'São João Nepomuceno', uf: '31' },
  { value: '3412', name: 'Senador Cortes', uf: '31' },
  { value: '3413', name: 'Simão Pereira', uf: '31' },
  { value: '3414', name: 'Além Paraíba', uf: '31' },
  { value: '3415', name: 'Argirita', uf: '31' },
  { value: '3416', name: 'Cataguases', uf: '31' },
  { value: '3417', name: 'Dona Euzébia', uf: '31' },
  { value: '3418', name: 'Estrela Dalva', uf: '31' },
  { value: '3419', name: 'Itamarati de Minas', uf: '31' },
  { value: '3420', name: 'Laranjal', uf: '31' },
  { value: '3421', name: 'Leopoldina', uf: '31' },
  { value: '3422', name: 'Palma', uf: '31' },
  { value: '3423', name: 'Pirapetinga', uf: '31' },
  { value: '3424', name: 'Recreio', uf: '31' },
  { value: '3425', name: 'Santana de Cataguases', uf: '31' },
  { value: '3426', name: 'Santo Antônio do Aventureiro', uf: '31' },
  { value: '3427', name: 'Volta Grande', uf: '31' },
  { value: '3428', name: 'Água Doce do Norte', uf: '32' },
  { value: '3429', name: 'Barra de São Francisco', uf: '32' },
  { value: '3430', name: 'Ecoporanga', uf: '32' },
  { value: '3431', name: 'Mantenópolis', uf: '32' },
  { value: '3432', name: 'Águia Branca', uf: '32' },
  { value: '3433', name: 'Boa Esperança', uf: '32' },
  { value: '3434', name: 'Nova Venécia', uf: '32' },
  { value: '3435', name: 'São Gabriel da Palha', uf: '32' },
  { value: '3436', name: 'Vila Pavão', uf: '32' },
  { value: '3437', name: 'Vila Valério', uf: '32' },
  { value: '3438', name: 'Alto Rio Novo', uf: '32' },
  { value: '3439', name: 'Baixo Guandu', uf: '32' },
  { value: '3440', name: 'Colatina', uf: '32' },
  { value: '3441', name: 'Governador Lindenberg', uf: '32' },
  { value: '3442', name: 'Marilândia', uf: '32' },
  { value: '3443', name: 'Pancas', uf: '32' },
  { value: '3444', name: 'São Domingos do Norte', uf: '32' },
  { value: '3445', name: 'Montanha', uf: '32' },
  { value: '3446', name: 'Mucurici', uf: '32' },
  { value: '3447', name: 'Pinheiros', uf: '32' },
  { value: '3448', name: 'Ponto Belo', uf: '32' },
  { value: '3449', name: 'Conceição da Barra', uf: '32' },
  { value: '3450', name: 'Jaguaré', uf: '32' },
  { value: '3451', name: 'Pedro Canário', uf: '32' },
  { value: '3452', name: 'São Mateus', uf: '32' },
  { value: '3453', name: 'Aracruz', uf: '32' },
  { value: '3454', name: 'Fundão', uf: '32' },
  { value: '3455', name: 'Ibiraçu', uf: '32' },
  { value: '3456', name: 'João Neiva', uf: '32' },
  { value: '3457', name: 'Linhares', uf: '32' },
  { value: '3458', name: 'Rio Bananal', uf: '32' },
  { value: '3459', name: 'Sooretama', uf: '32' },
  { value: '3460', name: 'Ibertioga', uf: '31' },
  { value: '3461', name: 'Ressaquinha', uf: '31' },
  { value: '3462', name: 'Santa Bárbara do Tugúrio', uf: '31' },
  { value: '3463', name: 'Senhora dos Remédios', uf: '31' },
  { value: '3464', name: 'Acaiaca', uf: '31' },
  { value: '3465', name: 'Barra Longa', uf: '31' },
  { value: '3466', name: 'Dom Silvério', uf: '31' },
  { value: '3467', name: 'Guaraciaba', uf: '31' },
  { value: '3468', name: 'Jequeri', uf: '31' },
  { value: '3469', name: 'Oratórios', uf: '31' },
  { value: '3470', name: 'Piedade de Ponte Nova', uf: '31' },
  { value: '3471', name: 'Ponte Nova', uf: '31' },
  { value: '3472', name: 'Raul Soares', uf: '31' },
  { value: '3473', name: 'Rio Casca', uf: '31' },
  { value: '3474', name: 'Rio Doce', uf: '31' },
  { value: '3475', name: 'Santa Cruz do Escalvado', uf: '31' },
  { value: '3476', name: 'Santo Antônio do Grama', uf: '31' },
  { value: '3477', name: 'São Pedro dos Ferros', uf: '31' },
  { value: '3478', name: 'Sem-Peixe', uf: '31' },
  { value: '3479', name: 'Sericita', uf: '31' },
  { value: '3480', name: 'Urucânia', uf: '31' },
  { value: '3481', name: 'Vermelho Novo', uf: '31' },
  { value: '3482', name: 'Abre Campo', uf: '31' },
  { value: '3483', name: 'Alto Caparaó', uf: '31' },
  { value: '3484', name: 'Caparaó', uf: '31' },
  { value: '3485', name: 'Caputira', uf: '31' },
  { value: '3486', name: 'Chalé', uf: '31' },
  { value: '3487', name: 'Durandé', uf: '31' },
  { value: '3488', name: 'Lajinha', uf: '31' },
  { value: '3489', name: 'Luisburgo', uf: '31' },
  { value: '3490', name: 'Manhuaçu', uf: '31' },
  { value: '3491', name: 'Manhumirim', uf: '31' },
  { value: '3492', name: 'Martins Soares', uf: '31' },
  { value: '3493', name: 'Matipó', uf: '31' },
  { value: '3494', name: 'Pedra Bonita', uf: '31' },
  { value: '3495', name: 'Alto Jequitibá', uf: '31' },
  { value: '3496', name: 'Reduto', uf: '31' },
  { value: '3497', name: 'Santa Margarida', uf: '31' },
  { value: '3498', name: 'Santana do Manhuaçu', uf: '31' },
  { value: '3499', name: 'São João do Manhuaçu', uf: '31' },
  { value: '3500', name: 'São José do Mantimento', uf: '31' },
  { value: '3501', name: 'Simonésia', uf: '31' },
  { value: '3502', name: 'Alto Rio Doce', uf: '31' },
  { value: '3503', name: 'Amparo do Serra', uf: '31' },
  { value: '3504', name: 'Araponga', uf: '31' },
  { value: '3505', name: 'Brás Pires', uf: '31' },
  { value: '3506', name: 'Cajuri', uf: '31' },
  { value: '3507', name: 'Canaã', uf: '31' },
  { value: '3508', name: 'Cipotânea', uf: '31' },
  { value: '3509', name: 'Coimbra', uf: '31' },
  { value: '3510', name: 'Ervália', uf: '31' },
  { value: '3511', name: 'Lamim', uf: '31' },
  { value: '3512', name: 'Paula Cândido', uf: '31' },
  { value: '3513', name: 'Pedra do Anta', uf: '31' },
  { value: '3514', name: 'Piranga', uf: '31' },
  { value: '3515', name: 'Porto Firme', uf: '31' },
  { value: '3516', name: 'Presidente Bernardes', uf: '31' },
  { value: '3517', name: 'Rio Espera', uf: '31' },
  { value: '3518', name: 'São Miguel do Anta', uf: '31' },
  { value: '3519', name: 'Senhora de Oliveira', uf: '31' },
  { value: '3520', name: 'Teixeiras', uf: '31' },
  { value: '3521', name: 'Viçosa', uf: '31' },
  { value: '3522', name: 'Antônio Prado de Minas', uf: '31' },
  { value: '3523', name: 'Barão de Monte Alto', uf: '31' },
  { value: '3524', name: 'Caiana', uf: '31' },
  { value: '3525', name: 'Carangola', uf: '31' },
  { value: '3526', name: 'Divino', uf: '31' },
  { value: '3527', name: 'Espera Feliz', uf: '31' },
  { value: '3528', name: 'Eugenópolis', uf: '31' },
  { value: '3529', name: 'Faria Lemos', uf: '31' },
  { value: '3530', name: 'Fervedouro', uf: '31' },
  { value: '3531', name: 'Miradouro', uf: '31' },
  { value: '3532', name: 'Miraí', uf: '31' },
  { value: '3533', name: 'Muriaé', uf: '31' },
  { value: '3534', name: 'Orizânia', uf: '31' },
  { value: '3535', name: 'Patrocínio do Muriaé', uf: '31' },
  { value: '3536', name: 'Pedra Dourada', uf: '31' },
  { value: '3537', name: 'Rosário da Limeira', uf: '31' },
  { value: '3538', name: 'São Francisco do Glória', uf: '31' },
  { value: '3539', name: 'São Sebastião da Vargem Alegre', uf: '31' },
  { value: '3540', name: 'Tombos', uf: '31' },
  { value: '3541', name: 'Vieiras', uf: '31' },
  { value: '3542', name: 'Astolfo Dutra', uf: '31' },
  { value: '3543', name: 'Divinésia', uf: '31' },
  { value: '3544', name: 'Dores do Turvo', uf: '31' },
  { value: '3545', name: 'Guarani', uf: '31' },
  { value: '3546', name: 'Guidoval', uf: '31' },
  { value: '3547', name: 'Guiricema', uf: '31' },
  { value: '3548', name: 'Mercês', uf: '31' },
  { value: '3549', name: 'Piraúba', uf: '31' },
  { value: '3550', name: 'Rio Pomba', uf: '31' },
  { value: '3551', name: 'Rodeiro', uf: '31' },
  { value: '3552', name: 'São Geraldo', uf: '31' },
  { value: '3553', name: 'Senador Firmino', uf: '31' },
  { value: '3554', name: 'Silveirânia', uf: '31' },
  { value: '3555', name: 'Tabuleiro', uf: '31' },
  { value: '3556', name: 'Tocantins', uf: '31' },
  { value: '3557', name: 'Ubá', uf: '31' },
  { value: '3558', name: 'Visconde do Rio Branco', uf: '31' },
  { value: '3559', name: 'Aracitaba', uf: '31' },
  { value: '3560', name: 'Ouro Fino', uf: '31' },
  { value: '3561', name: 'Poços de Caldas', uf: '31' },
  { value: '3562', name: 'Santa Rita de Caldas', uf: '31' },
  { value: '3563', name: 'Bom Repouso', uf: '31' },
  { value: '3564', name: 'Borda da Mata', uf: '31' },
  { value: '3565', name: 'Bueno Brandão', uf: '31' },
  { value: '3566', name: 'Camanducaia', uf: '31' },
  { value: '3567', name: 'Cambuí', uf: '31' },
  { value: '3568', name: 'Congonhal', uf: '31' },
  { value: '3569', name: 'Córrego do Bom Jesus', uf: '31' },
  { value: '3570', name: 'Espírito Santo do Dourado', uf: '31' },
  { value: '3571', name: 'Estiva', uf: '31' },
  { value: '3572', name: 'Extrema', uf: '31' },
  { value: '3573', name: 'Gonçalves', uf: '31' },
  { value: '3574', name: 'Ipuiúna', uf: '31' },
  { value: '3575', name: 'Itapeva', uf: '31' },
  { value: '3576', name: 'Munhoz', uf: '31' },
  { value: '3577', name: 'Pouso Alegre', uf: '31' },
  { value: '3578', name: 'Sapucaí-Mirim', uf: '31' },
  { value: '3579', name: 'Senador Amaral', uf: '31' },
  { value: '3580', name: 'Senador José Bento', uf: '31' },
  { value: '3581', name: 'Tocos do Moji', uf: '31' },
  { value: '3582', name: 'Toledo', uf: '31' },
  { value: '3583', name: 'Cachoeira de Minas', uf: '31' },
  { value: '3584', name: 'Careaçu', uf: '31' },
  { value: '3585', name: 'Conceição das Pedras', uf: '31' },
  { value: '3586', name: 'Conceição dos Ouros', uf: '31' },
  { value: '3587', name: 'Cordislândia', uf: '31' },
  { value: '3588', name: 'Heliodora', uf: '31' },
  { value: '3589', name: 'Natércia', uf: '31' },
  { value: '3590', name: 'Pedralva', uf: '31' },
  { value: '3591', name: 'Santa Rita do Sapucaí', uf: '31' },
  { value: '3592', name: 'São Gonçalo do Sapucaí', uf: '31' },
  { value: '3593', name: 'São João da Mata', uf: '31' },
  { value: '3594', name: 'São José do Alegre', uf: '31' },
  { value: '3595', name: 'São Sebastião da Bela Vista', uf: '31' },
  { value: '3596', name: 'Silvianópolis', uf: '31' },
  { value: '3597', name: 'Turvolândia', uf: '31' },
  { value: '3598', name: 'Alagoa', uf: '31' },
  { value: '3599', name: 'Baependi', uf: '31' },
  { value: '3600', name: 'Cambuquira', uf: '31' },
  { value: '3601', name: 'Carmo de Minas', uf: '31' },
  { value: '3602', name: 'Caxambu', uf: '31' },
  { value: '3603', name: 'Conceição do Rio Verde', uf: '31' },
  { value: '3604', name: 'Itamonte', uf: '31' },
  { value: '3605', name: 'Itanhandu', uf: '31' },
  { value: '3606', name: 'Jesuânia', uf: '31' },
  { value: '3607', name: 'Lambari', uf: '31' },
  { value: '3608', name: 'Olímpio Noronha', uf: '31' },
  { value: '3609', name: 'Passa Quatro', uf: '31' },
  { value: '3610', name: 'Pouso Alto', uf: '31' },
  { value: '3611', name: 'São Lourenço', uf: '31' },
  { value: '3612', name: 'São Sebastião do Rio Verde', uf: '31' },
  { value: '3613', name: 'Soledade de Minas', uf: '31' },
  { value: '3614', name: 'Aiuruoca', uf: '31' },
  { value: '3615', name: 'Andrelândia', uf: '31' },
  { value: '3616', name: 'Arantina', uf: '31' },
  { value: '3617', name: 'Bocaina de Minas', uf: '31' },
  { value: '3618', name: 'Bom Jardim de Minas', uf: '31' },
  { value: '3619', name: 'Carvalhos', uf: '31' },
  { value: '3620', name: 'Cruzília', uf: '31' },
  { value: '3621', name: 'Liberdade', uf: '31' },
  { value: '3622', name: 'Minduri', uf: '31' },
  { value: '3623', name: 'Passa Vinte', uf: '31' },
  { value: '3624', name: 'São Vicente de Minas', uf: '31' },
  { value: '3625', name: 'Seritinga', uf: '31' },
  { value: '3626', name: 'Serranos', uf: '31' },
  { value: '3627', name: 'Brazópolis', uf: '31' },
  { value: '3628', name: 'Consolação', uf: '31' },
  { value: '3629', name: 'Cristina', uf: '31' },
  { value: '3630', name: 'Delfim Moreira', uf: '31' },
  { value: '3631', name: 'Dom Viçoso', uf: '31' },
  { value: '3632', name: 'Itajubá', uf: '31' },
  { value: '3633', name: 'Maria da Fé', uf: '31' },
  { value: '3634', name: 'Marmelópolis', uf: '31' },
  { value: '3635', name: 'Paraisópolis', uf: '31' },
  { value: '3636', name: 'Piranguçu', uf: '31' },
  { value: '3637', name: 'Piranguinho', uf: '31' },
  { value: '3638', name: 'Virgínia', uf: '31' },
  { value: '3639', name: 'Wenceslau Braz', uf: '31' },
  { value: '3640', name: 'Carrancas', uf: '31' },
  { value: '3641', name: 'Ijaci', uf: '31' },
  { value: '3642', name: 'Ingaí', uf: '31' },
  { value: '3643', name: 'Itumirim', uf: '31' },
  { value: '3644', name: 'Itutinga', uf: '31' },
  { value: '3645', name: 'Lavras', uf: '31' },
  { value: '3646', name: 'Luminárias', uf: '31' },
  { value: '3647', name: 'Nepomuceno', uf: '31' },
  { value: '3648', name: 'Ribeirão Vermelho', uf: '31' },
  { value: '3649', name: 'Conceição da Barra de Minas', uf: '31' },
  { value: '3650', name: 'Coronel Xavier Chaves', uf: '31' },
  { value: '3651', name: 'Dores de Campos', uf: '31' },
  { value: '3652', name: 'Lagoa Dourada', uf: '31' },
  { value: '3653', name: 'Madre de Deus de Minas', uf: '31' },
  { value: '3654', name: 'Nazareno', uf: '31' },
  { value: '3655', name: 'Piedade do Rio Grande', uf: '31' },
  { value: '3656', name: 'Prados', uf: '31' },
  { value: '3657', name: 'Resende Costa', uf: '31' },
  { value: '3658', name: 'Ritápolis', uf: '31' },
  { value: '3659', name: 'Santa Cruz de Minas', uf: '31' },
  { value: '3660', name: 'Santana do Garambéu', uf: '31' },
  { value: '3661', name: 'São João del Rei', uf: '31' },
  { value: '3662', name: 'São Tiago', uf: '31' },
  { value: '3663', name: 'Tiradentes', uf: '31' },
  { value: '3664', name: 'Alfredo Vasconcelos', uf: '31' },
  { value: '3665', name: 'Antônio Carlos', uf: '31' },
  { value: '3666', name: 'Barbacena', uf: '31' },
  { value: '3667', name: 'Barroso', uf: '31' },
  { value: '3668', name: 'Capela Nova', uf: '31' },
  { value: '3669', name: 'Caranaíba', uf: '31' },
  { value: '3670', name: 'Carandaí', uf: '31' },
  { value: '3671', name: 'Desterro do Melo', uf: '31' },
  { value: '3672', name: 'Resplendor', uf: '31' },
  { value: '3673', name: 'Santa Rita do Itueto', uf: '31' },
  { value: '3674', name: 'Taparuba', uf: '31' },
  { value: '3675', name: 'Bambuí', uf: '31' },
  { value: '3676', name: 'Córrego Danta', uf: '31' },
  { value: '3677', name: 'Doresópolis', uf: '31' },
  { value: '3678', name: 'Iguatama', uf: '31' },
  { value: '3679', name: 'Medeiros', uf: '31' },
  { value: '3680', name: 'Piumhi', uf: '31' },
  { value: '3681', name: 'São Roque de Minas', uf: '31' },
  { value: '3682', name: 'Tapiraí', uf: '31' },
  { value: '3683', name: 'Vargem Bonita', uf: '31' },
  { value: '3684', name: 'Carmo do Cajuru', uf: '31' },
  { value: '3685', name: 'Cláudio', uf: '31' },
  { value: '3686', name: 'Conceição do Pará', uf: '31' },
  { value: '3687', name: 'Divinópolis', uf: '31' },
  { value: '3688', name: 'Igaratinga', uf: '31' },
  { value: '3689', name: 'Itaúna', uf: '31' },
  { value: '3690', name: 'Nova Serrana', uf: '31' },
  { value: '3691', name: 'Perdigão', uf: '31' },
  { value: '3692', name: 'Santo Antônio do Monte', uf: '31' },
  { value: '3693', name: 'São Gonçalo do Pará', uf: '31' },
  { value: '3694', name: 'São Sebastião do Oeste', uf: '31' },
  { value: '3695', name: 'Arcos', uf: '31' },
  { value: '3696', name: 'Camacho', uf: '31' },
  { value: '3697', name: 'Córrego Fundo', uf: '31' },
  { value: '3698', name: 'Formiga', uf: '31' },
  { value: '3699', name: 'Itapecerica', uf: '31' },
  { value: '3700', name: 'Pains', uf: '31' },
  { value: '3701', name: 'Pedra do Indaiá', uf: '31' },
  { value: '3702', name: 'Pimenta', uf: '31' },
  { value: '3703', name: 'Aguanil', uf: '31' },
  { value: '3704', name: 'Campo Belo', uf: '31' },
  { value: '3705', name: 'Cana Verde', uf: '31' },
  { value: '3706', name: 'Candeias', uf: '31' },
  { value: '3707', name: 'Cristais', uf: '31' },
  { value: '3708', name: 'Perdões', uf: '31' },
  { value: '3709', name: 'Santana do Jacaré', uf: '31' },
  { value: '3710', name: 'Bom Sucesso', uf: '31' },
  { value: '3711', name: 'Carmo da Mata', uf: '31' },
  { value: '3712', name: 'Carmópolis de Minas', uf: '31' },
  { value: '3713', name: 'Ibituruna', uf: '31' },
  { value: '3714', name: 'Oliveira', uf: '31' },
  { value: '3715', name: 'Passa Tempo', uf: '31' },
  { value: '3716', name: 'Piracema', uf: '31' },
  { value: '3717', name: 'Santo Antônio do Amparo', uf: '31' },
  { value: '3718', name: 'São Francisco de Paula', uf: '31' },
  { value: '3719', name: 'Alpinópolis', uf: '31' },
  { value: '3720', name: 'Bom Jesus da Penha', uf: '31' },
  { value: '3721', name: 'Capetinga', uf: '31' },
  { value: '3722', name: 'Capitólio', uf: '31' },
  { value: '3723', name: 'Cássia', uf: '31' },
  { value: '3724', name: 'Claraval', uf: '31' },
  { value: '3725', name: 'Delfinópolis', uf: '31' },
  { value: '3726', name: 'Fortaleza de Minas', uf: '31' },
  { value: '3727', name: 'Ibiraci', uf: '31' },
  { value: '3728', name: 'Itaú de Minas', uf: '31' },
  { value: '3729', name: 'Passos', uf: '31' },
  { value: '3730', name: 'Pratápolis', uf: '31' },
  { value: '3731', name: 'São João Batista do Glória', uf: '31' },
  { value: '3732', name: 'São José da Barra', uf: '31' },
  { value: '3733', name: 'Arceburgo', uf: '31' },
  { value: '3734', name: 'Cabo Verde', uf: '31' },
  { value: '3735', name: 'Guaranésia', uf: '31' },
  { value: '3736', name: 'Guaxupé', uf: '31' },
  { value: '3737', name: 'Itamogi', uf: '31' },
  { value: '3738', name: 'Jacuí', uf: '31' },
  { value: '3739', name: 'Juruaia', uf: '31' },
  { value: '3740', name: 'Monte Belo', uf: '31' },
  { value: '3741', name: 'Monte Santo de Minas', uf: '31' },
  { value: '3742', name: 'Muzambinho', uf: '31' },
  { value: '3743', name: 'Nova Resende', uf: '31' },
  { value: '3744', name: 'São Pedro da União', uf: '31' },
  { value: '3745', name: 'São Sebastião do Paraíso', uf: '31' },
  { value: '3746', name: 'São Tomás de Aquino', uf: '31' },
  { value: '3747', name: 'Alfenas', uf: '31' },
  { value: '3748', name: 'Alterosa', uf: '31' },
  { value: '3749', name: 'Areado', uf: '31' },
  { value: '3750', name: 'Carmo do Rio Claro', uf: '31' },
  { value: '3751', name: 'Carvalhópolis', uf: '31' },
  { value: '3752', name: 'Conceição da Aparecida', uf: '31' },
  { value: '3753', name: 'Divisa Nova', uf: '31' },
  { value: '3754', name: 'Fama', uf: '31' },
  { value: '3755', name: 'Machado', uf: '31' },
  { value: '3756', name: 'Paraguaçu', uf: '31' },
  { value: '3757', name: 'Poço Fundo', uf: '31' },
  { value: '3758', name: 'Serrania', uf: '31' },
  { value: '3759', name: 'Boa Esperança', uf: '31' },
  { value: '3760', name: 'Campanha', uf: '31' },
  { value: '3761', name: 'Campo do Meio', uf: '31' },
  { value: '3762', name: 'Campos Gerais', uf: '31' },
  { value: '3763', name: 'Carmo da Cachoeira', uf: '31' },
  { value: '3764', name: 'Coqueiral', uf: '31' },
  { value: '3765', name: 'Elói Mendes', uf: '31' },
  { value: '3766', name: 'Guapé', uf: '31' },
  { value: '3767', name: 'Ilicínea', uf: '31' },
  { value: '3768', name: 'Monsenhor Paulo', uf: '31' },
  { value: '3769', name: 'Santana da Vargem', uf: '31' },
  { value: '3770', name: 'São Bento Abade', uf: '31' },
  { value: '3771', name: 'São Thomé das Letras', uf: '31' },
  { value: '3772', name: 'Três Corações', uf: '31' },
  { value: '3773', name: 'Três Pontas', uf: '31' },
  { value: '3774', name: 'Varginha', uf: '31' },
  { value: '3775', name: 'Albertina', uf: '31' },
  { value: '3776', name: 'Andradas', uf: '31' },
  { value: '3777', name: 'Bandeira do Sul', uf: '31' },
  { value: '3778', name: 'Botelhos', uf: '31' },
  { value: '3779', name: 'Caldas', uf: '31' },
  { value: '3780', name: 'Campestre', uf: '31' },
  { value: '3781', name: 'Ibitiúra de Minas', uf: '31' },
  { value: '3782', name: 'Inconfidentes', uf: '31' },
  { value: '3783', name: 'Jacutinga', uf: '31' },
  { value: '3784', name: 'Monte Sião', uf: '31' },
  { value: '3785', name: 'Santa Efigênia de Minas', uf: '31' },
  { value: '3786', name: 'São João Evangelista', uf: '31' },
  { value: '3787', name: 'Sardoá', uf: '31' },
  { value: '3788', name: 'Senhora do Porto', uf: '31' },
  { value: '3789', name: 'Virginópolis', uf: '31' },
  { value: '3790', name: 'Água Boa', uf: '31' },
  { value: '3791', name: 'Cantagalo', uf: '31' },
  { value: '3792', name: 'Frei Lagonegro', uf: '31' },
  { value: '3793', name: 'José Raydan', uf: '31' },
  { value: '3794', name: 'Peçanha', uf: '31' },
  { value: '3795', name: 'Santa Maria do Suaçuí', uf: '31' },
  { value: '3796', name: 'São José do Jacuri', uf: '31' },
  { value: '3797', name: 'São Pedro do Suaçuí', uf: '31' },
  { value: '3798', name: 'São Sebastião do Maranhão', uf: '31' },
  { value: '3799', name: 'Alpercata', uf: '31' },
  { value: '3800', name: 'Campanário', uf: '31' },
  { value: '3801', name: 'Capitão Andrade', uf: '31' },
  { value: '3802', name: 'Coroaci', uf: '31' },
  { value: '3803', name: 'Divino das Laranjeiras', uf: '31' },
  { value: '3804', name: 'Engenheiro Caldas', uf: '31' },
  { value: '3805', name: 'Fernandes Tourinho', uf: '31' },
  { value: '3806', name: 'Frei Inocêncio', uf: '31' },
  { value: '3807', name: 'Galiléia', uf: '31' },
  { value: '3808', name: 'Governador Valadares', uf: '31' },
  { value: '3809', name: 'Itambacuri', uf: '31' },
  { value: '3810', name: 'Itanhomi', uf: '31' },
  { value: '3811', name: 'Jampruca', uf: '31' },
  { value: '3812', name: 'Marilac', uf: '31' },
  { value: '3813', name: 'Nacip Raydan', uf: '31' },
  { value: '3814', name: 'Nova Módica', uf: '31' },
  { value: '3815', name: 'Pescador', uf: '31' },
  { value: '3816', name: 'São Geraldo da Piedade', uf: '31' },
  { value: '3817', name: 'São Geraldo do Baixio', uf: '31' },
  { value: '3818', name: 'São José da Safira', uf: '31' },
  { value: '3819', name: 'São José do Divino', uf: '31' },
  { value: '3820', name: 'Sobrália', uf: '31' },
  { value: '3821', name: 'Tumiritinga', uf: '31' },
  { value: '3822', name: 'Mathias Lobato', uf: '31' },
  { value: '3823', name: 'Virgolândia', uf: '31' },
  { value: '3824', name: 'Central de Minas', uf: '31' },
  { value: '3825', name: 'Itabirinha', uf: '31' },
  { value: '3826', name: 'Mantena', uf: '31' },
  { value: '3827', name: 'Mendes Pimentel', uf: '31' },
  { value: '3828', name: 'Nova Belém', uf: '31' },
  { value: '3829', name: 'São Félix de Minas', uf: '31' },
  { value: '3830', name: 'São João do Manteninha', uf: '31' },
  { value: '3831', name: 'Açucena', uf: '31' },
  { value: '3832', name: 'Antônio Dias', uf: '31' },
  { value: '3833', name: 'Belo Oriente', uf: '31' },
  { value: '3834', name: 'Coronel Fabriciano', uf: '31' },
  { value: '3835', name: 'Ipatinga', uf: '31' },
  { value: '3836', name: 'Jaguaraçu', uf: '31' },
  { value: '3837', name: 'Joanésia', uf: '31' },
  { value: '3838', name: 'Marliéria', uf: '31' },
  { value: '3839', name: 'Mesquita', uf: '31' },
  { value: '3840', name: 'Naque', uf: '31' },
  { value: '3841', name: 'Periquito', uf: '31' },
  { value: '3842', name: 'Santana do Paraíso', uf: '31' },
  { value: '3843', name: 'Timóteo', uf: '31' },
  { value: '3844', name: 'Bom Jesus do Galho', uf: '31' },
  { value: '3845', name: 'Bugre', uf: '31' },
  { value: '3846', name: 'Caratinga', uf: '31' },
  { value: '3847', name: 'Córrego Novo', uf: '31' },
  { value: '3848', name: 'Dom Cavati', uf: '31' },
  { value: '3849', name: 'Entre Folhas', uf: '31' },
  { value: '3850', name: 'Iapu', uf: '31' },
  { value: '3851', name: 'Imbé de Minas', uf: '31' },
  { value: '3852', name: 'Inhapim', uf: '31' },
  { value: '3853', name: 'Ipaba', uf: '31' },
  { value: '3854', name: 'Piedade de Caratinga', uf: '31' },
  { value: '3855', name: "Pingo-d'Água", uf: '31' },
  { value: '3856', name: 'Santa Bárbara do Leste', uf: '31' },
  { value: '3857', name: 'Santa Rita de Minas', uf: '31' },
  { value: '3858', name: 'São Domingos das Dores', uf: '31' },
  { value: '3859', name: 'São João do Oriente', uf: '31' },
  { value: '3860', name: 'São Sebastião do Anta', uf: '31' },
  { value: '3861', name: 'Tarumirim', uf: '31' },
  { value: '3862', name: 'Ubaporanga', uf: '31' },
  { value: '3863', name: 'Vargem Alegre', uf: '31' },
  { value: '3864', name: 'Aimorés', uf: '31' },
  { value: '3865', name: 'Alvarenga', uf: '31' },
  { value: '3866', name: 'Conceição de Ipanema', uf: '31' },
  { value: '3867', name: 'Conselheiro Pena', uf: '31' },
  { value: '3868', name: 'Cuparaque', uf: '31' },
  { value: '3869', name: 'Goiabeira', uf: '31' },
  { value: '3870', name: 'Ipanema', uf: '31' },
  { value: '3871', name: 'Itueta', uf: '31' },
  { value: '3872', name: 'Mutum', uf: '31' },
  { value: '3873', name: 'Pocrane', uf: '31' },
  { value: '3874', name: 'Florestal', uf: '31' },
  { value: '3875', name: 'Onça de Pitangui', uf: '31' },
  { value: '3876', name: 'Pará de Minas', uf: '31' },
  { value: '3877', name: 'Pitangui', uf: '31' },
  { value: '3878', name: 'São José da Varginha', uf: '31' },
  { value: '3879', name: 'Belo Horizonte', uf: '31' },
  { value: '3880', name: 'Betim', uf: '31' },
  { value: '3881', name: 'Brumadinho', uf: '31' },
  { value: '3882', name: 'Caeté', uf: '31' },
  { value: '3883', name: 'Confins', uf: '31' },
  { value: '3884', name: 'Contagem', uf: '31' },
  { value: '3885', name: 'Esmeraldas', uf: '31' },
  { value: '3886', name: 'Ibirité', uf: '31' },
  { value: '3887', name: 'Igarapé', uf: '31' },
  { value: '3888', name: 'Juatuba', uf: '31' },
  { value: '3889', name: 'Lagoa Santa', uf: '31' },
  { value: '3890', name: 'Mário Campos', uf: '31' },
  { value: '3891', name: 'Mateus Leme', uf: '31' },
  { value: '3892', name: 'Nova Lima', uf: '31' },
  { value: '3893', name: 'Pedro Leopoldo', uf: '31' },
  { value: '3894', name: 'Raposos', uf: '31' },
  { value: '3895', name: 'Ribeirão das Neves', uf: '31' },
  { value: '3896', name: 'Rio Acima', uf: '31' },
  { value: '3897', name: 'Sabará', uf: '31' },
  { value: '3898', name: 'Santa Luzia', uf: '31' },
  { value: '3899', name: 'São Joaquim de Bicas', uf: '31' },
  { value: '3900', name: 'São José da Lapa', uf: '31' },
  { value: '3901', name: 'Sarzedo', uf: '31' },
  { value: '3902', name: 'Vespasiano', uf: '31' },
  { value: '3903', name: 'Alvinópolis', uf: '31' },
  { value: '3904', name: 'Barão de Cocais', uf: '31' },
  { value: '3905', name: 'Bela Vista de Minas', uf: '31' },
  { value: '3906', name: 'Bom Jesus do Amparo', uf: '31' },
  { value: '3907', name: 'Catas Altas', uf: '31' },
  { value: '3908', name: 'Dionísio', uf: '31' },
  { value: '3909', name: 'Ferros', uf: '31' },
  { value: '3910', name: 'Itabira', uf: '31' },
  { value: '3911', name: 'João Monlevade', uf: '31' },
  { value: '3912', name: 'Nova União', uf: '31' },
  { value: '3913', name: 'Nova Era', uf: '31' },
  { value: '3914', name: 'Rio Piracicaba', uf: '31' },
  { value: '3915', name: 'Santa Bárbara', uf: '31' },
  { value: '3916', name: 'Santa Maria de Itabira', uf: '31' },
  { value: '3917', name: 'São Domingos do Prata', uf: '31' },
  { value: '3918', name: 'São Gonçalo do Rio Abaixo', uf: '31' },
  { value: '3919', name: 'São José do Goiabal', uf: '31' },
  { value: '3920', name: 'Taquaraçu de Minas', uf: '31' },
  { value: '3921', name: 'Belo Vale', uf: '31' },
  { value: '3922', name: 'Bonfim', uf: '31' },
  { value: '3923', name: 'Crucilândia', uf: '31' },
  { value: '3924', name: 'Itaguara', uf: '31' },
  { value: '3925', name: 'Itatiaiuçu', uf: '31' },
  { value: '3926', name: 'Jeceaba', uf: '31' },
  { value: '3927', name: 'Moeda', uf: '31' },
  { value: '3928', name: 'Piedade dos Gerais', uf: '31' },
  { value: '3929', name: 'Rio Manso', uf: '31' },
  { value: '3930', name: 'Diogo de Vasconcelos', uf: '31' },
  { value: '3931', name: 'Itabirito', uf: '31' },
  { value: '3932', name: 'Mariana', uf: '31' },
  { value: '3933', name: 'Ouro Preto', uf: '31' },
  { value: '3934', name: 'Casa Grande', uf: '31' },
  { value: '3935', name: 'Catas Altas da Noruega', uf: '31' },
  { value: '3936', name: 'Congonhas', uf: '31' },
  { value: '3937', name: 'Conselheiro Lafaiete', uf: '31' },
  { value: '3938', name: 'Cristiano Otoni', uf: '31' },
  { value: '3939', name: 'Desterro de Entre Rios', uf: '31' },
  { value: '3940', name: 'Entre Rios de Minas', uf: '31' },
  { value: '3941', name: 'Itaverava', uf: '31' },
  { value: '3942', name: 'Ouro Branco', uf: '31' },
  { value: '3943', name: 'Queluzito', uf: '31' },
  { value: '3944', name: 'Santana dos Montes', uf: '31' },
  { value: '3945', name: 'São Brás do Suaçuí', uf: '31' },
  { value: '3946', name: 'Braúnas', uf: '31' },
  { value: '3947', name: 'Carmésia', uf: '31' },
  { value: '3948', name: 'Coluna', uf: '31' },
  { value: '3949', name: 'Divinolândia de Minas', uf: '31' },
  { value: '3950', name: 'Dores de Guanhães', uf: '31' },
  { value: '3951', name: 'Gonzaga', uf: '31' },
  { value: '3952', name: 'Guanhães', uf: '31' },
  { value: '3953', name: 'Materlândia', uf: '31' },
  { value: '3954', name: 'Paulistas', uf: '31' },
  { value: '3955', name: 'Sabinópolis', uf: '31' },
  { value: '3956', name: 'Careiro', uf: '13' },
  { value: '3957', name: 'Careiro da Várzea', uf: '13' },
  { value: '3958', name: 'Iranduba', uf: '13' },
  { value: '3959', name: 'Manacapuru', uf: '13' },
  { value: '3960', name: 'Manaquiri', uf: '13' },
  { value: '3961', name: 'Manaus', uf: '13' },
  { value: '3962', name: 'Presidente Figueiredo', uf: '13' },
  { value: '3963', name: 'Rio Preto da Eva', uf: '13' },
  { value: '3964', name: 'Itacoatiara', uf: '13' },
  { value: '3965', name: 'Itapiranga', uf: '13' },
  { value: '3966', name: 'Nova Olinda do Norte', uf: '13' },
  { value: '3967', name: 'Silves', uf: '13' },
  { value: '3968', name: 'Urucurituba', uf: '13' },
  { value: '3969', name: 'Barreirinha', uf: '13' },
  { value: '3970', name: 'Boa Vista do Ramos', uf: '13' },
  { value: '3971', name: 'Maués', uf: '13' },
  { value: '3972', name: 'Nhamundá', uf: '13' },
  { value: '3973', name: 'Parintins', uf: '13' },
  { value: '3974', name: 'São Sebastião do Uatumã', uf: '13' },
  { value: '3975', name: 'Urucará', uf: '13' },
  { value: '3976', name: 'Boca do Acre', uf: '13' },
  { value: '3977', name: 'Pauini', uf: '13' },
  { value: '3978', name: 'Canutama', uf: '13' },
  { value: '3979', name: 'Lábrea', uf: '13' },
  { value: '3980', name: 'Tapauá', uf: '13' },
  { value: '3981', name: 'Apuí', uf: '13' },
  { value: '3982', name: 'Borba', uf: '13' },
  { value: '3983', name: 'Humaitá', uf: '13' },
  { value: '3984', name: 'Manicoré', uf: '13' },
  { value: '3985', name: 'Novo Aripuanã', uf: '13' },
  { value: '3986', name: 'Amajari', uf: '14' },
  { value: '3987', name: 'Alto Alegre', uf: '14' },
  { value: '3988', name: 'Boa Vista', uf: '14' },
  { value: '3989', name: 'Pacaraima', uf: '14' },
  { value: '3990', name: 'Bonfim', uf: '14' },
  { value: '3991', name: 'Cantá', uf: '14' },
  { value: '3992', name: 'Normandia', uf: '14' },
  { value: '3993', name: 'Uiramutã', uf: '14' },
  { value: '3994', name: 'Caracaraí', uf: '14' },
  { value: '3995', name: 'Iracema', uf: '14' },
  { value: '3996', name: 'Mucajaí', uf: '14' },
  { value: '3997', name: 'Caroebe', uf: '14' },
  { value: '3998', name: 'Rorainópolis', uf: '14' },
  { value: '3999', name: 'São João da Baliza', uf: '14' },
  { value: '4000', name: 'São Luiz', uf: '14' },
  { value: '4001', name: 'Faro', uf: '15' },
  { value: '4002', name: 'Juruti', uf: '15' },
  { value: '4003', name: 'Óbidos', uf: '15' },
  { value: '4004', name: 'Oriximiná', uf: '15' },
  { value: '4005', name: 'Terra Santa', uf: '15' },
  { value: '4006', name: 'Alenquer', uf: '15' },
  { value: '4007', name: 'Belterra', uf: '15' },
  { value: '4008', name: 'Curuá', uf: '15' },
  { value: '4009', name: 'Monte Alegre', uf: '15' },
  { value: '4010', name: 'Placas', uf: '15' },
  { value: '4011', name: 'Prainha', uf: '15' },
  { value: '4012', name: 'Santarém', uf: '15' },
  { value: '4013', name: 'Almeirim', uf: '15' },
  { value: '4014', name: 'Porto de Moz', uf: '15' },
  { value: '4015', name: 'Bagre', uf: '15' },
  { value: '4016', name: 'Gurupá', uf: '15' },
  { value: '4017', name: 'Melgaço', uf: '15' },
  { value: '4018', name: 'Portel', uf: '15' },
  { value: '4019', name: 'Afuá', uf: '15' },
  { value: '4020', name: 'Anajás', uf: '15' },
  { value: '4021', name: 'Breves', uf: '15' },
  { value: '4022', name: 'Curralinho', uf: '15' },
  { value: '4023', name: 'São Sebastião da Boa Vista', uf: '15' },
  { value: '4024', name: 'Cachoeira do Arari', uf: '15' },
  { value: '4025', name: 'Chaves', uf: '15' },
  { value: '4026', name: 'Muaná', uf: '15' },
  { value: '4027', name: 'Ponta de Pedras', uf: '15' },
  { value: '4028', name: 'Salvaterra', uf: '15' },
  { value: '4029', name: 'Santa Cruz do Arari', uf: '15' },
  { value: '4030', name: 'Soure', uf: '15' },
  { value: '4031', name: 'Ananindeua', uf: '15' },
  { value: '4032', name: 'Barcarena', uf: '15' },
  { value: '4033', name: 'Belém', uf: '15' },
  { value: '4034', name: 'Benevides', uf: '15' },
  { value: '4035', name: 'Marituba', uf: '15' },
  { value: '4036', name: 'Santa Bárbara do Pará', uf: '15' },
  { value: '4037', name: 'Bujaru', uf: '15' },
  { value: '4038', name: 'Castanhal', uf: '15' },
  { value: '4039', name: 'Inhangapi', uf: '15' },
  { value: '4040', name: 'Santa Isabel do Pará', uf: '15' },
  { value: '4041', name: 'Santo Antônio do Tauá', uf: '15' },
  { value: '4042', name: 'Colares', uf: '15' },
  { value: '4043', name: 'Curuçá', uf: '15' },
  { value: '4044', name: 'Magalhães Barata', uf: '15' },
  { value: '4045', name: 'Maracanã', uf: '15' },
  { value: '4046', name: 'Marapanim', uf: '15' },
  { value: '4047', name: 'Salinópolis', uf: '15' },
  { value: '4048', name: 'São Caetano de Odivelas', uf: '15' },
  { value: '4049', name: 'São João da Ponta', uf: '15' },
  { value: '4050', name: 'São João de Pirabas', uf: '15' },
  { value: '4051', name: 'Terra Alta', uf: '15' },
  { value: '4052', name: 'Vigia', uf: '15' },
  { value: '4053', name: 'Augusto Corrêa', uf: '15' },
  { value: '4054', name: 'Bonito', uf: '15' },
  { value: '4055', name: 'Bragança', uf: '15' },
  { value: '4056', name: 'Capanema', uf: '15' },
  { value: '4057', name: 'Igarapé-Açu', uf: '15' },
  { value: '4058', name: 'Nova Timboteua', uf: '15' },
  { value: '4059', name: 'Peixe-Boi', uf: '15' },
  { value: '4060', name: 'Primavera', uf: '15' },
  { value: '4061', name: 'Quatipuru', uf: '15' },
  { value: '4062', name: 'Santa Maria do Pará', uf: '15' },
  { value: '4063', name: 'Santarém Novo', uf: '15' },
  { value: '4064', name: 'São Francisco do Pará', uf: '15' },
  { value: '4065', name: 'Tracuateua', uf: '15' },
  { value: '4066', name: 'Abaetetuba', uf: '15' },
  { value: '4067', name: 'Baião', uf: '15' },
  { value: '4068', name: 'Cametá', uf: '15' },
  { value: '4069', name: 'Igarapé-Miri', uf: '15' },
  { value: '4070', name: 'Limoeiro do Ajuru', uf: '15' },
  { value: '4071', name: 'Mocajuba', uf: '15' },
  { value: '4072', name: 'Oeiras do Pará', uf: '15' },
  { value: '4073', name: 'Acará', uf: '15' },
  { value: '4074', name: 'Concórdia do Pará', uf: '15' },
  { value: '4075', name: 'Moju', uf: '15' },
  { value: '4076', name: 'Tailândia', uf: '15' },
  { value: '4077', name: 'Tomé-Açu', uf: '15' },
  { value: '4078', name: 'Aurora do Pará', uf: '15' },
  { value: '4079', name: 'Cachoeira do Piriá', uf: '15' },
  { value: '4080', name: 'Capitão Poço', uf: '15' },
  { value: '4081', name: 'Garrafão do Norte', uf: '15' },
  { value: '4082', name: 'Ipixuna do Pará', uf: '15' },
  { value: '4083', name: 'Irituia', uf: '15' },
  { value: '4084', name: 'Mãe do Rio', uf: '15' },
  { value: '4085', name: 'Nova Esperança do Piriá', uf: '15' },
  { value: '4086', name: 'Ourém', uf: '15' },
  { value: '4087', name: 'Santa Luzia do Pará', uf: '15' },
  { value: '4088', name: 'São Domingos do Capim', uf: '15' },
  { value: '4089', name: 'São Miguel do Guamá', uf: '15' },
  { value: '4090', name: 'Viseu', uf: '15' },
  { value: '4091', name: 'Aveiro', uf: '15' },
  { value: '4092', name: 'Itaituba', uf: '15' },
  { value: '4093', name: 'Jacareacanga', uf: '15' },
  { value: '4094', name: 'Novo Progresso', uf: '15' },
  { value: '4095', name: 'Rurópolis', uf: '15' },
  { value: '4096', name: 'Trairão', uf: '15' },
  { value: '4097', name: 'Altamira', uf: '15' },
  { value: '4098', name: 'Anapu', uf: '15' },
  { value: '4099', name: 'Brasil Novo', uf: '15' },
  { value: '4100', name: 'Medicilândia', uf: '15' },
  { value: '4101', name: 'Pacajá', uf: '15' },
  { value: '4102', name: 'Senador José Porfírio', uf: '15' },
  { value: '4103', name: 'Uruará', uf: '15' },
  { value: '4104', name: 'Vitória do Xingu', uf: '15' },
  { value: '4105', name: 'Breu Branco', uf: '15' },
  { value: '4106', name: 'Itupiranga', uf: '15' },
  { value: '4107', name: 'Jacundá', uf: '15' },
  { value: '4108', name: 'Nova Ipixuna', uf: '15' },
  { value: '4109', name: 'Novo Repartimento', uf: '15' },
  { value: '4110', name: 'Tucuruí', uf: '15' },
  { value: '4111', name: 'Abel Figueiredo', uf: '15' },
  { value: '4112', name: 'Bom Jesus do Tocantins', uf: '15' },
  { value: '4113', name: 'Dom Eliseu', uf: '15' },
  { value: '4114', name: 'Goianésia do Pará', uf: '15' },
  { value: '4115', name: 'Paragominas', uf: '15' },
  { value: '4116', name: 'Rondon do Pará', uf: '15' },
  { value: '4117', name: 'Ulianópolis', uf: '15' },
  { value: '4118', name: 'Bannach', uf: '15' },
  { value: '4119', name: 'Cumaru do Norte', uf: '15' },
  { value: '4120', name: 'Ourilândia do Norte', uf: '15' },
  { value: '4121', name: 'São Félix do Xingu', uf: '15' },
  { value: '4122', name: 'Tucumã', uf: '15' },
  { value: '4123', name: 'Água Azul do Norte', uf: '15' },
  { value: '4124', name: 'Canaã dos Carajás', uf: '15' },
  { value: '4125', name: 'Curionópolis', uf: '15' },
  { value: '4126', name: 'Eldorado dos Carajás', uf: '15' },
  { value: '4127', name: 'Parauapebas', uf: '15' },
  { value: '4128', name: 'Brejo Grande do Araguaia', uf: '15' },
  { value: '4129', name: 'Marabá', uf: '15' },
  { value: '4130', name: 'Palestina do Pará', uf: '15' },
  { value: '4131', name: 'São Domingos do Araguaia', uf: '15' },
  { value: '4132', name: 'São João do Araguaia', uf: '15' },
  { value: '4133', name: "Pau D'Arco", uf: '15' },
  { value: '4134', name: 'Piçarra', uf: '15' },
  { value: '4135', name: 'Redenção', uf: '15' },
  { value: '4136', name: 'Rio Maria', uf: '15' },
  { value: '4137', name: 'São Geraldo do Araguaia', uf: '15' },
  { value: '4138', name: 'Sapucaia', uf: '15' },
  { value: '4139', name: 'Xinguara', uf: '15' },
  { value: '4140', name: 'Conceição do Araguaia', uf: '15' },
  { value: '4141', name: 'Floresta do Araguaia', uf: '15' },
  { value: '4142', name: 'Santa Maria das Barreiras', uf: '15' },
  { value: '4143', name: 'Santana do Araguaia', uf: '15' },
  { value: '4144', name: 'Calçoene', uf: '16' },
  { value: '4145', name: 'Oiapoque', uf: '16' },
  { value: '4146', name: 'Amapá', uf: '16' },
  { value: '4147', name: 'Pracuúba', uf: '16' },
  { value: '4148', name: 'Tartarugalzinho', uf: '16' },
  { value: '4149', name: 'Serra do Navio', uf: '16' },
  { value: '4150', name: 'Pedra Branca do Amapari', uf: '16' },
  { value: '4151', name: 'Cutias', uf: '16' },
  { value: '4152', name: 'Ferreira Gomes', uf: '16' },
  { value: '4153', name: 'Itaubal', uf: '16' },
  { value: '4154', name: 'Macapá', uf: '16' },
  { value: '4155', name: 'Porto Grande', uf: '16' },
  { value: '4156', name: 'Santana', uf: '16' },
  { value: '4157', name: 'Laranjal do Jari', uf: '16' },
  { value: '4158', name: 'Mazagão', uf: '16' },
  { value: '4159', name: 'Vitória do Jari', uf: '16' },
  { value: '4160', name: 'Aguiarnópolis', uf: '17' },
  { value: '4161', name: 'Ananás', uf: '17' },
  { value: '4162', name: 'Angico', uf: '17' },
  { value: '4163', name: 'Araguatins', uf: '17' },
  { value: '4164', name: 'Augustinópolis', uf: '17' },
  { value: '4165', name: 'Axixá do Tocantins', uf: '17' },
  { value: '4166', name: 'Buriti do Tocantins', uf: '17' },
  { value: '4167', name: 'Cachoeirinha', uf: '17' },
  { value: '4168', name: 'Carrasco Bonito', uf: '17' },
  { value: '4169', name: 'Darcinópolis', uf: '17' },
  { value: '4170', name: 'Esperantina', uf: '17' },
  { value: '4171', name: 'Itaguatins', uf: '17' },
  { value: '4172', name: 'Luzinópolis', uf: '17' },
  { value: '4173', name: 'Maurilândia do Tocantins', uf: '17' },
  { value: '4174', name: 'Palmeiras do Tocantins', uf: '17' },
  { value: '4175', name: 'Nazaré', uf: '17' },
  { value: '4176', name: 'Praia Norte', uf: '17' },
  { value: '4177', name: 'Riachinho', uf: '17' },
  { value: '4178', name: 'Sampaio', uf: '17' },
  { value: '4179', name: 'Santa Terezinha do Tocantins', uf: '17' },
  { value: '4180', name: 'São Bento do Tocantins', uf: '17' },
  { value: '4181', name: 'São Miguel do Tocantins', uf: '17' },
  { value: '4182', name: 'São Sebastião do Tocantins', uf: '17' },
  { value: '4183', name: 'Sítio Novo do Tocantins', uf: '17' },
  { value: '4184', name: 'Tocantinópolis', uf: '17' },
  { value: '4185', name: 'Aragominas', uf: '17' },
  { value: '4186', name: 'Araguaína', uf: '17' },
  { value: '4187', name: 'Araguanã', uf: '17' },
  { value: '4188', name: 'Arapoema', uf: '17' },
  { value: '4189', name: 'Babaçulândia', uf: '17' },
  { value: '4190', name: 'Bandeirantes do Tocantins', uf: '17' },
  { value: '4191', name: 'Carmolândia', uf: '17' },
  { value: '4192', name: 'Colinas do Tocantins', uf: '17' },
  { value: '4193', name: 'Filadélfia', uf: '17' },
  { value: '4194', name: 'Muricilândia', uf: '17' },
  { value: '4195', name: 'Nova Olinda', uf: '17' },
  { value: '4196', name: 'Palmeirante', uf: '17' },
  { value: '4197', name: "Pau D'Arco", uf: '17' },
  { value: '4198', name: 'Piraquê', uf: '17' },
  { value: '4199', name: 'Santa Fé do Araguaia', uf: '17' },
  { value: '4200', name: 'Wanderlândia', uf: '17' },
  { value: '4201', name: 'Xambioá', uf: '17' },
  { value: '4202', name: 'Abreulândia', uf: '17' },
  { value: '4203', name: 'Araguacema', uf: '17' },
  { value: '4204', name: 'Barrolândia', uf: '17' },
  { value: '4205', name: 'Bernardo Sayão', uf: '17' },
  { value: '4206', name: 'Brasilândia do Tocantins', uf: '17' },
  { value: '4207', name: 'Caseara', uf: '17' },
  { value: '4208', name: 'Couto de Magalhães', uf: '17' },
  { value: '4209', name: 'Divinópolis do Tocantins', uf: '17' },
  { value: '4210', name: 'Dois Irmãos do Tocantins', uf: '17' },
  { value: '4211', name: 'Fortaleza do Tabocão', uf: '17' },
  { value: '4212', name: 'Goianorte', uf: '17' },
  { value: '4213', name: 'Guaraí', uf: '17' },
  { value: '4214', name: 'Itaporã do Tocantins', uf: '17' },
  { value: '4215', name: 'Juarina', uf: '17' },
  { value: '4216', name: 'Marianópolis do Tocantins', uf: '17' },
  { value: '4217', name: 'Miracema do Tocantins', uf: '17' },
  { value: '4218', name: 'Miranorte', uf: '17' },
  { value: '4219', name: 'Monte Santo do Tocantins', uf: '17' },
  { value: '4220', name: 'Pequizeiro', uf: '17' },
  { value: '4221', name: 'Colméia', uf: '17' },
  { value: '4222', name: 'Presidente Kennedy', uf: '17' },
  { value: '4223', name: 'Rio dos Bois', uf: '17' },
  { value: '4224', name: 'Tupirama', uf: '17' },
  { value: '4225', name: 'Tupiratins', uf: '17' },
  { value: '4226', name: 'Araguaçu', uf: '17' },
  { value: '4227', name: 'Chapada de Areia', uf: '17' },
  { value: '4228', name: 'Cristalândia', uf: '17' },
  { value: '4229', name: 'Dueré', uf: '17' },
  { value: '4230', name: 'Fátima', uf: '17' },
  { value: '4231', name: 'Formoso do Araguaia', uf: '17' },
  { value: '4232', name: 'Lagoa da Confusão', uf: '17' },
  { value: '4233', name: 'Nova Rosalândia', uf: '17' },
  { value: '4234', name: 'Oliveira de Fátima', uf: '17' },
  { value: '4235', name: 'Paraíso do Tocantins', uf: '17' },
  { value: '4236', name: 'Pium', uf: '17' },
  { value: '4237', name: 'Pugmil', uf: '17' },
  { value: '4238', name: 'Sandolândia', uf: '17' },
  { value: '4239', name: 'Aliança do Tocantins', uf: '17' },
  { value: '4240', name: 'Alvorada', uf: '17' },
  { value: '4241', name: 'Brejinho de Nazaré', uf: '17' },
  { value: '4242', name: 'Cariri do Tocantins', uf: '17' },
  { value: '4243', name: 'Crixás do Tocantins', uf: '17' },
  { value: '4244', name: 'Figueirópolis', uf: '17' },
  { value: '4245', name: 'Gurupi', uf: '17' },
  { value: '4246', name: 'Jaú do Tocantins', uf: '17' },
  { value: '4247', name: 'Palmeirópolis', uf: '17' },
  { value: '4248', name: 'Peixe', uf: '17' },
  { value: '4249', name: 'Santa Rita do Tocantins', uf: '17' },
  { value: '4250', name: 'São Salvador do Tocantins', uf: '17' },
  { value: '4251', name: 'Sucupira', uf: '17' },
  { value: '4252', name: 'Talismã', uf: '17' },
  { value: '4253', name: 'Aparecida do Rio Negro', uf: '17' },
  { value: '4254', name: 'Bom Jesus do Tocantins', uf: '17' },
  { value: '4255', name: 'Ipueiras', uf: '17' },
  { value: '4256', name: 'Lajeado', uf: '17' },
  { value: '4257', name: 'Monte do Carmo', uf: '17' },
  { value: '4258', name: 'Pedro Afonso', uf: '17' },
  { value: '4259', name: 'Porto Nacional', uf: '17' },
  { value: '4260', name: 'Santa Maria do Tocantins', uf: '17' },
  { value: '4261', name: 'Silvanópolis', uf: '17' },
  { value: '4262', name: 'Palmas', uf: '17' },
  { value: '4263', name: 'Tocantínia', uf: '17' },
  { value: '4264', name: 'Barra do Ouro', uf: '17' },
  { value: '4265', name: 'Campos Lindos', uf: '17' },
  { value: '4266', name: 'Centenário', uf: '17' },
  { value: '4267', name: 'Goiatins', uf: '17' },
  { value: '4268', name: 'Itacajá', uf: '17' },
  { value: '4269', name: 'Itapiratins', uf: '17' },
  { value: '4270', name: 'Lagoa do Tocantins', uf: '17' },
  { value: '4271', name: 'Lizarda', uf: '17' },
  { value: '4272', name: 'Mateiros', uf: '17' },
  { value: '4273', name: 'Novo Acordo', uf: '17' },
  { value: '4274', name: 'Ponte Alta do Tocantins', uf: '17' },
  { value: '4275', name: 'Recursolândia', uf: '17' },
  { value: '4276', name: 'Rio Sono', uf: '17' },
  { value: '4277', name: 'Santa Tereza do Tocantins', uf: '17' },
  { value: '4278', name: 'São Félix do Tocantins', uf: '17' },
  { value: '4279', name: 'Almas', uf: '17' },
  { value: '4280', name: 'Arraias', uf: '17' },
  { value: '4281', name: 'Aurora do Tocantins', uf: '17' },
  { value: '4282', name: 'Chapada da Natividade', uf: '17' },
  { value: '4283', name: 'Combinado', uf: '17' },
  { value: '4284', name: 'Conceição do Tocantins', uf: '17' },
  { value: '4285', name: 'Dianópolis', uf: '17' },
  { value: '4286', name: 'Lavandeira', uf: '17' },
  { value: '4287', name: 'Natividade', uf: '17' },
  { value: '4288', name: 'Novo Alegre', uf: '17' },
  { value: '4289', name: 'Novo Jardim', uf: '17' },
  { value: '4290', name: 'Paranã', uf: '17' },
  { value: '4291', name: 'Pindorama do Tocantins', uf: '17' },
  { value: '4292', name: 'Ponte Alta do Bom Jesus', uf: '17' },
  { value: '4293', name: 'Porto Alegre do Tocantins', uf: '17' },
  { value: '4294', name: 'Rio da Conceição', uf: '17' },
  { value: '4295', name: 'Santa Rosa do Tocantins', uf: '17' },
  { value: '4296', name: 'São Valério da Natividade', uf: '17' },
  { value: '4297', name: 'Taguatinga', uf: '17' },
  { value: '4298', name: 'Taipas do Tocantins', uf: '17' },
  { value: '4299', name: 'Alcântara', uf: '21' },
  { value: '4300', name: 'Apicum-Açu', uf: '21' },
  { value: '4301', name: 'Bacuri', uf: '21' },
  { value: '4302', name: 'Bacurituba', uf: '21' },
  { value: '4303', name: 'Bequimão', uf: '21' },
  { value: '4304', name: 'Cajapió', uf: '21' },
  { value: '4305', name: 'Cedral', uf: '21' },
  { value: '4306', name: 'Central do Maranhão', uf: '21' },
  { value: '4307', name: 'Cururupu', uf: '21' },
  { value: '4308', name: 'Guimarães', uf: '21' },
  { value: '4309', name: 'Mirinzal', uf: '21' },
  { value: '4310', name: 'Porto Rico do Maranhão', uf: '21' },
  { value: '4311', name: 'Serrano do Maranhão', uf: '21' },
  { value: '4312', name: 'Paço do Lumiar', uf: '21' },
  { value: '4313', name: 'Raposa', uf: '21' },
  { value: '4314', name: 'São José de Ribamar', uf: '21' },
  { value: '4315', name: 'São Luís', uf: '21' },
  { value: '4316', name: 'Axixá', uf: '21' },
  { value: '4317', name: 'Bacabeira', uf: '21' },
  { value: '4318', name: 'Cachoeira Grande', uf: '21' },
  { value: '4319', name: 'Icatu', uf: '21' },
  { value: '4320', name: 'Morros', uf: '21' },
  { value: '4321', name: 'Presidente Juscelino', uf: '21' },
  { value: '4322', name: 'Rosário', uf: '21' },
  { value: '4323', name: 'Santa Rita', uf: '21' },
  { value: '4324', name: 'Barreirinhas', uf: '21' },
  { value: '4325', name: 'Humberto de Campos', uf: '21' },
  { value: '4326', name: 'Paulino Neves', uf: '21' },
  { value: '4327', name: 'Primeira Cruz', uf: '21' },
  { value: '4328', name: 'Santo Amaro do Maranhão', uf: '21' },
  { value: '4329', name: 'Tutóia', uf: '21' },
  { value: '4330', name: 'Anajatuba', uf: '21' },
  { value: '4331', name: 'Arari', uf: '21' },
  { value: '4332', name: 'Bela Vista do Maranhão', uf: '21' },
  { value: '4333', name: 'Cajari', uf: '21' },
  { value: '4334', name: 'Conceição do Lago-Açu', uf: '21' },
  { value: '4335', name: 'Igarapé do Meio', uf: '21' },
  { value: '4336', name: 'Matinha', uf: '21' },
  { value: '4337', name: 'Monção', uf: '21' },
  { value: '4338', name: 'Olinda Nova do Maranhão', uf: '21' },
  { value: '4339', name: 'Palmeirândia', uf: '21' },
  { value: '4340', name: 'Pedro do Rosário', uf: '21' },
  { value: '4341', name: 'Penalva', uf: '21' },
  { value: '4342', name: 'Peri Mirim', uf: '21' },
  { value: '4343', name: 'Pinheiro', uf: '21' },
  { value: '4344', name: 'Presidente Sarney', uf: '21' },
  { value: '4345', name: 'Santa Helena', uf: '21' },
  { value: '4346', name: 'São Bento', uf: '21' },
  { value: '4347', name: 'São João Batista', uf: '21' },
  { value: '4348', name: 'São Vicente Ferrer', uf: '21' },
  { value: '4349', name: 'Viana', uf: '21' },
  { value: '4350', name: 'Vitória do Mearim', uf: '21' },
  { value: '4351', name: 'Cantanhede', uf: '21' },
  { value: '4352', name: 'Itapecuru Mirim', uf: '21' },
  { value: '4353', name: 'Matões do Norte', uf: '21' },
  { value: '4354', name: 'Miranda do Norte', uf: '21' },
  { value: '4355', name: 'Nina Rodrigues', uf: '21' },
  { value: '4356', name: 'Pirapemas', uf: '21' },
  { value: '4357', name: 'Presidente Vargas', uf: '21' },
  { value: '4358', name: 'Vargem Grande', uf: '21' },
  { value: '4359', name: 'Amapá do Maranhão', uf: '21' },
  { value: '4360', name: 'Boa Vista do Gurupi', uf: '21' },
  { value: '4361', name: 'Cândido Mendes', uf: '21' },
  { value: '4362', name: 'Carutapera', uf: '21' },
  { value: '4363', name: 'Centro do Guilherme', uf: '21' },
  { value: '4364', name: 'Centro Novo do Maranhão', uf: '21' },
  { value: '4365', name: 'Godofredo Viana', uf: '21' },
  { value: '4366', name: 'Governador Nunes Freire', uf: '21' },
  { value: '4367', name: 'Junco do Maranhão', uf: '21' },
  { value: '4368', name: 'Luís Domingues', uf: '21' },
  { value: '4369', name: 'Maracaçumé', uf: '21' },
  { value: '4370', name: 'Maranhãozinho', uf: '21' },
  { value: '4371', name: 'Turiaçu', uf: '21' },
  { value: '4372', name: 'Turilândia', uf: '21' },
  { value: '4373', name: 'Altamira do Maranhão', uf: '21' },
  { value: '4374', name: 'Alto Alegre do Pindaré', uf: '21' },
  { value: '4375', name: 'Araguanã', uf: '21' },
  { value: '4376', name: 'Bom Jardim', uf: '21' },
  { value: '4377', name: 'Bom Jesus das Selvas', uf: '21' },
  { value: '4378', name: 'Brejo de Areia', uf: '21' },
  { value: '4379', name: 'Buriticupu', uf: '21' },
  { value: '4380', name: 'Governador Newton Bello', uf: '21' },
  { value: '4381', name: 'Lago da Pedra', uf: '21' },
  { value: '4382', name: 'Lagoa Grande do Maranhão', uf: '21' },
  { value: '4383', name: 'Marajá do Sena', uf: '21' },
  { value: '4384', name: 'Nova Olinda do Maranhão', uf: '21' },
  { value: '4385', name: 'Paulo Ramos', uf: '21' },
  { value: '4386', name: 'Pindaré-Mirim', uf: '21' },
  { value: '4387', name: 'Presidente Médici', uf: '21' },
  { value: '4388', name: 'Santa Inês', uf: '21' },
  { value: '4389', name: 'Santa Luzia', uf: '21' },
  { value: '4390', name: 'Santa Luzia do Paruá', uf: '21' },
  { value: '4391', name: 'São João do Carú', uf: '21' },
  { value: '4392', name: 'Tufilândia', uf: '21' },
  { value: '4393', name: 'Vitorino Freire', uf: '21' },
  { value: '4394', name: 'Zé Doca', uf: '21' },
  { value: '4395', name: 'Açailândia', uf: '21' },
  { value: '4396', name: 'Amarante do Maranhão', uf: '21' },
  { value: '4397', name: 'Buritirana', uf: '21' },
  { value: '4398', name: 'Cidelândia', uf: '21' },
  { value: '4399', name: 'Davinópolis', uf: '21' },
  { value: '4400', name: 'Governador Edison Lobão', uf: '21' },
  { value: '4401', name: 'Imperatriz', uf: '21' },
  { value: '4402', name: 'Itinga do Maranhão', uf: '21' },
  { value: '4403', name: 'João Lisboa', uf: '21' },
  { value: '4404', name: 'Lajeado Novo', uf: '21' },
  { value: '4405', name: 'Montes Altos', uf: '21' },
  { value: '4406', name: 'Ribamar Fiquene', uf: '21' },
  { value: '4407', name: 'São Francisco do Brejão', uf: '21' },
  { value: '4408', name: 'São Pedro da Água Branca', uf: '21' },
  { value: '4409', name: 'Senador La Rocque', uf: '21' },
  { value: '4410', name: 'Vila Nova dos Martírios', uf: '21' },
  { value: '4411', name: 'Bacabal', uf: '21' },
  { value: '4412', name: 'Bernardo do Mearim', uf: '21' },
  { value: '4413', name: 'Bom Lugar', uf: '21' },
  { value: '4414', name: 'Esperantinópolis', uf: '21' },
  { value: '4415', name: 'Igarapé Grande', uf: '21' },
  { value: '4416', name: 'Lago do Junco', uf: '21' },
  { value: '4417', name: 'Lago Verde', uf: '21' },
  { value: '4418', name: 'Lago dos Rodrigues', uf: '21' },
  { value: '4419', name: 'Lima Campos', uf: '21' },
  { value: '4420', name: "Olho d'Água das Cunhãs", uf: '21' },
  { value: '4421', name: 'Pedreiras', uf: '21' },
  { value: '4422', name: 'Pio XII', uf: '21' },
  { value: '4423', name: 'Poção de Pedras', uf: '21' },
  { value: '4424', name: 'Santo Antônio dos Lopes', uf: '21' },
  { value: '4425', name: 'São Luís Gonzaga do Maranhão', uf: '21' },
  { value: '4426', name: 'São Mateus do Maranhão', uf: '21' },
  { value: '4427', name: 'São Raimundo do Doca Bezerra', uf: '21' },
  { value: '4428', name: 'São Roberto', uf: '21' },
  { value: '4429', name: 'Satubinha', uf: '21' },
  { value: '4430', name: 'Trizidela do Vale', uf: '21' },
  { value: '4431', name: 'Arame', uf: '21' },
  { value: '4432', name: 'Barra do Corda', uf: '21' },
  { value: '4433', name: 'Fernando Falcão', uf: '21' },
  { value: '4434', name: 'Formosa da Serra Negra', uf: '21' },
  { value: '4435', name: 'Grajaú', uf: '21' },
  { value: '4436', name: 'Itaipava do Grajaú', uf: '21' },
  { value: '4437', name: 'Jenipapo dos Vieiras', uf: '21' },
  { value: '4438', name: 'Joselândia', uf: '21' },
  { value: '4439', name: 'Santa Filomena do Maranhão', uf: '21' },
  { value: '4440', name: 'Sítio Novo', uf: '21' },
  { value: '4441', name: 'Tuntum', uf: '21' },
  { value: '4442', name: 'Dom Pedro', uf: '21' },
  { value: '4443', name: 'Fortuna', uf: '21' },
  { value: '4444', name: 'Gonçalves Dias', uf: '21' },
  { value: '4445', name: 'Governador Archer', uf: '21' },
  { value: '4446', name: 'Governador Eugênio Barros', uf: '21' },
  { value: '4447', name: 'Governador Luiz Rocha', uf: '21' },
  { value: '4448', name: 'Graça Aranha', uf: '21' },
  { value: '4449', name: 'Presidente Dutra', uf: '21' },
  { value: '4450', name: 'São Domingos do Maranhão', uf: '21' },
  { value: '4451', name: 'São José dos Basílios', uf: '21' },
  { value: '4452', name: 'Senador Alexandre Costa', uf: '21' },
  { value: '4453', name: 'Água Doce do Maranhão', uf: '21' },
  { value: '4454', name: 'Araioses', uf: '21' },
  { value: '4455', name: 'Magalhães de Almeida', uf: '21' },
  { value: '4456', name: 'Santa Quitéria do Maranhão', uf: '21' },
  { value: '4457', name: 'Santana do Maranhão', uf: '21' },
  { value: '4458', name: 'São Bernardo', uf: '21' },
  { value: '4459', name: 'Anapurus', uf: '21' },
  { value: '4460', name: 'Belágua', uf: '21' },
  { value: '4461', name: 'Brejo', uf: '21' },
  { value: '4462', name: 'Buriti', uf: '21' },
  { value: '4463', name: 'Chapadinha', uf: '21' },
  { value: '4464', name: 'Mata Roma', uf: '21' },
  { value: '4465', name: 'Milagres do Maranhão', uf: '21' },
  { value: '4466', name: 'São Benedito do Rio Preto', uf: '21' },
  { value: '4467', name: 'Urbano Santos', uf: '21' },
  { value: '4468', name: 'Alto Alegre do Maranhão', uf: '21' },
  { value: '4469', name: 'Capinzal do Norte', uf: '21' },
  { value: '4470', name: 'Codó', uf: '21' },
  { value: '4471', name: 'Coroatá', uf: '21' },
  { value: '4472', name: 'Peritoró', uf: '21' },
  { value: '4473', name: 'Timbiras', uf: '21' },
  { value: '4474', name: 'Afonso Cunha', uf: '21' },
  { value: '4475', name: 'Aldeias Altas', uf: '21' },
  { value: '4476', name: 'Coelho Neto', uf: '21' },
  { value: '4477', name: 'Duque Bacelar', uf: '21' },
  { value: '4478', name: 'Buriti Bravo', uf: '21' },
  { value: '4479', name: 'Caxias', uf: '21' },
  { value: '4480', name: 'Matões', uf: '21' },
  { value: '4481', name: 'Parnarama', uf: '21' },
  { value: '4482', name: 'São João do Soter', uf: '21' },
  { value: '4483', name: 'Timon', uf: '21' },
  { value: '4484', name: 'Barão de Grajaú', uf: '21' },
  { value: '4485', name: 'Colinas', uf: '21' },
  { value: '4486', name: 'Jatobá', uf: '21' },
  { value: '4487', name: 'Lagoa do Mato', uf: '21' },
  { value: '4488', name: 'Mirador', uf: '21' },
  { value: '4489', name: 'Nova Iorque', uf: '21' },
  { value: '4490', name: 'Paraibano', uf: '21' },
  { value: '4491', name: 'Passagem Franca', uf: '21' },
  { value: '4492', name: 'Pastos Bons', uf: '21' },
  { value: '4493', name: 'São Francisco do Maranhão', uf: '21' },
  { value: '4494', name: 'São João dos Patos', uf: '21' },
  { value: '4495', name: 'Sucupira do Norte', uf: '21' },
  { value: '4496', name: 'Sucupira do Riachão', uf: '21' },
  { value: '4497', name: 'Campestre do Maranhão', uf: '21' },
  { value: '4498', name: 'Carolina', uf: '21' },
  { value: '4499', name: 'Estreito', uf: '21' },
  { value: '4500', name: 'Porto Franco', uf: '21' },
  { value: '4501', name: 'São João do Paraíso', uf: '21' },
  { value: '4502', name: 'São Pedro dos Crentes', uf: '21' },
  { value: '4503', name: 'Alto Parnaíba', uf: '21' },
  { value: '4504', name: 'Balsas', uf: '21' },
  { value: '4505', name: 'Feira Nova do Maranhão', uf: '21' },
  { value: '4506', name: 'Riachão', uf: '21' },
  { value: '4507', name: 'Tasso Fragoso', uf: '21' },
  { value: '4508', name: 'Benedito Leite', uf: '21' },
  { value: '4509', name: 'Fortaleza dos Nogueiras', uf: '21' },
  { value: '4510', name: 'Loreto', uf: '21' },
  { value: '4511', name: 'Nova Colinas', uf: '21' },
  { value: '4512', name: 'Sambaíba', uf: '21' },
  { value: '4513', name: 'São Domingos do Azeitão', uf: '21' },
  { value: '4514', name: 'São Félix de Balsas', uf: '21' },
  { value: '4515', name: 'São Raimundo das Mangabeiras', uf: '21' },
  { value: '4516', name: 'Barras', uf: '22' },
  { value: '4517', name: 'Batalha', uf: '22' },
  { value: '4518', name: 'Boa Hora', uf: '22' },
  { value: '4519', name: 'Brasileira', uf: '22' },
  { value: '4520', name: 'Cabeceiras do Piauí', uf: '22' },
  { value: '4521', name: 'Campo Largo do Piauí', uf: '22' },
  { value: '4522', name: 'Esperantina', uf: '22' },
  { value: '4523', name: 'Joaquim Pires', uf: '22' },
  { value: '4524', name: 'Joca Marques', uf: '22' },
  { value: '4525', name: 'Luzilândia', uf: '22' },
  { value: '4526', name: 'Madeiro', uf: '22' },
  { value: '4527', name: 'Matias Olímpio', uf: '22' },
  { value: '4528', name: 'Miguel Alves', uf: '22' },
  { value: '4529', name: 'Morro do Chapéu do Piauí', uf: '22' },
  { value: '4530', name: 'Nossa Senhora dos Remédios', uf: '22' },
  { value: '4531', name: 'Piripiri', uf: '22' },
  { value: '4532', name: 'Porto', uf: '22' },
  { value: '4533', name: 'São João do Arraial', uf: '22' },
  { value: '4534', name: 'Bom Princípio do Piauí', uf: '22' },
  { value: '4535', name: 'Buriti dos Lopes', uf: '22' },
  { value: '4536', name: 'Cajueiro da Praia', uf: '22' },
  { value: '4537', name: 'Caraúbas do Piauí', uf: '22' },
  { value: '4538', name: 'Caxingó', uf: '22' },
  { value: '4539', name: 'Cocal', uf: '22' },
  { value: '4540', name: 'Cocal dos Alves', uf: '22' },
  { value: '4541', name: 'Ilha Grande', uf: '22' },
  { value: '4542', name: 'Luís Correia', uf: '22' },
  { value: '4543', name: 'Murici dos Portelas', uf: '22' },
  { value: '4544', name: 'Parnaíba', uf: '22' },
  { value: '4545', name: 'Piracuruca', uf: '22' },
  { value: '4546', name: 'São João da Fronteira', uf: '22' },
  { value: '4547', name: 'São José do Divino', uf: '22' },
  { value: '4548', name: 'Altos', uf: '22' },
  { value: '4549', name: 'Beneditinos', uf: '22' },
  { value: '4550', name: 'Coivaras', uf: '22' },
  { value: '4551', name: 'Curralinhos', uf: '22' },
  { value: '4552', name: 'Demerval Lobão', uf: '22' },
  { value: '4553', name: 'José de Freitas', uf: '22' },
  { value: '4554', name: 'Lagoa Alegre', uf: '22' },
  { value: '4555', name: 'Lagoa do Piauí', uf: '22' },
  { value: '4556', name: 'Miguel Leão', uf: '22' },
  { value: '4557', name: 'Monsenhor Gil', uf: '22' },
  { value: '4558', name: "Pau D'Arco do Piauí", uf: '22' },
  { value: '4559', name: 'Teresina', uf: '22' },
  { value: '4560', name: 'União', uf: '22' },
  { value: '4561', name: 'Alto Longá', uf: '22' },
  { value: '4562', name: 'Assunção do Piauí', uf: '22' },
  { value: '4563', name: 'Boqueirão do Piauí', uf: '22' },
  { value: '4564', name: 'Buriti dos Montes', uf: '22' },
  { value: '4565', name: 'Campo Maior', uf: '22' },
  { value: '4566', name: 'Capitão de Campos', uf: '22' },
  { value: '4567', name: 'Castelo do Piauí', uf: '22' },
  { value: '4568', name: 'Cocal de Telha', uf: '22' },
  { value: '4569', name: 'Domingos Mourão', uf: '22' },
  { value: '4570', name: 'Jatobá do Piauí', uf: '22' },
  { value: '4571', name: 'Juazeiro do Piauí', uf: '22' },
  { value: '4572', name: 'Lagoa de São Francisco', uf: '22' },
  { value: '4573', name: 'Milton Brandão', uf: '22' },
  { value: '4574', name: 'Nossa Senhora de Nazaré', uf: '22' },
  { value: '4575', name: 'Novo Santo Antônio', uf: '22' },
  { value: '4576', name: 'Pedro II', uf: '22' },
  { value: '4577', name: 'São João da Serra', uf: '22' },
  { value: '4578', name: 'São Miguel do Tapuio', uf: '22' },
  { value: '4579', name: 'Sigefredo Pacheco', uf: '22' },
  { value: '4580', name: 'Agricolândia', uf: '22' },
  { value: '4581', name: 'Água Branca', uf: '22' },
  { value: '4582', name: 'Amarante', uf: '22' },
  { value: '4583', name: 'Angical do Piauí', uf: '22' },
  { value: '4584', name: 'Arraial', uf: '22' },
  { value: '4585', name: 'Barro Duro', uf: '22' },
  { value: '4586', name: 'Francisco Ayres', uf: '22' },
  { value: '4587', name: 'Hugo Napoleão', uf: '22' },
  { value: '4588', name: 'Jardim do Mulato', uf: '22' },
  { value: '4589', name: 'Lagoinha do Piauí', uf: '22' },
  { value: '4590', name: "Olho D'Água do Piauí", uf: '22' },
  { value: '4591', name: 'Palmeirais', uf: '22' },
  { value: '4592', name: 'Passagem Franca do Piauí', uf: '22' },
  { value: '4593', name: 'Regeneração', uf: '22' },
  { value: '4594', name: 'Santo Antônio dos Milagres', uf: '22' },
  { value: '4595', name: 'São Gonçalo do Piauí', uf: '22' },
  { value: '4596', name: 'São Pedro do Piauí', uf: '22' },
  { value: '4597', name: 'Aroazes', uf: '22' },
  { value: '4598', name: "Barra D'Alcântara", uf: '22' },
  { value: '4599', name: 'Elesbão Veloso', uf: '22' },
  { value: '4600', name: 'Francinópolis', uf: '22' },
  { value: '4601', name: 'Inhuma', uf: '22' },
  { value: '4602', name: 'Lagoa do Sítio', uf: '22' },
  { value: '4603', name: 'Novo Oriente do Piauí', uf: '22' },
  { value: '4604', name: 'Pimenteiras', uf: '22' },
  { value: '4605', name: 'Prata do Piauí', uf: '22' },
  { value: '4606', name: 'Santa Cruz dos Milagres', uf: '22' },
  { value: '4607', name: 'São Félix do Piauí', uf: '22' },
  { value: '4608', name: 'São Miguel da Baixa Grande', uf: '22' },
  { value: '4609', name: 'Valença do Piauí', uf: '22' },
  { value: '4610', name: 'Várzea Grande', uf: '22' },
  { value: '4611', name: 'Baixa Grande do Ribeiro', uf: '22' },
  { value: '4612', name: 'Ribeiro Gonçalves', uf: '22' },
  { value: '4613', name: 'Santa Filomena', uf: '22' },
  { value: '4614', name: 'Uruçuí', uf: '22' },
  { value: '4615', name: 'Antônio Almeida', uf: '22' },
  { value: '4616', name: 'Bertolínia', uf: '22' },
  { value: '4617', name: 'Colônia do Gurguéia', uf: '22' },
  { value: '4618', name: 'Eliseu Martins', uf: '22' },
  { value: '4619', name: 'Landri Sales', uf: '22' },
  { value: '4620', name: 'Manoel Emídio', uf: '22' },
  { value: '4621', name: 'Marcos Parente', uf: '22' },
  { value: '4622', name: 'Porto Alegre do Piauí', uf: '22' },
  { value: '4623', name: 'Sebastião Leal', uf: '22' },
  { value: '4624', name: 'Canavieira', uf: '22' },
  { value: '4625', name: 'Flores do Piauí', uf: '22' },
  { value: '4626', name: 'Floriano', uf: '22' },
  { value: '4627', name: 'Guadalupe', uf: '22' },
  { value: '4628', name: 'Itaueira', uf: '22' },
  { value: '4629', name: 'Jerumenha', uf: '22' },
  { value: '4630', name: 'Nazaré do Piauí', uf: '22' },
  { value: '4631', name: 'Pavussu', uf: '22' },
  { value: '4632', name: 'Rio Grande do Piauí', uf: '22' },
  { value: '4633', name: 'São Francisco do Piauí', uf: '22' },
  { value: '4634', name: 'São José do Peixe', uf: '22' },
  { value: '4635', name: 'São Miguel do Fidalgo', uf: '22' },
  { value: '4636', name: 'Alvorada do Gurguéia', uf: '22' },
  { value: '4637', name: 'Barreiras do Piauí', uf: '22' },
  { value: '4638', name: 'Bom Jesus', uf: '22' },
  { value: '4639', name: 'Cristino Castro', uf: '22' },
  { value: '4640', name: 'Currais', uf: '22' },
  { value: '4641', name: 'Gilbués', uf: '22' },
  { value: '4642', name: 'Monte Alegre do Piauí', uf: '22' },
  { value: '4643', name: 'Palmeira do Piauí', uf: '22' },
  { value: '4644', name: 'Redenção do Gurguéia', uf: '22' },
  { value: '4645', name: 'Santa Luz', uf: '22' },
  { value: '4646', name: 'São Gonçalo do Gurguéia', uf: '22' },
  { value: '4647', name: 'Anísio de Abreu', uf: '22' },
  { value: '4648', name: 'Bonfim do Piauí', uf: '22' },
  { value: '4649', name: 'Brejo do Piauí', uf: '22' },
  { value: '4650', name: 'Canto do Buriti', uf: '22' },
  { value: '4651', name: 'Caracol', uf: '22' },
  { value: '4652', name: 'Coronel José Dias', uf: '22' },
  { value: '4653', name: 'Dirceu Arcoverde', uf: '22' },
  { value: '4654', name: 'Dom Inocêncio', uf: '22' },
  { value: '4655', name: 'Fartura do Piauí', uf: '22' },
  { value: '4656', name: 'Guaribas', uf: '22' },
  { value: '4657', name: 'Jurema', uf: '22' },
  { value: '4658', name: 'Pajeú do Piauí', uf: '22' },
  { value: '4659', name: 'São Braz do Piauí', uf: '22' },
  { value: '4660', name: 'São Lourenço do Piauí', uf: '22' },
  { value: '4661', name: 'São Raimundo Nonato', uf: '22' },
  { value: '4662', name: 'Tamboril do Piauí', uf: '22' },
  { value: '4663', name: 'Várzea Branca', uf: '22' },
  { value: '4664', name: 'Avelino Lopes', uf: '22' },
  { value: '4665', name: 'Corrente', uf: '22' },
  { value: '4666', name: 'Cristalândia do Piauí', uf: '22' },
  { value: '4667', name: 'Curimatá', uf: '22' },
  { value: '4668', name: 'Júlio Borges', uf: '22' },
  { value: '4669', name: 'Morro Cabeça no Tempo', uf: '22' },
  { value: '4670', name: 'Parnaguá', uf: '22' },
  { value: '4671', name: 'Riacho Frio', uf: '22' },
  { value: '4672', name: 'Sebastião Barros', uf: '22' },
  { value: '4673', name: 'Aroeiras do Itaim', uf: '22' },
  { value: '4674', name: 'Bocaina', uf: '22' },
  { value: '4675', name: 'Cajazeiras do Piauí', uf: '22' },
  { value: '4676', name: 'Colônia do Piauí', uf: '22' },
  { value: '4677', name: 'Dom Expedito Lopes', uf: '22' },
  { value: '4678', name: 'Geminiano', uf: '22' },
  { value: '4679', name: 'Ipiranga do Piauí', uf: '22' },
  { value: '4680', name: 'Oeiras', uf: '22' },
  { value: '4681', name: 'Paquetá', uf: '22' },
  { value: '4682', name: 'Picos', uf: '22' },
  { value: '4683', name: 'Santa Cruz do Piauí', uf: '22' },
  { value: '4684', name: 'Santana do Piauí', uf: '22' },
  { value: '4685', name: 'Santa Rosa do Piauí', uf: '22' },
  { value: '4686', name: 'São João da Canabrava', uf: '22' },
  { value: '4687', name: 'São João da Varjota', uf: '22' },
  { value: '4688', name: 'São José do Piauí', uf: '22' },
  { value: '4689', name: 'São Luis do Piauí', uf: '22' },
  { value: '4690', name: 'Sussuapara', uf: '22' },
  { value: '4691', name: 'Tanque do Piauí', uf: '22' },
  { value: '4692', name: 'Wall Ferraz', uf: '22' },
  { value: '4693', name: 'Alagoinha do Piauí', uf: '22' },
  { value: '4694', name: 'Alegrete do Piauí', uf: '22' },
  { value: '4695', name: 'Francisco Santos', uf: '22' },
  { value: '4696', name: 'Monsenhor Hipólito', uf: '22' },
  { value: '4697', name: 'Pio IX', uf: '22' },
  { value: '4698', name: 'Santo Antônio de Lisboa', uf: '22' },
  { value: '4699', name: 'São Julião', uf: '22' },
  { value: '4700', name: 'Acauã', uf: '22' },
  { value: '4701', name: 'Bela Vista do Piauí', uf: '22' },
  { value: '4702', name: 'Belém do Piauí', uf: '22' },
  { value: '4703', name: 'Betânia do Piauí', uf: '22' },
  { value: '4704', name: 'Caldeirão Grande do Piauí', uf: '22' },
  { value: '4705', name: 'Campinas do Piauí', uf: '22' },
  { value: '4706', name: 'Campo Alegre do Fidalgo', uf: '22' },
  { value: '4707', name: 'Campo Grande do Piauí', uf: '22' },
  { value: '4708', name: 'Capitão Gervásio Oliveira', uf: '22' },
  { value: '4709', name: 'Caridade do Piauí', uf: '22' },
  { value: '4710', name: 'Conceição do Canindé', uf: '22' },
  { value: '4711', name: 'Curral Novo do Piauí', uf: '22' },
  { value: '4712', name: 'Floresta do Piauí', uf: '22' },
  { value: '4713', name: 'Francisco Macedo', uf: '22' },
  { value: '4714', name: 'Fronteiras', uf: '22' },
  { value: '4715', name: 'Isaías Coelho', uf: '22' },
  { value: '4716', name: 'Itainópolis', uf: '22' },
  { value: '4717', name: 'Jacobina do Piauí', uf: '22' },
  { value: '4718', name: 'Jaicós', uf: '22' },
  { value: '4719', name: 'João Costa', uf: '22' },
  { value: '4720', name: 'Lagoa do Barro do Piauí', uf: '22' },
  { value: '4721', name: 'Marcolândia', uf: '22' },
  { value: '4722', name: 'Massapê do Piauí', uf: '22' },
  { value: '4723', name: 'Padre Marcos', uf: '22' },
  { value: '4724', name: 'Paes Landim', uf: '22' },
  { value: '4725', name: 'Patos do Piauí', uf: '22' },
  { value: '4726', name: 'Paulistana', uf: '22' },
  { value: '4727', name: 'Pedro Laurentino', uf: '22' },
  { value: '4728', name: 'Nova Santa Rita', uf: '22' },
  { value: '4729', name: 'Queimada Nova', uf: '22' },
  { value: '4730', name: 'Ribeira do Piauí', uf: '22' },
  { value: '4731', name: 'Santo Inácio do Piauí', uf: '22' },
  { value: '4732', name: 'São Francisco de Assis do Piauí', uf: '22' },
  { value: '4733', name: 'São João do Piauí', uf: '22' },
  { value: '4734', name: 'Simões', uf: '22' },
  { value: '4735', name: 'Simplício Mendes', uf: '22' },
  { value: '4736', name: 'Socorro do Piauí', uf: '22' },
  { value: '4737', name: 'Vera Mendes', uf: '22' },
  { value: '4738', name: 'Vila Nova do Piauí', uf: '22' },
  { value: '4739', name: 'Acaraú', uf: '23' },
  { value: '4740', name: 'Barroquinha', uf: '23' },
  { value: '4741', name: 'Bela Cruz', uf: '23' },
  { value: '4742', name: 'Camocim', uf: '23' },
  { value: '4743', name: 'Chaval', uf: '23' },
  { value: '4744', name: 'Cruz', uf: '23' },
  { value: '4745', name: 'Granja', uf: '23' },
  { value: '4746', name: 'Itarema', uf: '23' },
  { value: '4747', name: 'Jijoca de Jericoacoara', uf: '23' },
  { value: '4748', name: 'Marco', uf: '23' },
  { value: '4749', name: 'Martinópole', uf: '23' },
  { value: '4750', name: 'Morrinhos', uf: '23' },
  { value: '4751', name: 'Carnaubal', uf: '23' },
  { value: '4752', name: 'Croatá', uf: '23' },
  { value: '4753', name: 'Guaraciaba do Norte', uf: '23' },
  { value: '4754', name: 'Ibiapina', uf: '23' },
  { value: '4755', name: 'São Benedito', uf: '23' },
  { value: '4756', name: 'Tianguá', uf: '23' },
  { value: '4757', name: 'Ubajara', uf: '23' },
  { value: '4758', name: 'Viçosa do Ceará', uf: '23' },
  { value: '4759', name: 'Coreaú', uf: '23' },
  { value: '4760', name: 'Frecheirinha', uf: '23' },
  { value: '4761', name: 'Moraújo', uf: '23' },
  { value: '4762', name: 'Uruoca', uf: '23' },
  { value: '4763', name: 'Alcântaras', uf: '23' },
  { value: '4764', name: 'Meruoca', uf: '23' },
  { value: '4765', name: 'Cariré', uf: '23' },
  { value: '4766', name: 'Forquilha', uf: '23' },
  { value: '4767', name: 'Graça', uf: '23' },
  { value: '4768', name: 'Groaíras', uf: '23' },
  { value: '4769', name: 'Irauçuba', uf: '23' },
  { value: '4770', name: 'Massapê', uf: '23' },
  { value: '4771', name: 'Miraíma', uf: '23' },
  { value: '4772', name: 'Mucambo', uf: '23' },
  { value: '4773', name: 'Pacujá', uf: '23' },
  { value: '4774', name: 'Santana do Acaraú', uf: '23' },
  { value: '4775', name: 'Senador Sá', uf: '23' },
  { value: '4776', name: 'Sobral', uf: '23' },
  { value: '4777', name: 'Ipu', uf: '23' },
  { value: '4778', name: 'Ipueiras', uf: '23' },
  { value: '4779', name: 'Pires Ferreira', uf: '23' },
  { value: '4780', name: 'Poranga', uf: '23' },
  { value: '4781', name: 'Reriutaba', uf: '23' },
  { value: '4782', name: 'Varjota', uf: '23' },
  { value: '4783', name: 'Catunda', uf: '23' },
  { value: '4784', name: 'Hidrolândia', uf: '23' },
  { value: '4785', name: 'Santa Quitéria', uf: '23' },
  { value: '4786', name: 'Amontada', uf: '23' },
  { value: '4787', name: 'Itapipoca', uf: '23' },
  { value: '4788', name: 'Trairi', uf: '23' },
  { value: '4789', name: 'Paracuru', uf: '23' },
  { value: '4790', name: 'Paraipaba', uf: '23' },
  { value: '4791', name: 'São Gonçalo do Amarante', uf: '23' },
  { value: '4792', name: 'Itapagé', uf: '23' },
  { value: '4793', name: 'Tururu', uf: '23' },
  { value: '4794', name: 'Umirim', uf: '23' },
  { value: '4795', name: 'Uruburetama', uf: '23' },
  { value: '4796', name: 'Apuiarés', uf: '23' },
  { value: '4797', name: 'General Sampaio', uf: '23' },
  { value: '4798', name: 'Pentecoste', uf: '23' },
  { value: '4799', name: 'São Luís do Curu', uf: '23' },
  { value: '4800', name: 'Tejuçuoca', uf: '23' },
  { value: '4801', name: 'Canindé', uf: '23' },
  { value: '4802', name: 'Caridade', uf: '23' },
  { value: '4803', name: 'Itatira', uf: '23' },
  { value: '4804', name: 'Paramoti', uf: '23' },
  { value: '4805', name: 'Acarape', uf: '23' },
  { value: '4806', name: 'Aracoiaba', uf: '23' },
  { value: '4807', name: 'Aratuba', uf: '23' },
  { value: '4808', name: 'Baturité', uf: '23' },
  { value: '4809', name: 'Capistrano', uf: '23' },
  { value: '4810', name: 'Guaramiranga', uf: '23' },
  { value: '4811', name: 'Itapiúna', uf: '23' },
  { value: '4812', name: 'Mulungu', uf: '23' },
  { value: '4813', name: 'Pacoti', uf: '23' },
  { value: '4814', name: 'Palmácia', uf: '23' },
  { value: '4815', name: 'Redenção', uf: '23' },
  { value: '4816', name: 'Barreira', uf: '23' },
  { value: '4817', name: 'Chorozinho', uf: '23' },
  { value: '4818', name: 'Ocara', uf: '23' },
  { value: '4819', name: 'Beberibe', uf: '23' },
  { value: '4820', name: 'Cascavel', uf: '23' },
  { value: '4821', name: 'Pindoretama', uf: '23' },
  { value: '4822', name: 'Aquiraz', uf: '23' },
  { value: '4823', name: 'Caucaia', uf: '23' },
  { value: '4824', name: 'Eusébio', uf: '23' },
  { value: '4825', name: 'Fortaleza', uf: '23' },
  { value: '4826', name: 'Guaiúba', uf: '23' },
  { value: '4827', name: 'Itaitinga', uf: '23' },
  { value: '4828', name: 'Maracanaú', uf: '23' },
  { value: '4829', name: 'Maranguape', uf: '23' },
  { value: '4830', name: 'Pacatuba', uf: '23' },
  { value: '4831', name: 'Horizonte', uf: '23' },
  { value: '4832', name: 'Pacajus', uf: '23' },
  { value: '4833', name: 'Ararendá', uf: '23' },
  { value: '4834', name: 'Crateús', uf: '23' },
  { value: '4835', name: 'Independência', uf: '23' },
  { value: '4836', name: 'Ipaporanga', uf: '23' },
  { value: '4837', name: 'Monsenhor Tabosa', uf: '23' },
  { value: '4838', name: 'Nova Russas', uf: '23' },
  { value: '4839', name: 'Novo Oriente', uf: '23' },
  { value: '4840', name: 'Quiterianópolis', uf: '23' },
  { value: '4841', name: 'Tamboril', uf: '23' },
  { value: '4842', name: 'Banabuiú', uf: '23' },
  { value: '4843', name: 'Boa Viagem', uf: '23' },
  { value: '4844', name: 'Choró', uf: '23' },
  { value: '4845', name: 'Ibaretama', uf: '23' },
  { value: '4846', name: 'Madalena', uf: '23' },
  { value: '4847', name: 'Quixadá', uf: '23' },
  { value: '4848', name: 'Quixeramobim', uf: '23' },
  { value: '4849', name: 'Aiuaba', uf: '23' },
  { value: '4850', name: 'Arneiroz', uf: '23' },
  { value: '4851', name: 'Catarina', uf: '23' },
  { value: '4852', name: 'Parambu', uf: '23' },
  { value: '4853', name: 'Saboeiro', uf: '23' },
  { value: '4854', name: 'Tauá', uf: '23' },
  { value: '4855', name: 'Acopiara', uf: '23' },
  { value: '4856', name: 'Deputado Irapuan Pinheiro', uf: '23' },
  { value: '4857', name: 'Milhã', uf: '23' },
  { value: '4858', name: 'Mombaça', uf: '23' },
  { value: '4859', name: 'Pedra Branca', uf: '23' },
  { value: '4860', name: 'Piquet Carneiro', uf: '23' },
  { value: '4861', name: 'Senador Pompeu', uf: '23' },
  { value: '4862', name: 'Solonópole', uf: '23' },
  { value: '4863', name: 'Aracati', uf: '23' },
  { value: '4864', name: 'Fortim', uf: '23' },
  { value: '4865', name: 'Icapuí', uf: '23' },
  { value: '4866', name: 'Itaiçaba', uf: '23' },
  { value: '4867', name: 'Alto Santo', uf: '23' },
  { value: '4868', name: 'Ibicuitinga', uf: '23' },
  { value: '4869', name: 'Jaguaruana', uf: '23' },
  { value: '4870', name: 'Limoeiro do Norte', uf: '23' },
  { value: '4871', name: 'Morada Nova', uf: '23' },
  { value: '4872', name: 'Palhano', uf: '23' },
  { value: '4873', name: 'Quixeré', uf: '23' },
  { value: '4874', name: 'Russas', uf: '23' },
  { value: '4875', name: 'São João do Jaguaribe', uf: '23' },
  { value: '4876', name: 'Tabuleiro do Norte', uf: '23' },
  { value: '4877', name: 'Jaguaretama', uf: '23' },
  { value: '4878', name: 'Jaguaribara', uf: '23' },
  { value: '4879', name: 'Jaguaribe', uf: '23' },
  { value: '4880', name: 'Ererê', uf: '23' },
  { value: '4881', name: 'Iracema', uf: '23' },
  { value: '4882', name: 'Pereiro', uf: '23' },
  { value: '4883', name: 'Potiretama', uf: '23' },
  { value: '4884', name: 'Cedro', uf: '23' },
  { value: '4885', name: 'Icó', uf: '23' },
  { value: '4886', name: 'Iguatu', uf: '23' },
  { value: '4887', name: 'Orós', uf: '23' },
  { value: '4888', name: 'Quixelô', uf: '23' },
  { value: '4889', name: 'Antonina do Norte', uf: '23' },
  { value: '4890', name: 'Cariús', uf: '23' },
  { value: '4891', name: 'Jucás', uf: '23' },
  { value: '4892', name: 'Tarrafas', uf: '23' },
  { value: '4893', name: 'Várzea Alegre', uf: '23' },
  { value: '4894', name: 'Baixio', uf: '23' },
  { value: '4895', name: 'Ipaumirim', uf: '23' },
  { value: '4896', name: 'Lavras da Mangabeira', uf: '23' },
  { value: '4897', name: 'Umari', uf: '23' },
  { value: '4898', name: 'Araripe', uf: '23' },
  { value: '4899', name: 'Assaré', uf: '23' },
  { value: '4900', name: 'Campos Sales', uf: '23' },
  { value: '4901', name: 'Potengi', uf: '23' },
  { value: '4902', name: 'Salitre', uf: '23' },
  { value: '4903', name: 'Altaneira', uf: '23' },
  { value: '4904', name: 'Caririaçu', uf: '23' },
  { value: '4905', name: 'Farias Brito', uf: '23' },
  { value: '4906', name: 'Granjeiro', uf: '23' },
  { value: '4907', name: 'Aurora', uf: '23' },
  { value: '4908', name: 'Barro', uf: '23' },
  { value: '4909', name: 'Mauriti', uf: '23' },
  { value: '4910', name: 'Barbalha', uf: '23' },
  { value: '4911', name: 'Crato', uf: '23' },
  { value: '4912', name: 'Jardim', uf: '23' },
  { value: '4913', name: 'Juazeiro do Norte', uf: '23' },
  { value: '4914', name: 'Missão Velha', uf: '23' },
  { value: '4915', name: 'Nova Olinda', uf: '23' },
  { value: '4916', name: 'Porteiras', uf: '23' },
  { value: '4917', name: 'Santana do Cariri', uf: '23' },
  { value: '4918', name: 'Abaiara', uf: '23' },
  { value: '4919', name: 'Brejo Santo', uf: '23' },
  { value: '4920', name: 'Jati', uf: '23' },
  { value: '4921', name: 'Milagres', uf: '23' },
  { value: '4922', name: 'Penaforte', uf: '23' },
  { value: '4923', name: 'Areia Branca', uf: '24' },
  { value: '4924', name: 'Baraúna', uf: '24' },
  { value: '4925', name: 'Grossos', uf: '24' },
  { value: '4926', name: 'Mossoró', uf: '24' },
  { value: '4927', name: 'Tibau', uf: '24' },
  { value: '4928', name: 'Serra do Mel', uf: '24' },
  { value: '4929', name: 'Apodi', uf: '24' },
  { value: '4930', name: 'Caraúbas', uf: '24' },
  { value: '4931', name: 'Felipe Guerra', uf: '24' },
  { value: '4932', name: 'Governador Dix-Sept Rosado', uf: '24' },
  { value: '4933', name: 'Augusto Severo', uf: '24' },
  { value: '4934', name: 'Janduís', uf: '24' },
  { value: '4935', name: 'Messias Targino', uf: '24' },
  { value: '4936', name: 'Paraú', uf: '24' },
  { value: '4937', name: 'Triunfo Potiguar', uf: '24' },
  { value: '4938', name: 'Upanema', uf: '24' },
  { value: '4939', name: 'Açu', uf: '24' },
  { value: '4940', name: 'Alto do Rodrigues', uf: '24' },
  { value: '4941', name: 'Carnaubais', uf: '24' },
  { value: '4942', name: 'Ipanguaçu', uf: '24' },
  { value: '4943', name: 'Itajá', uf: '24' },
  { value: '4944', name: 'Jucurutu', uf: '24' },
  { value: '4945', name: 'Pendências', uf: '24' },
  { value: '4946', name: 'Porto do Mangue', uf: '24' },
  { value: '4947', name: 'São Rafael', uf: '24' },
  { value: '4948', name: 'Água Nova', uf: '24' },
  { value: '4949', name: 'Coronel João Pessoa', uf: '24' },
  { value: '4950', name: 'Doutor Severiano', uf: '24' },
  { value: '4951', name: 'Encanto', uf: '24' },
  { value: '4952', name: 'Luís Gomes', uf: '24' },
  { value: '4953', name: 'Major Sales', uf: '24' },
  { value: '4954', name: 'Riacho de Santana', uf: '24' },
  { value: '4955', name: 'São Miguel', uf: '24' },
  { value: '4956', name: 'Venha-Ver', uf: '24' },
  { value: '4957', name: 'Alexandria', uf: '24' },
  { value: '4958', name: 'Francisco Dantas', uf: '24' },
  { value: '4959', name: 'Itaú', uf: '24' },
  { value: '4960', name: 'José da Penha', uf: '24' },
  { value: '4961', name: 'Marcelino Vieira', uf: '24' },
  { value: '4962', name: 'Paraná', uf: '24' },
  { value: '4963', name: 'Pau dos Ferros', uf: '24' },
  { value: '4964', name: 'Pilões', uf: '24' },
  { value: '4965', name: 'Portalegre', uf: '24' },
  { value: '4966', name: 'Rafael Fernandes', uf: '24' },
  { value: '4967', name: 'Riacho da Cruz', uf: '24' },
  { value: '4968', name: 'Rodolfo Fernandes', uf: '24' },
  { value: '4969', name: 'São Francisco do Oeste', uf: '24' },
  { value: '4970', name: 'Severiano Melo', uf: '24' },
  { value: '4971', name: 'Taboleiro Grande', uf: '24' },
  { value: '4972', name: 'Tenente Ananias', uf: '24' },
  { value: '4973', name: 'Viçosa', uf: '24' },
  { value: '4974', name: 'Almino Afonso', uf: '24' },
  { value: '4975', name: 'Antônio Martins', uf: '24' },
  { value: '4976', name: 'Frutuoso Gomes', uf: '24' },
  { value: '4977', name: 'João Dias', uf: '24' },
  { value: '4978', name: 'Lucrécia', uf: '24' },
  { value: '4979', name: 'Martins', uf: '24' },
  { value: '4980', name: "Olho-d'Água do Borges", uf: '24' },
  { value: '4981', name: 'Patu', uf: '24' },
  { value: '4982', name: 'Rafael Godeiro', uf: '24' },
  { value: '4983', name: 'Serrinha dos Pintos', uf: '24' },
  { value: '4984', name: 'Umarizal', uf: '24' },
  { value: '4985', name: 'Caiçara do Norte', uf: '24' },
  { value: '4986', name: 'Galinhos', uf: '24' },
  { value: '4987', name: 'Guamaré', uf: '24' },
  { value: '4988', name: 'Macau', uf: '24' },
  { value: '4989', name: 'São Bento do Norte', uf: '24' },
  { value: '4990', name: 'Afonso Bezerra', uf: '24' },
  { value: '4991', name: 'Angicos', uf: '24' },
  { value: '4992', name: 'Caiçara do Rio do Vento', uf: '24' },
  { value: '4993', name: 'Fernando Pedroza', uf: '24' },
  { value: '4994', name: 'Jardim de Angicos', uf: '24' },
  { value: '4995', name: 'Lajes', uf: '24' },
  { value: '4996', name: 'Pedra Preta', uf: '24' },
  { value: '4997', name: 'Pedro Avelino', uf: '24' },
  { value: '4998', name: 'Bodó', uf: '24' },
  { value: '4999', name: 'Cerro Corá', uf: '24' },
  { value: '5000', name: 'Florânia', uf: '24' },
  { value: '5001', name: 'Lagoa Nova', uf: '24' },
  { value: '5002', name: 'Santana do Matos', uf: '24' },
  { value: '5003', name: 'São Vicente', uf: '24' },
  { value: '5004', name: 'Tenente Laurentino Cruz', uf: '24' },
  { value: '5005', name: 'Caicó', uf: '24' },
  { value: '5006', name: 'Ipueira', uf: '24' },
  { value: '5007', name: 'Jardim de Piranhas', uf: '24' },
  { value: '5008', name: 'São Fernando', uf: '24' },
  { value: '5009', name: 'São João do Sabugi', uf: '24' },
  { value: '5010', name: 'Serra Negra do Norte', uf: '24' },
  { value: '5011', name: 'Timbaúba dos Batistas', uf: '24' },
  { value: '5012', name: 'Acari', uf: '24' },
  { value: '5013', name: 'Carnaúba dos Dantas', uf: '24' },
  { value: '5014', name: 'Cruzeta', uf: '24' },
  { value: '5015', name: 'Currais Novos', uf: '24' },
  { value: '5016', name: 'Equador', uf: '24' },
  { value: '5017', name: 'Jardim do Seridó', uf: '24' },
  { value: '5018', name: 'Ouro Branco', uf: '24' },
  { value: '5019', name: 'Parelhas', uf: '24' },
  { value: '5020', name: 'Santana do Seridó', uf: '24' },
  { value: '5021', name: 'São José do Seridó', uf: '24' },
  { value: '5022', name: 'Bento Fernandes', uf: '24' },
  { value: '5023', name: 'Jandaíra', uf: '24' },
  { value: '5024', name: 'João Câmara', uf: '24' },
  { value: '5025', name: 'Parazinho', uf: '24' },
  { value: '5026', name: 'Poço Branco', uf: '24' },
  { value: '5027', name: 'Barcelona', uf: '24' },
  { value: '5028', name: 'Campo Redondo', uf: '24' },
  { value: '5029', name: 'Coronel Ezequiel', uf: '24' },
  { value: '5030', name: 'Jaçanã', uf: '24' },
  { value: '5031', name: 'Japi', uf: '24' },
  { value: '5032', name: 'Lagoa de Velhos', uf: '24' },
  { value: '5033', name: 'Lajes Pintadas', uf: '24' },
  { value: '5034', name: 'Monte das Gameleiras', uf: '24' },
  { value: '5035', name: 'Ruy Barbosa', uf: '24' },
  { value: '5036', name: 'Santa Cruz', uf: '24' },
  { value: '5037', name: 'São Bento do Trairí', uf: '24' },
  { value: '5038', name: 'São José do Campestre', uf: '24' },
  { value: '5039', name: 'São Tomé', uf: '24' },
  { value: '5040', name: 'Serra de São Bento', uf: '24' },
  { value: '5041', name: 'Sítio Novo', uf: '24' },
  { value: '5042', name: 'Tangará', uf: '24' },
  { value: '5043', name: 'Bom Jesus', uf: '24' },
  { value: '5044', name: 'Brejinho', uf: '24' },
  { value: '5045', name: 'Ielmo Marinho', uf: '24' },
  { value: '5046', name: 'Januário Cicco', uf: '24' },
  { value: '5047', name: 'Jundiá', uf: '24' },
  { value: '5048', name: "Lagoa d'Anta", uf: '24' },
  { value: '5049', name: 'Lagoa de Pedras', uf: '24' },
  { value: '5050', name: 'Lagoa Salgada', uf: '24' },
  { value: '5051', name: 'Monte Alegre', uf: '24' },
  { value: '5052', name: 'Nova Cruz', uf: '24' },
  { value: '5053', name: 'Passa e Fica', uf: '24' },
  { value: '5054', name: 'Passagem', uf: '24' },
  { value: '5055', name: 'Santa Maria', uf: '24' },
  { value: '5056', name: 'Presidente Juscelino', uf: '24' },
  { value: '5057', name: 'Riachuelo', uf: '24' },
  { value: '5058', name: 'Santo Antônio', uf: '24' },
  { value: '5059', name: 'São Paulo do Potengi', uf: '24' },
  { value: '5060', name: 'São Pedro', uf: '24' },
  { value: '5061', name: 'Senador Elói de Souza', uf: '24' },
  { value: '5062', name: 'Serrinha', uf: '24' },
  { value: '5063', name: 'Várzea', uf: '24' },
  { value: '5064', name: 'Vera Cruz', uf: '24' },
  { value: '5065', name: 'Maxaranguape', uf: '24' },
  { value: '5066', name: 'Rio do Fogo', uf: '24' },
  { value: '5067', name: 'Pedra Grande', uf: '24' },
  { value: '5068', name: 'Pureza', uf: '24' },
  { value: '5069', name: 'São Miguel do Gostoso', uf: '24' },
  { value: '5070', name: 'Taipu', uf: '24' },
  { value: '5071', name: 'Touros', uf: '24' },
  { value: '5072', name: 'Ceará-Mirim', uf: '24' },
  { value: '5073', name: 'Macaíba', uf: '24' },
  { value: '5074', name: 'Nísia Floresta', uf: '24' },
  { value: '5075', name: 'São Gonçalo do Amarante', uf: '24' },
  { value: '5076', name: 'São José de Mipibu', uf: '24' },
  { value: '5077', name: 'Parnamirim', uf: '24' },
  { value: '5078', name: 'Extremoz', uf: '24' },
  { value: '5079', name: 'Natal', uf: '24' },
  { value: '5080', name: 'Arês', uf: '24' },
  { value: '5081', name: 'Baía Formosa', uf: '24' },
  { value: '5082', name: 'Canguaretama', uf: '24' },
  { value: '5083', name: 'Espírito Santo', uf: '24' },
  { value: '5084', name: 'Goianinha', uf: '24' },
  { value: '5085', name: 'Montanhas', uf: '24' },
  { value: '5086', name: 'Pedro Velho', uf: '24' },
  { value: '5087', name: 'Senador Georgino Avelino', uf: '24' },
  { value: '5088', name: 'Tibau do Sul', uf: '24' },
  { value: '5089', name: 'Vila Flor', uf: '24' },
  { value: '5090', name: 'Belém do Brejo do Cruz', uf: '25' },
  { value: '5091', name: 'Bom Sucesso', uf: '25' },
  { value: '5092', name: 'Brejo do Cruz', uf: '25' },
  { value: '5093', name: 'Brejo dos Santos', uf: '25' },
  { value: '5094', name: 'Catolé do Rocha', uf: '25' },
  { value: '5095', name: 'Jericó', uf: '25' },
  { value: '5096', name: 'Lagoa', uf: '25' },
  { value: '5097', name: 'Mato Grosso', uf: '25' },
  { value: '5098', name: 'Riacho dos Cavalos', uf: '25' },
  { value: '5099', name: 'São Bento', uf: '25' },
  { value: '5100', name: 'São José do Brejo do Cruz', uf: '25' },
  { value: '5101', name: 'São João do Rio do Peixe', uf: '25' },
  { value: '5102', name: 'Bernardino Batista', uf: '25' },
  { value: '5103', name: 'Bom Jesus', uf: '25' },
  { value: '5104', name: 'Bonito de Santa Fé', uf: '25' },
  { value: '5105', name: 'Cachoeira dos Índios', uf: '25' },
  { value: '5106', name: 'Cajazeiras', uf: '25' },
  { value: '5107', name: 'Carrapateira', uf: '25' },
  { value: '5108', name: 'Monte Horebe', uf: '25' },
  { value: '5109', name: 'Poço Dantas', uf: '25' },
  { value: '5110', name: 'Poço de José de Moura', uf: '25' },
  { value: '5111', name: 'Santa Helena', uf: '25' },
  { value: '5112', name: 'Santarém', uf: '25' },
  { value: '5113', name: 'São José de Piranhas', uf: '25' },
  { value: '5114', name: 'Triunfo', uf: '25' },
  { value: '5115', name: 'Uiraúna', uf: '25' },
  { value: '5116', name: 'Aparecida', uf: '25' },
  { value: '5117', name: 'Cajazeirinhas', uf: '25' },
  { value: '5118', name: 'Condado', uf: '25' },
  { value: '5119', name: 'Vista Serrana', uf: '25' },
  { value: '5120', name: 'Lastro', uf: '25' },
  { value: '5121', name: 'Malta', uf: '25' },
  { value: '5122', name: 'Marizópolis', uf: '25' },
  { value: '5123', name: 'Nazarezinho', uf: '25' },
  { value: '5124', name: 'Paulista', uf: '25' },
  { value: '5125', name: 'Pombal', uf: '25' },
  { value: '5126', name: 'Santa Cruz', uf: '25' },
  { value: '5127', name: 'São Bentinho', uf: '25' },
  { value: '5128', name: 'São Domingos de Pombal', uf: '25' },
  { value: '5129', name: 'São Francisco', uf: '25' },
  { value: '5130', name: 'São José da Lagoa Tapada', uf: '25' },
  { value: '5131', name: 'Sousa', uf: '25' },
  { value: '5132', name: 'Vieirópolis', uf: '25' },
  { value: '5133', name: 'Areia de Baraúnas', uf: '25' },
  { value: '5134', name: 'Cacimba de Areia', uf: '25' },
  { value: '5135', name: "Mãe d'Água", uf: '25' },
  { value: '5136', name: 'Passagem', uf: '25' },
  { value: '5137', name: 'Patos', uf: '25' },
  { value: '5138', name: 'Quixabá', uf: '25' },
  { value: '5139', name: 'Santa Teresinha', uf: '25' },
  { value: '5140', name: 'São José de Espinharas', uf: '25' },
  { value: '5141', name: 'São José do Bonfim', uf: '25' },
  { value: '5142', name: 'Aguiar', uf: '25' },
  { value: '5143', name: 'Igaracy', uf: '25' },
  { value: '5144', name: 'Catingueira', uf: '25' },
  { value: '5145', name: 'Coremas', uf: '25' },
  { value: '5146', name: 'Emas', uf: '25' },
  { value: '5147', name: 'Nova Olinda', uf: '25' },
  { value: '5148', name: "Olho d'Água", uf: '25' },
  { value: '5149', name: 'Piancó', uf: '25' },
  { value: '5150', name: 'Santana dos Garrotes', uf: '25' },
  { value: '5151', name: 'Boa Ventura', uf: '25' },
  { value: '5152', name: 'Conceição', uf: '25' },
  { value: '5153', name: 'Curral Velho', uf: '25' },
  { value: '5154', name: 'Diamante', uf: '25' },
  { value: '5155', name: 'Ibiara', uf: '25' },
  { value: '5156', name: 'Itaporanga', uf: '25' },
  { value: '5157', name: 'Pedra Branca', uf: '25' },
  { value: '5158', name: 'Santa Inês', uf: '25' },
  { value: '5159', name: 'Santana de Mangueira', uf: '25' },
  { value: '5160', name: 'São José de Caiana', uf: '25' },
  { value: '5161', name: 'Serra Grande', uf: '25' },
  { value: '5162', name: 'Água Branca', uf: '25' },
  { value: '5163', name: 'Cacimbas', uf: '25' },
  { value: '5164', name: 'Desterro', uf: '25' },
  { value: '5165', name: 'Imaculada', uf: '25' },
  { value: '5166', name: 'Juru', uf: '25' },
  { value: '5167', name: 'Manaíra', uf: '25' },
  { value: '5168', name: 'Maturéia', uf: '25' },
  { value: '5169', name: 'Princesa Isabel', uf: '25' },
  { value: '5170', name: 'São José de Princesa', uf: '25' },
  { value: '5171', name: 'Tavares', uf: '25' },
  { value: '5172', name: 'Teixeira', uf: '25' },
  { value: '5173', name: 'Junco do Seridó', uf: '25' },
  { value: '5174', name: 'Salgadinho', uf: '25' },
  { value: '5175', name: 'Santa Luzia', uf: '25' },
  { value: '5176', name: 'São José do Sabugi', uf: '25' },
  { value: '5177', name: 'São Mamede', uf: '25' },
  { value: '5178', name: 'Várzea', uf: '25' },
  { value: '5179', name: 'Baraúna', uf: '25' },
  { value: '5180', name: 'Cubati', uf: '25' },
  { value: '5181', name: 'Frei Martinho', uf: '25' },
  { value: '5182', name: 'Juazeirinho', uf: '25' },
  { value: '5183', name: 'Nova Palmeira', uf: '25' },
  { value: '5184', name: 'Pedra Lavrada', uf: '25' },
  { value: '5185', name: 'Picuí', uf: '25' },
  { value: '5186', name: 'Seridó', uf: '25' },
  { value: '5187', name: 'Tenório', uf: '25' },
  { value: '5188', name: 'Amparo', uf: '25' },
  { value: '5189', name: 'Assunção', uf: '25' },
  { value: '5190', name: 'Camalaú', uf: '25' },
  { value: '5191', name: 'Congo', uf: '25' },
  { value: '5192', name: 'Coxixola', uf: '25' },
  { value: '5193', name: 'Livramento', uf: '25' },
  { value: '5194', name: 'Monteiro', uf: '25' },
  { value: '5195', name: 'Ouro Velho', uf: '25' },
  { value: '5196', name: 'Parari', uf: '25' },
  { value: '5197', name: 'Prata', uf: '25' },
  { value: '5198', name: 'São João do Tigre', uf: '25' },
  { value: '5199', name: 'São José dos Cordeiros', uf: '25' },
  { value: '5200', name: 'São Sebastião do Umbuzeiro', uf: '25' },
  { value: '5201', name: 'Serra Branca', uf: '25' },
  { value: '5202', name: 'Sumé', uf: '25' },
  { value: '5203', name: 'Taperoá', uf: '25' },
  { value: '5204', name: 'Zabelê', uf: '25' },
  { value: '5205', name: 'Alcantil', uf: '25' },
  { value: '5206', name: 'Barra de Santana', uf: '25' },
  { value: '5207', name: 'Barra de São Miguel', uf: '25' },
  { value: '5208', name: 'Boqueirão', uf: '25' },
  { value: '5209', name: 'Cabaceiras', uf: '25' },
  { value: '5210', name: 'Caraúbas', uf: '25' },
  { value: '5211', name: 'Caturité', uf: '25' },
  { value: '5212', name: 'Gurjão', uf: '25' },
  { value: '5213', name: 'Riacho de Santo Antônio', uf: '25' },
  { value: '5214', name: 'Santo André', uf: '25' },
  { value: '5215', name: 'São Domingos do Cariri', uf: '25' },
  { value: '5216', name: 'São João do Cariri', uf: '25' },
  { value: '5217', name: 'Algodão de Jandaíra', uf: '25' },
  { value: '5218', name: 'Arara', uf: '25' },
  { value: '5219', name: 'Barra de Santa Rosa', uf: '25' },
  { value: '5220', name: 'Cuité', uf: '25' },
  { value: '5221', name: 'Damião', uf: '25' },
  { value: '5222', name: 'Nova Floresta', uf: '25' },
  { value: '5223', name: 'Olivedos', uf: '25' },
  { value: '5224', name: 'Pocinhos', uf: '25' },
  { value: '5225', name: 'Remígio', uf: '25' },
  { value: '5226', name: 'Soledade', uf: '25' },
  { value: '5227', name: 'Sossêgo', uf: '25' },
  { value: '5228', name: 'Araruna', uf: '25' },
  { value: '5229', name: 'Cacimba de Dentro', uf: '25' },
  { value: '5230', name: 'Casserengue', uf: '25' },
  { value: '5231', name: 'Dona Inês', uf: '25' },
  { value: '5232', name: 'Riachão', uf: '25' },
  { value: '5233', name: 'Solânea', uf: '25' },
  { value: '5234', name: 'Campo de Santana', uf: '25' },
  { value: '5235', name: 'Areial', uf: '25' },
  { value: '5236', name: 'Esperança', uf: '25' },
  { value: '5237', name: 'Montadas', uf: '25' },
  { value: '5238', name: 'São Sebastião de Lagoa de Roça', uf: '25' },
  { value: '5239', name: 'Alagoa Grande', uf: '25' },
  { value: '5240', name: 'Alagoa Nova', uf: '25' },
  { value: '5241', name: 'Areia', uf: '25' },
  { value: '5242', name: 'Bananeiras', uf: '25' },
  { value: '5243', name: 'Borborema', uf: '25' },
  { value: '5244', name: 'Matinhas', uf: '25' },
  { value: '5245', name: 'Pilões', uf: '25' },
  { value: '5246', name: 'Serraria', uf: '25' },
  { value: '5247', name: 'Alagoinha', uf: '25' },
  { value: '5248', name: 'Araçagi', uf: '25' },
  { value: '5249', name: 'Belém', uf: '25' },
  { value: '5250', name: 'Caiçara', uf: '25' },
  { value: '5251', name: 'Cuitegi', uf: '25' },
  { value: '5252', name: 'Duas Estradas', uf: '25' },
  { value: '5253', name: 'Guarabira', uf: '25' },
  { value: '5254', name: 'Lagoa de Dentro', uf: '25' },
  { value: '5255', name: 'Logradouro', uf: '25' },
  { value: '5256', name: 'Mulungu', uf: '25' },
  { value: '5257', name: 'Pilõezinhos', uf: '25' },
  { value: '5258', name: 'Pirpirituba', uf: '25' },
  { value: '5259', name: 'Serra da Raiz', uf: '25' },
  { value: '5260', name: 'Sertãozinho', uf: '25' },
  { value: '5261', name: 'Boa Vista', uf: '25' },
  { value: '5262', name: 'Campina Grande', uf: '25' },
  { value: '5263', name: 'Fagundes', uf: '25' },
  { value: '5264', name: 'Lagoa Seca', uf: '25' },
  { value: '5265', name: 'Massaranduba', uf: '25' },
  { value: '5266', name: 'Puxinanã', uf: '25' },
  { value: '5267', name: 'Queimadas', uf: '25' },
  { value: '5268', name: 'Serra Redonda', uf: '25' },
  { value: '5269', name: 'Caldas Brandão', uf: '25' },
  { value: '5270', name: 'Gurinhém', uf: '25' },
  { value: '5271', name: 'Ingá', uf: '25' },
  { value: '5272', name: 'Itabaiana', uf: '25' },
  { value: '5273', name: 'Itatuba', uf: '25' },
  { value: '5274', name: 'Juarez Távora', uf: '25' },
  { value: '5275', name: 'Mogeiro', uf: '25' },
  { value: '5276', name: 'Riachão do Bacamarte', uf: '25' },
  { value: '5277', name: 'Salgado de São Félix', uf: '25' },
  { value: '5278', name: 'Aroeiras', uf: '25' },
  { value: '5279', name: 'Gado Bravo', uf: '25' },
  { value: '5280', name: 'Natuba', uf: '25' },
  { value: '5281', name: 'Santa Cecília', uf: '25' },
  { value: '5282', name: 'Umbuzeiro', uf: '25' },
  { value: '5283', name: 'Baía da Traição', uf: '25' },
  { value: '5284', name: 'Capim', uf: '25' },
  { value: '5285', name: 'Cuité de Mamanguape', uf: '25' },
  { value: '5286', name: 'Curral de Cima', uf: '25' },
  { value: '5287', name: 'Itapororoca', uf: '25' },
  { value: '5288', name: 'Jacaraú', uf: '25' },
  { value: '5289', name: 'Mamanguape', uf: '25' },
  { value: '5290', name: 'Marcação', uf: '25' },
  { value: '5291', name: 'Mataraca', uf: '25' },
  { value: '5292', name: 'Pedro Régis', uf: '25' },
  { value: '5293', name: 'Rio Tinto', uf: '25' },
  { value: '5294', name: 'Cruz do Espírito Santo', uf: '25' },
  { value: '5295', name: 'Juripiranga', uf: '25' },
  { value: '5296', name: 'Mari', uf: '25' },
  { value: '5297', name: 'Pilar', uf: '25' },
  { value: '5298', name: 'Riachão do Poço', uf: '25' },
  { value: '5299', name: 'São José dos Ramos', uf: '25' },
  { value: '5300', name: 'São Miguel de Taipu', uf: '25' },
  { value: '5301', name: 'Sapé', uf: '25' },
  { value: '5302', name: 'Sobrado', uf: '25' },
  { value: '5303', name: 'Bayeux', uf: '25' },
  { value: '5304', name: 'Cabedelo', uf: '25' },
  { value: '5305', name: 'Conde', uf: '25' },
  { value: '5306', name: 'João Pessoa', uf: '25' },
  { value: '5307', name: 'Lucena', uf: '25' },
  { value: '5308', name: 'Santa Rita', uf: '25' },
  { value: '5309', name: 'Alhandra', uf: '25' },
  { value: '5310', name: 'Caaporã', uf: '25' },
  { value: '5311', name: 'Pedras de Fogo', uf: '25' },
  { value: '5312', name: 'Pitimbu', uf: '25' },
  { value: '5313', name: 'Araripina', uf: '26' },
  { value: '5314', name: 'Bodocó', uf: '26' },
  { value: '5315', name: 'Exu', uf: '26' },
  { value: '5316', name: 'Granito', uf: '26' },
  { value: '5317', name: 'Ipubi', uf: '26' },
  { value: '5318', name: 'Ouricuri', uf: '26' },
  { value: '5319', name: 'Santa Cruz', uf: '26' },
  { value: '5320', name: 'Santa Filomena', uf: '26' },
  { value: '5321', name: 'Moreilândia', uf: '26' },
  { value: '5322', name: 'Trindade', uf: '26' },
  { value: '5323', name: 'Cedro', uf: '26' },
  { value: '5324', name: 'Mirandiba', uf: '26' },
  { value: '5325', name: 'Parnamirim', uf: '26' },
  { value: '5326', name: 'Salgueiro', uf: '26' },
  { value: '5327', name: 'São José do Belmonte', uf: '26' },
  { value: '5328', name: 'Serrita', uf: '26' },
  { value: '5329', name: 'Verdejante', uf: '26' },
  { value: '5330', name: 'Afogados da Ingazeira', uf: '26' },
  { value: '5331', name: 'Brejinho', uf: '26' },
  { value: '5332', name: 'Calumbi', uf: '26' },
  { value: '5333', name: 'Carnaíba', uf: '26' },
  { value: '5334', name: 'Flores', uf: '26' },
  { value: '5335', name: 'Iguaraci', uf: '26' },
  { value: '5336', name: 'Ingazeira', uf: '26' },
  { value: '5337', name: 'Itapetim', uf: '26' },
  { value: '5338', name: 'Quixaba', uf: '26' },
  { value: '5339', name: 'Santa Cruz da Baixa Verde', uf: '26' },
  { value: '5340', name: 'Santa Terezinha', uf: '26' },
  { value: '5341', name: 'São José do Egito', uf: '26' },
  { value: '5342', name: 'Serra Talhada', uf: '26' },
  { value: '5343', name: 'Solidão', uf: '26' },
  { value: '5344', name: 'Tabira', uf: '26' },
  { value: '5345', name: 'Triunfo', uf: '26' },
  { value: '5346', name: 'Tuparetama', uf: '26' },
  { value: '5347', name: 'Arcoverde', uf: '26' },
  { value: '5348', name: 'Betânia', uf: '26' },
  { value: '5349', name: 'Custódia', uf: '26' },
  { value: '5350', name: 'Ibimirim', uf: '26' },
  { value: '5351', name: 'Inajá', uf: '26' },
  { value: '5352', name: 'Manari', uf: '26' },
  { value: '5353', name: 'Sertânia', uf: '26' },
  { value: '5354', name: 'Afrânio', uf: '26' },
  { value: '5355', name: 'Cabrobó', uf: '26' },
  { value: '5356', name: 'Dormentes', uf: '26' },
  { value: '5357', name: 'Lagoa Grande', uf: '26' },
  { value: '5358', name: 'Orocó', uf: '26' },
  { value: '5359', name: 'Petrolina', uf: '26' },
  { value: '5360', name: 'Santa Maria da Boa Vista', uf: '26' },
  { value: '5361', name: 'Terra Nova', uf: '26' },
  { value: '5362', name: 'Belém de São Francisco', uf: '26' },
  { value: '5363', name: 'Carnaubeira da Penha', uf: '26' },
  { value: '5364', name: 'Floresta', uf: '26' },
  { value: '5365', name: 'Itacuruba', uf: '26' },
  { value: '5366', name: 'Jatobá', uf: '26' },
  { value: '5367', name: 'Petrolândia', uf: '26' },
  { value: '5368', name: 'Tacaratu', uf: '26' },
  { value: '5369', name: 'Águas Belas', uf: '26' },
  { value: '5370', name: 'Buíque', uf: '26' },
  { value: '5371', name: 'Itaíba', uf: '26' },
  { value: '5372', name: 'Pedra', uf: '26' },
  { value: '5373', name: 'Tupanatinga', uf: '26' },
  { value: '5374', name: 'Venturosa', uf: '26' },
  { value: '5375', name: 'Alagoinha', uf: '26' },
  { value: '5376', name: 'Belo Jardim', uf: '26' },
  { value: '5377', name: 'Bezerros', uf: '26' },
  { value: '5378', name: 'Brejo da Madre de Deus', uf: '26' },
  { value: '5379', name: 'Cachoeirinha', uf: '26' },
  { value: '5380', name: 'Capoeiras', uf: '26' },
  { value: '5381', name: 'Caruaru', uf: '26' },
  { value: '5382', name: 'Gravatá', uf: '26' },
  { value: '5383', name: 'Jataúba', uf: '26' },
  { value: '5384', name: 'Pesqueira', uf: '26' },
  { value: '5385', name: 'Poção', uf: '26' },
  { value: '5386', name: 'Riacho das Almas', uf: '26' },
  { value: '5387', name: 'Sanharó', uf: '26' },
  { value: '5388', name: 'São Bento do Una', uf: '26' },
  { value: '5389', name: 'São Caitano', uf: '26' },
  { value: '5390', name: 'Tacaimbó', uf: '26' },
  { value: '5391', name: 'Casinhas', uf: '26' },
  { value: '5392', name: 'Frei Miguelinho', uf: '26' },
  { value: '5393', name: 'Santa Cruz do Capibaribe', uf: '26' },
  { value: '5394', name: 'Santa Maria do Cambucá', uf: '26' },
  { value: '5395', name: 'Surubim', uf: '26' },
  { value: '5396', name: 'Taquaritinga do Norte', uf: '26' },
  { value: '5397', name: 'Toritama', uf: '26' },
  { value: '5398', name: 'Vertente do Lério', uf: '26' },
  { value: '5399', name: 'Vertentes', uf: '26' },
  { value: '5400', name: 'Bom Jardim', uf: '26' },
  { value: '5401', name: 'Cumaru', uf: '26' },
  { value: '5402', name: 'Feira Nova', uf: '26' },
  { value: '5403', name: 'João Alfredo', uf: '26' },
  { value: '5404', name: 'Limoeiro', uf: '26' },
  { value: '5405', name: 'Machados', uf: '26' },
  { value: '5406', name: 'Orobó', uf: '26' },
  { value: '5407', name: 'Passira', uf: '26' },
  { value: '5408', name: 'Salgadinho', uf: '26' },
  { value: '5409', name: 'São Vicente Ferrer', uf: '26' },
  { value: '5410', name: 'Angelim', uf: '26' },
  { value: '5411', name: 'Bom Conselho', uf: '26' },
  { value: '5412', name: 'Brejão', uf: '26' },
  { value: '5413', name: 'Caetés', uf: '26' },
  { value: '5414', name: 'Calçado', uf: '26' },
  { value: '5415', name: 'Canhotinho', uf: '26' },
  { value: '5416', name: 'Correntes', uf: '26' },
  { value: '5417', name: 'Garanhuns', uf: '26' },
  { value: '5418', name: 'Iati', uf: '26' },
  { value: '5419', name: 'Jucati', uf: '26' },
  { value: '5420', name: 'Jupi', uf: '26' },
  { value: '5421', name: 'Jurema', uf: '26' },
  { value: '5422', name: 'Lagoa do Ouro', uf: '26' },
  { value: '5423', name: 'Lajedo', uf: '26' },
  { value: '5424', name: 'Palmeirina', uf: '26' },
  { value: '5425', name: 'Paranatama', uf: '26' },
  { value: '5426', name: 'Saloá', uf: '26' },
  { value: '5427', name: 'São João', uf: '26' },
  { value: '5428', name: 'Terezinha', uf: '26' },
  { value: '5429', name: 'Agrestina', uf: '26' },
  { value: '5430', name: 'Altinho', uf: '26' },
  { value: '5431', name: 'Barra de Guabiraba', uf: '26' },
  { value: '5432', name: 'Bonito', uf: '26' },
  { value: '5433', name: 'Camocim de São Félix', uf: '26' },
  { value: '5434', name: 'Cupira', uf: '26' },
  { value: '5435', name: 'Ibirajuba', uf: '26' },
  { value: '5436', name: 'Lagoa dos Gatos', uf: '26' },
  { value: '5437', name: 'Panelas', uf: '26' },
  { value: '5438', name: 'Sairé', uf: '26' },
  { value: '5439', name: 'São Joaquim do Monte', uf: '26' },
  { value: '5440', name: 'Aliança', uf: '26' },
  { value: '5441', name: 'Buenos Aires', uf: '26' },
  { value: '5442', name: 'Camutanga', uf: '26' },
  { value: '5443', name: 'Carpina', uf: '26' },
  { value: '5444', name: 'Condado', uf: '26' },
  { value: '5445', name: 'Ferreiros', uf: '26' },
  { value: '5446', name: 'Goiana', uf: '26' },
  { value: '5447', name: 'Itambé', uf: '26' },
  { value: '5448', name: 'Itaquitinga', uf: '26' },
  { value: '5449', name: 'Lagoa do Carro', uf: '26' },
  { value: '5450', name: 'Lagoa do Itaenga', uf: '26' },
  { value: '5451', name: 'Macaparana', uf: '26' },
  { value: '5452', name: 'Nazaré da Mata', uf: '26' },
  { value: '5453', name: 'Paudalho', uf: '26' },
  { value: '5454', name: 'Timbaúba', uf: '26' },
  { value: '5455', name: 'Tracunhaém', uf: '26' },
  { value: '5456', name: 'Vicência', uf: '26' },
  { value: '5457', name: 'Chã de Alegria', uf: '26' },
  { value: '5458', name: 'Chã Grande', uf: '26' },
  { value: '5459', name: 'Glória do Goitá', uf: '26' },
  { value: '5460', name: 'Pombos', uf: '26' },
  { value: '5461', name: 'Vitória de Santo Antão', uf: '26' },
  { value: '5462', name: 'Água Preta', uf: '26' },
  { value: '5463', name: 'Amaraji', uf: '26' },
  { value: '5464', name: 'Barreiros', uf: '26' },
  { value: '5465', name: 'Belém de Maria', uf: '26' },
  { value: '5466', name: 'Catende', uf: '26' },
  { value: '5467', name: 'Cortês', uf: '26' },
  { value: '5468', name: 'Escada', uf: '26' },
  { value: '5469', name: 'Gameleira', uf: '26' },
  { value: '5470', name: 'Jaqueira', uf: '26' },
  { value: '5471', name: 'Joaquim Nabuco', uf: '26' },
  { value: '5472', name: 'Maraial', uf: '26' },
  { value: '5473', name: 'Palmares', uf: '26' },
  { value: '5474', name: 'Primavera', uf: '26' },
  { value: '5475', name: 'Quipapá', uf: '26' },
  { value: '5476', name: 'Ribeirão', uf: '26' },
  { value: '5477', name: 'Rio Formoso', uf: '26' },
  { value: '5478', name: 'São Benedito do Sul', uf: '26' },
  { value: '5479', name: 'São José da Coroa Grande', uf: '26' },
  { value: '5480', name: 'Sirinhaém', uf: '26' },
  { value: '5481', name: 'Tamandaré', uf: '26' },
  { value: '5482', name: 'Xexéu', uf: '26' },
  { value: '5483', name: 'Araçoiaba', uf: '26' },
  { value: '5484', name: 'Igarassu', uf: '26' },
  { value: '5485', name: 'Ilha de Itamaracá', uf: '26' },
  { value: '5486', name: 'Itapissuma', uf: '26' },
  { value: '5487', name: 'Abreu e Lima', uf: '26' },
  { value: '5488', name: 'Camaragibe', uf: '26' },
  { value: '5489', name: 'Jaboatão dos Guararapes', uf: '26' },
  { value: '5490', name: 'Moreno', uf: '26' },
  { value: '5491', name: 'Olinda', uf: '26' },
  { value: '5492', name: 'Paulista', uf: '26' },
  { value: '5493', name: 'Recife', uf: '26' },
  { value: '5494', name: 'São Lourenço da Mata', uf: '26' },
  { value: '5495', name: 'Cabo de Santo Agostinho', uf: '26' },
  { value: '5496', name: 'Ipojuca', uf: '26' },
  { value: '5497', name: 'Fernando de Noronha', uf: '26' },
  { value: '5498', name: 'Água Branca', uf: '27' },
  { value: '5499', name: 'Canapi', uf: '27' },
  { value: '5500', name: 'Inhapi', uf: '27' },
  { value: '5501', name: 'Mata Grande', uf: '27' },
  { value: '5502', name: 'Pariconha', uf: '27' },
  { value: '5503', name: 'Delmiro Gouveia', uf: '27' },
  { value: '5504', name: "Olho d'Água do Casado", uf: '27' },
  { value: '5505', name: 'Piranhas', uf: '27' },
  { value: '5506', name: 'Carneiros', uf: '27' },
  { value: '5507', name: 'Dois Riachos', uf: '27' },
  { value: '5508', name: 'Maravilha', uf: '27' },
  { value: '5509', name: 'Ouro Branco', uf: '27' },
  { value: '5510', name: 'Palestina', uf: '27' },
  { value: '5511', name: 'Pão de Açúcar', uf: '27' },
  { value: '5512', name: 'Poço das Trincheiras', uf: '27' },
  { value: '5513', name: 'Santana do Ipanema', uf: '27' },
  { value: '5514', name: 'São José da Tapera', uf: '27' },
  { value: '5515', name: 'Senador Rui Palmeira', uf: '27' },
  { value: '5516', name: 'Batalha', uf: '27' },
  { value: '5517', name: 'Belo Monte', uf: '27' },
  { value: '5518', name: 'Jacaré dos Homens', uf: '27' },
  { value: '5519', name: 'Jaramataia', uf: '27' },
  { value: '5520', name: 'Major Isidoro', uf: '27' },
  { value: '5521', name: 'Monteirópolis', uf: '27' },
  { value: '5522', name: "Olho d'Água das Flores", uf: '27' },
  { value: '5523', name: 'Olivença', uf: '27' },
  { value: '5524', name: 'Belém', uf: '27' },
  { value: '5525', name: 'Cacimbinhas', uf: '27' },
  { value: '5526', name: 'Estrela de Alagoas', uf: '27' },
  { value: '5527', name: 'Igaci', uf: '27' },
  { value: '5528', name: 'Maribondo', uf: '27' },
  { value: '5529', name: 'Mar Vermelho', uf: '27' },
  { value: '5530', name: 'Minador do Negrão', uf: '27' },
  { value: '5531', name: 'Palmeira dos Índios', uf: '27' },
  { value: '5532', name: 'Paulo Jacinto', uf: '27' },
  { value: '5533', name: 'Quebrangulo', uf: '27' },
  { value: '5534', name: "Tanque d'Arca", uf: '27' },
  { value: '5535', name: 'Arapiraca', uf: '27' },
  { value: '5536', name: 'Campo Grande', uf: '27' },
  { value: '5537', name: 'Coité do Nóia', uf: '27' },
  { value: '5538', name: 'Craíbas', uf: '27' },
  { value: '5539', name: 'Feira Grande', uf: '27' },
  { value: '5540', name: 'Girau do Ponciano', uf: '27' },
  { value: '5541', name: 'Lagoa da Canoa', uf: '27' },
  { value: '5542', name: 'Limoeiro de Anadia', uf: '27' },
  { value: '5543', name: 'São Sebastião', uf: '27' },
  { value: '5544', name: 'Taquarana', uf: '27' },
  { value: '5545', name: "Olho d'Água Grande", uf: '27' },
  { value: '5546', name: 'São Brás', uf: '27' },
  { value: '5547', name: 'Traipu', uf: '27' },
  { value: '5548', name: 'Chã Preta', uf: '27' },
  { value: '5549', name: 'Ibateguara', uf: '27' },
  { value: '5550', name: 'Pindoba', uf: '27' },
  { value: '5551', name: 'Santana do Mundaú', uf: '27' },
  { value: '5552', name: 'São José da Laje', uf: '27' },
  { value: '5553', name: 'União dos Palmares', uf: '27' },
  { value: '5554', name: 'Viçosa', uf: '27' },
  { value: '5555', name: 'Atalaia', uf: '27' },
  { value: '5556', name: 'Branquinha', uf: '27' },
  { value: '5557', name: 'Cajueiro', uf: '27' },
  { value: '5558', name: 'Campestre', uf: '27' },
  { value: '5559', name: 'Capela', uf: '27' },
  { value: '5560', name: 'Colônia Leopoldina', uf: '27' },
  { value: '5561', name: 'Flexeiras', uf: '27' },
  { value: '5562', name: 'Jacuípe', uf: '27' },
  { value: '5563', name: 'Joaquim Gomes', uf: '27' },
  { value: '5564', name: 'Jundiá', uf: '27' },
  { value: '5565', name: 'Pinto Bandeira', uf: '43' },
];

const ufs = [
  { value: '11', name: 'RO' },
  { value: '12', name: 'AC' },
  { value: '13', name: 'AM' },
  { value: '41', name: 'PR' },
  { value: '29', name: 'BA' },
  { value: '27', name: 'AL' },
  { value: '28', name: 'SE' },
  { value: '52', name: 'GO' },
  { value: '53', name: 'DF' },
  { value: '51', name: 'MT' },
  { value: '50', name: 'MS' },
  { value: '43', name: 'RS' },
  { value: '14', name: 'RR' },
  { value: '15', name: 'PA' },
  { value: '16', name: 'AP' },
  { value: '17', name: 'TO' },
  { value: '17', name: 'TO' },
  { value: '21', name: 'MA' },
  { value: '22', name: 'PI' },
  { value: '23', name: 'CE' },
  { value: '24', name: 'RN' },
  { value: '25', name: 'PB' },
  { value: '26', name: 'PE' },
  { value: '31', name: 'MG' },
  { value: '32', name: 'ES' },
  { value: '33', name: 'RJ' },
  { value: '35', name: 'SP' },
  { value: '42', name: 'SC' },
];
const addressPrefix = [
  '-',
  'Acesso',
  'Alameda',
  'Alto',
  'Area',
  'Arteria',
  'Avenida',
  'Beco',
  'Calcada',
  'Caminho',
  'Campo',
  'Canal',
  'Chacara',
  'CPC',
  'Distrito',
  'Esquina',
  'Estrada',
  'Fazenda',
  'Ferrovia',
  'Ladeira',
  'Lago',
  'Largo',
  'Linha',
  'Loteamento',
  'Modulo',
  'Nucleo',
  'Outros',
  'Parada',
  'Paralela',
  'Parque',
  'Passagem',
  'Passarela',
  'Passeio',
  'Praca',
  'Quadra',
  'Quinta',
  'Rodovia',
  'Rua',
  'Servidao',
  'Setor',
  'Sitio',
  'Terminal',
  'Travessa',
  'Via',
  'Viaduto',
  'Viela',
  'Vila',
];

export {
  addressPrefix,
  educationOptions,
  badesulRole,
  race,
  occupation,
  nationality,
  pepOptions,
  countries,
  documentOptions,
  maritalStatus,
  genderOptions,
  municipalities,
  ufs,

  legalNature,
};
